
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ljEF1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6RwwD = parcelRequire("6RwwD");


var $aI2Eh = parcelRequire("aI2Eh");


var $eO7Q2 = parcelRequire("eO7Q2");


var $4nt1R = parcelRequire("4nt1R");


var $dVPAB = parcelRequire("dVPAB");


var $emQKL = parcelRequire("emQKL");


var $40ukF = parcelRequire("40ukF");


var $3gmKQ = parcelRequire("3gmKQ");


var $iVGec = parcelRequire("iVGec");


var $hFvHs = parcelRequire("hFvHs");


var $2ZvWx = parcelRequire("2ZvWx");


var $jNalm = parcelRequire("jNalm");


var $gkbos = parcelRequire("gkbos");


var $cXtTj = parcelRequire("cXtTj");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $cDpdq = parcelRequire("cDpdq");





var $kpCD8 = parcelRequire("kpCD8");


var $c2E4R = parcelRequire("c2E4R");


var $iLrhi = parcelRequire("iLrhi");


var $kCECX = parcelRequire("kCECX");


var $6rwn6 = parcelRequire("6rwn6");

const $28d1024403af18a1$export$811d95c3175e32b1 = ({ config: { onArrowUp: onArrowUp, onArrowDown: onArrowDown, onInputChange: onInputChange }, api: api })=>{
    return {
        name: 'arrowKeyPlugin',
        pmPlugins () {
            return [
                {
                    name: 'arrowKeyPlugin',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            props: {
                                handleTextInput: ()=>{
                                    onInputChange();
                                },
                                handleKeyDown: (view, event)=>{
                                    if (event.key === 'Backspace') onInputChange();
                                    if (!(0, $c2E4R.atTheBeginningOfDoc)(view.state)) return;
                                    if (event.key === 'ArrowUp') onArrowUp({
                                        replaceDocument: (value)=>api?.core.actions.replaceDocument(value),
                                        view: view
                                    });
                                    else if (event.key === 'ArrowDown') onArrowDown({
                                        replaceDocument: (value)=>{
                                            api?.core.actions.replaceDocument(value);
                                            // Needed because the down arrow by default moves the cursor to the end of the input
                                            // preventDefault, stopPropagation, etc. doesn't work to prevent this in this callback
                                            // So we need to wait for the next tick to move the cursor to the start of the input
                                            new Promise((resolve)=>{
                                                setTimeout(()=>{
                                                    view.dispatch(view.state.tr.setSelection(new (0, $kCECX.TextSelection)(view.state.tr.doc.resolve(0), view.state.tr.doc.resolve(0))));
                                                    resolve(true);
                                                }, 0);
                                            });
                                        },
                                        view: view
                                    });
                                }
                            }
                        });
                    }
                }
            ];
        }
    };
};
const $28d1024403af18a1$export$bb1e6e55f39d8be9 = ({ userMessages: userMessages })=>{
    const storeMessagesRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(userMessages);
    storeMessagesRef.current = userMessages;
    const currentMessageRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        currentMessageRef.current = undefined;
    }, [
        userMessages.length
    ]);
    const moveMessageUpOrDown = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(({ replaceDocument: replaceDocument, position: position, view: view })=>{
        const increment = position === 'up' ? -1 : 1;
        const isEmpty = (0, $iLrhi.isEmptyDocument)(view.state.doc);
        if (!storeMessagesRef.current.length) return;
        // If the input is not empty and the current message is not set(it's not the history message), do nothing
        if (!isEmpty && currentMessageRef.current === undefined) return;
        const currentMessageIndex = currentMessageRef.current ? storeMessagesRef.current.findIndex((message)=>message.id === currentMessageRef.current?.id) : storeMessagesRef.current.length;
        // If the currentindex is humanMessages.length, the next index will either be the last message (pressing up)
        // or out of bounds (pressing down and resetting the current message to undefined)
        const newMessageIndex = Math.max(0, currentMessageIndex + increment);
        const newMessage = storeMessagesRef.current[newMessageIndex];
        currentMessageRef.current = newMessage;
        replaceDocument(newMessage?.content ?? (0, $6rwn6.encodeAdf)(''));
    }, []);
    const handleArrowUp = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(({ replaceDocument: replaceDocument_0, view: view_0 })=>{
        moveMessageUpOrDown({
            replaceDocument: replaceDocument_0,
            position: 'up',
            view: view_0
        });
    }, [
        moveMessageUpOrDown
    ]);
    const handleArrowDown = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(({ replaceDocument: replaceDocument_1, view: view_1 })=>{
        moveMessageUpOrDown({
            replaceDocument: replaceDocument_1,
            position: 'down',
            view: view_1
        });
    }, [
        moveMessageUpOrDown
    ]);
    const handleInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        // Reset the current message to undefined when input gets updated
        currentMessageRef.current = undefined;
    }, []);
    return {
        handleArrowUp: handleArrowUp,
        handleArrowDown: handleArrowDown,
        handleInputChange: handleInputChange
    };
};



var $e4kXe = parcelRequire("e4kXe");


var $1hQ0e = parcelRequire("1hQ0e");








var $8nvEM = parcelRequire("8nvEM");

const $9c25ea95daa57463$var$INLINE_SUGGESTION_CLASS_NAME = 'placeholder-decoration placeholder-decoration-inline creation-inline-suggestion';
const $9c25ea95daa57463$var$INLINE_SUGGESTION_TEST_ID = 'creation-inline-suggestion';
const $9c25ea95daa57463$var$inlineSuggestionPluginKey = new (0, $kCECX.PluginKey)('creationInlineSuggestionPlugin');
const $9c25ea95daa57463$var$getInlineSuggestionPosition = (editorState, prefix)=>{
    const { doc: doc, selection: selection } = editorState;
    const paragraph = doc.firstChild;
    if (doc.childCount !== 1 || paragraph?.type.name !== 'paragraph' || doc.textContent !== prefix || !selection.empty) return undefined;
    const endOfParagraph = doc.content.size - 1;
    return selection.from === endOfParagraph ? endOfParagraph : undefined;
};
const $9c25ea95daa57463$var$createInlineSuggestionDecoration = ({ currentIndex: currentIndex, editorState: editorState, suggestions: suggestions, position: position })=>{
    const suggestion = suggestions[currentIndex % suggestions.length];
    return (0, $8nvEM.DecorationSet).create(editorState.doc, [
        (0, $8nvEM.Decoration).widget(position, ()=>{
            const doc = (0, $1hQ0e.getDocument)();
            if (!doc) throw new Error('Document not found');
            const suggestionElement = doc.createElement('span');
            suggestionElement.className = $9c25ea95daa57463$var$INLINE_SUGGESTION_CLASS_NAME;
            suggestionElement.setAttribute('aria-hidden', 'true');
            suggestionElement.setAttribute('contenteditable', 'false');
            suggestionElement.setAttribute('data-testid', $9c25ea95daa57463$var$INLINE_SUGGESTION_TEST_ID);
            suggestionElement.textContent = suggestion;
            return suggestionElement;
        }, {
            key: `creation-inline-suggestion-${currentIndex}`,
            side: 1
        })
    ]);
};
const $9c25ea95daa57463$var$prefersReducedMotion = ()=>typeof globalThis.matchMedia === 'function' && globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;
const $9c25ea95daa57463$export$baf253247d93a75a = ({ config: config })=>({
        name: 'creationInlineSuggestion',
        pmPlugins () {
            if (!config || config.suggestions.length === 0) return [];
            return [
                {
                    name: 'creationInlineSuggestion',
                    plugin: ()=>new (0, $kpCD8.SafePlugin)({
                            key: $9c25ea95daa57463$var$inlineSuggestionPluginKey,
                            state: {
                                init: (_config, editorState)=>{
                                    const hasShown = $9c25ea95daa57463$var$getInlineSuggestionPosition(editorState, config.prefix) !== undefined;
                                    return {
                                        currentIndex: 0,
                                        dismissed: false,
                                        hasShown: hasShown
                                    };
                                },
                                apply: (transaction, pluginState, _oldEditorState, newEditorState)=>{
                                    const meta = transaction.getMeta($9c25ea95daa57463$var$inlineSuggestionPluginKey);
                                    const isEligible = $9c25ea95daa57463$var$getInlineSuggestionPosition(newEditorState, config.prefix) !== undefined;
                                    const hasShown = pluginState.hasShown || isEligible;
                                    const dismissed = pluginState.dismissed || pluginState.hasShown && !isEligible && (transaction.docChanged || transaction.selectionSet);
                                    return {
                                        currentIndex: meta?.currentIndex ?? pluginState.currentIndex,
                                        dismissed: dismissed,
                                        hasShown: hasShown
                                    };
                                }
                            },
                            props: {
                                decorations (editorState) {
                                    const pluginState = $9c25ea95daa57463$var$inlineSuggestionPluginKey.getState(editorState);
                                    const position = $9c25ea95daa57463$var$getInlineSuggestionPosition(editorState, config.prefix);
                                    if (!pluginState || pluginState.dismissed || position === undefined) return undefined;
                                    return $9c25ea95daa57463$var$createInlineSuggestionDecoration({
                                        currentIndex: pluginState.currentIndex,
                                        editorState: editorState,
                                        position: position,
                                        suggestions: config.suggestions
                                    });
                                },
                                handleDOMEvents: {
                                    mousedown (view) {
                                        const pluginState = $9c25ea95daa57463$var$inlineSuggestionPluginKey.getState(view.state);
                                        const position = $9c25ea95daa57463$var$getInlineSuggestionPosition(view.state, config.prefix);
                                        if (!pluginState || pluginState.dismissed || position === undefined) return false;
                                        const suggestion = config.suggestions[pluginState.currentIndex % config.suggestions.length];
                                        view.dispatch(view.state.tr.insertText(suggestion, position));
                                        return false;
                                    }
                                }
                            },
                            view (editorView) {
                                let intervalId;
                                let timeoutId;
                                let hasReducedMotionAdvanced = false;
                                const clearTimers = ()=>{
                                    if (intervalId !== undefined) {
                                        clearInterval(intervalId);
                                        intervalId = undefined;
                                    }
                                    if (timeoutId !== undefined) {
                                        clearTimeout(timeoutId);
                                        timeoutId = undefined;
                                    }
                                };
                                const advanceSuggestion = (view, index)=>{
                                    const pluginState = $9c25ea95daa57463$var$inlineSuggestionPluginKey.getState(view.state);
                                    if (!pluginState || pluginState.dismissed) return;
                                    const currentIndex = index ?? (pluginState.currentIndex + 1) % config.suggestions.length;
                                    view.dispatch(view.state.tr.setMeta($9c25ea95daa57463$var$inlineSuggestionPluginKey, {
                                        currentIndex: currentIndex
                                    }));
                                };
                                const updateTimer = (view)=>{
                                    const pluginState = $9c25ea95daa57463$var$inlineSuggestionPluginKey.getState(view.state);
                                    const isVisible = pluginState !== undefined && !pluginState.dismissed && $9c25ea95daa57463$var$getInlineSuggestionPosition(view.state, config.prefix) !== undefined;
                                    if (!isVisible || config.suggestions.length < 2) {
                                        clearTimers();
                                        return;
                                    }
                                    if ($9c25ea95daa57463$var$prefersReducedMotion()) {
                                        if (timeoutId === undefined && !hasReducedMotionAdvanced) timeoutId = setTimeout(()=>{
                                            timeoutId = undefined;
                                            hasReducedMotionAdvanced = true;
                                            advanceSuggestion(view, 1);
                                        }, config.intervalMs);
                                        return;
                                    }
                                    if (intervalId === undefined) intervalId = setInterval(()=>{
                                        advanceSuggestion(view);
                                    }, config.intervalMs);
                                };
                                updateTimer(editorView);
                                return {
                                    update: updateTimer,
                                    destroy: clearTimers
                                };
                            }
                        })
                }
            ];
        }
    });





const $43f6591bebf603cb$var$message = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "ai-mate.chat-input.placeholder",
        defaultMessage: "Write a prompt to get started"
    },
    placeholderUpdated: {
        id: "ai-mate.chat-input.placeholder.updated.latest",
        defaultMessage: "Write a prompt, @mentions someone, or use / for actions"
    },
    placeholderShort: {
        id: "ai-mate.chat-input.placeholder.short",
        defaultMessage: "Write a prompt..."
    }
});
var $43f6591bebf603cb$export$2e2bcd8739ae039 = $43f6591bebf603cb$var$message;






var $aPdNQ = parcelRequire("aPdNQ");

/**
 * Removes textColor marks from a ProseMirror Slice.
 *
 * When users manually copy text from an area that has an explicit text color
 * (e.g. white text on a dark chat-bubble background) and then paste it into
 * the chat input, the color mark is preserved.  Because the input has a light
 * background the text can become invisible.
 *
 * This helper recursively walks every node in the slice and strips the
 * `textColor` mark so that pasted content always uses the editor's default
 * text color.
 */ function $a651fb4b1931b65b$var$removeTextColorFromNode(node) {
    if (node.isText) {
        const filteredMarks = node.marks.filter((mark)=>mark.type.name !== 'textColor');
        return node.mark(filteredMarks);
    }
    if (node.content && node.content.size > 0) {
        const children = [];
        node.content.forEach((child)=>{
            children.push($a651fb4b1931b65b$var$removeTextColorFromNode(child));
        });
        return node.copy((0, $aPdNQ.Fragment).from(children));
    }
    return node;
}
function $a651fb4b1931b65b$var$removeTextColorFromSlice(slice) {
    const { content: content, openStart: openStart, openEnd: openEnd } = slice;
    const children = [];
    content.forEach((node)=>{
        children.push($a651fb4b1931b65b$var$removeTextColorFromNode(node));
    });
    return new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(children), openStart, openEnd);
}
const $a651fb4b1931b65b$export$5503306a243aac08 = ()=>{
    return {
        name: 'pasteTextColorPlugin',
        pmPlugins () {
            return [
                {
                    name: 'pasteTextColorPlugin',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            props: {
                                transformPasted (slice) {
                                    return $a651fb4b1931b65b$var$removeTextColorFromSlice(slice);
                                }
                            }
                        });
                    }
                }
            ];
        }
    };
};


const $172e38f51769df21$export$451e6f6982270493 = 256000;
const $172e38f51769df21$export$22e9fc2aa16bb38f = ({ onSave: onSave, arrowKeyPluginConfig: arrowKeyPluginConfig, productKey: productKey, siteId: siteId, placeholderPrompts: placeholderPrompts, placeholderPromptAnimationOptions: placeholderPromptAnimationOptions, placeholderText: placeholderText, inlineSuggestion: inlineSuggestion, linkPickerOptions: linkPickerOptions = {}, useShortMessages: useShortMessages = false, connectorSources: connectorSources = [], autocomplete: autocomplete, enableAgentSectioning: enableAgentSectioning = false, handleMentionsChanged: handleMentionsChanged, smartCardContext: smartCardContext, mentionNodeDataProvider: mentionNodeDataProvider, profilecardProvider: profilecardProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const linkPicker = (0, $cDpdq.useLinkPickerEditorProps)(linkPickerOptions, {
        cloudId: siteId,
        product: productKey
    });
    const { handleArrowDown: handleArrowDown, handleArrowUp: handleArrowUp, handleInputChange: handleInputChange } = (0, $28d1024403af18a1$export$bb1e6e55f39d8be9)({
        userMessages: arrowKeyPluginConfig.userMessages
    });
    const knownSourcesRef = (0, $cozmU.useRef)(connectorSources);
    knownSourcesRef.current = connectorSources;
    const handleMentionsChangedRef = (0, $cozmU.useRef)(handleMentionsChanged);
    handleMentionsChangedRef.current = handleMentionsChanged;
    const smartCardContextRef = (0, $cozmU.useRef)(smartCardContext);
    smartCardContextRef.current = smartCardContext;
    const forwardMentionsChangedRef = (0, $cozmU.useRef)((changes)=>{
        handleMentionsChangedRef.current?.(changes);
    });
    const shouldForwardMentionChanges = handleMentionsChanged !== undefined;
    const autocompletePluginOptions = autocomplete ? {
        ...autocomplete,
        surface: autocomplete.surface ?? 'rovo-chat'
    } : autocomplete;
    // productKey gate before the experiment read keeps exposure Confluence-only.
    // Register the plugin in the first preset so Editor Core never reconfigures
    // (and blur()s) after mount. web-llm stays in the plugin's dynamic import.
    const shouldEnableAutocomplete = !!autocompletePluginOptions && productKey === 'confluence' && (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_autocomplete_rovo_chat_editor');
    const { preset: preset, editorApi: editorApi } = (0, $dVPAB.usePreset)(()=>{
        const isUpdatedPlaceholderEnabled = ()=>(0, $cXtTj.default).getExperimentValue('rovo-chat-input-placeholder-updated', 'isEnabled', false);
        const placeholderConfig = placeholderPrompts ? {
            placeholderPrompts: placeholderPrompts,
            placeholderPromptAnimationOptions: placeholderPromptAnimationOptions
        } : placeholderText ? {
            placeholder: placeholderText
        } : {
            placeholder: formatMessage(useShortMessages ? (0, $43f6591bebf603cb$export$2e2bcd8739ae039).placeholderShort : isUpdatedPlaceholderEnabled() ? (0, $43f6591bebf603cb$export$2e2bcd8739ae039).placeholderUpdated : (0, $43f6591bebf603cb$export$2e2bcd8739ae039).placeholder)
        };
        const presetBuilder = (0, $4nt1R.createDefaultPreset)({
            allowAnalyticsGASV3: (0, $iDrrr.fg)('platform_rovo_chat_enable_editor_plugin_analytics'),
            placeholder: placeholderConfig,
            paste: {
                pasteWarningOptions: {
                    cannotPasteSyncedBlock: {
                        title: (0, $aI2Eh.syncBlockMessages).cannotPasteSyncedBlockTitle,
                        description: (0, $aI2Eh.syncBlockMessages).cannotPasteSyncedBlockUnsupportedDescription,
                        urlHref: (0, $eO7Q2.SYNCED_BLOCKS_DOCUMENTATION_URL),
                        urlText: (0, $aI2Eh.syncBlockMessages).cannotPasteSyncedBlockAction
                    }
                }
            },
            hyperlinkOptions: {
                linkPicker: linkPicker,
                lpLinkPicker: true
            },
            blockType: {
                allowBlockType: {
                    exclude: [
                        'heading'
                    ]
                },
                lastNodeMustBeParagraph: false
            },
            toolbar: {
                enableNewToolbarExperience: false
            }
        }).add([
            (0, $jNalm.saveOnEnterPlugin),
            onSave
        ]).add([
            (0, $2ZvWx.mentionsPlugin),
            {
                enableAgentSectioning: enableAgentSectioning || (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents'),
                handleMentionsChanged: shouldForwardMentionChanges ? forwardMentionsChangedRef.current : undefined,
                ...mentionNodeDataProvider ? {
                    mentionNodeDataProvider: mentionNodeDataProvider
                } : {},
                ...profilecardProvider ? {
                    profilecardProvider: profilecardProvider
                } : {}
            }
        ]).add((0, $iVGec.gridPlugin)).add([
            (0, $40ukF.cardPlugin),
            {
                allowBlockCards: false,
                allowEmbeds: false,
                linkPicker: linkPicker,
                lpLinkPicker: true,
                provider: Promise.resolve((0, $6RwwD.editorCardProvider)),
                smartCardContext: smartCardContextRef.current
            }
        ]).add((0, $hFvHs.listPlugin)).add((0, $3gmKQ.extensionPlugin)).add([
            (0, $e4kXe.connectorSourceInputRulePlugin),
            {
                knownSourcesRef: knownSourcesRef
            }
        ]).maybeAdd([
            (0, $9c25ea95daa57463$export$baf253247d93a75a),
            inlineSuggestion
        ], !!inlineSuggestion).add((0, $gkbos.textColorPlugin)).add((0, $a651fb4b1931b65b$export$5503306a243aac08)).maybeAdd([
            (0, $emQKL.autocompletePlugin),
            autocompletePluginOptions
        ], shouldEnableAutocomplete);
        return presetBuilder.add([
            (0, $28d1024403af18a1$export$811d95c3175e32b1),
            {
                onArrowDown: handleArrowDown,
                onArrowUp: handleArrowUp,
                onInputChange: handleInputChange
            }
        ]);
    }, [
        inlineSuggestion,
        shouldForwardMentionChanges,
        mentionNodeDataProvider,
        profilecardProvider
    ]);
    return {
        preset: preset,
        editorApi: editorApi
    };
};
module.exports["MAX_CHARACTERS_INPUT"] = $172e38f51769df21$export$451e6f6982270493;
module.exports["useEditorPreset"] = $172e38f51769df21$export$22e9fc2aa16bb38f;

});

parcelRegister("emQKL", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $jv11C = parcelRequire("jv11C");


var $kpCD8 = parcelRequire("kpCD8");


var $44cyU = parcelRequire("44cyU");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $dl7hN = parcelRequire("dl7hN");




const $f43e491c0e6eeee7$var$GHOST_TEXT_CLASS = 'autocomplete-ghost-text';
const $f43e491c0e6eeee7$export$6a85b5542ba7ed73 = (doc, position, text)=>{
    if (!text) return (0, $8nvEM.DecorationSet).empty;
    const decoration = (0, $8nvEM.Decoration).widget(position, ()=>{
        const container = document.createElement('span');
        container.className = $f43e491c0e6eeee7$var$GHOST_TEXT_CLASS;
        container.setAttribute('data-autocomplete-ghost', 'true');
        container.setAttribute('contenteditable', 'false');
        container.setAttribute('aria-hidden', 'true');
        container.style.color = '#999';
        container.style.opacity = '0.6';
        container.style.pointerEvents = 'auto';
        container.style.userSelect = 'none';
        container.style.cursor = 'pointer';
        container.style.fontStyle = 'italic';
        // U+200B (Zero Width Space) gives the browser a line-break opportunity
        // immediately before the ghost text. This ensures the typed text before
        // the span is never pushed to the next line by the ghost text's width —
        // only the ghost text itself will wrap if it doesn't fit.
        container.textContent = '\u200b' + text;
        return container;
    }, {
        side: 1,
        // Render after content at this position
        // A matching key short-circuits `WidgetType.eq`, so ProseMirror reuses
        // the rendered node and never calls `toDOM` again. Keying on the text
        // keeps that reuse when nothing changed while still forcing a redraw
        // when the ghost advances through a keystroke that confirmed it —
        // otherwise the stale tail stays on screen and Tab inserts a
        // character the user already typed.
        key: `autocomplete-ghost-text:${text}`
    });
    return (0, $8nvEM.DecorationSet).create(doc, [
        decoration
    ]);
};


/**
 * Local Slow Lane Client: On-device inference via @mlc-ai/web-llm.
 *
 * Drop-in replacement for the network-based slow-lane-client. Instead of calling
 * a backend API, this client runs two models in the browser via WebGPU, in a
 * single MLCEngine, to reproduce the BE encoder's outputs on-device:
 *
 *   - Causal LM (SmolLM2-135M-Instruct): context-keyed one-step boundary primes
 *     provide canonical first-token logits. A persistent token-prefix scheduler
 *     expands shared paths and exact-scores only plausible finalists.
 *   - Semantic embedder (Snowflake Arctic Embed S): produces the real 384-d
 *     `semantic_vector`. Inputs are wrapped as passages (see `wrapForArctic`) so
 *     the runtime vector lands in the same space as the precomputed word bin.
 *
 * ── Why main thread (no Web Worker)? ─────────────────────────────────────
 * The models are small enough (~640 MB combined VRAM) that WebGPU inference on
 * the main thread is viable:
 *
 *   - WebGPU GPU compute is inherently async (doesn't block the main thread)
 *   - CPU overhead for named-token reads and cache bookkeeping is small
 *   - Per-inference latency is well within autocomplete expectations
 *     (~250 ms between word boundaries)
 *
 * This avoids all the complexity of Web Workers:
 *   - No CSP workarounds (blob URLs, inline scripts)
 *   - No bundler configuration (worker-plugin, import.meta.url)
 *   - No message passing protocol
 *   - Standard npm import — just works
 *
 * ── Interface ────────────────────────────────────────────────────────────
 * Same base shape as createSlowLaneClient, plus on-device canonical-surface
 * scoring. Semantic updates remain word-boundary timed; causal work is requested
 * independently for exact pre-surface contexts.
 */ 
var $a8cFP = parcelRequire("a8cFP");


var $ln5kH = parcelRequire("ln5kH");


var $gKGLg = parcelRequire("gKGLg");


var $eGuir = parcelRequire("eGuir");





var $cVZWR = parcelRequire("cVZWR");


var $gpRHn = parcelRequire("gpRHn");

// ─── Constants ───────────────────────────────────────────────────────────────
const $ae68e65f1ca82a3b$var$DEFAULT_DEBOUNCE_MS = 300;
// eslint-disable-next-line require-unicode-regexp
const $ae68e65f1ca82a3b$var$OOM_REGEX = /\boom\b/;
const $ae68e65f1ca82a3b$export$52e4ea87e1fa9c52 = 'SmolLM2-135M-Instruct-q0f16-MLC';
const $ae68e65f1ca82a3b$export$cf1b3c95cebf5c2c = 'snowflake-arctic-embed-s-q0f32-MLC-b4';
const $ae68e65f1ca82a3b$export$db72946c40e668b5 = (text)=>`[CLS] ${text} [SEP]`;
const $ae68e65f1ca82a3b$export$93abf2f096f2bfe = {
    /**
   * Word-level approximation of the BE causal LM token limit.
   *
   * BE: `CausalLMEncoder.max_context_tokens = 100` (BPE tokens, left-truncated).
   * FE: no tokenizer available, so we approximate with word count. English text
   * averages ~1.3–1.5 BPE tokens/word, meaning 100 words ≈ 130–150 tokens.
   * Using 100 words keeps the approximation simple and errs on the side of
   * sending slightly more context than the BE sees — acceptable for a PoC.
   */ MAX_CONTEXT_TOKENS: 100,
    /**
   * Word-level rolling window for the semantic embedder.
   *
   * BE: `SlowLaneEngine.max_context_words = 100` (applied in
   * `typeahead_context_encoding.py` before calling `SemanticEncoder.encode`).
   * Truncated identically here so the runtime Arctic vector lands in the same
   * region of the embedding space as the precomputed word-vector bin.
   */ MAX_CONTEXT_WORDS: 100
};
const $ae68e65f1ca82a3b$export$e347284e8010dda3 = {
    /**
   * How many contexts keep their prefilled state before the oldest is dropped.
   *
   * Sizes every context-keyed cache together on purpose: an expansion needs
   * both the boundary logits and the candidate list to still be resident, so
   * bounding them separately would evict half of a context and strand the
   * other half.
   *
   * The context of a keystroke is the text *before* the word being typed,
   * which does not change while that word is typed, so one word should cost
   * one prefill and then hit. Measured hit rate was 45% over the first 84s of
   * a session and 24% over the following four minutes, well short of that, and
   * prompt prefills per decision rose 0.80 → 1.25 across the same split while
   * cost per prefill stayed flat. Contexts were being dropped while still live.
   *
   * A boundary entry holds a `Float32Array` over the 49,152-token vocabulary,
   * so each one is ~192KB and this bound is the dominant term in the scorer's
   * footprint: ~24MB resident here, against ~6MB at the 32 this replaced. That
   * cost is what kept the bound low, not a hit rate anyone had measured.
   */ BOUNDARY_CACHE_MAX: 128,
    EXACT_MAX_TARGET_TOKENS: 8,
    PREFIX_CACHE_MAX: 256,
    /**
   * How many candidates compete for expansion in one context.
   *
   * Each distinct token prefix among them is a separate branch, and a branch
   * the engine is not already standing on costs a prompt prefill before its
   * first decode. A wide field therefore spreads a decision's round trips
   * across candidates and finishes none of them inside the budget.
   */ PROGRESSIVE_CANDIDATES_MAX: 8,
    /**
   * Ceiling on distinct token prefixes explored per context.
   *
   * Raising this to 8 to give long surfaces more room did the opposite: model
   * calls per decision went 2.35 → 4.32, the warm-KV extend share fell 40% →
   * 31% as the extra branches displaced the live path, the prefix queue backed
   * up to 29 deep, and acceptances per thousand decisions fell 9.3 → 6.7. No
   * phrase was shown either way, so breadth was never the binding constraint.
   *
   * What blocked them then was normalisation against a short word's per-token
   * mean, which has since been replaced by a posterior over sequence
   * log-likelihoods. That removes the bias towards short surfaces but does not
   * by itself make phrases reachable: a longer surface is strictly less likely
   * than a shorter one, so a phrase sharing a shortlist with a unigram still
   * holds little of its mass. Whether the remaining gap is the threshold or the
   * comparison is still open.
   */ PROGRESSIVE_EXPANSIONS_PER_CONTEXT_MAX: 4,
    PROGRESSIVE_INPUT_MAX: 400,
    SURFACE_CACHE_MAX: 128,
    TIER_A_PRIMES_MAX: 3
};
/**
 * How much optimistic score we give up to stay on the warm KV path.
 *
 * Expanding a prefix the cache already holds costs one decode step, while
 * branching to any other prefix costs a full prompt prefill first. Measured,
 * that is about 30ms against about 66ms, so continuing the live path is worth
 * roughly half a round trip and the margin has to be wide enough to reflect
 * that. At the previous 0.05 almost any ranking difference was enough to
 * abandon the sequence, and 70% of expansions ended up re-prefilling.
 */ const $ae68e65f1ca82a3b$var$PROGRESSIVE_WARM_PATH_MARGIN = 0.25;
const $ae68e65f1ca82a3b$var$splitOnWhitespace = (text)=>{
    const trimmed = text.trim();
    if (trimmed === '') return [];
    const words = [];
    let wordStart = -1;
    for(let i = 0; i < trimmed.length; i++){
        if (trimmed[i].trim() === '') {
            if (wordStart !== -1) {
                words.push(trimmed.slice(wordStart, i));
                wordStart = -1;
            }
            continue;
        }
        if (wordStart === -1) wordStart = i;
    }
    if (wordStart !== -1) words.push(trimmed.slice(wordStart));
    return words;
};
/**
 * Return the last `n` whitespace-separated words of `text`, joined by spaces.
 * Mirrors the BE rolling-window truncation applied before both encoders.
 */ const $ae68e65f1ca82a3b$var$truncateToLastNWords = (text, n)=>{
    const words = $ae68e65f1ca82a3b$var$splitOnWhitespace(text);
    return words.length <= n ? text : words.slice(-n).join(' ');
};
/**
 * Full canonical leading-space token sequence for every served surface. The
 * producer keeps the existing `phrase-continuation-tokens.json` wire name while
 * expanding its key set to the complete word/bigram/phrase union.
 */ let $ae68e65f1ca82a3b$var$surfaceTokenIds = new Map();
let $ae68e65f1ca82a3b$var$surfaceTokenTrie = new (0, $eGuir.CanonicalSurfaceTokenTrie)();
/** De-dupes concurrent loads and lets repeated calls await the same payload. */ let $ae68e65f1ca82a3b$var$surfaceTokenIdsPromise;
const $ae68e65f1ca82a3b$var$isPhraseContinuationTokens = (payload)=>{
    if (payload == null || typeof payload !== 'object') return false;
    return Object.values(payload).every((value)=>Array.isArray(value) && value.every((entry)=>typeof entry === 'number' && entry >= 0));
};
/** Lazily load the producer's full-union canonical surface token map. */ const $ae68e65f1ca82a3b$var$loadCanonicalSurfaceTokens = ()=>{
    if (!$ae68e65f1ca82a3b$var$surfaceTokenIdsPromise) $ae68e65f1ca82a3b$var$surfaceTokenIdsPromise = (async ()=>{
        const continuationTokensData = await (0, $ln5kH.fetchAutocompleteArtifactJson)((0, $gKGLg.ARTIFACT_NAME).PHRASE_CONTINUATION_TOKENS, {
            summarize: (payload)=>`${Object.keys(payload).length} surfaces`,
            validate: $ae68e65f1ca82a3b$var$isPhraseContinuationTokens
        }).catch(()=>null);
        $ae68e65f1ca82a3b$var$surfaceTokenIds = new Map(Object.entries(continuationTokensData ?? {}).map(([surface, tokenIds])=>[
                surface.toLowerCase(),
                tokenIds
            ]));
        $ae68e65f1ca82a3b$var$surfaceTokenTrie = new (0, $eGuir.CanonicalSurfaceTokenTrie)($ae68e65f1ca82a3b$var$surfaceTokenIds.entries());
        if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
        console.log(`%c[CTC:model] %c${$ae68e65f1ca82a3b$var$surfaceTokenIds.size > 0 ? "\u2705 canonical surface tokens loaded:" : "\u26A0\uFE0F canonical surface tokens unavailable \u2014 LM evidence will remain absent:"}`, 'color: #9c27b0; font-weight: bold;', $ae68e65f1ca82a3b$var$surfaceTokenIds.size > 0 ? 'color: #4caf50; font-weight: bold;' : 'color: #ff9800; font-weight: bold;', {
            surfaces: $ae68e65f1ca82a3b$var$surfaceTokenIds.size
        });
    })().catch((e)=>{
        // Don't cache a rejected promise — a transient import failure would
        // otherwise prevent the local model from ever initialising again this
        // session. Reset so the next init attempt retries.
        $ae68e65f1ca82a3b$var$surfaceTokenIdsPromise = undefined;
        throw e;
    });
    return $ae68e65f1ca82a3b$var$surfaceTokenIdsPromise;
};

const $ae68e65f1ca82a3b$export$ad366118632d1082 = (config = {})=>{
    const { debounceMs: debounceMs = $ae68e65f1ca82a3b$var$DEFAULT_DEBOUNCE_MS, onUpdate: onUpdate, onBoundaryLmUpdate: onBoundaryLmUpdate, onSurfaceScoreUpdate: onSurfaceScoreUpdate, onStatus: onStatus, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, modelId: modelId = $ae68e65f1ca82a3b$export$52e4ea87e1fa9c52, customModelConfig: customModelConfig, surface: surface } = config;
    // ── State ──────────────────────────────────────────────────────────────
    let storedContextInput = null;
    let storedContextVector = null;
    let storedLmLogits = null;
    const boundaryCache = new Map();
    const prefixExpansionCache = new Map();
    const surfaceScoreCache = new Map();
    let causalInFlight = false;
    let inFlightBoundaryContextKey = null;
    let latestCausalFamilyKey = '';
    let causalRequestsThisFamily = 0;
    let causalGeneratedTokensThisFamily = 0;
    let tierAPrimeCacheHitsThisFamily = 0;
    let tierAPrimeCacheMissesThisFamily = 0;
    let causalInferenceOrdinal = 0;
    const causalInferenceByContext = new Map();
    const causalInferenceByFamily = new Map();
    const exactEvidenceCountByContext = new Map();
    const pendingBoundaryPrimes = new Map();
    const pendingPrefixExpansions = new Map();
    const inFlightPrefixExpansions = new Set();
    // The engine holds exactly one linear KV sequence. WebLLM lets us extend it
    // (`forwardTokensAndSample`) or drop it (a text completion always resets
    // first), but never fork or rewind it. Tracking what is currently
    // materialised is what makes decoding continuous: expanding a token prefix
    // that extends `kvPath` costs a single decode step, while any other prefix
    // costs a fresh prompt prefill.
    let kvContextKey = null;
    let kvPath = [];
    const isPrefixOf = (prefix, path)=>prefix.length <= path.length && prefix.every((token, index)=>token === path[index]);
    /**
   * Whether running this expansion would extend the sequence the engine is
   * already holding rather than discarding it for a fresh prompt prefill.
   *
   * `planProgressiveExpansion` also prefers a warm group, but it decides when
   * the work is queued and the queue is drained later. A boundary prime or
   * another context's expansion running in between moves the path out from
   * under that choice, so the preference has to be re-checked at the moment
   * something is picked up.
   */ const extendsLiveKvPath = (request)=>kvContextKey === request.contextKey && isPrefixOf(kvPath, request.tokenPrefix);
    const progressiveRequests = new Map();
    const progressivePrefixesByContext = new Map();
    let debounceTimer = null;
    let lastRequestedText = '';
    let requestCounter = 0;
    let latestRequestId = -1;
    let inferenceInFlight = false;
    let activeInferenceText = null;
    // The requestId of the inference currently in flight. Tracked so the
    // in-flight dedup path can restore `latestRequestId` to it — otherwise an
    // intermediate keystroke that bumped `latestRequestId` would cause the
    // in-flight (still-current) result to be discarded as stale.
    let activeInferenceRequestId = -1;
    let pendingInference = null;
    let ready = false;
    let destroyed = false;
    let initFailed = false;
    let engine = null;
    let engineInitPromise = null;
    const causalLogitProcessor = new (0, $eGuir.CanonicalLogitProcessor)();
    const unloadEngine = (engineToUnload)=>{
        engineToUnload.unload().catch((error)=>{
            if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
            console.log('%c[CTC:model] %cFailed to unload engine', 'color: #9c27b0; font-weight: bold;', 'color: inherit;', error);
        });
    };
    // ── Engine initialisation ──────────────────────────────────────────────
    const initProgressCallback = (progress)=>{
        const message = `[${(progress.progress * 100).toFixed(0)}%] ${progress.text}`;
        if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
        console.log(`%c[CTC:model] %c\u{1F504} ${message}`, 'color: #9c27b0; font-weight: bold;', 'color: inherit;');
        onStatus?.(message);
    };
    const bytesToMB = (bytes)=>typeof bytes === 'number' ? Math.round(bytes / 1048576) : undefined;
    /**
   * Inspect the machine's WebGPU support so a load failure can be attributed
   * to a concrete hardware/browser limitation rather than a generic error.
   */ const probeWebGpuCapabilities = async ()=>{
        const gpu = navigator.gpu;
        if (!gpu) return {
            available: false
        };
        try {
            const adapter = await gpu.requestAdapter();
            if (!adapter) return {
                available: true,
                adapterAvailable: false
            };
            let vendor;
            let architecture;
            try {
                const info = adapter.info ?? await adapter.requestAdapterInfo?.();
                vendor = info?.vendor || undefined;
                architecture = info?.architecture || undefined;
            } catch  {
            // adapter info is best-effort
            }
            return {
                available: true,
                adapterAvailable: true,
                shaderF16Supported: adapter.features.has('shader-f16'),
                maxBufferSizeMB: bytesToMB(adapter.limits?.maxBufferSize),
                maxStorageBufferBindingSizeMB: bytesToMB(adapter.limits?.maxStorageBufferBindingSize),
                vendor: vendor,
                architecture: architecture
            };
        } catch  {
            return {
                available: true,
                adapterAvailable: false
            };
        }
    };
    /** Map an MLC/WebLLM engine-creation error message to a coarse reason. */ const classifyEngineError = (message)=>{
        const lower = message.toLowerCase();
        if (lower.includes('loading chunk') || lower.includes('dynamically imported module') || lower.includes('dynamic import')) return 'module_load_failed';
        if (lower.includes('out of memory') || $ae68e65f1ca82a3b$var$OOM_REGEX.test(lower) || lower.includes('allocation') || lower.includes('exceeds') || lower.includes('buffer size') || lower.includes('not enough memory')) return 'insufficient_memory';
        // Pre-flight already returns missing_shader_f16 when the feature is absent,
        // so only match the exact feature token here — not bare 'shader' (compile
        // errors) or bare 'f16' (present in model ids like q0f16-MLC).
        if (lower.includes('shader-f16') || lower.includes('shader_f16')) return 'missing_shader_f16';
        if (lower.includes('fetch') || lower.includes('network') || lower.includes('download') || lower.includes('http') || lower.includes('cache')) return 'model_download_failed';
        return 'init_failed';
    };
    // Canonical, controlled failure descriptions. We never emit the raw engine
    // error into analytics — it can embed customer-context URLs/paths (HOT-120175)
    // — so the analytics `message` is always one of these fixed strings.
    const LOAD_FAILURE_MESSAGE = {
        webgpu_unavailable: 'WebGPU is not available in this browser',
        webgpu_no_adapter: 'No compatible WebGPU adapter found',
        missing_shader_f16: 'GPU does not support the shader-f16 feature',
        insufficient_memory: 'Insufficient GPU memory to load the model',
        model_download_failed: 'Failed to download model assets',
        module_load_failed: 'Failed to load the web-llm runtime module',
        init_failed: 'Model engine failed to initialise'
    };
    const handleLoadFailure = (reason, capabilities, debugDetail)=>{
        ready = false;
        const message = LOAD_FAILURE_MESSAGE[reason];
        if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
        console.log(`[CTC:model] Engine initialisation failed (${reason}): ${debugDetail ?? message}`);
        onStatus?.(`Engine initialisation failed: ${message}`);
        onLoadError?.({
            reason: reason,
            message: message,
            modelId: modelId,
            embeddingModelId: $ae68e65f1ca82a3b$export$cf1b3c95cebf5c2c,
            capabilities: capabilities
        });
        engineInitPromise = null;
        initFailed = true;
    };
    const initEngine = async ()=>{
        const capabilities = await probeWebGpuCapabilities();
        // ── Pre-flight: machine limitations short-circuit before the expensive load ──
        if (!capabilities.available) {
            handleLoadFailure('webgpu_unavailable', capabilities);
            return;
        }
        if (capabilities.adapterAvailable === false) {
            handleLoadFailure('webgpu_no_adapter', capabilities);
            return;
        }
        if (capabilities.shaderF16Supported === false) {
            handleLoadFailure('missing_shader_f16', capabilities);
            return;
        }
        const startTime = performance.now();
        try {
            if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
            console.log(`%c[CTC:model] %c\u{1F680} Initialising MLC engine with models: ${modelId} (LM) + ${$ae68e65f1ca82a3b$export$cf1b3c95cebf5c2c} (embedder)`, 'color: #9c27b0; font-weight: bold;', 'color: inherit;');
            onStatus?.(`Initialising models: ${modelId} + ${$ae68e65f1ca82a3b$export$cf1b3c95cebf5c2c}\u{2026}`);
            // Fetch the web-llm runtime and canonical token artifact in parallel;
            // both are dynamically imported so they stay out of the main editor chunk.
            const [{ MLCEngine: MLCEngineCtor, prebuiltAppConfig: prebuiltAppConfig }] = await Promise.all([
                (parcelRequire("2GLSY")),
                $ae68e65f1ca82a3b$var$loadCanonicalSurfaceTokens()
            ]);
            const customModelRecord = customModelConfig ? {
                model: customModelConfig.model,
                model_id: modelId,
                model_lib: customModelConfig.modelLib,
                low_resource_required: true,
                required_features: [
                    'shader-f16'
                ],
                ...customModelConfig.vramRequiredMB !== undefined ? {
                    vram_required_MB: customModelConfig.vramRequiredMB
                } : {},
                ...customModelConfig.contextWindowSize !== undefined ? {
                    overrides: {
                        context_window_size: customModelConfig.contextWindowSize
                    }
                } : {}
            } : undefined;
            const appConfig = {
                model_list: [
                    ...prebuiltAppConfig.model_list,
                    ...customModelRecord ? [
                        customModelRecord
                    ] : []
                ]
            };
            // Construct the engine with the logit-capture processor registered for
            // the causal LM only (the embedder never decodes tokens), then load
            // both the LM and the embedder into the same engine (multi-model).
            const newEngine = new MLCEngineCtor({
                appConfig: appConfig,
                initProgressCallback: initProgressCallback,
                logitProcessorRegistry: new Map([
                    [
                        modelId,
                        causalLogitProcessor
                    ]
                ])
            });
            await newEngine.reload([
                modelId,
                $ae68e65f1ca82a3b$export$cf1b3c95cebf5c2c
            ]);
            if (destroyed) {
                // destroy() was called while we were loading — clean up
                unloadEngine(newEngine);
                return;
            }
            engine = newEngine;
            ready = true;
            const loadDurationMs = Math.round(performance.now() - startTime);
            if ((0, $dl7hN.isAutocompleteDebugEnabled)()) {
                // eslint-disable-next-line no-console
                console.log("%c[CTC:model] %c\u2705 Both models loaded and ready", 'color: #9c27b0; font-weight: bold;', 'color: #4caf50;');
                // One-time identity summary so you can confirm which models are active
                // without digging through the init-progress scroll.
                // eslint-disable-next-line no-console
                console.log("%c[CTC:model] %c\uD83E\uDDE0 Causal LM    \u2192", 'color: #9c27b0; font-weight: bold;', 'color: #2196f3; font-weight: bold;', modelId);
                // eslint-disable-next-line no-console
                console.log("%c[CTC:model] %c\uD83D\uDD22 Embedder     \u2192", 'color: #9c27b0; font-weight: bold;', 'color: #009688; font-weight: bold;', $ae68e65f1ca82a3b$export$cf1b3c95cebf5c2c);
            }
            onStatus?.('Model loaded and ready.');
            onLoadSuccess?.({
                modelId: modelId,
                embeddingModelId: $ae68e65f1ca82a3b$export$cf1b3c95cebf5c2c,
                loadDurationMs: loadDurationMs,
                capabilities: capabilities
            });
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : String(err);
            handleLoadFailure(classifyEngineError(errorMsg), capabilities, errorMsg);
        }
    };
    const ensureEngineInitialized = ()=>{
        if (initFailed) return Promise.resolve();
        if (!engineInitPromise) engineInitPromise = initEngine();
        return engineInitPromise;
    };
    // ── Inference ──────────────────────────────────────────────────────────
    /** Run the boundary-timed Arctic semantic inference independently of the LM. */ const runInference = async (text, requestId)=>{
        if (!engine || destroyed) return;
        const experienceId = String(requestId);
        const semanticText = $ae68e65f1ca82a3b$var$truncateToLastNWords(text, $ae68e65f1ca82a3b$export$93abf2f096f2bfe.MAX_CONTEXT_WORDS);
        const arcticInput = $ae68e65f1ca82a3b$export$db72946c40e668b5(semanticText);
        if ((0, $dl7hN.isAutocompleteDebugVerbose)()) // eslint-disable-next-line no-console
        console.log(`%c[CTC:model] %c\u{1F522} Arctic input (${arcticInput.length} chars, ${$ae68e65f1ca82a3b$var$splitOnWhitespace(semanticText).length} words): "${arcticInput.length > 100 ? `${arcticInput.slice(0, 100)}\u{2026}` : arcticInput}"`, 'color: #9c27b0; font-weight: bold;', 'color: #009688;');
        try {
            // Reuse the network slow-lane-fetch UFO experience (tagged isLocalLLM:true,
            // matching LOAD_VECTORS/LOAD_VOCABULARY) so on-device inference
            // latency/success-rate feeds the same FE Reliability SLO. Started inside
            // the try — post engine-init (parity with the network fetch, which
            // excludes the one-time model load) and so the catch below always
            // terminates the experience, even on a synchronous throw.
            (0, $a8cFP.startExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, experienceId, {
                textLength: text.length,
                isLocalLLM: true,
                ...surface ? {
                    surface: surface
                } : {}
            });
            const tStart = performance.now();
            const embeddingResponse = await engine.embeddings.create({
                model: $ae68e65f1ca82a3b$export$cf1b3c95cebf5c2c,
                input: arcticInput
            });
            const tEmbDone = performance.now();
            if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
            console.log(`%c[CTC:model] %c\u{23F1} Embedder: ${(tEmbDone - tStart).toFixed(0)}ms`, 'color: #9c27b0; font-weight: bold;', 'color: #ff9800;');
            // Discard stale results
            if (requestId < latestRequestId || destroyed) {
                (0, $a8cFP.abortExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, experienceId, destroyed ? 'destroyed' : 'superseded', {
                    isLocalLLM: true,
                    ...surface ? {
                        surface: surface
                    } : {}
                });
                return;
            }
            // ── Semantic vector: real 384-d Arctic embedding ─────────────
            // Guard against base64-encoded responses (encoding_format: 'base64' would
            // yield a string, and new Float32Array(string) silently produces an empty
            // array, corrupting downstream cosine-similarity scoring).
            const embedding = embeddingResponse.data?.[0]?.embedding;
            storedContextVector = Array.isArray(embedding) && embedding.length > 0 ? new Float32Array(embedding) : null;
            storedContextInput = storedContextVector ? semanticText : null;
            if ((0, $dl7hN.isAutocompleteDebugEnabled)()) {
                // eslint-disable-next-line no-console
                console.groupCollapsed(`%c[CTC:model] %c\u{1F4E5} Inference result (request #${requestId})`, 'color: #9c27b0; font-weight: bold;', 'color: inherit;');
                if (storedContextVector) {
                    let sumSq = 0;
                    for(let i = 0; i < storedContextVector.length; i++)sumSq += storedContextVector[i] * storedContextVector[i];
                    // eslint-disable-next-line no-console
                    console.log(`\u{2705} semantic vector: ${storedContextVector.length} dims (L2 norm ${Math.sqrt(sumSq).toFixed(3)})`);
                } else // eslint-disable-next-line no-console
                console.log("\u274C No vector");
                // eslint-disable-next-line no-console
                console.log("\uD83E\uDDE0 causal LM: independently primed by exact candidate contexts");
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
            (0, $a8cFP.succeedExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, experienceId, {
                textLength: text.length,
                hasVector: storedContextVector !== null,
                hasLmLogits: false,
                isLocalLLM: true,
                ...surface ? {
                    surface: surface
                } : {}
            });
            onUpdate?.({
                textLength: text.length,
                hasVector: storedContextVector !== null,
                hasLmLogits: false
            });
        } catch (err) {
            // Discard errors for stale requests or after teardown
            if (requestId < latestRequestId || destroyed) {
                (0, $a8cFP.abortExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, experienceId, destroyed ? 'destroyed' : 'superseded', {
                    isLocalLLM: true,
                    ...surface ? {
                        surface: surface
                    } : {}
                });
                return;
            }
            storedContextInput = null;
            storedContextVector = null;
            storedLmLogits = null;
            (0, $a8cFP.failExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, experienceId, {
                errorType: 'inference',
                isLocalLLM: true,
                ...surface ? {
                    surface: surface
                } : {}
            });
            onUpdate?.({
                textLength: text.length,
                hasVector: false,
                hasLmLogits: false
            });
            const errorMsg = err instanceof Error ? err.message : String(err);
            if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
            console.log(`%c[CTC:model] %c\u{274C} Inference error (request #${requestId}): ${errorMsg}`, 'color: #9c27b0; font-weight: bold;', 'color: #f44336;');
        }
    };
    // ── Canonical causal scorer ─────────────────────────────────────────────
    const surfaceCacheKey = (contextKey, surface, tokenIds = $ae68e65f1ca82a3b$var$surfaceTokenIds.get(surface.toLowerCase()) ?? [])=>`${contextKey}\u0000${surface.toLowerCase()}\u0000${tokenIds.join(',')}`;
    // Declared as functions rather than generic arrows: this file carries a `webpackChunkName`
    // comment, which opts it into a build-time parse that reads `<T>(` as a JSX tag.
    function getLru(cache, key) {
        const value = cache.get(key);
        if (value === undefined) return null;
        cache.delete(key);
        cache.set(key, value);
        return value;
    }
    function setLru(cache, key, value, maxSize) {
        cache.delete(key);
        cache.set(key, value);
        while(cache.size > maxSize){
            const oldest = cache.keys().next().value;
            if (oldest === undefined) break;
            cache.delete(oldest);
        }
    }
    const prefixCacheKey = (contextKey, tokenPrefix)=>`${contextKey}\u0000${tokenPrefix.join(',')}`;
    const logProgressiveState = (state, detail)=>{
        if (!(0, $dl7hN.isAutocompleteDebugEnabled)()) return;
        // eslint-disable-next-line no-console
        console.log(`%c[CTC:model] %c\u{1F500} grouped ${state} \xb7 ${detail}`, 'color: #9c27b0; font-weight: bold;', state === 'failed' ? 'color: #f44336;' : state === 'completed' || state === 'cached' ? 'color: #4caf50;' : 'color: #2196f3;');
    };
    const createCausalInferenceAggregate = (startedAt)=>({
            e2eLatencyMs: 0,
            failedRequests: 0,
            firstStartedAt: startedAt,
            promptTokens: 0,
            promptUsageSamples: 0,
            requestedCompletionTokens: 0,
            requests: 0,
            sampledOutputTokens: 0,
            timeToFirstTokenMs: 0,
            wallClockMs: 0,
            webLlmDecodeSteps: 0,
            webLlmUsageSamples: 0
        });
    const updateCausalInferenceAggregate = (cache, key, measurement)=>{
        const aggregate = getLru(cache, key) ?? createCausalInferenceAggregate(performance.now() - measurement.wallClockMs);
        aggregate.requests++;
        aggregate.requestedCompletionTokens += measurement.requestedCompletionTokens;
        aggregate.wallClockMs += measurement.wallClockMs;
        if (measurement.outcome === 'failed') aggregate.failedRequests++;
        if (measurement.promptTokens !== null) {
            aggregate.promptTokens += measurement.promptTokens;
            aggregate.promptUsageSamples++;
        }
        if (measurement.sampledOutputTokens !== null && measurement.webLlmDecodeSteps !== null) {
            aggregate.sampledOutputTokens += measurement.sampledOutputTokens;
            aggregate.webLlmDecodeSteps += measurement.webLlmDecodeSteps;
            aggregate.webLlmUsageSamples++;
        }
        if (measurement.timeToFirstTokenMs !== null) aggregate.timeToFirstTokenMs += measurement.timeToFirstTokenMs;
        if (measurement.e2eLatencyMs !== null) aggregate.e2eLatencyMs += measurement.e2eLatencyMs;
        setLru(cache, key, aggregate, $ae68e65f1ca82a3b$export$e347284e8010dda3.BOUNDARY_CACHE_MAX);
        return aggregate;
    };
    const causalAggregateForLog = (aggregate)=>({
            calls: aggregate.requests,
            elapsedMs: Number((performance.now() - aggregate.firstStartedAt).toFixed(1)),
            failedCalls: aggregate.failedRequests,
            inferenceWallMs: Number(aggregate.wallClockMs.toFixed(1)),
            promptTokens: aggregate.promptUsageSamples > 0 ? aggregate.promptTokens : 'unreported',
            requestedOutputTokens: aggregate.requestedCompletionTokens,
            sampledOutputTokens: aggregate.webLlmUsageSamples > 0 ? aggregate.sampledOutputTokens : 'unreported',
            timeToFirstTokenMs: aggregate.timeToFirstTokenMs > 0 ? Number(aggregate.timeToFirstTokenMs.toFixed(1)) : 'unreported',
            webLlmE2eMs: aggregate.e2eLatencyMs > 0 ? Number(aggregate.e2eLatencyMs.toFixed(1)) : 'unreported',
            webLlmDecodeSteps: aggregate.webLlmUsageSamples > 0 ? aggregate.webLlmDecodeSteps : 'unreported'
        });
    const recordCausalInference = (measurement)=>{
        if (!(0, $dl7hN.isAutocompleteDebugEnabled)()) return;
        const familyAggregate = updateCausalInferenceAggregate(causalInferenceByFamily, measurement.familyKey, measurement);
        const contextAggregate = updateCausalInferenceAggregate(causalInferenceByContext, measurement.contextKey, measurement);
        // One line plus two nested objects per LM call is heavy enough to distort
        // the latencies it reports, so keep the per-call breakdown behind verbose.
        if (!(0, $dl7hN.isAutocompleteDebugVerbose)()) return;
        // eslint-disable-next-line no-console
        console.log(`%c[CTC:model-cost]%c ${measurement.kind} ${measurement.outcome} \xb7 ${measurement.wallClockMs.toFixed(1)}ms \xb7 prompt ${measurement.promptTokens ?? '?'} tok/${measurement.promptWords} words \xb7 output ${measurement.sampledOutputTokens ?? '?'} sampled/${measurement.requestedCompletionTokens} requested \xb7 decode ${measurement.webLlmDecodeSteps ?? '?'} step${measurement.webLlmDecodeSteps === 1 ? '' : 's'} \xb7 TTFT ${measurement.timeToFirstTokenMs?.toFixed(1) ?? '?'}ms \xb7 ${measurement.warmState}`, (0, $dl7hN.CTC_STYLES).section, (0, $dl7hN.CTC_STYLES).body, {
            request: {
                contextKey: measurement.contextKey,
                familyKey: measurement.familyKey,
                kind: measurement.kind,
                outcome: measurement.outcome,
                warmState: measurement.warmState
            },
            actual: {
                decodeTokensPerSecond: measurement.decodeTokensPerSecond,
                e2eLatencyMs: measurement.e2eLatencyMs,
                prefillTokensPerSecond: measurement.prefillTokensPerSecond,
                promptTokens: measurement.promptTokens,
                promptWords: measurement.promptWords,
                sampledOutputTokens: measurement.sampledOutputTokens,
                timePerDecodeTokenMs: measurement.timePerDecodeTokenMs,
                timeToFirstTokenMs: measurement.timeToFirstTokenMs,
                wallClockMs: measurement.wallClockMs,
                webLlmDecodeSteps: measurement.webLlmDecodeSteps
            },
            context: causalAggregateForLog(contextAggregate),
            family: causalAggregateForLog(familyAggregate)
        });
    };
    /**
   * Pull the captured distribution out of the processor, timing the handover.
   *
   * Every call yields one array the width of the vocabulary. If that width is
   * large and the handover is slow, thousands of calls per session turn into
   * allocation churn that shows up as latency without any model work behind it.
   */ const captureLogits = ()=>causalLogitProcessor.getCapturedLogits();
    const createMeasuredCausalCompletion = async (activeEngine, input)=>{
        const prompt = $ae68e65f1ca82a3b$var$truncateToLastNWords(input.prompt, $ae68e65f1ca82a3b$export$93abf2f096f2bfe.MAX_CONTEXT_TOKENS);
        const promptWords = $ae68e65f1ca82a3b$var$splitOnWhitespace(prompt).length;
        const startedAt = performance.now();
        const warmState = ++causalInferenceOrdinal === 1 ? 'cold-first-call' : 'warm';
        try {
            const completion = await activeEngine.completions.create({
                model: modelId,
                prompt: prompt,
                max_tokens: input.requestedCompletionTokens,
                temperature: 0,
                logprobs: false,
                ignore_eos: true
            });
            const latencyMs = performance.now() - startedAt;
            const usage = completion.usage;
            const webLlmDecodeSteps = usage?.completion_tokens ?? null;
            // WebLLM samples the first output token during prefill, but its
            // completion_tokens usage counter increments only in decodeStep().
            // Add that prefill-sampled token back without exceeding max_tokens.
            const sampledOutputTokens = webLlmDecodeSteps === null ? null : Math.min(input.requestedCompletionTokens, webLlmDecodeSteps + 1);
            recordCausalInference({
                contextKey: input.contextKey,
                decodeTokensPerSecond: usage?.extra?.decode_tokens_per_s ?? null,
                e2eLatencyMs: usage?.extra?.e2e_latency_s !== undefined ? usage.extra.e2e_latency_s * 1000 : null,
                familyKey: input.familyKey,
                kind: input.kind,
                outcome: 'completed',
                prefillTokensPerSecond: usage?.extra?.prefill_tokens_per_s ?? null,
                promptTokens: usage?.prompt_tokens ?? null,
                promptWords: promptWords,
                requestedCompletionTokens: input.requestedCompletionTokens,
                sampledOutputTokens: sampledOutputTokens,
                timePerDecodeTokenMs: usage?.extra?.time_per_output_token_s !== undefined ? usage.extra.time_per_output_token_s * 1000 : null,
                timeToFirstTokenMs: usage?.extra?.time_to_first_token_s !== undefined ? usage.extra.time_to_first_token_s * 1000 : null,
                wallClockMs: latencyMs,
                warmState: warmState,
                webLlmDecodeSteps: webLlmDecodeSteps
            });
            return {
                latencyMs: latencyMs
            };
        } catch (error) {
            const latencyMs = performance.now() - startedAt;
            recordCausalInference({
                contextKey: input.contextKey,
                decodeTokensPerSecond: null,
                e2eLatencyMs: null,
                familyKey: input.familyKey,
                kind: input.kind,
                outcome: 'failed',
                prefillTokensPerSecond: null,
                promptTokens: null,
                promptWords: promptWords,
                requestedCompletionTokens: input.requestedCompletionTokens,
                sampledOutputTokens: null,
                timePerDecodeTokenMs: null,
                timeToFirstTokenMs: null,
                wallClockMs: latencyMs,
                warmState: warmState,
                webLlmDecodeSteps: null
            });
            throw error;
        }
    };
    const logExactEvidenceReadiness = (contextKey, familyKey, exactSurfaceCount, source)=>{
        if (!(0, $dl7hN.isAutocompleteDebugEnabled)()) return;
        const previousCount = exactEvidenceCountByContext.get(contextKey) ?? 0;
        if (exactSurfaceCount <= previousCount) return;
        setLru(exactEvidenceCountByContext, contextKey, exactSurfaceCount, $ae68e65f1ca82a3b$export$e347284e8010dda3.BOUNDARY_CACHE_MAX);
        const contextAggregate = getLru(causalInferenceByContext, contextKey);
        const familyAggregate = getLru(causalInferenceByFamily, familyKey);
        // eslint-disable-next-line no-console
        console.log(`%c[CTC:readiness]%c exact evidence \xb7 ${exactSurfaceCount} surface${exactSurfaceCount === 1 ? '' : 's'} \xb7 source=${source} \xb7 ctx=${contextKey.slice(0, 64)}`, (0, $dl7hN.CTC_STYLES).good, (0, $dl7hN.CTC_STYLES).body, {
            context: contextAggregate ? causalAggregateForLog(contextAggregate) : null,
            contextKey: contextKey,
            exactSurfaceCount: exactSurfaceCount,
            family: familyAggregate ? causalAggregateForLog(familyAggregate) : null,
            familyKey: familyKey,
            source: source
        });
    };
    const getProgressiveEvidence = (contextKey, candidateSurface, tokenIds = $ae68e65f1ca82a3b$var$surfaceTokenTrie.getTokenIds(candidateSurface) ?? [])=>{
        if (tokenIds.length === 0) return null;
        const exactKey = surfaceCacheKey(contextKey, candidateSurface, tokenIds);
        const exact = getLru(surfaceScoreCache, exactKey);
        if (exact) return {
            meanTokenLogProbabilityUpperBound: exact.meanTokenLogProbability,
            scoredTokenCount: exact.tokenCount,
            totalLogProbability: exact.totalLogProbability,
            totalTokenCount: exact.tokenCount
        };
        const boundary = getLru(boundaryCache, contextKey);
        const firstToken = tokenIds[0];
        if (!boundary || firstToken === undefined) return null;
        let totalLogProbability = (0, $eGuir.logSoftmaxAt)(boundary.rawLogits, firstToken);
        if (!Number.isFinite(totalLogProbability)) return null;
        let scoredTokenCount = 1;
        while(scoredTokenCount < tokenIds.length){
            const prefix = tokenIds.slice(0, scoredTokenCount);
            const expansion = getLru(prefixExpansionCache, prefixCacheKey(contextKey, prefix));
            if (!expansion) break;
            const nextTokenLogProbability = (0, $eGuir.logSoftmaxAt)(expansion.rawNextTokenLogits, tokenIds[scoredTokenCount]);
            if (!Number.isFinite(nextTokenLogProbability)) break;
            totalLogProbability = expansion.totalLogProbability + nextTokenLogProbability;
            scoredTokenCount++;
        }
        if (scoredTokenCount === tokenIds.length) {
            const exactScore = {
                contextKey: contextKey,
                surface: candidateSurface,
                totalLogProbability: totalLogProbability,
                meanTokenLogProbability: totalLogProbability / tokenIds.length,
                tokenCount: tokenIds.length
            };
            setLru(surfaceScoreCache, exactKey, exactScore, $ae68e65f1ca82a3b$export$e347284e8010dda3.SURFACE_CACHE_MAX);
        }
        return {
            // Every unscored future token has log probability <= 0. Dividing the
            // scored total by the final token count is therefore a safe optimistic
            // bound on the eventual mean.
            meanTokenLogProbabilityUpperBound: totalLogProbability / tokenIds.length,
            scoredTokenCount: scoredTokenCount,
            totalLogProbability: totalLogProbability,
            totalTokenCount: tokenIds.length
        };
    };
    const planProgressiveExpansion = (contextKey)=>{
        const request = progressiveRequests.get(contextKey);
        if (!request || destroyed || !boundaryCache.has(contextKey)) return;
        const eligible = request.candidates.filter((candidate)=>candidate.tokenIds.length > 0 && candidate.tokenIds.length <= $ae68e65f1ca82a3b$export$e347284e8010dda3.EXACT_MAX_TARGET_TOKENS).map((candidate)=>({
                ...candidate,
                evidence: getProgressiveEvidence(contextKey, candidate.surface, candidate.tokenIds)
            })).filter((candidate)=>candidate.evidence !== null);
        // Score candidates the way arbitration will: a posterior over sequence
        // log-likelihoods, blended with the corpus prior at the shipped weights.
        //
        // Sharing the rule is the point. Ranking on `exp(per-token mean)` instead
        // answers a different question — it favours short surfaces, because
        // dividing by fewer tokens flatters them — so this scheduler used to stop
        // reading on a margin the decision layer did not recognise, and then
        // abstain for want of the very tokens it declined to read. Nothing about
        // that was visible from either side.
        //
        // The normaliser spans every eligible candidate rather than only the
        // scheduled ones. That can only make each posterior smaller and each margin
        // narrower, so the error is always towards reading another token instead of
        // stopping early — the safe direction ahead of a precision-first gate.
        const normalizer = (0, $eGuir.logSumExp)(eligible.map((candidate)=>candidate.evidence.totalLogProbability));
        const confidenceScore = (candidate)=>(0, $cVZWR.STAGE1_WEIGHT) * (candidate.rankHint ?? 0) + (0, $cVZWR.STAGE2_WEIGHT) * (Number.isFinite(normalizer) ? Math.exp(candidate.evidence.totalLogProbability - normalizer) : 0);
        const candidates = eligible.sort((a, b)=>confidenceScore(b) - confidenceScore(a)).slice(0, $ae68e65f1ca82a3b$export$e347284e8010dda3.PROGRESSIVE_CANDIDATES_MAX);
        const unresolved = candidates.filter((candidate)=>candidate.evidence.scoredTokenCount < candidate.tokenIds.length);
        if (unresolved.length === 0) {
            logProgressiveState('completed', `ctx=${contextKey.slice(0, 48)} \xb7 exact=${candidates.length}/${candidates.length}`);
            return;
        }
        const bestExactScore = Math.max(...candidates.filter((candidate)=>candidate.evidence.scoredTokenCount === candidate.tokenIds.length).map(confidenceScore), -Infinity);
        const bestUnresolvedScore = Math.max(...unresolved.map(confidenceScore), -Infinity);
        if (bestExactScore - bestUnresolvedScore >= (0, $cVZWR.MIN_WINNER_MARGIN)) {
            logProgressiveState('completed', `safe bound \xb7 ctx=${contextKey.slice(0, 40)} \xb7 margin=${(bestExactScore - bestUnresolvedScore).toFixed(2)} \xb7 unresolved=${unresolved.length}`);
            return;
        }
        const groups = $ae68e65f1ca82a3b$var$surfaceTokenTrie.groupByScoredPrefix(unresolved.map((candidate)=>({
                surface: candidate.surface,
                tokenIds: candidate.tokenIds,
                scoredTokenCount: candidate.evidence.scoredTokenCount
            })));
        const bySurface = new Map(candidates.map((candidate)=>[
                candidate.surface,
                candidate
            ]));
        const rankedGroups = groups.map((group)=>{
            const members = group.surfaces.map((candidateSurface)=>bySurface.get(candidateSurface)).filter((candidate)=>Boolean(candidate));
            const optimisticScore = Math.max(...members.map(confidenceScore));
            return {
                ...group,
                optimisticScore: optimisticScore
            };
        }).sort((a, b)=>b.optimisticScore - a.optimisticScore);
        const bestGroup = rankedGroups[0];
        if (!bestGroup) return;
        const warmGroup = kvContextKey === contextKey ? rankedGroups.find((group)=>isPrefixOf(kvPath, group.tokenPrefix)) : undefined;
        const nextGroup = warmGroup && warmGroup.optimisticScore >= bestGroup.optimisticScore - $ae68e65f1ca82a3b$var$PROGRESSIVE_WARM_PATH_MARGIN ? warmGroup : bestGroup;
        const contextPrefixes = progressivePrefixesByContext.get(contextKey) ?? new Set();
        progressivePrefixesByContext.set(contextKey, contextPrefixes);
        const key = prefixCacheKey(contextKey, nextGroup.tokenPrefix);
        if (getLru(prefixExpansionCache, key)) {
            logProgressiveState('cached', `ctx=${contextKey.slice(0, 40)} \xb7 prefix=[${nextGroup.tokenPrefix.join(',')}]`);
            planProgressiveExpansion(contextKey);
            return;
        }
        if (pendingPrefixExpansions.has(key) || inFlightPrefixExpansions.has(key)) {
            logProgressiveState('deduplicated', `ctx=${contextKey.slice(0, 40)} \xb7 prefix=[${nextGroup.tokenPrefix.join(',')}]`);
            return;
        }
        if (contextPrefixes.size >= $ae68e65f1ca82a3b$export$e347284e8010dda3.PROGRESSIVE_EXPANSIONS_PER_CONTEXT_MAX) {
            logProgressiveState('completed', `ctx=${contextKey.slice(0, 48)} \xb7 expansion cap=${contextPrefixes.size} \xb7 unresolved=${unresolved.length}`);
            return;
        }
        contextPrefixes.add(key);
        pendingPrefixExpansions.set(key, {
            contextKey: contextKey,
            familyKey: request.familyKey,
            prompt: request.prompt,
            tokenPrefix: nextGroup.tokenPrefix,
            surfaces: nextGroup.surfaces
        });
        logProgressiveState('queued', `ctx=${contextKey.slice(0, 40)} \xb7 prefix=[${nextGroup.tokenPrefix.join(',')}] \xb7 surfaces=${nextGroup.surfaces.length}`);
        drainCausalQueue();
    };
    /**
   * Prefill `prompt` and cache the boundary distribution that follows it.
   *
   * A text completion resets the KV cache before prefilling, so asking for a
   * single token leaves the cache holding exactly the prompt. That is the
   * anchor every later decode step extends.
   */ const prefillBoundary = async (activeEngine, request)=>{
        kvContextKey = null;
        kvPath = [];
        causalRequestsThisFamily++;
        causalGeneratedTokensThisFamily++;
        causalLogitProcessor.startCapture();
        const { latencyMs: latencyMs } = await createMeasuredCausalCompletion(activeEngine, {
            contextKey: request.contextKey,
            familyKey: request.familyKey,
            kind: 'boundary',
            prompt: request.prompt,
            requestedCompletionTokens: 1
        });
        const rawLogits = captureLogits();
        if (!rawLogits) return null;
        setLru(boundaryCache, request.contextKey, {
            contextKey: request.contextKey,
            prompt: request.prompt,
            rawLogits: rawLogits
        }, $ae68e65f1ca82a3b$export$e347284e8010dda3.BOUNDARY_CACHE_MAX);
        kvContextKey = request.contextKey;
        kvPath = [];
        return {
            latencyMs: latencyMs,
            rawLogits: rawLogits
        };
    };
    /**
   * Append one token to the KV cache and return the distribution that follows.
   *
   * This deliberately bypasses the completion API: a completion would reset the
   * cache and re-prefill the whole prompt, whereas this forwards a single token
   * on top of the work already done.
   */ const decodeOneToken = async (activeEngine, token)=>{
        causalLogitProcessor.startCapture();
        try {
            // The engine also holds the embedder, so it refuses to forward unless
            // the caller says which model to forward through.
            await activeEngine.forwardTokensAndSample([
                token
            ], false, modelId);
        } catch (error) {
            kvContextKey = null;
            kvPath = [];
            throw error;
        }
        causalRequestsThisFamily++;
        causalGeneratedTokensThisFamily++;
        return captureLogits();
    };
    const runBoundaryPrime = async (request)=>{
        if (!engine || destroyed) return;
        const primed = await prefillBoundary(engine, request);
        if (!primed) return;
        const { latencyMs: latencyMs, rawLogits: rawLogits } = primed;
        planProgressiveExpansion(request.contextKey);
        const progressiveRequest = progressiveRequests.get(request.contextKey);
        const exactSurfaceCount = progressiveRequest?.candidates.filter((candidate)=>{
            const evidence = getProgressiveEvidence(request.contextKey, candidate.surface, candidate.tokenIds);
            return evidence !== null && evidence.scoredTokenCount === evidence.totalTokenCount;
        }).length ?? 0;
        logExactEvidenceReadiness(request.contextKey, progressiveRequest?.familyKey ?? request.familyKey, exactSurfaceCount, 'boundary');
        if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
        console.log(`%c[CTC:model] %c\u{1F9E0} Tier A prime #${request.priority + 1} \xb7 ctx=${request.contextKey.slice(0, 48)} \xb7 ${rawLogits.length} logits \xb7 ${latencyMs.toFixed(0)}ms \xb7 family req:${causalRequestsThisFamily} tok:${causalGeneratedTokensThisFamily} A hit/miss:${tierAPrimeCacheHitsThisFamily}/${tierAPrimeCacheMissesThisFamily}`, 'color: #9c27b0; font-weight: bold;', 'color: #2196f3;');
        const callbackFamilyKey = progressiveRequests.get(request.contextKey)?.familyKey ?? request.familyKey;
        if (callbackFamilyKey === latestCausalFamilyKey && !destroyed) onBoundaryLmUpdate?.({
            contextKey: request.contextKey,
            familyKey: callbackFamilyKey,
            latencyMs: latencyMs
        });
    };
    const runPrefixExpansion = async (request)=>{
        if (!engine || destroyed) return;
        const activeEngine = engine;
        const startedAt = performance.now();
        logProgressiveState('started', `ctx=${request.contextKey.slice(0, 40)} \xb7 prefix=[${request.tokenPrefix.join(',')}] \xb7 surfaces=${request.surfaces.length}`);
        // Resume from whatever the KV cache already holds for this context, and
        // fall back to a prompt prefill only when the requested prefix branches
        // away from it.
        let logitsAtPath = null;
        let totalAtPath = 0;
        const pathIsLive = extendsLiveKvPath(request);
        if (pathIsLive) {
            if (kvPath.length === 0) logitsAtPath = getLru(boundaryCache, request.contextKey)?.rawLogits ?? null;
            else {
                const resume = getLru(prefixExpansionCache, prefixCacheKey(request.contextKey, kvPath));
                logitsAtPath = resume?.rawNextTokenLogits ?? null;
                totalAtPath = resume?.totalLogProbability ?? 0;
            }
        }
        if (!logitsAtPath) {
            const primed = await prefillBoundary(activeEngine, request);
            if (!primed) {
                logProgressiveState('failed', `ctx=${request.contextKey.slice(0, 40)} \xb7 prefix=[${request.tokenPrefix.join(',')}] \xb7 missing boundary logits`);
                return;
            }
            logitsAtPath = primed.rawLogits;
            totalAtPath = 0;
        }
        // Walking the path caches every depth along it, not just the requested
        // one, so a later expansion that shares this prefix costs nothing.
        const contextPrefixes = progressivePrefixesByContext.get(request.contextKey) ?? new Set();
        progressivePrefixesByContext.set(request.contextKey, contextPrefixes);
        for(let index = kvPath.length; index < request.tokenPrefix.length; index++){
            const token = request.tokenPrefix[index];
            if (token === undefined) break;
            const stepLogProbability = (0, $eGuir.logSoftmaxAt)(logitsAtPath, token);
            if (!Number.isFinite(stepLogProbability)) {
                logProgressiveState('failed', `ctx=${request.contextKey.slice(0, 40)} \xb7 prefix=[${request.tokenPrefix.join(',')}] \xb7 token ${token} unscoreable`);
                return;
            }
            // eslint-disable-next-line no-await-in-loop
            const nextLogits = await decodeOneToken(activeEngine, token);
            if (!nextLogits || destroyed) {
                kvContextKey = null;
                kvPath = [];
                logProgressiveState('failed', `ctx=${request.contextKey.slice(0, 40)} \xb7 prefix=[${request.tokenPrefix.join(',')}] \xb7 missing logits`);
                return;
            }
            kvContextKey = request.contextKey;
            kvPath = [
                ...kvPath,
                token
            ];
            totalAtPath += stepLogProbability;
            logitsAtPath = nextLogits;
            const stepKey = prefixCacheKey(request.contextKey, kvPath);
            const expansion = {
                contextKey: request.contextKey,
                tokenPrefix: [
                    ...kvPath
                ],
                totalLogProbability: totalAtPath,
                rawNextTokenLogits: nextLogits
            };
            setLru(prefixExpansionCache, stepKey, expansion, $ae68e65f1ca82a3b$export$e347284e8010dda3.PREFIX_CACHE_MAX);
            contextPrefixes.add(stepKey);
        }
        const latencyMs = performance.now() - startedAt;
        const progressiveRequest = progressiveRequests.get(request.contextKey);
        let newlyExact = 0;
        let exactSurfaceCount = 0;
        if (progressiveRequest) for (const candidate of progressiveRequest.candidates){
            const exactKey = surfaceCacheKey(request.contextKey, candidate.surface, candidate.tokenIds);
            const wasExact = surfaceScoreCache.has(exactKey);
            const evidence = getProgressiveEvidence(request.contextKey, candidate.surface, candidate.tokenIds);
            if (!wasExact && evidence !== null && evidence.scoredTokenCount === evidence.totalTokenCount && surfaceScoreCache.has(exactKey)) newlyExact++;
            if (evidence !== null && evidence.scoredTokenCount === evidence.totalTokenCount) exactSurfaceCount++;
        }
        logExactEvidenceReadiness(request.contextKey, progressiveRequest?.familyKey ?? request.familyKey, exactSurfaceCount, 'prefix');
        logProgressiveState('expanded', `ctx=${request.contextKey.slice(0, 40)} \xb7 prefix=[${request.tokenPrefix.join(',')}] \xb7 exact+${newlyExact} \xb7 ${latencyMs.toFixed(0)}ms`);
        planProgressiveExpansion(request.contextKey);
        const callbackFamilyKey = progressiveRequests.get(request.contextKey)?.familyKey ?? request.familyKey;
        if (callbackFamilyKey === latestCausalFamilyKey && !destroyed) onSurfaceScoreUpdate?.({
            contextKey: request.contextKey,
            count: newlyExact,
            familyKey: callbackFamilyKey,
            latencyMs: latencyMs
        });
        else logProgressiveState('stale', `cached only \xb7 ctx=${request.contextKey.slice(0, 40)} \xb7 family=${request.familyKey.slice(0, 32)}`);
    };
    /**
   * Whether any live decision would still take this request's result.
   *
   * Ranking on the family a request was created under, as this used to, misses
   * in both directions. Work queued a keystroke ago for a context still under
   * the cursor sorts as stale even though the callbacks resolve delivery
   * through `progressiveRequests` and would hand it over. Work for a context
   * nothing asks about any more sorts as runnable even though the same
   * resolution drops it on arrival — and that one is expensive, because an
   * abandoned context is never the one the KV cache holds, so running it pays
   * a prompt prefill and leaves the live context evicted, charging the next
   * live request a second prefill. Two prefills for a discarded result.
   *
   * Either signal alone is enough to keep the work, which matters because a
   * boundary prime is queued before its context's surfaces are requested: at
   * that moment the stored family is still the previous decision's, and only
   * the request's own family says it is current.
   *
   * Agreeing with the layer being fed is the correction the expansion planner
   * already carries for arbitration's scoring rule — a scheduler deciding on
   * its own rule stops on margins the consumer does not recognise.
   */ const stillWanted = (request)=>request.familyKey === latestCausalFamilyKey || progressiveRequests.get(request.contextKey)?.familyKey === latestCausalFamilyKey;
    const drainCausalQueue = ()=>{
        if (causalInFlight || destroyed) return;
        // Drop abandoned work rather than leaving it to be picked up whenever the
        // live family happens to have nothing queued. Its cached side effects are
        // speculative — they only pay off if the user deletes back into exactly
        // this context and prefix — and the prefill pair above is certain.
        for (const [key, request] of pendingPrefixExpansions)if (!stillWanted(request)) pendingPrefixExpansions.delete(key);
        for (const [contextKey, request] of pendingBoundaryPrimes)if (!stillWanted(request)) pendingBoundaryPrimes.delete(contextKey);
        const sortedPrimes = Array.from(pendingBoundaryPrimes.values()).sort((a, b)=>a.priority - b.priority);
        // Everything left is wanted, so relevance no longer needs a sort key.
        // Take whichever request continues the live sequence: that expansion costs
        // one decode step where any other costs a full prompt prefill, and nothing
        // is skipped, only reordered.
        //
        // Staying inside the live context when nothing continues it was tried and
        // reverted. It moved re-primes from `reprime-context` to `reprime-branch`
        // and left the total flat, because both pay for a prompt prefill: a
        // context whose remaining prefixes diverge at the first token re-primes as
        // a branch instead of as a context. Ordering cannot recover that; only
        // queueing fewer divergent branches can, which is what the prune above
        // does.
        const sortedPrefixes = Array.from(pendingPrefixExpansions.values()).sort((a, b)=>Number(extendsLiveKvPath(b)) - Number(extendsLiveKvPath(a)));
        const nextPrefix = sortedPrefixes[0];
        const nextPrime = nextPrefix ? undefined : sortedPrimes[0];
        if (!nextPrefix && !nextPrime) return;
        causalInFlight = true;
        let prefixKey = null;
        if (nextPrefix) {
            prefixKey = prefixCacheKey(nextPrefix.contextKey, nextPrefix.tokenPrefix);
            pendingPrefixExpansions.delete(prefixKey);
            inFlightPrefixExpansions.add(prefixKey);
        } else if (nextPrime) {
            pendingBoundaryPrimes.delete(nextPrime.contextKey);
            inFlightBoundaryContextKey = nextPrime.contextKey;
        }
        ensureEngineInitialized().then(()=>nextPrefix ? runPrefixExpansion(nextPrefix) : nextPrime ? runBoundaryPrime(nextPrime) : undefined).catch((error)=>{
            if (nextPrefix) logProgressiveState('failed', `ctx=${nextPrefix.contextKey.slice(0, 40)} \xb7 prefix=[${nextPrefix.tokenPrefix.join(',')}] \xb7 ${error instanceof Error ? error.message : String(error)}`);
            if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
            console.log(`%c[CTC:model] %c\u{274C} canonical causal request failed: ${error instanceof Error ? error.message : String(error)}`, 'color: #9c27b0; font-weight: bold;', 'color: #f44336;');
        }).finally(()=>{
            if (prefixKey) inFlightPrefixExpansions.delete(prefixKey);
            if (nextPrime) inFlightBoundaryContextKey = null;
            causalInFlight = false;
            drainCausalQueue();
        });
    };
    // ── Context update (debounced) ─────────────────────────────────────────
    const startInference = (text, requestId)=>{
        // Self-contained guard: never start a new inference cycle after teardown,
        // regardless of caller discipline.
        if (destroyed) return;
        inferenceInFlight = true;
        activeInferenceText = text;
        activeInferenceRequestId = requestId;
        ensureEngineInitialized().then(()=>runInference(text, requestId)).catch(()=>{}).finally(()=>{
            inferenceInFlight = false;
            activeInferenceText = null;
            activeInferenceRequestId = -1;
            const next = pendingInference;
            pendingInference = null;
            if (next && !destroyed) startInference(next.text, next.requestId);
        });
    };
    const doUpdateContext = (text)=>{
        if (destroyed || !text || text.trim().length === 0) return;
        if (inferenceInFlight && text === activeInferenceText) {
            // The latest desired text already matches the in-flight inference, so
            // re-running it would be wasted work. But an intermediate keystroke may
            // have bumped `latestRequestId` past the in-flight request (and then been
            // coalesced away), which would cause runInference to discard the
            // still-current result as stale. Pin `latestRequestId` back to the active
            // request so its result is accepted, and drop any now-superseded pending
            // request.
            latestRequestId = activeInferenceRequestId;
            pendingInference = null;
            return;
        }
        if (inferenceInFlight && pendingInference?.text === text) return;
        const requestId = ++requestCounter;
        latestRequestId = requestId;
        if ((0, $dl7hN.isAutocompleteDebugEnabled)()) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(`%c[CTC:model] %c\u{1F4E4} Context update (request #${requestId}) | ${text.length} chars`, 'color: #9c27b0; font-weight: bold;', 'color: inherit;');
            const lines = text.split('\n');
            lines.forEach((line, i)=>{
                // eslint-disable-next-line no-console
                console.log(`  ${i === lines.length - 1 ? "\u25B6" : ' '} ${line}`);
            });
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        if (inferenceInFlight) {
            pendingInference = {
                text: text,
                requestId: requestId
            };
            return;
        }
        startInference(text, requestId);
    };
    const updateContextDebounced = (text)=>{
        if (debounceTimer) clearTimeout(debounceTimer);
        if (inferenceInFlight) {
            pendingInference = null;
            if (text === activeInferenceText) {
                latestRequestId = activeInferenceRequestId;
                lastRequestedText = text;
                return;
            }
        }
        lastRequestedText = text;
        debounceTimer = setTimeout(()=>{
            debounceTimer = null;
            doUpdateContext(lastRequestedText);
        }, debounceMs);
    };
    const setLatestCausalFamily = (familyKey)=>{
        if (familyKey === latestCausalFamilyKey) return;
        latestCausalFamilyKey = familyKey;
        causalRequestsThisFamily = 0;
        causalGeneratedTokensThisFamily = 0;
        tierAPrimeCacheHitsThisFamily = 0;
        tierAPrimeCacheMissesThisFamily = 0;
    };
    const primeBoundaryLm = (input)=>{
        if (destroyed) return;
        setLatestCausalFamily(input.familyKey);
        if (getLru(boundaryCache, input.contextKey)) {
            tierAPrimeCacheHitsThisFamily++;
            if ((0, $dl7hN.isAutocompleteDebugVerbose)()) // eslint-disable-next-line no-console
            console.log(`%c[CTC:model] %c\u{26A1} Tier A cache hit \xb7 ctx=${input.contextKey.slice(0, 48)}`, 'color: #9c27b0; font-weight: bold;', 'color: #2196f3;');
            return;
        }
        if (pendingBoundaryPrimes.has(input.contextKey) || inFlightBoundaryContextKey === input.contextKey) {
            logProgressiveState('deduplicated', `boundary \xb7 ctx=${input.contextKey.slice(0, 48)}`);
            return;
        }
        if (pendingBoundaryPrimes.size >= $ae68e65f1ca82a3b$export$e347284e8010dda3.TIER_A_PRIMES_MAX) {
            const stalePending = Array.from(pendingBoundaryPrimes.entries()).find(([, request])=>request.familyKey !== latestCausalFamilyKey);
            if (stalePending) {
                pendingBoundaryPrimes.delete(stalePending[0]);
                logProgressiveState('stale', `dropped unstarted boundary \xb7 ctx=${stalePending[0].slice(0, 48)}`);
            }
        }
        if (pendingBoundaryPrimes.size < $ae68e65f1ca82a3b$export$e347284e8010dda3.TIER_A_PRIMES_MAX) {
            tierAPrimeCacheMissesThisFamily++;
            pendingBoundaryPrimes.set(input.contextKey, input);
        }
        drainCausalQueue();
    };
    const requestProgressiveSurfaceScores = (input)=>{
        if (destroyed) return;
        setLatestCausalFamily(input.familyKey);
        const candidates = input.candidates.filter((candidate)=>candidate.tokenIds.length > 0 && candidate.tokenIds.length <= $ae68e65f1ca82a3b$export$e347284e8010dda3.EXACT_MAX_TARGET_TOKENS).slice(0, $ae68e65f1ca82a3b$export$e347284e8010dda3.PROGRESSIVE_INPUT_MAX);
        if (candidates.length === 0) return;
        const previous = progressiveRequests.get(input.contextKey);
        const candidateSignature = candidates.map((candidate)=>`${candidate.surface}:${candidate.tokenIds.join(',')}`).join('\u0001');
        const previousSignature = previous?.candidates.map((candidate)=>`${candidate.surface}:${candidate.tokenIds.join(',')}`).join('\u0001');
        setLru(progressiveRequests, input.contextKey, {
            ...input,
            candidates: candidates
        }, $ae68e65f1ca82a3b$export$e347284e8010dda3.BOUNDARY_CACHE_MAX);
        for (const cachedContextKey of progressivePrefixesByContext.keys())if (!progressiveRequests.has(cachedContextKey)) progressivePrefixesByContext.delete(cachedContextKey);
        const cachedProgressCount = candidates.filter((candidate)=>{
            const evidence = getProgressiveEvidence(input.contextKey, candidate.surface, candidate.tokenIds);
            return evidence !== null && (evidence.scoredTokenCount > 1 || evidence.scoredTokenCount === evidence.totalTokenCount);
        }).length;
        if (cachedProgressCount > 0) logProgressiveState('cached', `ctx=${input.contextKey.slice(0, 40)} \xb7 surfaces=${cachedProgressCount}/${candidates.length}`);
        if (candidateSignature === previousSignature) logProgressiveState('deduplicated', `candidate set \xb7 ctx=${input.contextKey.slice(0, 40)} \xb7 surfaces=${candidates.length}`);
        else logProgressiveState('queued', `candidate set \xb7 ctx=${input.contextKey.slice(0, 40)} \xb7 surfaces=${candidates.length}`);
        planProgressiveExpansion(input.contextKey);
    };
    // ── Public API (same shape as createSlowLaneClient) ────────────────────
    return {
        updateContext: updateContextDebounced,
        getBoundaryLmState: (contextKey)=>getLru(boundaryCache, contextKey),
        getCanonicalSurfaceTokenIds: (candidateSurface)=>$ae68e65f1ca82a3b$var$surfaceTokenTrie.getTokenIds(candidateSurface),
        getCanonicalSurfaceCount: ()=>$ae68e65f1ca82a3b$var$surfaceTokenIds.size,
        getContextInput: ()=>storedContextInput,
        getContextVector: ()=>storedContextVector,
        getLmLogits: ()=>storedLmLogits,
        getProgressiveSurfaceEvidence: (contextKey, candidateSurface)=>getProgressiveEvidence(contextKey, candidateSurface),
        getSurfaceScore: (contextKey, candidateSurface)=>getLru(surfaceScoreCache, surfaceCacheKey(contextKey, candidateSurface)),
        setContextVector: (vector)=>{
            storedContextInput = null;
            storedContextVector = vector;
        },
        setLmLogits: (logits)=>{
            storedLmLogits = logits;
        },
        primeBoundaryLm: primeBoundaryLm,
        requestProgressiveSurfaceScores: requestProgressiveSurfaceScores,
        isWordBoundary: $gpRHn.isWordBoundary,
        isReady: ()=>ready,
        destroy: ()=>{
            destroyed = true;
            ready = false;
            if (debounceTimer) clearTimeout(debounceTimer);
            if (engine) {
                const engineToUnload = engine;
                engine = null;
                unloadEngine(engineToUnload);
            }
            engineInitPromise = null;
            inferenceInFlight = false;
            activeInferenceText = null;
            activeInferenceRequestId = -1;
            pendingInference = null;
            storedContextInput = null;
            storedContextVector = null;
            storedLmLogits = null;
            causalInFlight = false;
            inFlightBoundaryContextKey = null;
            kvContextKey = null;
            kvPath = [];
            latestCausalFamilyKey = '';
            pendingBoundaryPrimes.clear();
            pendingPrefixExpansions.clear();
            inFlightPrefixExpansions.clear();
            progressiveRequests.clear();
            progressivePrefixesByContext.clear();
            boundaryCache.clear();
            causalInferenceByContext.clear();
            causalInferenceByFamily.clear();
            exactEvidenceCountByContext.clear();
            prefixExpansionCache.clear();
            surfaceScoreCache.clear();
            causalLogitProcessor.resetState();
        }
    };
};









var $6PkRt = parcelRequire("6PkRt");

const $f4538d6150bdc15e$export$7f2aa48dd1e99876 = new (0, $kCECX.PluginKey)('autocomplete');
const $f4538d6150bdc15e$var$PREDICTION_COALESCE_MS = 0;
const $f4538d6150bdc15e$var$GHOST_DECISION_BUDGET_MS = 100;
const $f4538d6150bdc15e$var$NETWORK_SLOW_LANE_DEBOUNCE_MS = 300;
const $f4538d6150bdc15e$var$LOCAL_SLOW_LANE_DEBOUNCE_MS = 100;
const $f4538d6150bdc15e$var$CONTEXT_REFRESH_THROTTLE_MS = 1000;
// Caps the dedup Set so long editing sessions don't retain every distinct
// version of the (potentially hundreds-of-KB) page content for the plugin's
// lifetime. Eviction is FIFO; a re-ingest of an evicted text is harmless.
const $f4538d6150bdc15e$var$MAX_INGESTED_CONTEXT_TEXTS = 50;
// Re-prime callback of every mounted editor. The harvested set and the L1
// boosts are shared by all of them, and more than one is mounted routinely — a
// comment box alongside its replies, or a comment box alongside the chat input.
// Membership doubles as the mount count, so a teardown only clears the shared
// stores once the last editor has gone.
//
// Decision: one pot, shared across hosts. Terms harvested in a comment box can
// be offered in the chat input and the other way round. Both are content from
// the page the reader is looking at, so the mixing is between things they can
// already see; partitioning the boosts would mean a per-host overlay on every
// trie node, which the scoring path reads on every keystroke.
const $f4538d6150bdc15e$var$mountedEditors = new Set();
// The scope that shared learning belongs to, as last reported by a host that
// scopes its context. Held here rather than per editor because the data it
// guards is shared and some hosts replace one editor with another across a
// navigation: an instance-local key would read as unset on exactly the change it
// exists to catch, while the previous scope's terms carried on in these globals.
// Undefined until a scoping host says otherwise. An editor that sends no key
// still shares the pot being emptied, so it is re-primed from the context it
// already holds rather than left with learning it can no longer see.
let $f4538d6150bdc15e$var$contextScopeKey;
// Set by whichever editor first finished importing the harvester chunk. The
// reset paths go through this rather than their own copy, because the editor
// that has to clear the set is not always one that imported it — the set is one
// per module, and nothing can be in it unless some editor got this far.
let $f4538d6150bdc15e$var$loadedInlineCodeHarvester = null;
// Caps how many times the word-boundary path will retry getContext() while the
// parent comment is still missing. Combined with the 1s throttle this gives a
// ~5s window to cover a still-loading comment thread, then stops permanently so
// non-comment editors (where parentCommentContent never arrives) don't refetch
// on every word boundary for the plugin's lifetime.
const $f4538d6150bdc15e$var$MAX_CONTEXT_REFRESH_ATTEMPTS = 5;
const $f4538d6150bdc15e$var$INLINE_LEAF_TEXT = ' ';
let $f4538d6150bdc15e$var$slowLaneClientInstanceSequence = 0;
// eslint-disable-next-line require-unicode-regexp
const $f4538d6150bdc15e$var$WORD_BOUNDARY_CHARS_REGEX = /[\s.,;:!?]/;
const $f4538d6150bdc15e$var$TRAILING_SURFACE_PREFIX_REGEX = RegExp("[\\p{L}\\p{N}_'-]+$", "u");
const $f4538d6150bdc15e$var$hasDestroy = (client)=>'destroy' in client && typeof client.destroy === 'function';
const $f4538d6150bdc15e$var$createInitialState = ()=>({
        ghostText: '',
        ghostPosition: -1,
        decorationSet: (0, $8nvEM.DecorationSet).empty,
        suggestion: null
    });
const $f4538d6150bdc15e$var$clearGhostState = (pluginState)=>({
        ...pluginState,
        ghostText: '',
        ghostPosition: -1,
        decorationSet: (0, $8nvEM.DecorationSet).empty,
        suggestion: null
    });
/**
 * Keep a displayed ghost alive when the user types the character it already
 * predicted.
 *
 * Clearing on every document change throws away a suggestion the keystroke just
 * confirmed, and the replacement decision has to re-earn it from an empty state
 * inside the budget — which it often misses, so the ghost blinks out mid-word.
 * It is worse for multi-word surfaces: typing the space in `machine learning`
 * empties the current word, and the display gate refuses to show anything again
 * until three characters of `learning` exist.
 *
 * A confirming keystroke is not new information about the prediction, so the
 * ghost simply advances by one character and the still-running decision is free
 * to replace it with something better. Anything else — a different character,
 * a paste, a deletion, an edit elsewhere — clears as before.
 */ const $f4538d6150bdc15e$var$advanceGhostThroughTypedCharacter = (tr, pluginState)=>{
    const { ghostPosition: ghostPosition, ghostText: ghostText, suggestion: suggestion } = pluginState;
    if (ghostText.length < 2 || ghostPosition < 0 || !suggestion) // A one-character tail leaves nothing to show after advancing.
    return null;
    // Exactly one character longer, with the cursor sitting just past the ghost
    // anchor: together these identify a single insertion made at the anchor
    // rather than a paste or an edit elsewhere in the document.
    if (tr.doc.content.size - tr.before.content.size !== 1) return null;
    if (!tr.selection.empty || tr.selection.from !== ghostPosition + 1) return null;
    if (tr.doc.textBetween(ghostPosition, ghostPosition + 1) !== ghostText[0]) return null;
    const remaining = ghostText.slice(1);
    const nextPosition = ghostPosition + 1;
    return {
        ...pluginState,
        ghostText: remaining,
        ghostPosition: nextPosition,
        decorationSet: (0, $f43e491c0e6eeee7$export$6a85b5542ba7ed73)(tr.doc, nextPosition, remaining),
        // `surface` stays the full candidate so cooldown and analytics still
        // describe the suggestion that was originally committed. The replaced
        // prefix grows with the keystroke: it is the run the insertion overwrites,
        // and the user has just typed one more character of it.
        suggestion: {
            ...suggestion,
            ghostText: remaining,
            position: nextPosition,
            ...suggestion.replacesTypedPrefixLength === undefined ? {} : {
                replacesTypedPrefixLength: suggestion.replacesTypedPrefixLength + 1
            }
        }
    };
};
/**
 * Extract text content before the cursor from the current document.
 * Returns the last ~200 characters for context.
 */ const $f4538d6150bdc15e$var$getTextBeforeCursor = (state)=>{
    const { $from: $from } = state.selection;
    const maxChars = 200;
    const blockNode = $from.parent;
    const offsetInBlock = $from.parentOffset;
    // PM offsets count inline leaf nodes; textContent indices do not.
    const blockText = blockNode.textBetween(0, offsetInBlock, undefined, $f4538d6150bdc15e$var$INLINE_LEAF_TEXT);
    if (blockText.length >= maxChars) return blockText.slice(-maxChars);
    let fullText = blockText;
    // Walk backwards through previous blocks until we have enough context.
    let depth = $from.depth - 1;
    while(fullText.length < maxChars && depth >= 0){
        const parentNode = $from.node(depth);
        const indexInParent = $from.index(depth);
        for(let i = indexInParent - 1; i >= 0 && fullText.length < maxChars; i--){
            const sibling = parentNode.child(i);
            const siblingText = sibling.textBetween(0, sibling.content.size, '\n', $f4538d6150bdc15e$var$INLINE_LEAF_TEXT);
            fullText = siblingText + '\n' + fullText;
        }
        depth--;
    }
    return fullText.slice(-maxChars);
};
const $f4538d6150bdc15e$var$getTrailingSurfaceToken = (text)=>text.trimEnd().match($f4538d6150bdc15e$var$TRAILING_SURFACE_PREFIX_REGEX)?.[0] ?? '';
const $f4538d6150bdc15e$var$getTrailingSurfacePrefixLength = (text)=>$f4538d6150bdc15e$var$getTrailingSurfaceToken(text).length;
/**
 * Set the autocomplete state via a transaction metadata.
 */ const $f4538d6150bdc15e$var$setAutocompleteMeta = (tr, meta)=>{
    return tr.setMeta($f4538d6150bdc15e$export$7f2aa48dd1e99876, meta);
};
/**
 * Apply a ghost text suggestion to the editor state.
 */ let $f4538d6150bdc15e$var$lastShownGhostText = '';
const $f4538d6150bdc15e$var$showGhostText = (view, prediction, position, revision, decisionStartedAt, replacesTypedPrefixLength)=>{
    try {
        const { state: state, dispatch: dispatch } = view;
        const suggestion = {
            ...replacesTypedPrefixLength === undefined ? {} : {
                replacesTypedPrefixLength: replacesTypedPrefixLength
            },
            decisionLatencyMs: performance.now() - decisionStartedAt,
            evidenceTier: prediction.evidenceTier,
            ghostText: prediction.text,
            meanTokenLogProbability: prediction.meanTokenLogProbability,
            poolHeldExtension: prediction.poolHeldExtension,
            position: position,
            posterior: prediction.posterior,
            rankScore: prediction.rankScore,
            revision: revision,
            shortlistSize: prediction.shortlistSize,
            surface: prediction.surface,
            termType: prediction.termType,
            winnerMargin: prediction.winnerMargin
        };
        const decorationSet = (0, $f43e491c0e6eeee7$export$6a85b5542ba7ed73)(state.doc, position, prediction.text);
        const tr = $f4538d6150bdc15e$var$setAutocompleteMeta(state.tr, {
            ghostText: prediction.text,
            ghostPosition: position,
            decorationSet: decorationSet,
            suggestion: suggestion
        });
        dispatch(tr);
        return suggestion;
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-autocomplete/showGhostText'
        });
        return null;
    }
};
/**
 * Clear the current ghost text from the editor.
 */ const $f4538d6150bdc15e$var$clearGhostText = (state, dispatch)=>{
    const pluginState = $f4538d6150bdc15e$export$7f2aa48dd1e99876.getState(state);
    if (!pluginState || !pluginState.ghostText) return false;
    if (dispatch) try {
        const tr = $f4538d6150bdc15e$var$setAutocompleteMeta(state.tr, {
            ghostText: '',
            ghostPosition: -1,
            decorationSet: (0, $8nvEM.DecorationSet).empty,
            suggestion: null
        });
        dispatch(tr);
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-autocomplete/clearGhostText'
        });
        return false;
    }
    return true;
};
/**
 * Accept the current ghost text suggestion and insert it into the document.
 */ const $f4538d6150bdc15e$var$acceptGhostText = (state, dispatch)=>{
    const pluginState = $f4538d6150bdc15e$export$7f2aa48dd1e99876.getState(state);
    if (!pluginState?.suggestion || !pluginState.ghostText) return null;
    if (dispatch) try {
        const { ghostText: ghostText, ghostPosition: ghostPosition, suggestion: suggestion } = pluginState;
        // Replacing back over the typed prefix rewrites it in the surface's own
        // casing; every other path appends and leaves the prefix untouched.
        const replaceFrom = Math.max(0, ghostPosition - Math.min(suggestion.replacesTypedPrefixLength ?? 0, ghostPosition));
        let tr = state.tr;
        if (replaceFrom === ghostPosition) tr = tr.insertText(ghostText, ghostPosition);
        else {
            tr = tr.insertText(suggestion.surface, replaceFrom, ghostPosition);
            // Only the harvested path replaces, and what authorized it was the
            // surface being marked as code somewhere in the session. Inserting it
            // as plain text loses that, so the identifier the user accepted reads
            // as prose while the same identifier they typed by hand does not.
            const codeMark = state.schema.marks.code;
            if (codeMark) {
                tr = tr.addMark(replaceFrom, replaceFrom + suggestion.surface.length, codeMark.create());
                // The backtick input rule never ran, so nothing else will close this
                // mark. Without dropping it from the stored set the next character
                // the user types continues the code span.
                tr = tr.removeStoredMark(codeMark);
            }
        }
        tr = $f4538d6150bdc15e$var$setAutocompleteMeta(tr, {
            ghostText: '',
            ghostPosition: -1,
            decorationSet: (0, $8nvEM.DecorationSet).empty,
            suggestion: null
        });
        dispatch(tr);
        return suggestion;
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-autocomplete/acceptGhostText'
        });
        return null;
    }
    return pluginState.suggestion;
};
const $f4538d6150bdc15e$var$acceptGhostTextWithAnalytics = (state, dispatch, onAccepted)=>{
    const acceptedSuggestion = $f4538d6150bdc15e$var$acceptGhostText(state, dispatch);
    if (acceptedSuggestion) {
        // Start the post-accept cooldown so the just-accepted unit isn't immediately
        // re-offered (QI-2 echo, e.g. `end to end` → `end to end to end`).
        (0, $6PkRt.noteSuggestionAccepted)(acceptedSuggestion.surface);
        onAccepted(acceptedSuggestion);
    }
    return acceptedSuggestion !== null;
};
/**
 * Build the text payload for the slow-lane request by prepending any available
 * comment context ahead of the live document text. This gives the backend
 * model richer context about the thread the user is writing in.
 */ const $f4538d6150bdc15e$var$buildSlowLaneText = (docText, context)=>{
    const lines = [];
    if (context?.parentCommentContent) lines.push(`comment: ${context.parentCommentContent}`);
    context?.siblingCommentsContents?.forEach((sibling, index)=>{
        lines.push(`reply ${index + 1}: ${sibling}`);
    });
    const nextReplyNumber = (context?.siblingCommentsContents?.length ?? 0) + 1;
    lines.push(`reply ${nextReplyNumber}: ${docText}`);
    return lines.join('\n');
};
const $f4538d6150bdc15e$var$createMidWordCharacterRegex = ()=>{
    try {
        // string-built regex avoids TS1501 under the package's ES5 build target
        // Ignored via go/ees019
        // eslint-disable-next-line e18e/prefer-static-regex
        return new RegExp('[\\p{L}\\p{N}_]', 'u');
    } catch  {
        return null;
    }
};
const $f4538d6150bdc15e$var$midWordCharacterRegex = $f4538d6150bdc15e$var$createMidWordCharacterRegex();
const $f4538d6150bdc15e$var$isAsciiWordCharacter = (char)=>{
    if (char === '_') return true;
    const charCode = char.charCodeAt(0);
    return charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 90 || charCode >= 97 && charCode <= 122;
};
const $f4538d6150bdc15e$var$isMidWordCharacter = (char)=>{
    if ($f4538d6150bdc15e$var$midWordCharacterRegex) return $f4538d6150bdc15e$var$midWordCharacterRegex.test(char);
    if ($f4538d6150bdc15e$var$isAsciiWordCharacter(char)) return true;
    return char.toLocaleLowerCase() !== char.toLocaleUpperCase();
};
const $f4538d6150bdc15e$var$getLeadingTextCharacter = (text)=>{
    const firstCodePoint = text?.codePointAt(0);
    if (firstCodePoint === undefined) return undefined;
    return String.fromCodePoint(firstCodePoint);
};
/**
 * The one verdict a harvested surface may speak on.
 *
 * `no-candidate` is the only abstention that means no vocabulary reaches the
 * prefix at all. Every other one — a margin the model cannot clear, a rival
 * still being read — describes known words in contention, where a session
 * surface with no score behind it would be overruling the ranker rather than
 * filling a gap it left.
 */ const $f4538d6150bdc15e$var$HARVEST_ELIGIBLE_ABSTAIN_REASON = 'no-candidate';
/**
 * Whether the scored path has finished with this exact prefix and found nothing.
 *
 * The 100ms deadline expiring is not the same answer: it means the ranker was
 * still working, and displaying then would race a suggestion that is about to
 * arrive. So the harvest path reads the recorded verdict rather than the clock.
 */ const $f4538d6150bdc15e$var$scoredPathFinishedEmpty = (textBefore)=>{
    const outcome = (0, $6PkRt.getLastPredictionOutcome)();
    return outcome !== null && outcome.textBefore === textBefore && !outcome.awaitingAsyncEvidence && outcome.abstainReason === $f4538d6150bdc15e$var$HARVEST_ELIGIBLE_ABSTAIN_REASON;
};
/**
 * Whether the surface is already sitting immediately before the typed prefix.
 *
 * Completing `ml-s` to `ml-studio` right after `ml-studio` produces the echo the
 * scored path's repetition guard exists to stop, and this path does not go
 * through arbitration to inherit it.
 */ const $f4538d6150bdc15e$var$repeatsPrecedingText = (match, textBefore)=>{
    const trimmed = textBefore.trimEnd();
    const preceding = trimmed.slice(0, trimmed.length - match.typedPrefixLength).trimEnd();
    return preceding.toLowerCase().endsWith(match.surface.toLowerCase());
};
/**
 * Dress a harvested match as a prediction so it commits through the same path as
 * a scored one.
 *
 * The scoring fields are zeroed rather than invented: there is no posterior, no
 * margin and no shortlist behind this surface, and `session-harvest` on the
 * evidence tier is what says so wherever the snapshot is read.
 */ const $f4538d6150bdc15e$var$buildHarvestPrediction = (match)=>({
        evidenceDepth: {
            totalChars: 0,
            totalTokens: 0,
            verifiedChars: 0,
            verifiedTokens: 0
        },
        evidenceTier: 'session-harvest',
        meanTokenLogProbability: 0,
        poolHeldExtension: false,
        posterior: 0,
        rankScore: 0,
        shortlistSize: 0,
        surface: match.surface,
        termType: 'word',
        text: match.ghostText,
        winnerMargin: 0
    });
const $f4538d6150bdc15e$var$isEnglishLocale = (locale)=>{
    if (!locale) return false;
    return locale.toLowerCase().startsWith('en');
};

const $f4538d6150bdc15e$export$dd9f4347413c1469 = (options, api)=>{
    const surface = options?.surface ?? 'editor';
    const locale = options?.locale ?? (typeof navigator !== 'undefined' ? navigator.language : undefined);
    const isAutocompleteEnabled = $f4538d6150bdc15e$var$isEnglishLocale(locale);
    const isInlineCodeHarvestEnabled = isAutocompleteEnabled && options?.harvestInlineCode === true;
    let debounceTimer = null;
    let decisionDeadlineTimer = null;
    let hasIngestedPage = false;
    let resolvedContext;
    /**
   * Kept in sync with the live EditorView so the async getContext() promise
   * can re-trigger a slow-lane update the moment context arrives, even if the
   * user has already typed several words before the promise resolved.
   */ let currentView = null;
    let unsubscribeFromContextUpdates;
    // "Prime, don't ask-and-read": semantic, Tier-A, and Tier-B results land
    // asynchronously, often with no following keystroke. Re-run prediction when
    // they arrive so the caches are consumed immediately.
    let reschedulePredictionOnSlowLaneResult = null;
    /**
   * Set after accepting a suggestion so the next doc-change update
   * skips scheduling a new prediction for the just-inserted text.
   * Scoped to the factory so multiple editor instances don't share state.
   */ let justAccepted = false;
    /**
   * Stores the text-before-cursor snapshot at the moment the user dismissed
   * a suggestion via Escape. While the context remains identical, we suppress
   * re-showing the same suggestion. Resets to null as soon as the text changes.
   */ let dismissedContext = null;
    let decisionRevision = 0;
    let activeDecision;
    /**
   * cold  → no slow-lane vector received yet; frequency-only trie scoring
   * server → server slow-lane API returned the context vector
   * localLlm → on-device WebGPU/MLC model returned the context vector
   */ const getCompletionSource = ()=>{
        if (!slowLaneClient.getContextVector()) return 'cold';
        return options?.useLocalModel ? 'localLlm' : 'server';
    };
    /**
   * Which path produced a given suggestion.
   *
   * A harvested surface is reported as `harvest` rather than by the slow-lane
   * state it happened to be shown under, so its views and acceptances stay
   * separable from the scored path's and cannot quietly move the headline
   * acceptance rate.
   */ const completionSourceFor = (suggestion)=>suggestion?.evidenceTier === 'session-harvest' ? 'harvest' : getCompletionSource();
    const fireSuggestionDismissedAnalytics = (reason, suggestion)=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).SUGGESTION_DISMISSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTEXTUAL_TYPEAHEAD,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                completionSource: completionSourceFor(suggestion),
                reason: reason,
                surface: surface
            }
        });
    };
    const fireLocalModelLoadedAnalytics = (info)=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).LOCAL_MODEL_LOADED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTEXTUAL_TYPEAHEAD,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                modelId: info.modelId,
                embeddingModelId: info.embeddingModelId,
                loadDurationMs: info.loadDurationMs,
                gpuVendor: info.capabilities.vendor,
                gpuArchitecture: info.capabilities.architecture,
                surface: surface
            }
        });
    };
    const fireLocalModelLoadFailedAnalytics = (error)=>{
        const { capabilities: capabilities } = error;
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).LOCAL_MODEL_LOAD_FAILED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTEXTUAL_TYPEAHEAD,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                reason: error.reason,
                message: error.message,
                modelId: error.modelId,
                embeddingModelId: error.embeddingModelId,
                webgpuAvailable: capabilities.available,
                adapterAvailable: capabilities.adapterAvailable,
                shaderF16Supported: capabilities.shaderF16Supported,
                maxBufferSizeMB: capabilities.maxBufferSizeMB,
                maxStorageBufferBindingSizeMB: capabilities.maxStorageBufferBindingSizeMB,
                gpuVendor: capabilities.vendor,
                gpuArchitecture: capabilities.architecture,
                surface: surface
            }
        });
    };
    const fireSuggestionInsertedAnalytics = (suggestion)=>{
        const typedLength = Math.max(0, suggestion.surface.length - suggestion.ghostText.length);
        const suggestionLength = suggestion.surface.length;
        const kssDelta = suggestionLength - typedLength;
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).SUGGESTION_INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTEXTUAL_TYPEAHEAD,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                completionSource: completionSourceFor(suggestion),
                suggestionLength: suggestionLength,
                typedLength: typedLength,
                kssDelta: kssDelta,
                surface: surface
            }
        });
    };
    const slowLaneClient = options?.useLocalModel ? (0, $ae68e65f1ca82a3b$export$ad366118632d1082)({
        debounceMs: $f4538d6150bdc15e$var$LOCAL_SLOW_LANE_DEBOUNCE_MS,
        onLoadSuccess: fireLocalModelLoadedAnalytics,
        onLoadError: fireLocalModelLoadFailedAnalytics,
        // Re-run prediction for each independently scheduled model result.
        onUpdate: ()=>reschedulePredictionOnSlowLaneResult?.({
                kind: 'semantic'
            }),
        onBoundaryLmUpdate: ({ contextKey: contextKey, familyKey: familyKey, latencyMs: latencyMs })=>reschedulePredictionOnSlowLaneResult?.({
                contextKey: contextKey,
                familyKey: familyKey,
                kind: 'boundary',
                latencyMs: latencyMs
            }),
        onSurfaceScoreUpdate: ({ contextKey: contextKey, familyKey: familyKey, latencyMs: latencyMs })=>reschedulePredictionOnSlowLaneResult?.({
                contextKey: contextKey,
                familyKey: familyKey,
                kind: 'surface',
                latencyMs: latencyMs
            }),
        surface: surface
    }) : (0, $gpRHn.createSlowLaneClient)({
        baseUrl: '',
        debounceMs: $f4538d6150bdc15e$var$NETWORK_SLOW_LANE_DEBOUNCE_MS,
        // Re-run prediction when the BE semantic vector / LM logits land so
        // warm-mode unigram ranking applies without waiting for a keystroke.
        onUpdate: ()=>reschedulePredictionOnSlowLaneResult?.({
                kind: 'semantic'
            }),
        surface: surface
    });
    const slowLaneClientKind = options?.useLocalModel ? 'localLlm' : 'server';
    const slowLaneClientId = `${surface}:${slowLaneClientKind}:${++$f4538d6150bdc15e$var$slowLaneClientInstanceSequence}`;
    (0, $gpRHn.setDefaultSlowLaneClient)(slowLaneClient, {
        clientId: slowLaneClientId,
        kind: slowLaneClientKind
    });
    const registeredSlowLaneStatus = (0, $gpRHn.getDefaultSlowLaneClientStatus)();
    (0, $dl7hN.ctcTag)('init', `slow lane registered \xb7 id=${slowLaneClientId} \xb7 selected=${slowLaneClientKind} \xb7 canonical=${registeredSlowLaneStatus.canonicalScoringSupported ? 'yes' : 'no'} \xb7 ready=${registeredSlowLaneStatus.localModelReady ?? 'n/a'}`, slowLaneClientKind === 'localLlm' ? (0, $dl7hN.CTC_STYLES).good : (0, $dl7hN.CTC_STYLES).warn);
    let contextRequestInFlight = false;
    // A read the host asked for while another was open, kept so it can be made
    // once that one settles. One slot, not a queue: a burst of notifications only
    // ever means "read again", and the last of them describes the current state.
    let queuedContextRefreshSource;
    let lastContextRefreshAt = 0;
    // Bounds the word-boundary retry loop so it terminates even when the editor is
    // not in a comment thread (parentCommentContent never resolves).
    let wordBoundaryRefreshAttempts = 0;
    // Set when the plugin is torn down so in-flight getContext() resolutions don't
    // mutate the global text-predictor state after destruction.
    let destroyed = false;
    // L1 ingestion cannot run before the vocabulary has loaded: `incrementSessionFreq`
    // only touches trie nodes that already exist, so an empty trie silently rejects
    // every word. Text that arrives first — which a page usually does, since the
    // chat resolves it on focus in the same tick as the load starts — is held here
    // and applied once the load has settled.
    const pendingSessionContextTexts = new Set();
    const sessionIngestedContextTexts = new Set();
    let isVocabularyReady = false;
    let vocabularyLoadPromise;
    // Context text waiting on the harvester chunk, the vocabulary, or both. The
    // harvester drops surfaces the vocabulary already holds, so intake before the
    // load has settled would admit ordinary words no one needs completed.
    const pendingHarvestTexts = new Set();
    // Separate from `sessionIngestedContextTexts` because the two consumers settle
    // at different times: reply occurrences accumulate, so text fed twice would
    // count twice.
    const harvestedContextTexts = new Set();
    let inlineCodeHarvester = null;
    let inlineCodeHarvesterPromise;
    const addBoundedContextText = (texts, text)=>{
        texts.add(text);
        // Evict oldest entries (Set preserves insertion order) to bound memory.
        while(texts.size > $f4538d6150bdc15e$var$MAX_INGESTED_CONTEXT_TEXTS){
            const oldest = texts.values().next().value;
            if (oldest === undefined) break;
            texts.delete(oldest);
        }
    };
    const flushPendingSessionContext = ()=>{
        if (!isVocabularyReady || destroyed) return;
        for (const text of pendingSessionContextTexts){
            if (!sessionIngestedContextTexts.has(text)) {
                (0, $6PkRt.ingestDocumentPage)(text);
                addBoundedContextText(sessionIngestedContextTexts, text);
            }
            pendingSessionContextTexts.delete(text);
        }
    };
    const flushPendingHarvestTexts = ()=>{
        const harvester = inlineCodeHarvester;
        if (!harvester || !isVocabularyReady || destroyed || pendingHarvestTexts.size === 0) return;
        for (const text of pendingHarvestTexts){
            if (!harvestedContextTexts.has(text)) {
                harvester.harvestInlineCodeFromText(text);
                addBoundedContextText(harvestedContextTexts, text);
            }
            pendingHarvestTexts.delete(text);
        }
        harvester.logInlineCodeHarvest('context');
    };
    /**
   * Load the harvester chunk, once, and only for a host that asked for it.
   *
   * Kept off the critical path in the same way the vocabulary and vector loads
   * are: nothing is requested until the editor is focused, so a session that
   * never types in the chat pays nothing for the feature.
   */ const ensureInlineCodeHarvester = ()=>{
        if (!isInlineCodeHarvestEnabled || destroyed) return Promise.resolve(null);
        inlineCodeHarvesterPromise ?? (inlineCodeHarvesterPromise = (parcelRequire("2KSOM")).then((module)=>{
            if (destroyed) return null;
            inlineCodeHarvester = module;
            $f4538d6150bdc15e$var$loadedInlineCodeHarvester = module;
            flushPendingHarvestTexts();
            return module;
        }).catch((error)=>{
            // Clear the promise so a later focus can retry; the queued text is
            // still held and is fed by whichever attempt succeeds.
            inlineCodeHarvesterPromise = undefined;
            (0, $jv11C.logException)(error, {
                location: 'editor-plugin-autocomplete/loadInlineCodeHarvester'
            });
            return null;
        }));
        return inlineCodeHarvesterPromise;
    };
    /**
   * Re-read the document's code-marked spans.
   *
   * The backtick input rule consumes both delimiters on the closing tick, so a
   * finished span in the live document is only findable through its mark — and
   * only by walking, since a mark carries no notification.
   */ const harvestDocument = (doc, trigger)=>{
        if (!isInlineCodeHarvestEnabled || destroyed) return;
        const harvester = inlineCodeHarvester;
        if (!harvester) {
            ensureInlineCodeHarvester();
            return;
        }
        if (!isVocabularyReady) return;
        harvester.harvestInlineCodeFromDoc(doc);
        harvester.logInlineCodeHarvest(trigger);
    };
    const ensureVocabularyReady = ()=>{
        if (isVocabularyReady) {
            flushPendingSessionContext();
            flushPendingHarvestTexts();
            return Promise.resolve();
        }
        vocabularyLoadPromise ?? (vocabularyLoadPromise = (0, $6PkRt.loadDefaultVocabulary)({
            isLocalLLM: options?.useLocalModel ?? false,
            surface: surface
        }).then(()=>{
            if (destroyed) return;
            isVocabularyReady = true;
            flushPendingSessionContext();
            flushPendingHarvestTexts();
        }).catch((error)=>{
            // Do not consume the pending text on failure. A later focus retries the
            // load and can still apply the original context exactly once.
            vocabularyLoadPromise = undefined;
            (0, $jv11C.logException)(error, {
                location: 'editor-plugin-autocomplete/loadDefaultVocabulary'
            });
        }));
        return vocabularyLoadPromise;
    };
    const logContextResolved = (source, context)=>{
        if (!(0, $dl7hN.isAutocompleteDebugEnabled)()) return;
        // eslint-disable-next-line no-console
        console.log('%c[CTC:signal]%c getContext resolved', (0, $dl7hN.CTC_STYLES).brand, (0, $dl7hN.CTC_STYLES).body, {
            source: source,
            scope: context?.contextScopeKey,
            hasParentComment: !!context?.parentCommentContent,
            parentCommentPreview: context?.parentCommentContent?.slice(0, 80),
            siblingCount: context?.siblingCommentsContents?.length ?? 0,
            hasFullPage: !!context?.fullPageContent
        });
    };
    const ingestContextText = (text)=>{
        if (!text) return;
        if (!sessionIngestedContextTexts.has(text)) addBoundedContextText(pendingSessionContextTexts, text);
        // Queued unconditionally rather than only once the chunk is present:
        // context usually resolves in the same tick the load starts, and text
        // dropped for arriving early is a reply that can never be harvested.
        if (isInlineCodeHarvestEnabled && !harvestedContextTexts.has(text)) addBoundedContextText(pendingHarvestTexts, text);
    };
    const ingestResolvedContext = ()=>{
        ingestContextText(resolvedContext?.fullPageContent);
        ingestContextText(resolvedContext?.parentCommentContent);
        for (const siblingCommentContent of resolvedContext?.siblingCommentsContents ?? [])ingestContextText(siblingCommentContent);
        flushPendingSessionContext();
        flushPendingHarvestTexts();
    };
    /**
   * Put back what this editor had contributed to the pot another editor just
   * emptied.
   *
   * The scope that ended belongs to the host that reported it, not to everyone
   * sharing these globals. Without this an editor alongside it — a comment box
   * under a chat panel that switched conversation — is left with none of its
   * learning and no way back to it: the dedupe sets below are per editor, so
   * its own page reads as already ingested and is skipped from then on.
   *
   * Nothing is re-fetched. The context this editor resolved is still held, and
   * what it describes has not changed just because another host moved on.
   *
   * Only for an editor that reported no scope. One that did is party to the
   * same scope system and the scope just dropped may well be its own: a
   * Confluence page transition mounts the incoming editor before tearing down
   * the outgoing one, and the outgoing one is still holding the page that was
   * left. Putting that back is exactly what the eviction was for.
   */ const reprimeSessionLearning = ()=>{
        if (destroyed || resolvedContext?.contextScopeKey !== undefined) return;
        pendingSessionContextTexts.clear();
        sessionIngestedContextTexts.clear();
        pendingHarvestTexts.clear();
        harvestedContextTexts.clear();
        ingestResolvedContext();
        if (currentView) harvestDocument(currentView.state.doc, 'reprime');
    };
    /**
   * Drop everything learned for the scope that just ended.
   *
   * Both stores are claims about what is being discussed, and neither survives
   * the discussion changing: L1 boosts would keep a page's words ranked above
   * the next page's, and the harvested set holds one conversation's content.
   * The dedupe sets go too, so the context that arrives next is treated as
   * unseen and re-primes both — which is what makes this safe to do on a page
   * change, since the transcript is re-ingested along with the new page.
   *
   * The stores are shared, so every other mounted editor is put back in the
   * same tick from context it already holds. Only the scope that ended is
   * actually dropped.
   */ const resetSessionScopedLearning = (reason)=>{
        (0, $6PkRt.resetSessionBoosts)();
        $f4538d6150bdc15e$var$loadedInlineCodeHarvester?.resetInlineCodeHarvest();
        resolvedContext = undefined;
        pendingSessionContextTexts.clear();
        sessionIngestedContextTexts.clear();
        pendingHarvestTexts.clear();
        harvestedContextTexts.clear();
        (0, $dl7hN.ctcTag)('init', `session-scoped learning reset \xb7 ${reason}`, (0, $dl7hN.CTC_STYLES).dim);
        for (const reprimeOther of $f4538d6150bdc15e$var$mountedEditors)if (reprimeOther !== reprimeSessionLearning) reprimeOther();
    };
    const applyContext = (context)=>{
        // A host that scopes its context tells us which scope each read belongs to.
        // A read with no recorded key to compare against only records: that is the
        // first since the last editor went away, so there is nothing left to throw
        // away and resetting would drop the priming focus just started. A read from
        // a newly mounted editor is not that case — the key outlives the editor
        // precisely so a host that remounts across a navigation still evicts.
        if (context.contextScopeKey !== undefined && context.contextScopeKey !== $f4538d6150bdc15e$var$contextScopeKey) {
            if ($f4538d6150bdc15e$var$contextScopeKey !== undefined) resetSessionScopedLearning(`scope ${$f4538d6150bdc15e$var$contextScopeKey} \u{2192} ${context.contextScopeKey}`);
            $f4538d6150bdc15e$var$contextScopeKey = context.contextScopeKey;
        }
        // Merge rather than replace: the word-boundary retry may resolve only a
        // late-arriving field (e.g. parentCommentContent) without re-sending
        // fullPageContent, so replacing would drop previously resolved context.
        // Strip undefined values first so a field explicitly set to undefined by
        // getContext doesn't overwrite a previously resolved value.
        const definedContext = Object.fromEntries(Object.entries(context).filter(([, value])=>value !== undefined));
        resolvedContext = {
            ...resolvedContext,
            ...definedContext
        };
        ingestResolvedContext();
        // Context arrived after word boundaries may already have fired. Re-send
        // slow-lane context immediately so the next inference includes the thread.
        if (currentView) slowLaneClient.updateContext($f4538d6150bdc15e$var$buildSlowLaneText(currentView.state.doc.textContent, resolvedContext));
    };
    /**
   * Returns true when a fetch was actually started, false when it was skipped
   * (no getContext, a request already in flight, or throttled). Callers that
   * track a retry budget should only count attempts where this returns true.
   */ const refreshContext = ({ source: source, allowThrottle: allowThrottle = true })=>{
        if (!options?.getContext) return false;
        if (contextRequestInFlight) {
            // Only the reads that bypass the throttle are worth keeping: those are
            // the ones the host asked for by name, and a scope change travels among
            // them with no second channel to arrive on, so losing one would strand
            // the eviction until something else happened to move. A word-boundary
            // poll is a retry loop for context that has not landed yet, and the read
            // already open will bring it.
            if (!allowThrottle) queuedContextRefreshSource = source;
            return false;
        }
        const now = Date.now();
        if (allowThrottle && now - lastContextRefreshAt < $f4538d6150bdc15e$var$CONTEXT_REFRESH_THROTTLE_MS) return false;
        contextRequestInFlight = true;
        lastContextRefreshAt = now;
        options.getContext().then((context)=>{
            // Bail if the plugin was destroyed while the fetch was in flight —
            // applyContext mutates global text-predictor state we must not touch
            // after teardown.
            if (destroyed) return;
            logContextResolved(source, context);
            if (!context) return;
            applyContext(context);
        }).catch((error)=>{
            (0, $jv11C.logException)(error, {
                location: 'editor-plugin-autocomplete/getContext'
            });
        }).finally(()=>{
            contextRequestInFlight = false;
            const queuedSource = queuedContextRefreshSource;
            queuedContextRefreshSource = undefined;
            if (queuedSource !== undefined && !destroyed) refreshContext({
                source: queuedSource,
                allowThrottle: false
            });
        });
        return true;
    };
    const clearDecisionTimers = ()=>{
        if (debounceTimer) {
            clearTimeout(debounceTimer);
            debounceTimer = null;
        }
        if (decisionDeadlineTimer) {
            clearTimeout(decisionDeadlineTimer);
            decisionDeadlineTimer = null;
        }
    };
    const cancelActiveDecision = ()=>{
        clearDecisionTimers();
        activeDecision = undefined;
    };
    const isDecisionSnapshotCurrent = (view, decision)=>{
        const { state: state } = view;
        return state.selection.empty && state.selection.from === decision.position && $f4538d6150bdc15e$var$getTextBeforeCursor(state) === decision.textBefore;
    };
    const isDecisionCurrent = (view, decision)=>activeDecision?.revision === decision.revision && isDecisionSnapshotCurrent(view, decision);
    const expireActiveDecision = (decision)=>{
        if (activeDecision?.revision !== decision.revision) return;
        cancelActiveDecision();
    };
    /**
   * Offer a harvested inline-code surface on a prefix the scored path left
   * empty. Returns whether one was committed.
   */ const commitHarvestedSuggestion = (view, decision)=>{
        const harvester = inlineCodeHarvester;
        if (!harvester || !isInlineCodeHarvestEnabled) return false;
        if (!$f4538d6150bdc15e$var$scoredPathFinishedEmpty(decision.textBefore)) return false;
        const typedPrefix = $f4538d6150bdc15e$var$getTrailingSurfaceToken(decision.textBefore);
        const match = harvester.findHarvestedCompletion(typedPrefix);
        if (!match) return false;
        if ((0, $6PkRt.isSurfaceInAcceptCooldown)(match.surface) || $f4538d6150bdc15e$var$repeatsPrecedingText(match, decision.textBefore)) return false;
        const suggestion = $f4538d6150bdc15e$var$showGhostText(view, $f4538d6150bdc15e$var$buildHarvestPrediction(match), decision.position, decision.revision, decision.startedAt, match.typedPrefixLength);
        if (!suggestion) return false;
        cancelActiveDecision();
        (0, $dl7hN.ctcTag)('harvest', `offered "${match.surface}" for "${typedPrefix}" \xb7 ${match.collapsedBy} \xb7 ${match.replyOccurrences} reply / ${match.documentSpans} doc sightings${match.rivalSurfaces.length > 0 ? ` \xb7 over ${match.rivalSurfaces.join(', ')}` : ''}`, (0, $dl7hN.CTC_STYLES).lm);
        if (suggestion.ghostText !== $f4538d6150bdc15e$var$lastShownGhostText) {
            $f4538d6150bdc15e$var$lastShownGhostText = suggestion.ghostText;
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).SUGGESTION_VIEWED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTEXTUAL_TYPEAHEAD,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    completionSource: completionSourceFor(suggestion),
                    surface: surface
                }
            });
        }
        return true;
    };
    const evaluateActiveDecision = (view, revision)=>{
        const decision = activeDecision;
        if (!decision || decision.revision !== revision || !isDecisionCurrent(view, decision)) return;
        if (performance.now() > decision.deadlineAt) {
            expireActiveDecision(decision);
            return;
        }
        decision.evaluations++;
        try {
            const { state: state } = view;
            const { selection: selection } = state;
            // Suppress suggestions when the cursor is mid-word — only offer
            // completions when the cursor is at the trailing edge of a token.
            const nodeAfter = selection.$from.nodeAfter;
            const charAfterCursor = nodeAfter?.isText ? $f4538d6150bdc15e$var$getLeadingTextCharacter(nodeAfter.text) : undefined;
            if (charAfterCursor && $f4538d6150bdc15e$var$isMidWordCharacter(charAfterCursor)) {
                cancelActiveDecision();
                return;
            }
            if (decision.textBefore === dismissedContext) {
                cancelActiveDecision();
                return;
            }
            dismissedContext = null;
            // Two characters are enough to prefetch the canonical shortlist. The
            // predictor itself withholds display until the three-character gate.
            if (decision.textBefore.trim().length < 2) {
                cancelActiveDecision();
                return;
            }
            const prediction = (0, $6PkRt.predict)(decision.textBefore);
            if (!prediction || prediction.text.length === 0) {
                // Only where the scored path has finished and come away with nothing
                // does a harvested surface get to answer; otherwise remain in
                // `collecting` until an async signal arrives or the hard deadline
                // expires. We never display a provisional fallback.
                commitHarvestedSuggestion(view, decision);
                return;
            }
            const readyAtMs = performance.now() - decision.startedAt;
            if (readyAtMs > $f4538d6150bdc15e$var$GHOST_DECISION_BUDGET_MS) {
                cancelActiveDecision();
                if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
                console.log('%c[CTC:budget]%c fully gated after render deadline (render suppressed)', (0, $dl7hN.CTC_STYLES).section, (0, $dl7hN.CTC_STYLES).body, {
                    revision: decision.revision,
                    readyAtMs: readyAtMs,
                    surface: prediction.surface
                });
                return;
            }
            const suggestion = $f4538d6150bdc15e$var$showGhostText(view, prediction, decision.position, decision.revision, decision.startedAt);
            if (!suggestion) {
                cancelActiveDecision();
                return;
            }
            cancelActiveDecision();
            if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
            console.log('%c[CTC:decision]%c committed immutable ghost', (0, $dl7hN.CTC_STYLES).brand, (0, $dl7hN.CTC_STYLES).body, {
                revision: suggestion.revision,
                surface: suggestion.surface,
                ghostText: suggestion.ghostText,
                evidenceTier: suggestion.evidenceTier,
                rankScore: suggestion.rankScore,
                winnerMargin: suggestion.winnerMargin,
                decisionLatencyMs: suggestion.decisionLatencyMs,
                budgetMs: $f4538d6150bdc15e$var$GHOST_DECISION_BUDGET_MS,
                typedPrefixLength: $f4538d6150bdc15e$var$getTrailingSurfacePrefixLength(decision.textBefore),
                evaluations: decision.evaluations,
                asyncSignals: decision.asyncSignals,
                readyWithinBudget: suggestion.decisionLatencyMs <= $f4538d6150bdc15e$var$GHOST_DECISION_BUDGET_MS
            });
            if (suggestion.ghostText !== $f4538d6150bdc15e$var$lastShownGhostText) {
                $f4538d6150bdc15e$var$lastShownGhostText = suggestion.ghostText;
                api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $krYZG.ACTION).SUGGESTION_VIEWED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).CONTEXTUAL_TYPEAHEAD,
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                    attributes: {
                        completionSource: completionSourceFor(suggestion),
                        surface: surface
                    }
                });
            }
        } catch (error) {
            cancelActiveDecision();
            (0, $jv11C.logException)(error, {
                location: 'editor-plugin-autocomplete/evaluateActiveDecision'
            });
        }
    };
    const beginPredictionDecision = (view)=>{
        cancelActiveDecision();
        const { state: state } = view;
        if (!state.selection.empty) return;
        const startedAt = performance.now();
        const textBefore = $f4538d6150bdc15e$var$getTextBeforeCursor(state);
        const revision = ++decisionRevision;
        activeDecision = {
            asyncSignals: 0,
            deadlineAt: startedAt + $f4538d6150bdc15e$var$GHOST_DECISION_BUDGET_MS,
            evaluations: 0,
            position: state.selection.from,
            revision: revision,
            startedAt: startedAt,
            textBefore: textBefore
        };
        if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
        console.log('%c[CTC:decision]%c collecting', (0, $dl7hN.CTC_STYLES).brand, (0, $dl7hN.CTC_STYLES).body, {
            revision: revision,
            budgetMs: $f4538d6150bdc15e$var$GHOST_DECISION_BUDGET_MS,
            coalesceMs: $f4538d6150bdc15e$var$PREDICTION_COALESCE_MS,
            typedPrefixLength: $f4538d6150bdc15e$var$getTrailingSurfacePrefixLength(activeDecision.textBefore),
            textBefore: activeDecision.textBefore.slice(-80)
        });
        debounceTimer = setTimeout(()=>{
            debounceTimer = null;
            evaluateActiveDecision(view, revision);
        }, $f4538d6150bdc15e$var$PREDICTION_COALESCE_MS);
        decisionDeadlineTimer = setTimeout(()=>{
            decisionDeadlineTimer = null;
            if (activeDecision?.revision === revision) {
                const expiredDecision = activeDecision;
                if ((0, $dl7hN.isAutocompleteDebugEnabled)()) {
                    const elapsedMs = performance.now() - expiredDecision.startedAt;
                    const predictionDebug = (0, $6PkRt.getLastPredictionDebug)();
                    const matchingPredictionDebug = predictionDebug?.textBefore === expiredDecision.textBefore ? predictionDebug : null;
                    const abstentionPrefix = "\u2014 abstain: ";
                    const predictorDecision = matchingPredictionDebug?.decision;
                    const predictorReason = predictorDecision?.startsWith(abstentionPrefix) ? predictorDecision.slice(abstentionPrefix.length) : predictorDecision;
                    const decisionMessage = predictorReason && !matchingPredictionDebug?.awaitingAsyncEvidence ? `abstain: ${predictorReason}` : `abstain: ${$f4538d6150bdc15e$var$GHOST_DECISION_BUDGET_MS}ms decision budget expired${predictorReason ? ` \xb7 ${predictorReason}` : ''}`;
                    // eslint-disable-next-line no-console
                    console.log(`%c[CTC:decision]%c ${decisionMessage}`, (0, $dl7hN.CTC_STYLES).brand, (0, $dl7hN.CTC_STYLES).body, {
                        revision: revision,
                        budgetMs: $f4538d6150bdc15e$var$GHOST_DECISION_BUDGET_MS,
                        elapsedMs: elapsedMs,
                        typedPrefixLength: $f4538d6150bdc15e$var$getTrailingSurfacePrefixLength(expiredDecision.textBefore),
                        evaluations: expiredDecision.evaluations,
                        asyncSignals: expiredDecision.asyncSignals,
                        textBefore: expiredDecision.textBefore.slice(-80),
                        predictorDecision: predictorReason ?? null
                    });
                }
                expireActiveDecision(expiredDecision);
            }
        }, $f4538d6150bdc15e$var$GHOST_DECISION_BUDGET_MS);
    };
    // Async semantic/canonical results may complete the active decision, but they
    // never create a new decision or replace an already committed ghost.
    reschedulePredictionOnSlowLaneResult = (signal)=>{
        if (destroyed || !currentView) return;
        if (!activeDecision) return;
        const revision = activeDecision.revision;
        const elapsedMs = performance.now() - activeDecision.startedAt;
        const remainingMs = activeDecision.deadlineAt - performance.now();
        if (remainingMs < 0) {
            const expiredDecision = activeDecision;
            expireActiveDecision(expiredDecision);
            return;
        }
        activeDecision.asyncSignals++;
        if ((0, $dl7hN.isAutocompleteDebugVerbose)()) // eslint-disable-next-line no-console
        console.log('%c[CTC:readiness]%c async evidence signal', (0, $dl7hN.CTC_STYLES).section, (0, $dl7hN.CTC_STYLES).body, {
            ...signal,
            revision: revision,
            elapsedMs: elapsedMs,
            remainingMs: Math.max(0, remainingMs),
            typedPrefixLength: $f4538d6150bdc15e$var$getTrailingSurfacePrefixLength(activeDecision.textBefore),
            withinBudget: remainingMs >= 0
        });
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(()=>{
            debounceTimer = null;
            if (currentView) evaluateActiveDecision(currentView, revision);
        }, 0);
    };
    const maybeUpdateSessionFrequency = (view, prevState)=>{
        const newText = $f4538d6150bdc15e$var$getTextBeforeCursor(view.state);
        const prevText = $f4538d6150bdc15e$var$getTextBeforeCursor(prevState);
        if (newText.length <= prevText.length) return;
        const lastChar = newText[newText.length - 1];
        if (!$f4538d6150bdc15e$var$WORD_BOUNDARY_CHARS_REGEX.test(lastChar)) return;
        // Only fire if the previous state did not already end on a boundary,
        // so we don't double-count when multiple boundary chars are inserted.
        const prevLastChar = prevText[prevText.length - 1];
        if (prevLastChar && $f4538d6150bdc15e$var$WORD_BOUNDARY_CHARS_REGEX.test(prevLastChar)) return;
        const beforeBoundary = newText.slice(0, -1).trimEnd();
        const lastSpaceIdx = beforeBoundary.lastIndexOf(' ');
        const completedWord = beforeBoundary.slice(lastSpaceIdx + 1).toLowerCase();
        if (completedWord.length >= 2) (0, $6PkRt.incrementSessionFreq)(completedWord);
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $f4538d6150bdc15e$export$7f2aa48dd1e99876,
        state: {
            init: ()=>$f4538d6150bdc15e$var$createInitialState(),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($f4538d6150bdc15e$export$7f2aa48dd1e99876);
                if (meta) return {
                    ...pluginState,
                    ...meta
                };
                // A new prediction is scheduled from view.update either way; the
                // surviving ghost only covers the gap until it commits.
                if (tr.docChanged) return $f4538d6150bdc15e$var$advanceGhostThroughTypedCharacter(tr, pluginState) ?? $f4538d6150bdc15e$var$clearGhostState(pluginState);
                if (tr.selectionSet && pluginState.ghostText) return $f4538d6150bdc15e$var$clearGhostState(pluginState);
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                const pluginState = $f4538d6150bdc15e$export$7f2aa48dd1e99876.getState(state);
                return pluginState?.decorationSet ?? (0, $8nvEM.DecorationSet).empty;
            },
            handleKeyDown: (0, $44cyU.keydownHandler)({
                Tab: (state, dispatch)=>{
                    return $f4538d6150bdc15e$var$acceptGhostTextWithAnalytics(state, dispatch, (suggestion)=>{
                        justAccepted = true;
                        $f4538d6150bdc15e$var$lastShownGhostText = '';
                        cancelActiveDecision();
                        fireSuggestionInsertedAnalytics(suggestion);
                    });
                },
                ArrowRight: (state, dispatch)=>{
                    return $f4538d6150bdc15e$var$acceptGhostTextWithAnalytics(state, dispatch, (suggestion)=>{
                        justAccepted = true;
                        $f4538d6150bdc15e$var$lastShownGhostText = '';
                        cancelActiveDecision();
                        fireSuggestionInsertedAnalytics(suggestion);
                    });
                },
                Escape: (state, dispatch)=>{
                    const dismissed = $f4538d6150bdc15e$export$7f2aa48dd1e99876.getState(state)?.suggestion;
                    const didClear = $f4538d6150bdc15e$var$clearGhostText(state, dispatch);
                    if (didClear) {
                        cancelActiveDecision();
                        dismissedContext = $f4538d6150bdc15e$var$getTextBeforeCursor(state);
                        fireSuggestionDismissedAnalytics('escape', dismissed ?? null);
                    }
                    return didClear;
                }
            }),
            handleDOMEvents: {
                blur: (view)=>{
                    if (!isAutocompleteEnabled) return false;
                    const pluginState = $f4538d6150bdc15e$export$7f2aa48dd1e99876.getState(view.state);
                    if (pluginState?.ghostText) {
                        $f4538d6150bdc15e$var$clearGhostText(view.state, view.dispatch);
                        cancelActiveDecision();
                        fireSuggestionDismissedAnalytics('blur', pluginState.suggestion);
                    }
                    return false;
                },
                mousedown: (view, event)=>{
                    if (!isAutocompleteEnabled || !(event.target instanceof Element)) return false;
                    if (!event.target.closest('[data-autocomplete-ghost="true"]')) {
                        const dismissed = $f4538d6150bdc15e$export$7f2aa48dd1e99876.getState(view.state)?.suggestion;
                        const didClear = $f4538d6150bdc15e$var$clearGhostText(view.state, view.dispatch);
                        if (didClear) {
                            cancelActiveDecision();
                            dismissedContext = $f4538d6150bdc15e$var$getTextBeforeCursor(view.state);
                            $f4538d6150bdc15e$var$lastShownGhostText = '';
                            fireSuggestionDismissedAnalytics('click', dismissed ?? null);
                        }
                        return false;
                    }
                    event.preventDefault();
                    const accepted = $f4538d6150bdc15e$var$acceptGhostTextWithAnalytics(view.state, view.dispatch, (suggestion)=>{
                        justAccepted = true;
                        $f4538d6150bdc15e$var$lastShownGhostText = '';
                        cancelActiveDecision();
                        fireSuggestionInsertedAnalytics(suggestion);
                    });
                    if (accepted) view.focus();
                    return accepted;
                },
                focus: (view)=>{
                    if (!isAutocompleteEnabled) return false;
                    ensureVocabularyReady();
                    // First point at which the session is known to be using the input,
                    // which is where the rest of the artifacts are requested too.
                    ensureInlineCodeHarvester().then(()=>harvestDocument(view.state.doc, 'focus')).catch((error)=>{
                        (0, $jv11C.logException)(error, {
                            location: 'editor-plugin-autocomplete/harvestDocument'
                        });
                    });
                    (0, $6PkRt.loadVectorsAsync)({
                        isLocalLLM: options?.useLocalModel ?? false,
                        surface: surface
                    }).catch((error)=>{
                        (0, $jv11C.logException)(error, {
                            location: 'editor-plugin-autocomplete/loadVectorsAsync'
                        });
                    });
                    (0, $cVZWR.loadGrammarDataAsync)({
                        isLocalLLM: options?.useLocalModel ?? false,
                        surface: surface
                    }).catch((error)=>{
                        (0, $jv11C.logException)(error, {
                            location: 'editor-plugin-autocomplete/loadGrammarDataAsync'
                        });
                    });
                    if (!hasIngestedPage) {
                        hasIngestedPage = true;
                        refreshContext({
                            source: 'focus',
                            allowThrottle: false
                        });
                    }
                    return false;
                }
            }
        },
        view: (editorView)=>{
            // Capture up front so a subscription notification before the first PM
            // transaction can still drive slowLaneClient.updateContext (gated on currentView).
            currentView = editorView;
            $f4538d6150bdc15e$var$mountedEditors.add(reprimeSessionLearning);
            // Push channel for hosts that keep producing context after mount (e.g. Rovo chat).
            if (isAutocompleteEnabled && options?.subscribeToContextUpdates) unsubscribeFromContextUpdates = options.subscribeToContextUpdates(()=>{
                // Bypass throttle for freshness; a read still open defers this one
                // rather than overlapping it.
                refreshContext({
                    source: 'subscription',
                    allowThrottle: false
                });
            });
            return {
                update: (view, prevState)=>{
                    if (!isAutocompleteEnabled) return;
                    currentView = view;
                    if (!prevState.doc.eq(view.state.doc)) {
                        if (justAccepted) {
                            justAccepted = false;
                            // Snapshot the post-acceptance text so follow-up transactions hit
                            // the dismissedContext guard and abort until the user types again.
                            dismissedContext = $f4538d6150bdc15e$var$getTextBeforeCursor(view.state);
                            cancelActiveDecision();
                            return;
                        }
                        maybeUpdateSessionFrequency(view, prevState);
                        const textBefore = $f4538d6150bdc15e$var$getTextBeforeCursor(view.state);
                        if ((0, $gpRHn.isWordBoundary)(textBefore)) {
                            slowLaneClient.updateContext($f4538d6150bdc15e$var$buildSlowLaneText(view.state.doc.textContent, resolvedContext));
                            // The backtick input rule has fired by the time a span is
                            // finished, so a word boundary is the earliest point the mark
                            // exists to be found.
                            harvestDocument(view.state.doc, 'word-boundary');
                            // Context may not have resolved on first focus (e.g. comment
                            // thread still loading). Retry on word boundaries until we have
                            // the parent comment, throttled so we don't refetch constantly
                            // and capped so non-comment editors stop retrying entirely.
                            // Skipped for push-channel hosts (subscribeToContextUpdates): they
                            // never grow parentCommentContent, so polling only burns the budget.
                            if (!options?.subscribeToContextUpdates && !resolvedContext?.parentCommentContent && wordBoundaryRefreshAttempts < $f4538d6150bdc15e$var$MAX_CONTEXT_REFRESH_ATTEMPTS) // Only count the attempt when a fetch actually started, so an
                            // in-flight or throttled no-op doesn't burn the retry budget.
                            {
                                if (refreshContext({
                                    source: 'word-boundary'
                                })) wordBoundaryRefreshAttempts++;
                            }
                        }
                        beginPredictionDecision(view);
                    } else if (!prevState.selection.eq(view.state.selection)) cancelActiveDecision();
                },
                destroy: ()=>{
                    destroyed = true;
                    currentView = null;
                    unsubscribeFromContextUpdates?.();
                    unsubscribeFromContextUpdates = undefined;
                    cancelActiveDecision();
                    const releasedDefaultClient = (0, $gpRHn.clearDefaultSlowLaneClient)(slowLaneClient);
                    (0, $dl7hN.ctcTag)('init', `slow lane teardown \xb7 id=${slowLaneClientId} \xb7 default=${releasedDefaultClient ? 'released' : 'retained newer owner'}`, releasedDefaultClient ? (0, $dl7hN.CTC_STYLES).dim : (0, $dl7hN.CTC_STYLES).warn);
                    if ($f4538d6150bdc15e$var$hasDestroy(slowLaneClient)) slowLaneClient.destroy();
                    queuedContextRefreshSource = undefined;
                    pendingSessionContextTexts.clear();
                    sessionIngestedContextTexts.clear();
                    pendingHarvestTexts.clear();
                    harvestedContextTexts.clear();
                    // The harvested set holds one conversation's user and assistant
                    // content, and the L1 boosts describe what that conversation was
                    // about. Both live at module scope, so they have to be emptied here
                    // or they leak into whichever editor mounts next — but only once no
                    // editor is left to be using them. The scope key goes with them, and
                    // only with them: clearing it while another editor is still mounted
                    // would leave that editor's next read looking like a first one, with
                    // nothing to compare against and everything still loaded.
                    $f4538d6150bdc15e$var$mountedEditors.delete(reprimeSessionLearning);
                    if ($f4538d6150bdc15e$var$mountedEditors.size === 0) {
                        $f4538d6150bdc15e$var$loadedInlineCodeHarvester?.resetInlineCodeHarvest();
                        // Only for a host that scopes its context, which is the one asking
                        // for its learning to end with the conversation. A host that sends
                        // no scope has boosts belonging to the page it is on, and that page
                        // outlives an editor being unmounted — a Confluence comment box is
                        // closed far more often than the page under it changes.
                        if ($f4538d6150bdc15e$var$contextScopeKey !== undefined) {
                            (0, $6PkRt.resetSessionBoosts)();
                            $f4538d6150bdc15e$var$contextScopeKey = undefined;
                        }
                    }
                    inlineCodeHarvester = null;
                    inlineCodeHarvesterPromise = undefined;
                }
            };
        }
    });
};


const $aaa671a2d43477c1$export$a4d438569782dc29 = ({ config: options, api: api })=>{
    return {
        name: 'autocomplete',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $f4538d6150bdc15e$export$7f2aa48dd1e99876).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'autocomplete',
                    plugin: ()=>(0, $f4538d6150bdc15e$export$dd9f4347413c1469)(options, api)
                }
            ];
        }
    };
};
module.exports["autocompletePlugin"] = $aaa671a2d43477c1$export$a4d438569782dc29;

});

parcelRegister("dl7hN", function(module, exports) {
/**
 * Contextual Typeahead Completions (CTC) debug logging utility.
 *
 * Logs are silent by default. Enable in any environment (dev, staging, prod):
 *
 *   // Live, for the current session (no reload required):
 *   __atlCtcDebug__.enable()
 *
 *   // To disable:
 *   __atlCtcDebug__.disable()
 *
 *   // From initial page load (survives reload) — append to the URL:
 *   ?atlCtcDebug=1
 *
 * Storage-free by design: avoids browser-storage consent controls (BSC), which can
 * block uncategorized localStorage/sessionStorage/cookie writes in some products.
 */ const $6d219bb61783143e$export$8d5e95240c2d1dbe = {
    brand: 'color: #00b8d9; font-weight: bold;',
    section: 'color: #9c27b0; font-weight: bold;',
    dim: 'color: #888; font-style: italic;',
    good: 'color: #4caf50; font-weight: bold;',
    warn: 'color: #ff9800; font-weight: bold;',
    bad: 'color: #f44336; font-weight: bold;',
    cold: 'color: #9e9e9e; font-weight: bold;',
    lm: 'color: #e83e8c; font-weight: bold;',
    body: 'color: inherit; font-weight: normal;'
};
const $6d219bb61783143e$export$5c90934d6a7ab799 = (label, body)=>{
    if (!$6d219bb61783143e$export$90345dcf3b6a9e06()) return;
    // eslint-disable-next-line no-console
    console.log(`%c${label.padEnd(10)}%c${body}`, $6d219bb61783143e$export$8d5e95240c2d1dbe.section, $6d219bb61783143e$export$8d5e95240c2d1dbe.body);
};
const $6d219bb61783143e$export$64e6c5def147f898 = (tag, body, tagStyle = $6d219bb61783143e$export$8d5e95240c2d1dbe.brand)=>{
    if (!$6d219bb61783143e$export$90345dcf3b6a9e06()) return;
    // eslint-disable-next-line no-console
    console.log(`%c[CTC:${tag}]%c ${body}`, tagStyle, $6d219bb61783143e$export$8d5e95240c2d1dbe.body);
};
const $6d219bb61783143e$var$readUrlDebugFlag = ()=>{
    if (typeof window === 'undefined') return {
        enabled: false,
        verbose: false
    };
    try {
        const value = new URLSearchParams(window.location.search).get('atlCtcDebug');
        return {
            enabled: value === '1' || value === 'verbose',
            verbose: value === 'verbose'
        };
    } catch  {
        return {
            enabled: false,
            verbose: false
        };
    }
};
const $6d219bb61783143e$var$printLegend = (verbose)=>{
    // eslint-disable-next-line no-console
    console.groupCollapsed(`%c[CTC]%c debug enabled${verbose ? ' (verbose)' : ''} \u{2014} Contextual Typeahead Completion`, $6d219bb61783143e$export$8d5e95240c2d1dbe.brand, $6d219bb61783143e$export$8d5e95240c2d1dbe.body);
    // eslint-disable-next-line no-console
    console.log("%cPipeline%c  INPUT \u2192 SIGNALS \u2192 CANONICAL \u2192 GENERATE \u2192 SCORE \u2192 ARBITRATE \u2192 STABILIZE \u2192 CANDIDATES", $6d219bb61783143e$export$8d5e95240c2d1dbe.section, $6d219bb61783143e$export$8d5e95240c2d1dbe.body);
    // eslint-disable-next-line no-console
    console.log("%cEvidence%c  Tier A = exact-context first token \xb7 prefix = one more decoded token \xb7 exact = every token of the surface scored \xb7 absent = Stage 1", $6d219bb61783143e$export$8d5e95240c2d1dbe.section, $6d219bb61783143e$export$8d5e95240c2d1dbe.body);
    // eslint-disable-next-line no-console
    console.log('%cLM queue%c  one serialised GPU queue drains both: prompt prefills and single-token decode steps', $6d219bb61783143e$export$8d5e95240c2d1dbe.section, $6d219bb61783143e$export$8d5e95240c2d1dbe.body);
    // eslint-disable-next-line no-console
    console.log("%cPlanes%c    [CTC:init] loads \xb7 [CTC:signal] semantic/network \xb7 [CTC:model] primes/exact \xb7 [CTC:model-cost] prefill/decode \xb7 [CTC:readiness] deadline progress", $6d219bb61783143e$export$8d5e95240c2d1dbe.section, $6d219bb61783143e$export$8d5e95240c2d1dbe.body);
    // eslint-disable-next-line no-console
    console.log('%cInspect%c   __atlCtcDebug__.enable("verbose") \xb7 .disable() \xb7 .harvest() (session inline code) \xb7 .session() (L1 boosts) \u2014 both narrow to a prefix, e.g. .session("poll")', $6d219bb61783143e$export$8d5e95240c2d1dbe.section, $6d219bb61783143e$export$8d5e95240c2d1dbe.body);
    // eslint-disable-next-line no-console
    console.groupEnd();
};
// State lives on the window object (not a module closure) so duplicate copies of this
// module across separate bundles/realms share one source of truth and the console API
// controls them all. In-memory only; persisted across reload via the URL flag.
const $6d219bb61783143e$var$getDebugApi = ()=>{
    if (typeof window === 'undefined') return undefined;
    if (!window.__atlCtcDebug__) {
        const initial = $6d219bb61783143e$var$readUrlDebugFlag();
        let debugEnabled = initial.enabled;
        let debugVerbose = initial.verbose;
        if (debugEnabled) $6d219bb61783143e$var$printLegend(debugVerbose);
        window.__atlCtcDebug__ = {
            enable: (level)=>{
                debugEnabled = true;
                debugVerbose = level === 'verbose';
                $6d219bb61783143e$var$printLegend(debugVerbose);
            },
            disable: ()=>{
                debugEnabled = false;
                debugVerbose = false;
            },
            isEnabled: ()=>debugEnabled,
            isVerbose: ()=>debugEnabled && debugVerbose
        };
    }
    return window.__atlCtcDebug__;
};
const $6d219bb61783143e$export$90345dcf3b6a9e06 = ()=>$6d219bb61783143e$var$getDebugApi()?.isEnabled() ?? false;
const $6d219bb61783143e$export$4d7944315ac2d14 = ()=>$6d219bb61783143e$var$getDebugApi()?.isVerbose() ?? false;
const $6d219bb61783143e$export$ed82b207c1a50cec = (inspect)=>{
    const api = $6d219bb61783143e$var$getDebugApi();
    if (api) api.harvest = inspect;
};
const $6d219bb61783143e$export$b55fe3de04af7422 = (inspect)=>{
    const api = $6d219bb61783143e$var$getDebugApi();
    if (api) api.session = inspect;
};
// Eagerly install so the console API is available on load, regardless of call order.
$6d219bb61783143e$var$getDebugApi();
module.exports["CTC_STYLES"] = $6d219bb61783143e$export$8d5e95240c2d1dbe;
module.exports["ctcSection"] = $6d219bb61783143e$export$5c90934d6a7ab799;
module.exports["isAutocompleteDebugEnabled"] = $6d219bb61783143e$export$90345dcf3b6a9e06;
module.exports["ctcTag"] = $6d219bb61783143e$export$64e6c5def147f898;
module.exports["isAutocompleteDebugVerbose"] = $6d219bb61783143e$export$4d7944315ac2d14;
module.exports["registerCtcHarvestInspector"] = $6d219bb61783143e$export$ed82b207c1a50cec;
module.exports["registerCtcSessionInspector"] = $6d219bb61783143e$export$b55fe3de04af7422;

});

parcelRegister("2GLSY", function(module, exports) {

let $1f54a61af481c8e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f54a61af481c8e8$var$load("caHjs").then(()=>parcelRequire('kpD0n'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("6PkRt", function(module, exports) {
/**
 * Fast Lane Predictor: Local autocomplete using weighted trie + frequency + semantic scoring.
 *
 * Two prediction modes:
 *   1. Word boundary → bigram-based next-word suggestion (grammar-filtered)
 *   2. Mid-word (≥1 char) → grouped prefetch; ≥3 chars + exact evidence → ghost result
 *
 * Scoring is delegated to scoring-pipeline.ts which handles:
 *   Stage 1 (semantic + frequency), grammar filter, Stage 2 (optional LM re-ranking).
 *
 * Context vector: average of word vectors from text before cursor (last N words).
 * Falls back to cold mode (freq-only) when vectors not yet loaded.
 *
 * Session personalization (L1): words the user types are incrementally boosted
 * via incrementSessionFreq(), called on word boundaries from the plugin, and
 * words in ingested context text via ingestDocumentPage(). What the session has
 * boosted is visible at any time from the console: `__atlCtcDebug__.session()`,
 * or `__atlCtcDebug__.session('poll')` for one family — see inspectSessionBoosts.
 */ 
var $a8cFP = parcelRequire("a8cFP");


var $ln5kH = parcelRequire("ln5kH");


var $gKGLg = parcelRequire("gKGLg");


var $eGuir = parcelRequire("eGuir");


var $dl7hN = parcelRequire("dl7hN");


var $cVZWR = parcelRequire("cVZWR");


var $gpRHn = parcelRequire("gpRHn");

// ─── Constants ───────────────────────────────────────────────────────────────
// eslint-disable-next-line require-unicode-regexp
const $9b1bc75748eb73f9$var$PUNCTUATION_BOUNDARY_REGEX = /^[.,;:!?()\[\]{}"'`]+|[.,;:!?()\[\]{}"'`]+$/g;
// eslint-disable-next-line require-unicode-regexp
const $9b1bc75748eb73f9$var$WHITESPACE_SPLIT_REGEX = /\s+/;
// eslint-disable-next-line require-unicode-regexp
const $9b1bc75748eb73f9$var$SENTENCE_BOUNDARY_REGEX = /[\n.?!]+/;
// eslint-disable-next-line require-unicode-regexp
const $9b1bc75748eb73f9$var$TRAILING_WHITESPACE_REGEX = /\s$/;
const $9b1bc75748eb73f9$var$TRAILING_SURFACE_TOKEN_REGEX = RegExp("[\\p{L}\\p{N}_'-]+$", "u");
const $9b1bc75748eb73f9$var$SURFACE_TOKEN_REGEX = RegExp("[\\p{L}\\p{N}_'-]+", "gu");
const $9b1bc75748eb73f9$var$ONLY_WHITESPACE_REGEX = /^\s+$/u;
const $9b1bc75748eb73f9$var$UNIGRAM_PREFETCH_MIN_PREFIX_LENGTH = 1;
const $9b1bc75748eb73f9$var$MULTIWORD_PREFETCH_MIN_PREFIX_LENGTH = 1;
const $9b1bc75748eb73f9$var$DISPLAY_MIN_PREFIX_LENGTH = 3;
const $9b1bc75748eb73f9$var$MAX_CANDIDATES = 200;
const $9b1bc75748eb73f9$var$CONTEXT_WORDS = 10;
const $9b1bc75748eb73f9$var$L3_BASELINE_FREQ = 0.001;
// Max tokens in a completion term (bigram=2, phrase=3). Mirrors the producer's
// `phrase_max_words` default so the FE window never exceeds what was mined.
const $9b1bc75748eb73f9$var$PHRASE_MAX_WORDS = 3;
// Per-window cap on phrase-trie subtree collection (keeps the hot path bounded).
const $9b1bc75748eb73f9$var$MAX_PHRASE_CANDIDATES = 50;
/**
 * Share of its context shortlist's probability mass the model must put on a
 * surface before that surface may be shown.
 *
 * Candidates competing at the same boundary are normalised into a posterior
 * over that shortlist, so this reads directly as "the model is at least this
 * sure". Measuring distance from the best candidate instead cannot express
 * being unsure: the leader scores full marks whether it won by a nose or a
 * mile, which pushes the entire question of how contested a context is onto
 * `MIN_WINNER_MARGIN` — and there the blended score's only remaining spread is
 * the corpus prior, the weakest ranking signal we have.
 *
 * Each extra token raises the bar. A wrong multi-word ghost costs the reader
 * more to notice and undo than a wrong single word, and it is offered from the
 * same keystroke, so precision has to be bought per token of commitment.
 */ const $9b1bc75748eb73f9$var$MIN_LM_POSTERIOR = {
    word: 0.5,
    bigram: 0.6,
    phrase: 0.7
};
/**
 * How many scored candidates a context must hold before its leader may show.
 *
 * A posterior is a share of a shortlist, so a shortlist of one hands its only
 * member 1.0 whatever the model thinks of it — `logSumExp` of a single value
 * returns that value. Such a ghost sits in the top bucket without having beaten
 * anything, and it is the gate's blind spot rather than a case the gate ruled
 * on: 1 in 14 of them were accepted against 34% for word ghosts overall, and
 * every phrase shown through this hole was rejected.
 *
 * Counted over pool membership rather than over the normaliser, because those
 * two deliberately differ. Where a pool holds a surface and its own extension
 * the chain rule leaves one term in the denominator, and the resulting 1.0 is
 * earned — whichever the user meant, the shorter form is a correct ghost.
 *
 * Waived where the context never held a second candidate at all. The 1-in-14
 * acceptance above was measured over a population dominated by pools that read
 * as one because rivals had not come back, and it is that absence of evidence
 * the floor is for. A vocabulary offering a single continuation of a long
 * distinctive prefix is the opposite situation, and it is also where a ghost
 * saves the most keystrokes, so refusing it spends the most to learn the least.
 */ const $9b1bc75748eb73f9$var$MIN_SCORED_POOL_SIZE = 2;
/**
 * Mean per-token log-probability a surface must hold, in nats, independently of
 * anything it was competing against.
 *
 * Every other display test is relative: a posterior is a share of a shortlist,
 * and a winner margin is a distance from a rival. So a surface reaches the
 * screen by being the best of what happened to be in its pool, and nothing ever
 * asks whether the model finds it plausible at all. That gap was tolerable while
 * little was being read, and stopped being tolerable once the scheduler started
 * reading roughly twice as much per decision: shown-per-decision went from 3.2%
 * to 7.4% with no threshold moved, and acceptance of what showed fell from 32%
 * to 24.5%. More reading does not weaken a relative test — it hands it far more
 * pools to be the winner of, and the marginal winner is worse than the average.
 *
 * Set at the point where a uniform distribution over the model's vocabulary
 * sits: 49,152 tokens, so `ln(1/49152)` is about -10.8 nats. Below it the model
 * assigns the surface less mass than a token drawn at random, which is the only
 * statement about a surface that needs no reference to what it competed with.
 *
 * It was first tried at -8, chosen from the bucket where acceptance was measured
 * to fall away, and that reasoning does not survive more data. Acceptance against
 * this quantity turned out to be a smooth slope — about 19% below -8, 26% from -8
 * to -6, then flat near 35% above - with no discontinuity to place a threshold
 * at. A floor on a smooth slope is a coverage dial rather than a test: -8 removed
 * a band converting at 26% and cost 3.7 points of show rate, for an acceptance
 * movement no sample of this size can resolve. Anchoring to uniform instead makes
 * the value an argument about what is indefensible rather than a point picked off
 * a histogram, which is what stops it from being retuned every batch.
 *
 * Applied to the mean over the verified prefix, the same quantity
 * `ghostsByMeanLogProb` buckets, and deliberately not to
 * `meanTokenLogProbabilityUpperBound`. The bound is the right instrument for
 * keeping a candidate in the race, where dropping something that could still
 * clear the bar would be an error, but it is systematically higher than the
 * quantity acceptance is measured against. Judging a surface on the prefix that
 * was actually read is also what every other test here does.
 *
 * One value across all three shapes. Splitting it per shape needs an acceptance
 * curve per shape, and 19 bigrams and 1 phrase across five sessions cannot
 * support one.
 */ const $9b1bc75748eb73f9$var$MIN_MEAN_TOKEN_LOG_PROBABILITY = -10.8;
// Tab replaces the whole remaining suffix, so an N-character completion saves
// N-1 keystrokes: at one character it saves nothing at all and at two it saves
// one, which does not repay noticing the ghost and reaching for Tab. Offering
// them anyway spends the acceptance-rate denominator on completions nobody
// wants and teaches the user to stop reading ghosts. `DISPLAY_MIN_PREFIX_LENGTH`
// is the same guard on the side the user has already typed.
const $9b1bc75748eb73f9$var$MIN_SUGGESTION_LENGTH = 3;
/**
 * How many leading tokens of a surface must be scored before it may be shown.
 *
 * Scoring a token costs one model round trip, and a round trip costs about the
 * same no matter how much is in it, so the price of a candidate is its token
 * count. Demanding every token therefore caps what can ever reach the screen at
 * roughly two tokens inside the decision budget — which is why no phrase has
 * ever been displayed. Verifying a fixed prefix makes the cost of a candidate
 * independent of its length.
 */ const $9b1bc75748eb73f9$var$REQUIRED_VERIFIED_TOKENS = 2;
/**
 * Extra winner margin demanded of a surface judged on a verified prefix rather
 * than on every one of its tokens, to buy back the precision given up by
 * leaving the tail unread.
 */ const $9b1bc75748eb73f9$var$PARTIAL_EVIDENCE_MARGIN_PREMIUM = 0.08;
const $9b1bc75748eb73f9$var$ARBITRATION_MODE = 'confidence-v2';
const $9b1bc75748eb73f9$var$DEBUG_TEXT_TAIL_CHARS = 120;
class $9b1bc75748eb73f9$var$TrieNode {
    constructor(){
        this.children = new Map();
        this.word = null;
        this.tenantFreq = 0;
        this.docFreq = 0;
        this.authorFreq = 0;
        this.sessionFreq = 0;
        // Term-type + phrase metadata. Plain words keep `termType='word'` and null
        // metadata; bigram/phrase nodes carry the producer-shipped POS + association.
        this.termType = 'word';
        this.posSeq = null;
        this.headPos = null;
        this.association = null;
    }
}
class $9b1bc75748eb73f9$var$WeightedWordTrie {
    insert(word, tenantFreq, docFreq, authorFreq, meta) {
        let node = this.root;
        for (const char of word.toLowerCase()){
            let next = node.children.get(char);
            if (!next) {
                next = new $9b1bc75748eb73f9$var$TrieNode();
                node.children.set(char, next);
            }
            node = next;
        }
        node.word = word;
        node.tenantFreq = tenantFreq;
        node.docFreq = docFreq;
        node.authorFreq = authorFreq;
        node.termType = meta?.termType ?? 'word';
        node.posSeq = meta?.posSeq ?? null;
        node.headPos = meta?.headPos ?? null;
        node.association = meta?.association ?? null;
        if (tenantFreq > this.maxTenantFreq) this.maxTenantFreq = tenantFreq;
    }
    /**
   * Return all words matching this prefix, up to maxResults.
   * O(prefix_length + results) — traverses to the prefix node then collects subtree.
   */ getCandidates(prefix, maxResults = $9b1bc75748eb73f9$var$MAX_CANDIDATES) {
        let node = this.root;
        for (const char of prefix.toLowerCase()){
            const next = node.children.get(char);
            if (!next) return [];
            node = next;
        }
        const candidates = [];
        const stack = [
            node
        ];
        while(stack.length > 0 && candidates.length < maxResults){
            const current = stack.pop();
            if (!current) continue;
            // Only add candidates that are longer than the prefix
            if (current.word && current.word.length > prefix.length) candidates.push({
                word: current.word,
                node: current
            });
            for (const child of current.children.values())stack.push(child);
        }
        return candidates;
    }
    findNode(word) {
        let node = this.root;
        for (const char of word.toLowerCase()){
            const next = node.children.get(char);
            if (!next) return null;
            node = next;
        }
        return node.word !== null ? node : null;
    }
    /** Whether this exact surface is stored as a terminal word. */ hasWord(word) {
        return this.findNode(word) !== null;
    }
    /**
   * Set the session frequency for a word.
   * Returns true if the word exists in the trie.
   */ updateSessionFreq(word, count) {
        const node = this.findNode(word);
        if (!node) return false;
        node.sessionFreq = count;
        this.boostedNodes.add(node);
        return true;
    }
    /**
   * Increment the session frequency for a word by 1.
   * Returns true if the word exists in the trie.
   */ incrementSessionFreq(word) {
        const node = this.findNode(word);
        if (!node) return false;
        node.sessionFreq += 1;
        this.boostedNodes.add(node);
        return true;
    }
    /**
   * Zero every session boost, in the number of words boosted rather than the
   * number of words known.
   */ clearSessionBoosts() {
        for (const node of this.boostedNodes)node.sessionFreq = 0;
        this.boostedNodes.clear();
    }
    /**
   * Every word carrying a session boost, optionally limited to one prefix's
   * subtree. Unlike `getCandidates` a word equal to the prefix is included,
   * since the question here is what the session holds rather than what could
   * still be typed.
   *
   * Walks the trie rather than reading `boostedNodes`, since a prefix answer is
   * a subtree question and this only runs when a human asks it.
   */ collectSessionBoosted(prefix = '') {
        let node = this.root;
        for (const char of prefix.toLowerCase()){
            const next = node.children.get(char);
            if (!next) return [];
            node = next;
        }
        const boosted = [];
        const stack = [
            node
        ];
        while(stack.length > 0){
            const current = stack.pop();
            if (!current) continue;
            if (current.word !== null && current.sessionFreq > 0) boosted.push({
                word: current.word,
                node: current
            });
            for (const child of current.children.values())stack.push(child);
        }
        return boosted;
    }
    constructor(){
        this.root = new $9b1bc75748eb73f9$var$TrieNode();
        /**
     * Every node a session boost has been written to.
     *
     * Kept because dropping the boosts is no longer a rare event — it happens
     * each time the reader changes page or conversation — and walking a vocabulary
     * of tens of thousands of words to find the few hundred that were touched
     * costs about 10ms of main thread every time. The two writers below are the
     * only way a `sessionFreq` moves, so keeping this in step costs one Set
     * insertion on a path that is already descending the trie.
     */ this.boostedNodes = new Set();
        /** Highest tenantFreq seen — used to normalize freq scores at query time */ this.maxTenantFreq = 1;
    }
}
// L1/L2 Trie (Session + Atlassian Domain)
const $9b1bc75748eb73f9$var$wordTrie = new $9b1bc75748eb73f9$var$WeightedWordTrie();
// L3 Trie (General English Fallback)
const $9b1bc75748eb73f9$var$l3Trie = new $9b1bc75748eb73f9$var$WeightedWordTrie();
/**
 * L2 phrase/bigram trie. Kept SEPARATE from `wordTrie` so single-word
 * completion + L3 gap-fill stay untouched; multi-word units are only surfaced
 * by the (12b) multiword prefix-window matcher. Keys are the full normalized
 * surface string (spaces included), e.g. `"return on investment"`, so a lookup
 * is a plain char-trie walk over the whole phrase.
 */ const $9b1bc75748eb73f9$var$phraseTrie = new $9b1bc75748eb73f9$var$WeightedWordTrie();
const $9b1bc75748eb73f9$export$e83b7608dafb1b7 = (l3Words)=>{
    for (const word of l3Words)// Insert with a tiny baseline frequency so it mathematically
    // loses to any domain word in Stage 1, but still scores above 0.
    $9b1bc75748eb73f9$var$l3Trie.insert(word, $9b1bc75748eb73f9$var$L3_BASELINE_FREQ, 0, 0);
    $9b1bc75748eb73f9$var$recallGeneration++;
    (0, $dl7hN.ctcTag)('init', `L3 general English loaded: ${l3Words.length} words`);
};
// const bigramMap: Map<string, Record<string, number>> = new Map(
// 	Object.entries(bigramsData as Record<string, Record<string, number>>),
// );
let $9b1bc75748eb73f9$var$isInitialized = false;
let $9b1bc75748eb73f9$var$vectorStore = null;
let $9b1bc75748eb73f9$var$vectorsLoadStarted = false;
// Phrase/bigram artifacts load independently of the word vocabulary so a
// missing/late `bigrams.json`/`phrases.json` never breaks word completion.
let $9b1bc75748eb73f9$var$phrasesLoadStarted = false;
let $9b1bc75748eb73f9$var$phrasesLoaded = false;
let $9b1bc75748eb73f9$var$phraseTermCount = 0;
// Per-type frequency maxima, tracked separately because bigrams and phrases
// share one trie but have very different absolute frequency ranges (bigrams are
// far more frequent than 3-word phrases). Normalizing each type by its OWN max
// stops phrase freq scores from being crushed against the top bigram's count.
let $9b1bc75748eb73f9$var$maxBigramFreq = 1;
let $9b1bc75748eb73f9$var$maxPhraseFreq = 1;
let $9b1bc75748eb73f9$var$lastPredictionDebug = null;
let $9b1bc75748eb73f9$var$lastPredictionOutcome = null;
const $9b1bc75748eb73f9$var$recordPredictionOutcome = (outcome)=>{
    $9b1bc75748eb73f9$var$lastPredictionOutcome = outcome;
};
const $9b1bc75748eb73f9$export$7d201d50fd19305a = ()=>$9b1bc75748eb73f9$var$lastPredictionOutcome;
// ── Stabilization (QI-2): post-accept cooldown + whole-surface repetition ────
// Two guards that stop the accept→echo (`end to end` → `end to end to end`) and
// generally keep a just-accepted unit from being re-offered:
//  • repetition: never surface a candidate whose full surface already equals the
//    run of tokens immediately before the cursor (handled inline in predict()).
//  • cooldown: after an accept, briefly suppress re-offering that same unit. The
//    cooldown lifts only once BOTH the keystroke budget and the time window have
//    elapsed (either one still counting keeps it active).
const $9b1bc75748eb73f9$var$COOLDOWN_KEYSTROKES = 5;
const $9b1bc75748eb73f9$var$COOLDOWN_MS = 2000;
// Active post-accept cooldown, or null when none.
let $9b1bc75748eb73f9$var$acceptCooldown = null;
const $9b1bc75748eb73f9$export$aa59c0c98e9e4f4b = (surface)=>{
    const normalizedSurface = surface.trim().toLowerCase();
    if (normalizedSurface) $9b1bc75748eb73f9$var$acceptCooldown = {
        predictionsSince: 0,
        surface: normalizedSurface,
        ts: performance.now()
    };
};
const $9b1bc75748eb73f9$export$a7d8235b640c18e1 = (surface)=>{
    if (!$9b1bc75748eb73f9$var$acceptCooldown || $9b1bc75748eb73f9$var$acceptCooldown.surface !== surface.trim().toLowerCase()) return false;
    return $9b1bc75748eb73f9$var$acceptCooldown.predictionsSince <= $9b1bc75748eb73f9$var$COOLDOWN_KEYSTROKES || performance.now() - $9b1bc75748eb73f9$var$acceptCooldown.ts < $9b1bc75748eb73f9$var$COOLDOWN_MS;
};
/** Get vector for a word from the store. */ const $9b1bc75748eb73f9$var$getWordVector = (word)=>{
    if (!$9b1bc75748eb73f9$var$vectorStore) return null;
    const idx = $9b1bc75748eb73f9$var$vectorStore.wordIndex[word.toLowerCase()];
    if (idx === undefined) return null;
    const start = idx * $9b1bc75748eb73f9$var$vectorStore.dim;
    return $9b1bc75748eb73f9$var$vectorStore.float32.subarray(start, start + $9b1bc75748eb73f9$var$vectorStore.dim);
};
/**
 * Compute context vector by averaging vectors of last N words in text.
 * Falls back to null (cold mode) if no words have vectors.
 */ const $9b1bc75748eb73f9$var$computeContextVectorLocal = (textBefore)=>{
    if (!$9b1bc75748eb73f9$var$vectorStore) return null;
    const tokens = $9b1bc75748eb73f9$var$tokenize(textBefore);
    const words = tokens.slice(-$9b1bc75748eb73f9$var$CONTEXT_WORDS);
    const vectors = [];
    for (const word of words){
        const v = $9b1bc75748eb73f9$var$getWordVector(word);
        if (v) vectors.push(v);
    }
    if (vectors.length === 0) return null;
    const dim = $9b1bc75748eb73f9$var$vectorStore.dim;
    const avg = new Float32Array(dim);
    for (const v of vectors)for(let i = 0; i < dim; i++)avg[i] += v[i];
    for(let i = 0; i < dim; i++)avg[i] /= vectors.length;
    return avg;
};
/**
 * Get context vector for scoring. Prefers Slow Lane (BE) context when available
 * and dimension matches; otherwise falls back to local averaging.
 */ const $9b1bc75748eb73f9$var$getContextVectorForScoring = (textBefore)=>{
    const slowLaneVector = (0, $gpRHn.getStoredContextVector)();
    if (slowLaneVector && $9b1bc75748eb73f9$var$vectorStore && slowLaneVector.length === $9b1bc75748eb73f9$var$vectorStore.dim) return slowLaneVector;
    return $9b1bc75748eb73f9$var$computeContextVectorLocal(textBefore);
};
const $9b1bc75748eb73f9$var$tokenize = (text)=>{
    const tokens = [];
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
    for (const raw of text.toLowerCase().split($9b1bc75748eb73f9$var$WHITESPACE_SPLIT_REGEX)){
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
        const clean = raw.replace($9b1bc75748eb73f9$var$PUNCTUATION_BOUNDARY_REGEX, '');
        if (clean.length >= 2) tokens.push(clean);
    }
    return tokens;
};
const $9b1bc75748eb73f9$var$extractPreviousWord = (text)=>{
    // Only consider the current sentence/line the user is typing in.
    const sentences = text.split($9b1bc75748eb73f9$var$SENTENCE_BOUNDARY_REGEX);
    const currentSentence = sentences[sentences.length - 1];
    const words = currentSentence.trimEnd().split($9b1bc75748eb73f9$var$WHITESPACE_SPLIT_REGEX);
    return words.length >= 2 ? words[words.length - 2] : '';
};
/**
 * Collect phrase/bigram completion candidates for the multi-word window ending
 * at the current partial token.
 *
 * Builds windows of the last `2..PHRASE_MAX_WORDS` tokens of the current
 * sentence (widest first) and prefix-searches the phrase trie for each, so
 * `quarterly pla` matches `quarterly planning meeting`. Windows never cross a
 * sentence boundary (mirrors `extractPreviousWord`). Each result records the
 * matched window length so the caller can compute the ghost tail.
 *
 * :params:
 *   trimmed: Text before the cursor, trailing whitespace already removed
 * :returns:
 *   Matched phrase candidates (deduped, widest-window match wins per term)
 */ const $9b1bc75748eb73f9$var$getPhraseCandidates = (trimmed)=>{
    // Records every prefix window we probe and its match count so the (verbose)
    // debug line makes it obvious whether the phrase path found nothing because the
    // trie is empty, or because no phrase begins with the typed window.
    const windowsTried = [];
    const logPhrasePath = (skipReason)=>{
        if (!(0, $dl7hN.isAutocompleteDebugVerbose)()) return;
        const detail = skipReason ? skipReason : `windows: ${windowsTried.map((w)=>`"${w.window}"\u{2192}${w.matches}`).join(', ') || '(none)'}`;
        (0, $dl7hN.ctcTag)('phrase', `loaded=${$9b1bc75748eb73f9$var$phraseTermCount} (${$9b1bc75748eb73f9$var$phrasesLoaded ? 'ready' : 'not loaded'}) \xb7 ${detail}`, (0, $dl7hN.CTC_STYLES).section);
    };
    if ($9b1bc75748eb73f9$var$phraseTermCount === 0) {
        logPhrasePath("phrase trie empty \u2014 bigrams.json/phrases.json not loaded (or 0 terms)");
        return [];
    }
    const tokenMatches = Array.from(trimmed.matchAll($9b1bc75748eb73f9$var$SURFACE_TOKEN_REGEX));
    const lastMatch = tokenMatches[tokenMatches.length - 1];
    const lastStart = lastMatch?.index;
    if (!lastMatch || lastStart === undefined || lastStart + lastMatch[0].length !== trimmed.length) {
        logPhrasePath('no tokens in current sentence');
        return [];
    }
    const trailingTokens = [
        {
            start: lastStart,
            value: lastMatch[0]
        }
    ];
    for(let i = tokenMatches.length - 2; i >= 0; i--){
        const current = trailingTokens[0];
        const match = tokenMatches[i];
        const start = match.index;
        if (start === undefined) break;
        const end = start + match[0].length;
        const gap = trimmed.slice(end, current.start);
        if (!$9b1bc75748eb73f9$var$ONLY_WHITESPACE_REGEX.test(gap)) break;
        trailingTokens.unshift({
            start: start,
            value: match[0]
        });
        if (trailingTokens.length >= $9b1bc75748eb73f9$var$PHRASE_MAX_WORDS) break;
    }
    const partial = trailingTokens[trailingTokens.length - 1].value;
    const results = [];
    const seen = new Set();
    const maxPrev = trailingTokens.length - 1;
    // Widest window first so the most specific (longest-context) match wins the
    // dedup for a given phrase term. `prev` is the number of *preceding* complete
    // words included ahead of the current partial:
    //   prev ≥ 1 → "continue a phrase I've started" (e.g. "root c" → root cause).
    //              Preceding-word context is strong, so a short partial is fine.
    //   prev = 0 → "the partial is a phrase's FIRST word" (e.g. "root" → root
    //              cause). No preceding context, so require the partial to be a
    //              one character so grouped LM work can begin early. UI remains
    //              gated at DISPLAY_MIN_PREFIX_LENGTH.
    for(let prev = maxPrev; prev >= 0; prev--){
        if (prev === 0 && partial.length < $9b1bc75748eb73f9$var$MULTIWORD_PREFETCH_MIN_PREFIX_LENGTH) continue;
        const windowTokens = trailingTokens.slice(-(prev + 1));
        const windowPrefix = windowTokens.map((token)=>token.value).join(' ').toLowerCase();
        const windowLen = windowPrefix.length;
        const matches = $9b1bc75748eb73f9$var$phraseTrie.getCandidates(windowPrefix, $9b1bc75748eb73f9$var$MAX_PHRASE_CANDIDATES);
        windowsTried.push({
            window: windowPrefix,
            matches: matches.length
        });
        for (const match of matches){
            if (seen.has(match.word)) continue;
            seen.add(match.word);
            results.push({
                node: match.node,
                word: match.word,
                matchedPrefixLen: windowLen,
                surfaceStart: windowTokens[0].start
            });
        }
    }
    logPhrasePath();
    return results;
};
const $9b1bc75748eb73f9$export$fb0c1e3d681867d2 = ()=>{
    const slowLaneStatus = (0, $gpRHn.getDefaultSlowLaneClientStatus)();
    return {
        canonicalScoringSupported: slowLaneStatus.canonicalScoringSupported,
        canonicalSurfaceCount: slowLaneStatus.canonicalSurfaceCount,
        clientId: slowLaneStatus.clientId,
        clientKind: slowLaneStatus.clientKind,
        localModelReady: slowLaneStatus.localModelReady,
        slowLaneRegistered: slowLaneStatus.registered,
        vectorsLoaded: $9b1bc75748eb73f9$var$vectorStore !== null,
        wordCount: $9b1bc75748eb73f9$var$vectorStore ? Object.keys($9b1bc75748eb73f9$var$vectorStore.wordIndex).length : 0,
        vectorsLoadStarted: $9b1bc75748eb73f9$var$vectorsLoadStarted,
        isInitialized: $9b1bc75748eb73f9$var$isInitialized,
        phrasesLoaded: $9b1bc75748eb73f9$var$phrasesLoaded,
        phraseCount: $9b1bc75748eb73f9$var$phraseTermCount,
        maxFreqByType: {
            word: $9b1bc75748eb73f9$var$wordTrie.maxTenantFreq,
            bigram: $9b1bc75748eb73f9$var$maxBigramFreq,
            phrase: $9b1bc75748eb73f9$var$maxPhraseFreq
        }
    };
};
const $9b1bc75748eb73f9$export$fd2b59f22034dd2c = ()=>{
    return $9b1bc75748eb73f9$var$lastPredictionDebug;
};
const $9b1bc75748eb73f9$export$23ef18e0b7a5148d = (vocabulary)=>{
    for (const term of vocabulary.terms)$9b1bc75748eb73f9$var$wordTrie.insert(term.word, term.freq, term.docFreq, term.authorFreq);
    $9b1bc75748eb73f9$var$isInitialized = true;
    $9b1bc75748eb73f9$var$recallGeneration++;
};
const $9b1bc75748eb73f9$export$8fc7cb5981325f60 = (artifact, termType)=>{
    let count = 0;
    for (const [term, stats] of Object.entries(artifact)){
        $9b1bc75748eb73f9$var$phraseTrie.insert(term, stats.freq, stats.doc_freq, stats.author_freq, {
            termType: termType,
            posSeq: stats.pos_seq ?? null,
            headPos: stats.head_pos ?? null,
            association: stats.association ?? null
        });
        // Track each type's own frequency ceiling for per-type normalization.
        if (termType === 'bigram') {
            if (stats.freq > $9b1bc75748eb73f9$var$maxBigramFreq) $9b1bc75748eb73f9$var$maxBigramFreq = stats.freq;
        } else if (stats.freq > $9b1bc75748eb73f9$var$maxPhraseFreq) $9b1bc75748eb73f9$var$maxPhraseFreq = stats.freq;
        count++;
    }
    $9b1bc75748eb73f9$var$phraseTermCount += count;
    $9b1bc75748eb73f9$var$recallGeneration++;
    return count;
};
const $9b1bc75748eb73f9$export$3a8c67928d5f769d = (word)=>{
    $9b1bc75748eb73f9$var$wordTrie.incrementSessionFreq(word);
};
const $9b1bc75748eb73f9$export$7151fdda90e36782 = ()=>{
    $9b1bc75748eb73f9$var$wordTrie.clearSessionBoosts();
    // Anything memoized against the old boosts is now describing a session that
    // no longer exists.
    $9b1bc75748eb73f9$var$recallGeneration++;
};
const $9b1bc75748eb73f9$export$b641b45d2eba9391 = (word)=>{
    if ($9b1bc75748eb73f9$var$wordTrie.hasWord(word)) return 'l2';
    return $9b1bc75748eb73f9$var$l3Trie.hasWord(word) ? 'l3' : null;
};
const $9b1bc75748eb73f9$export$4c0c6bb8e981b843 = (pageContent)=>{
    if (!pageContent) return;
    const words = $9b1bc75748eb73f9$var$tokenize(pageContent);
    const validBoostedWords = new Set();
    for (const word of words){
        const didBoost = $9b1bc75748eb73f9$var$wordTrie.incrementSessionFreq(word);
        if (didBoost) validBoostedWords.add(word);
    }
    if ((0, $dl7hN.isAutocompleteDebugEnabled)() && validBoostedWords.size > 0) {
        (0, $dl7hN.ctcTag)('init', `L1 session primed ${validBoostedWords.size} words from page \xb7 __atlCtcDebug__.session() to inspect`, (0, $dl7hN.CTC_STYLES).brand);
        if ((0, $dl7hN.isAutocompleteDebugVerbose)()) // eslint-disable-next-line no-console
        console.dir(Array.from(validBoostedWords).sort());
    }
};
/**
 * How many boosted words `inspectSessionBoosts` lists.
 *
 * A page ingest can boost thousands, and a list that long is not read. The
 * strongest boosts are the ones that change an ordering, and `boosted` still
 * reports the full size, so the cap loses nothing but volume.
 */ const $9b1bc75748eb73f9$var$MAX_LISTED_SESSION_WORDS = 100;
const $9b1bc75748eb73f9$export$b8adc9808f469020 = (prefix)=>{
    const boosted = $9b1bc75748eb73f9$var$wordTrie.collectSessionBoosted(prefix ?? '');
    return {
        boosted: boosted.length,
        limit: $9b1bc75748eb73f9$var$MAX_LISTED_SESSION_WORDS,
        ...prefix === undefined ? {} : {
            prefix: prefix
        },
        words: boosted.sort((a, b)=>b.node.sessionFreq - a.node.sessionFreq || a.word.localeCompare(b.word, 'en', {
                numeric: true,
                sensitivity: 'base'
            })).slice(0, $9b1bc75748eb73f9$var$MAX_LISTED_SESSION_WORDS).map(({ node: node, word: word })=>({
                sessionFreq: node.sessionFreq,
                sessionOnly: node.tenantFreq === 0,
                surface: word,
                tenantFreq: node.tenantFreq
            }))
    };
};
// At module scope so the console answers before the first keystroke, which is
// when someone reaching for it usually asks.
(0, $dl7hN.registerCtcSessionInspector)($9b1bc75748eb73f9$export$b8adc9808f469020);
/**
 * Bumped whenever an artifact load changes what the tries can return, which is
 * the only way the candidate *set* for a given prefix can change.
 *
 * Session-frequency boosts are deliberately not counted: they mutate trie nodes
 * in place, and the memo holds those nodes by reference, so a boost is already
 * visible through a cached entry.
 */ let $9b1bc75748eb73f9$var$recallGeneration = 0;
let $9b1bc75748eb73f9$var$recallMemo = null;
const $9b1bc75748eb73f9$var$computeCanonicalRecall = (trimmed, currentWord, currentWordStart)=>{
    // Start recall at one character so grouped causal work can overlap later
    // keystrokes. Nothing is displayed until three characters.
    const wordCandidates = currentWord.length >= $9b1bc75748eb73f9$var$UNIGRAM_PREFETCH_MIN_PREFIX_LENGTH ? $9b1bc75748eb73f9$var$wordTrie.getCandidates(currentWord, $9b1bc75748eb73f9$var$MAX_CANDIDATES) : [];
    // Gap-fill from the L3 general-English trie, requesting a full buffer so
    // enough survive de-duplication against the L2 results.
    if (currentWord.length >= $9b1bc75748eb73f9$var$UNIGRAM_PREFETCH_MIN_PREFIX_LENGTH && wordCandidates.length < $9b1bc75748eb73f9$var$MAX_CANDIDATES) {
        const l3Candidates = $9b1bc75748eb73f9$var$l3Trie.getCandidates(currentWord, $9b1bc75748eb73f9$var$MAX_CANDIDATES);
        const existingWords = new Set(wordCandidates.map((c)=>c.word));
        for (const l3c of l3Candidates){
            if (wordCandidates.length >= $9b1bc75748eb73f9$var$MAX_CANDIDATES) break;
            if (!existingWords.has(l3c.word)) wordCandidates.push(l3c);
        }
    }
    // Multi-word completion terms (bigrams/phrases) matched on the trailing
    // window ending at the current partial token. Runs even when the unigram path
    // was skipped for a short partial, so first-word/early phrase matches surface.
    const phraseCandidates = $9b1bc75748eb73f9$var$getPhraseCandidates(trimmed);
    // Unify: a word completes the current partial token; a phrase completes its
    // matched multi-word window. Track the prefix length per term so the ghost
    // tail is sliced correctly regardless of term type.
    const matched = [
        ...wordCandidates.map(({ word: word, node: node })=>({
                word: word,
                node: node,
                matchedPrefixLen: currentWord.length,
                surfaceStart: currentWordStart
            })),
        ...phraseCandidates
    ];
    const positionCache = (0, $eGuir.createCanonicalContextPositionCache)();
    const canonicalMatched = matched.map((candidate)=>({
            ...candidate,
            ...(0, $eGuir.deriveCanonicalCandidateContext)(trimmed, candidate.matchedPrefixLen, candidate.word, (0, $gpRHn.getCanonicalSurfaceTokenIds), candidate.surfaceStart, positionCache)
        }));
    const prefixLenByWord = new Map();
    for (const m of canonicalMatched)if (!prefixLenByWord.has(m.word)) prefixLenByWord.set(m.word, m.matchedPrefixLen);
    return {
        canonicalMatched: canonicalMatched,
        prefixLenByWord: prefixLenByWord
    };
};
/**
 * Recall and canonical derivation for `trimmed`, reusing the previous result
 * when nothing they depend on has changed.
 *
 * `predict()` runs several times for one keystroke — once when the decision
 * opens and again for each async evidence signal that lands inside the budget —
 * and only the evidence differs between those runs. Without this, every run
 * re-walks the tries and re-derives a canonical context per candidate.
 */ const $9b1bc75748eb73f9$var$getCanonicalRecall = (trimmed, currentWord, currentWordStart)=>{
    const surfaceCount = (0, $gpRHn.getCanonicalSurfaceCount)();
    if ($9b1bc75748eb73f9$var$recallMemo !== null && $9b1bc75748eb73f9$var$recallMemo.trimmed === trimmed && $9b1bc75748eb73f9$var$recallMemo.generation === $9b1bc75748eb73f9$var$recallGeneration && $9b1bc75748eb73f9$var$recallMemo.surfaceCount === surfaceCount) return $9b1bc75748eb73f9$var$recallMemo;
    const recall = $9b1bc75748eb73f9$var$computeCanonicalRecall(trimmed, currentWord, currentWordStart);
    $9b1bc75748eb73f9$var$recallMemo = {
        ...recall,
        generation: $9b1bc75748eb73f9$var$recallGeneration,
        surfaceCount: surfaceCount,
        trimmed: trimmed
    };
    return recall;
};
const $9b1bc75748eb73f9$export$f2757470e79e02f3 = (textBefore)=>{
    if (!$9b1bc75748eb73f9$var$isInitialized) {
        // Vocabulary artifacts load asynchronously over the autocomplete gateway.
        // Kick off the load and skip this keystroke; the plugin also primes it on
        // focus, so the tries are usually ready before the user types.
        $9b1bc75748eb73f9$export$346f2d6e47b2ef51({
            source: 'predict'
        }).catch(()=>{});
        // Awaiting, not empty-handed: with no vocabulary loaded the harvester's own
        // intake filter has not been applied to anything either.
        $9b1bc75748eb73f9$var$recordPredictionOutcome({
            abstainReason: 'not-initialized',
            awaitingAsyncEvidence: true,
            scoredCandidateCount: 0,
            textBefore: textBefore
        });
        return null;
    }
    const t0 = performance.now();
    // Advance the post-accept cooldown once per prediction. It stays active until
    // BOTH the keystroke budget and the time window have elapsed; while active it
    // suppresses re-offering the just-accepted surface (see arbitration below).
    let cooledSurface = null;
    if ($9b1bc75748eb73f9$var$acceptCooldown) {
        $9b1bc75748eb73f9$var$acceptCooldown.predictionsSince += 1;
        const stillByKeys = $9b1bc75748eb73f9$var$acceptCooldown.predictionsSince <= $9b1bc75748eb73f9$var$COOLDOWN_KEYSTROKES;
        const stillByTime = performance.now() - $9b1bc75748eb73f9$var$acceptCooldown.ts < $9b1bc75748eb73f9$var$COOLDOWN_MS;
        if (stillByKeys || stillByTime) cooledSurface = $9b1bc75748eb73f9$var$acceptCooldown.surface;
        else $9b1bc75748eb73f9$var$acceptCooldown = null;
    }
    // ── Boundary/early-prefix prefetch; display remains gated at ≥3 ─────────
    if (textBefore.length > 0 && $9b1bc75748eb73f9$var$TRAILING_WHITESPACE_REGEX.test(textBefore)) {
        const boundaryContext = (0, $eGuir.deriveWhitespaceBoundaryContext)(textBefore);
        if (boundaryContext) (0, $gpRHn.primeBoundaryLm)({
            ...boundaryContext,
            familyKey: boundaryContext.contextKey,
            priority: 0
        });
        $9b1bc75748eb73f9$var$recordPredictionOutcome({
            abstainReason: 'prefetch',
            awaitingAsyncEvidence: true,
            scoredCandidateCount: 0,
            textBefore: textBefore
        });
        return null;
    }
    const trimmed = textBefore.trimEnd();
    const trailingSurfaceToken = trimmed.match($9b1bc75748eb73f9$var$TRAILING_SURFACE_TOKEN_REGEX)?.[0] ?? '';
    if (trailingSurfaceToken.length === 0) {
        $9b1bc75748eb73f9$var$recordPredictionOutcome({
            abstainReason: 'no-surface-token',
            awaitingAsyncEvidence: false,
            scoredCandidateCount: 0,
            textBefore: textBefore
        });
        return null;
    }
    const currentWord = trailingSurfaceToken;
    const currentWordStart = trimmed.length - currentWord.length;
    const { canonicalMatched: canonicalMatched, prefixLenByWord: prefixLenByWord } = $9b1bc75748eb73f9$var$getCanonicalRecall(trimmed, currentWord, currentWordStart);
    // If every trie was empty for this prefix
    if (canonicalMatched.length === 0) {
        // Terminal, and the only verdict that says the vocabulary has no claim on
        // this prefix at all — which is what makes it the harvester's cue.
        $9b1bc75748eb73f9$var$recordPredictionOutcome({
            abstainReason: 'no-candidate',
            awaitingAsyncEvidence: false,
            scoredCandidateCount: 0,
            textBefore: textBefore
        });
        if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
        console.log(`%c[CTC]%c \u{2014} abstain: no matches for "${currentWord}"`, (0, $dl7hN.CTC_STYLES).brand, (0, $dl7hN.CTC_STYLES).body);
        return null;
    }
    const previousWord = $9b1bc75748eb73f9$var$extractPreviousWord(trimmed);
    const contextVector = $9b1bc75748eb73f9$var$getContextVectorForScoring(trimmed);
    const lmLogits = (0, $gpRHn.getStoredLmLogits)();
    const mode = contextVector ? 'warm' : 'cold';
    // Build ScoringCandidate array from matched terms (words + phrases)
    const scoringCandidates = canonicalMatched.map(({ word: word, node: node })=>({
            word: word,
            tenantFreq: node.tenantFreq,
            docFreq: node.docFreq,
            authorFreq: node.authorFreq,
            sessionFreq: node.sessionFreq,
            termType: node.termType,
            posSeq: node.posSeq,
            headPos: node.headPos,
            association: node.association
        }));
    // Filter the LM payload to only words matching the current prefix so that
    // lmMax in rankCandidates reflects prefix-relevant signal, not the global distribution.
    const prefix = currentWord.toLowerCase();
    const currentWordSeparator = canonicalMatched.find((candidate)=>candidate.node.termType === 'word')?.separatorKind;
    const prefixLmLogits = lmLogits && currentWordSeparator === 'whitespace' ? Object.fromEntries(Object.entries(lmLogits).filter(([word])=>word.startsWith(prefix))) : null;
    const canonicalScoringSupported = (0, $gpRHn.isCanonicalSurfaceScoringSupported)();
    const eligibleContextKeys = Array.from(new Set(canonicalMatched.filter((candidate)=>candidate.canonicalTokenIds !== null).map((candidate)=>candidate.contextKey))).sort();
    const familyKey = eligibleContextKeys.join('\u0001');
    const primeRequests = (0, $eGuir.selectBoundaryPrimeRequests)(familyKey, canonicalMatched, $9b1bc75748eb73f9$var$PHRASE_MAX_WORDS);
    for (const request of primeRequests)(0, $gpRHn.primeBoundaryLm)(request);
    const runtimeBySurface = new Map(canonicalMatched.map((candidate)=>[
            candidate.word,
            candidate
        ]));
    const canonicalEvidence = new Map();
    const firstTokenGroups = new Map();
    for (const candidate of canonicalMatched){
        if (candidate.canonicalTokenIds === null) continue;
        // This accessor also materializes an exact cache entry when all tokens
        // have already been covered by shared-prefix work.
        (0, $gpRHn.getProgressiveSurfaceEvidence)(candidate.contextKey, candidate.word);
        const exact = (0, $gpRHn.getSurfaceScore)(candidate.contextKey, candidate.word);
        if (exact) {
            canonicalEvidence.set(candidate.word, {
                contextKey: candidate.contextKey,
                meanTokenLogProbability: exact.meanTokenLogProbability,
                score: 0,
                separatorKind: 'whitespace',
                source: 'canonical-full-surface',
                totalLogProbability: exact.totalLogProbability,
                totalSurfaceCharCount: candidate.word.length,
                totalTokenCount: exact.tokenCount,
                verifiedCharCount: candidate.word.length,
                verifiedTokenCount: exact.tokenCount
            });
            continue;
        }
        const group = firstTokenGroups.get(candidate.contextKey) ?? [];
        group.push(candidate);
        firstTokenGroups.set(candidate.contextKey, group);
    }
    for (const [contextKey, group] of firstTokenGroups){
        const boundary = (0, $gpRHn.getBoundaryLmState)(contextKey);
        if (!boundary) continue;
        let maxLogit = -Infinity;
        for (const candidate of group){
            const tokenId = candidate.canonicalTokenIds?.[0];
            const rawLogit = tokenId === undefined ? undefined : boundary.rawLogits[tokenId];
            if (rawLogit !== undefined && Number.isFinite(rawLogit) && rawLogit > maxLogit) maxLogit = rawLogit;
        }
        if (!Number.isFinite(maxLogit)) continue;
        for (const candidate of group){
            const tokenId = candidate.canonicalTokenIds?.[0];
            const rawLogit = tokenId === undefined ? undefined : boundary.rawLogits[tokenId];
            if (rawLogit === undefined || !Number.isFinite(rawLogit)) continue;
            const tokenCount = candidate.canonicalTokenIds?.length ?? 0;
            if (tokenId !== undefined && tokenCount === 1) {
                const totalLogProbability = (0, $eGuir.logSoftmaxAt)(boundary.rawLogits, tokenId);
                if (!Number.isFinite(totalLogProbability)) continue;
                canonicalEvidence.set(candidate.word, {
                    contextKey: contextKey,
                    meanTokenLogProbability: totalLogProbability,
                    score: 0,
                    separatorKind: 'whitespace',
                    source: 'canonical-full-surface',
                    totalLogProbability: totalLogProbability,
                    totalSurfaceCharCount: candidate.word.length,
                    totalTokenCount: 1,
                    verifiedCharCount: candidate.word.length,
                    verifiedTokenCount: 1
                });
                continue;
            }
            canonicalEvidence.set(candidate.word, {
                contextKey: contextKey,
                rawLogit: rawLogit,
                score: 0,
                separatorKind: 'whitespace',
                source: 'canonical-first-token',
                totalSurfaceCharCount: candidate.word.length,
                totalTokenCount: tokenCount,
                verifiedCharCount: 0,
                verifiedTokenCount: 1
            });
        }
    }
    const { candidates: ranked, grammarMeta: grammarMeta, pipelineDebug: pipelineDebug } = (0, $cVZWR.rankCandidates)(scoringCandidates, contextVector, (w)=>$9b1bc75748eb73f9$var$getWordVector(w), prefixLmLogits, {
        word: $9b1bc75748eb73f9$var$wordTrie.maxTenantFreq,
        bigram: $9b1bc75748eb73f9$var$maxBigramFreq,
        phrase: $9b1bc75748eb73f9$var$maxPhraseFreq
    }, previousWord, (surface)=>canonicalEvidence.get(surface) ?? null);
    const progressiveEligible = ranked.filter((candidate)=>{
        const runtime = runtimeBySurface.get(candidate.word);
        return runtime?.canonicalTokenIds !== null && runtime?.canonicalTokenIds !== undefined;
    });
    if (canonicalScoringSupported && progressiveEligible.length > 0) {
        const byContext = new Map();
        for (const candidate of progressiveEligible){
            const runtime = runtimeBySurface.get(candidate.word);
            if (!runtime || runtime.canonicalTokenIds === null) continue;
            const group = byContext.get(runtime.contextKey) ?? [];
            group.push({
                runtime: runtime,
                rankHint: candidate.stage1Score
            });
            byContext.set(runtime.contextKey, group);
        }
        for (const [contextKey, group] of byContext)(0, $gpRHn.requestProgressiveSurfaceScores)({
            familyKey: familyKey,
            contextKey: contextKey,
            prompt: group[0].runtime.contextBeforeSurface,
            candidates: group.map(({ runtime: runtime, rankHint: rankHint })=>({
                    surface: runtime.word,
                    tokenIds: runtime.canonicalTokenIds ?? [],
                    rankHint: rankHint
                }))
        });
    }
    // The one/two-character passes exist only to hide model latency. They may
    // prime and expand token groups above, but cannot commit UI.
    const displayPrefixReady = currentWord.length >= $9b1bc75748eb73f9$var$DISPLAY_MIN_PREFIX_LENGTH;
    // ── Arbitration: full-surface evidence → plausibility → winner margin ──
    const canonicalLmSupported = canonicalScoringSupported;
    const hasExactEvidence = (candidate)=>candidate.lmEvidence?.source === 'canonical-full-surface' && candidate.lmEvidence.meanTokenLogProbability !== undefined && Number.isFinite(candidate.lmEvidence.meanTokenLogProbability);
    /**
   * The evidence this candidate is judged on: the summed log-probability of
   * the tokens that have been read, their per-token mean, and whether they
   * cover the whole surface.
   *
   * `total` is the quantity the posterior is built from — it is a sequence
   * log-likelihood, so it is comparable across surfaces of different lengths
   * in a way the mean is not. `mean` is retained for reporting and for the
   * oracle arms, which compare aggregation rules against each other.
   *
   * Every token read costs a round trip, so a surface longer than
   * `REQUIRED_VERIFIED_TOKENS` is judged on its leading tokens and its tail is
   * left unread. Callers compensate with a wider winner margin rather than
   * treating the two kinds of evidence as equivalent.
   *
   * This is the depth-unaware read, and it is what the pool below is built
   * from. Arbitration goes through `judgedEvidenceFor`, which adds the one
   * requirement that can only be stated once the pool is known: a surface
   * cannot be judged against members it has not yet been read level with.
   */ const readJudgedEvidence = (candidate)=>{
        const evidence = candidate.lmEvidence;
        const exactMean = evidence?.meanTokenLogProbability;
        if (hasExactEvidence(candidate) && evidence && exactMean !== undefined) {
            const total = evidence.totalLogProbability ?? exactMean * evidence.totalTokenCount;
            return Number.isFinite(total) ? {
                complete: true,
                mean: exactMean,
                total: total
            } : null;
        }
        const runtime = runtimeBySurface.get(candidate.word);
        if (!runtime || runtime.canonicalTokenIds === null) return null;
        const progressive = (0, $gpRHn.getProgressiveSurfaceEvidence)(runtime.contextKey, candidate.word);
        if (!progressive || progressive.scoredTokenCount < $9b1bc75748eb73f9$var$REQUIRED_VERIFIED_TOKENS) return null;
        const total = progressive.totalLogProbability;
        const mean = total / progressive.scoredTokenCount;
        return Number.isFinite(mean) && Number.isFinite(total) ? {
            complete: false,
            mean: mean,
            total: total
        } : null;
    };
    // Normalise each context's shortlist into a posterior. `total` is a sequence
    // log-likelihood, so `exp(total - logSumExp(totals))` is the share of the
    // shortlist's probability mass the model puts on that surface.
    //
    // Unknown future token log-probabilities cannot exceed zero, so a partially
    // read candidate's total is an upper bound on its eventual total, and its
    // posterior an upper bound on its eventual posterior. That is what lets the
    // plausibility floor and the display gate be the same threshold — one
    // applied to the bound, one to the verified value — instead of two numbers
    // that have to be kept consistent by hand.
    //
    // Candidates with no evidence at all are left out of the sum rather than
    // defaulted. Any default would have to stand in for a log-probability, and a
    // value low enough not to distort the normaliser is indistinguishable from
    // omitting the candidate.
    const optimisticTotalByWord = new Map();
    const contextTotals = new Map();
    const contextSurfaces = new Map();
    // Counted before the total is looked up, so this is every candidate the
    // context could have scored rather than every candidate it did. The gap
    // between the two is what separates a context holding one match from a
    // context whose rivals have not come back yet.
    const contextRequestedCount = new Map();
    const bestTotalByContext = new Map();
    const bestCandidateByContext = new Map();
    for (const candidate of ranked){
        const runtime = runtimeBySurface.get(candidate.word);
        if (!runtime || runtime.canonicalTokenIds === null) continue;
        contextRequestedCount.set(runtime.contextKey, (contextRequestedCount.get(runtime.contextKey) ?? 0) + 1);
        const judged = readJudgedEvidence(candidate);
        const progressive = (0, $gpRHn.getProgressiveSurfaceEvidence)(runtime.contextKey, candidate.word);
        // Once a candidate has been read far enough to judge, its verified total
        // replaces the bound.
        const optimisticTotal = judged?.total ?? progressive?.totalLogProbability;
        if (optimisticTotal === undefined || !Number.isFinite(optimisticTotal)) continue;
        optimisticTotalByWord.set(candidate.word, optimisticTotal);
        const totals = contextTotals.get(runtime.contextKey);
        const surfaces = contextSurfaces.get(runtime.contextKey);
        if (totals && surfaces) {
            totals.push(optimisticTotal);
            surfaces.push(candidate.word);
        } else {
            contextTotals.set(runtime.contextKey, [
                optimisticTotal
            ]);
            contextSurfaces.set(runtime.contextKey, [
                candidate.word
            ]);
        }
        const best = bestTotalByContext.get(runtime.contextKey);
        if (best === undefined || optimisticTotal > best) {
            bestTotalByContext.set(runtime.contextKey, optimisticTotal);
            bestCandidateByContext.set(runtime.contextKey, candidate);
        }
    }
    /**
   * Whether a shorter member of the same pool is this surface's word-boundary
   * prefix — `happy path` where `happy` is also present.
   *
   * Only a multi-word surface can extend another, and a pool is a set, so this
   * costs one lookup per space rather than a comparison against every member.
   */ const extendsAPoolMember = (surface, pool)=>{
        for(let space = surface.indexOf(' '); space !== -1; space = surface.indexOf(' ', space + 1)){
            if (pool.has(surface.slice(0, space))) return true;
        }
        return false;
    };
    // A sequence total only falls as more of the sequence is read, so a partial
    // sum over `k` tokens sits above the same surface's total over `m > k`. An
    // extension read less far than the member it continues therefore carries a
    // total above that member's — and because the chain rule narrows the
    // denominator to the pool's minimal members, `exp(total - normaliser)` comes
    // out above 1 for a surface whose own continuation has not been looked at.
    // It needs a three-token first word to happen, which 2.6% of served bigrams
    // have, and it inflates both the posterior the gate reads and the
    // `confidenceScore` every other candidate's margin is measured against.
    //
    // A surface's canonical tokenization begins with the tokenization of its own
    // leading words — the producer encodes `" " + surface` in one call and the
    // ByteLevel pre-tokenizer splits on word boundaries, so no merge crosses a
    // space — which is what makes both corrections below exact rather than
    // approximate.
    //
    // The total is capped at what it continues: `P(happy path)` cannot exceed
    // `P(happy)`. Shortest-first, so a three-word phrase is capped against a
    // two-word prefix that has already been capped itself.
    //
    // And the surface is held unjudgeable until it has been read level with what
    // it continues, because the cap alone would leave it looking exactly as
    // certain as its prefix while saying nothing about its own tail.
    const underReadExtensions = new Set();
    for (const [contextKey, surfaces] of contextSurfaces){
        const pool = new Set(surfaces);
        for (const surface of [
            ...surfaces
        ].sort((a, b)=>a.length - b.length)){
            const own = optimisticTotalByWord.get(surface);
            if (own === undefined) continue;
            let cap = Infinity;
            let continuedDepth = 0;
            for(let space = surface.indexOf(' '); space !== -1; space = surface.indexOf(' ', space + 1)){
                const prefix = surface.slice(0, space);
                if (!pool.has(prefix)) continue;
                const prefixTotal = optimisticTotalByWord.get(prefix);
                if (prefixTotal !== undefined && prefixTotal < cap) cap = prefixTotal;
                const prefixDepth = runtimeBySurface.get(prefix)?.canonicalTokenIds?.length ?? 0;
                if (prefixDepth > continuedDepth) continuedDepth = prefixDepth;
            }
            if (own > cap) optimisticTotalByWord.set(surface, cap);
            const scoredDepth = (0, $gpRHn.getProgressiveSurfaceEvidence)(contextKey, surface)?.scoredTokenCount ?? 0;
            const surfaceDepth = runtimeBySurface.get(surface)?.canonicalTokenIds?.length ?? 0;
            if (scoredDepth < continuedDepth && scoredDepth < surfaceDepth) underReadExtensions.add(surface);
        }
    }
    /**
   * The evidence arbitration judges a candidate on.
   *
   * Wraps the depth-unaware read with the pool-relative requirement: a surface
   * that continues another pool member is not judgeable until it has been read
   * level with it, so the two totals being compared are taken at comparable
   * depths.
   */ const judgedEvidenceFor = (candidate)=>underReadExtensions.has(candidate.word) ? null : readJudgedEvidence(candidate);
    const hasJudgeableEvidence = (candidate)=>judgedEvidenceFor(candidate) !== null;
    // Normalise over the pool's minimal members only, and score everyone —
    // extensions included — against that.
    //
    // A sequence total is its prefix's total plus a log-probability that cannot
    // be positive, so summing a surface and its own extension double-counts:
    // `exp(total)` for `happy` already contains every continuation of `happy`,
    // `happy path` among them. Dividing one pool's mass between the two capped
    // the shorter form at half however certain it was, and the longer form below
    // that — both under gates neither could then clear, for a reason that was
    // arithmetic rather than evidence.
    //
    // Excluding extensions from the denominator is the chain rule: the minimal
    // members partition the mass, and an extension's share of that same
    // denominator is `P(prefix) * P(continuation | prefix)`, which is exactly
    // what a multi-word suggestion should be held to. Extensions stay in
    // `contextTotals`, so how contested a context is still counts every scored
    // candidate.
    const logSumExpByContext = new Map();
    for (const [contextKey, surfaces] of contextSurfaces){
        const pool = new Set(surfaces);
        const minimalTotals = [];
        for (const surface of surfaces){
            const total = optimisticTotalByWord.get(surface);
            if (total !== undefined && !extendsAPoolMember(surface, pool)) minimalTotals.push(total);
        }
        // An extension is strictly longer than what it extends, so the shortest
        // member of any non-empty pool is always minimal and this is never empty.
        logSumExpByContext.set(contextKey, (0, $eGuir.logSumExp)(minimalTotals));
    }
    /**
   * A candidate's share of its context shortlist's probability mass.
   *
   * Pass an optimistic (partially read) total for an upper bound on the
   * eventual posterior, or a verified total for the posterior itself.
   */ const posteriorFor = (candidate, total)=>{
        const runtime = runtimeBySurface.get(candidate.word);
        const normalizer = runtime ? logSumExpByContext.get(runtime.contextKey) : undefined;
        if (total === undefined || normalizer === undefined || !Number.isFinite(normalizer)) return 0;
        return Math.exp(total - normalizer);
    };
    const optimisticPosterior = (candidate)=>posteriorFor(candidate, optimisticTotalByWord.get(candidate.word));
    const judgedPosterior = (candidate)=>posteriorFor(candidate, judgedEvidenceFor(candidate)?.total);
    // A candidate stays in the race for as long as its optimistic posterior
    // could still clear the gate it will be held to. The bound only falls as
    // more tokens are read, so nothing dropped here could have gone on to win.
    const couldClearGate = (candidate)=>optimisticPosterior(candidate) >= $9b1bc75748eb73f9$var$MIN_LM_POSTERIOR[candidate.termType];
    const passesLmFloor = (candidate)=>judgedEvidenceFor(candidate) !== null && couldClearGate(candidate);
    const hasRequiredEvidence = (candidate)=>{
        if (canonicalLmSupported) return passesLmFloor(candidate);
        return candidate.termType === 'word' && candidate.lmEvidence?.source === 'network-logit';
    };
    // ── Stabilization guards (QI-2) ──────────────────────────────────────────
    // Whole-surface repetition: drop a candidate whose full surface already equals
    // the run of tokens immediately before the cursor — accepting it would
    // duplicate what was just typed (`end to end` → `end to end to end`).
    const beforeTokens = $9b1bc75748eb73f9$var$tokenize(trimmed);
    const duplicatesPreceding = (c)=>{
        const surfaceTokens = $9b1bc75748eb73f9$var$tokenize(c.word);
        const n = surfaceTokens.length;
        if (n === 0 || beforeTokens.length < n) return false;
        for(let i = 0; i < n; i++){
            if (beforeTokens[beforeTokens.length - n + i] !== surfaceTokens[i]) return false;
        }
        return true;
    };
    // Post-accept cooldown: don't re-offer the surface the user just accepted while
    // its cooldown is still active (see cooldown advance near t0).
    const isCooledDown = (c)=>cooledSurface !== null && c.word.toLowerCase() === cooledSurface;
    const isStabilized = (candidate)=>!duplicatesPreceding(candidate) && !isCooledDown(candidate);
    // A candidate the user has all but finished typing is not worth a ghost, and
    // a candidate we would never show is not worth waiting for either.
    const suggestionLengthFor = (candidate)=>candidate.word.length - (prefixLenByWord.get(candidate.word) ?? currentWord.length);
    const isWorthShowing = (candidate)=>suggestionLengthFor(candidate) >= $9b1bc75748eb73f9$var$MIN_SUGGESTION_LENGTH;
    const evidenceBacked = ranked.filter((candidate)=>hasRequiredEvidence(candidate) && isStabilized(candidate));
    const confidenceScore = (candidate)=>{
        if (!canonicalLmSupported) return candidate.finalScore;
        const runtime = runtimeBySurface.get(candidate.word);
        if (runtime?.canonicalTokenIds === null || !optimisticTotalByWord.has(candidate.word)) return candidate.stage1Score;
        return (0, $cVZWR.STAGE1_WEIGHT) * candidate.stage1Score + (0, $cVZWR.STAGE2_WEIGHT) * optimisticPosterior(candidate);
    };
    const exactConfidenceScore = (candidate)=>{
        if (!canonicalLmSupported || judgedEvidenceFor(candidate) === null) return candidate.finalScore;
        return (0, $cVZWR.STAGE1_WEIGHT) * candidate.stage1Score + (0, $cVZWR.STAGE2_WEIGHT) * judgedPosterior(candidate);
    };
    /**
   * How many candidates in this one's context were scored at all.
   *
   * Read off pool membership, which counts every candidate that contributed a
   * total, rather than off the normaliser, which the chain rule narrows to the
   * pool's minimal members.
   */ const scoredPoolSize = (candidate)=>{
        const contextKey = runtimeBySurface.get(candidate.word)?.contextKey;
        return contextKey === undefined ? 0 : contextTotals.get(contextKey)?.length ?? 0;
    };
    /**
   * How many candidates the context held before any of them were scored.
   *
   * A pool of one means two opposite things. Either the vocabulary offered a
   * single continuation of what was typed, which is the least contested case
   * there is; or rivals were offered and have not been read yet, which is the
   * least informed. Only the second deserves refusing, and the two are
   * distinguishable exactly here.
   */ const requestedPoolSize = (candidate)=>{
        const contextKey = runtimeBySurface.get(candidate.word)?.contextKey;
        return contextKey === undefined ? 0 : contextRequestedCount.get(contextKey) ?? 0;
    };
    // A suppressed short completion still counts as competition below, so losing
    // to one abstains rather than promoting the runner-up in its place.
    const gateCleared = evidenceBacked.filter(isWorthShowing).map((candidate)=>({
            candidate: candidate,
            posterior: judgedPosterior(candidate),
            score: exactConfidenceScore(candidate)
        }))// The gate is the model's own confidence in the surface; the blended score
    // only orders what has already cleared it, so a strong corpus prior can no
    // longer carry a surface the model is unsure of onto the screen.
    .filter(({ candidate: candidate, posterior: posterior })=>posterior >= $9b1bc75748eb73f9$var$MIN_LM_POSTERIOR[candidate.termType]);
    /**
   * Whether the model finds the surface plausible on its own terms.
   *
   * The gate above asks which candidate won its pool; this asks whether
   * winning it meant anything. The two come apart exactly where a pool is
   * thin — a shortlist of one hands its only member 1.0 by construction — and
   * a relative test can never see through that however it is tuned.
   *
   * Waived without canonical scoring, where there is no judged mean to test
   * and the network-logit path would otherwise refuse everything.
   */ const isPlausibleSurface = (candidate)=>{
        if (!canonicalLmSupported) return true;
        const mean = judgedEvidenceFor(candidate)?.mean;
        return mean !== undefined && mean >= $9b1bc75748eb73f9$var$MIN_MEAN_TOKEN_LOG_PROBABILITY;
    };
    // Kept as its own stage rather than folded into the gate so the three
    // populations stay separable in the abstain cascade: cleared its pool and was
    // implausible, was plausible and had nothing to clear the pool against, or
    // cleared both. A candidate refused here stays in `ranked` and so still
    // counts as competition below — promoting the runner-up in place of an
    // implausible leader would show something worse, not something better.
    const plausible = gateCleared.filter(({ candidate: candidate })=>isPlausibleSurface(candidate));
    // Applied after the gate rather than folded into it, so the two populations
    // stay separable: a surface refused here cleared its threshold and was
    // refused for having had nothing to clear it against.
    const eligible = plausible.filter(({ candidate: candidate })=>!canonicalLmSupported || scoredPoolSize(candidate) >= $9b1bc75748eb73f9$var$MIN_SCORED_POOL_SIZE || requestedPoolSize(candidate) <= 1).sort((a, b)=>b.score - a.score);
    const selected = eligible[0]?.candidate;
    const selectedDisplayScore = eligible[0]?.score ?? 0;
    const selectedEvidence = selected && hasRequiredEvidence(selected) ? selected.lmEvidence : null;
    /**
   * Whether `longer` is `shorter` continued past a word boundary, in the same
   * normaliser.
   *
   * Shared by the two places that have to agree on what an extension is: the
   * chain rule, which stops dividing a pool's mass between a sequence and its
   * own prefix, and the winner margin below, which stops treating one as the
   * other's rival. They were the same category error and are now the same test.
   */ const extendsInSamePool = (shorter, longer)=>{
        if (longer.word === shorter.word || !optimisticTotalByWord.has(longer.word)) return false;
        const pool = runtimeBySurface.get(shorter.word)?.contextKey;
        if (pool === undefined || runtimeBySurface.get(longer.word)?.contextKey !== pool) return false;
        return longer.word.length > shorter.word.length && longer.word.startsWith(shorter.word) && longer.word[shorter.word.length] === ' ';
    };
    // A candidate that extends the selection is not competing with it. Whichever
    // continuation the user meant, the shorter surface is a correct ghost — it is
    // the prefix of both — so the margin has nothing to arbitrate and charging the
    // selection for its own extension abstains on a case that could not be wrong.
    // The chain rule already removed this from the denominator; leaving it in the
    // margin meant a nested leader cleared its gate and then lost to the candidate
    // that had just been freed from dividing its mass. It penalised bigrams and
    // phrases specifically, because a nested pool is where they mostly appear.
    const runnerUpScore = selected ? Math.max(...ranked.filter((candidate)=>candidate.word !== selected.word && isStabilized(candidate) && !extendsInSamePool(selected, candidate)).map(confidenceScore), 0) : 0;
    const winnerMargin = selected ? selectedDisplayScore - runnerUpScore : 0;
    const hasMissingArtifactCompetitor = canonicalLmSupported && ranked.some((candidate)=>{
        const runtime = runtimeBySurface.get(candidate.word);
        return runtime?.separatorKind === 'whitespace' && runtime.canonicalTokenIds === null;
    });
    // A candidate with canonical tokens but no evidence at all cannot join the
    // posterior: it has no likelihood to contribute, and any stand-in value would
    // distort the normaliser for every other candidate in its context. Absent
    // evidence is not evidence of absence though — the context's boundary may
    // simply not be primed yet — so it holds the ghost back instead of being
    // silently ignored. In a primed context every candidate has at least
    // first-token evidence, so this only fires while a context is still cold.
    const hasUnscoredCompetitor = canonicalLmSupported && ranked.some((candidate)=>{
        const runtime = runtimeBySurface.get(candidate.word);
        return candidate.word !== selected?.word && runtime?.canonicalTokenIds !== null && runtime?.canonicalTokenIds !== undefined && !optimisticTotalByWord.has(candidate.word) && isStabilized(candidate) && isWorthShowing(candidate);
    });
    // A rival only holds the ghost back while it is still too unread to judge.
    // Under full-surface evidence that meant any long surface blocked everything
    // until every one of its tokens had been paid for, which abstained far more
    // often than it ever changed the winner. A rival now becomes judgeable after
    // `REQUIRED_VERIFIED_TOKENS`, so this settles within the budget.
    const hasUnresolvedPotential = canonicalLmSupported && ranked.some((candidate)=>{
        const runtime = runtimeBySurface.get(candidate.word);
        return candidate.word !== selected?.word && runtime?.canonicalTokenIds !== null && runtime?.canonicalTokenIds !== undefined && !hasJudgeableEvidence(candidate) && couldClearGate(candidate) && isStabilized(candidate) && isWorthShowing(candidate);
    });
    const requiredWinnerMargin = (0, $cVZWR.MIN_WINNER_MARGIN) + (selected && judgedEvidenceFor(selected)?.complete === false ? $9b1bc75748eb73f9$var$PARTIAL_EVIDENCE_MARGIN_PREMIUM : 0);
    // Everything the display decision needs except the veto itself. Splitting it
    // out is what lets the veto be priced: the value here at the moment the veto
    // fires is exactly the ghost the veto cost us.
    const clearsMarginBeforeColdVeto = selected !== undefined && !hasMissingArtifactCompetitor && winnerMargin >= requiredWinnerMargin;
    const clearsWinnerMargin = clearsMarginBeforeColdVeto && !hasUnscoredCompetitor;
    const suggestion = displayPrefixReady && selected && clearsWinnerMargin ? selected.word.slice(prefixLenByWord.get(selected.word) ?? currentWord.length) : null;
    // Which constraint bound. Computed on every evaluation rather than only under
    // debug, because it is counted for the session as well as printed, and
    // deriving the debug header from it keeps the two from disagreeing.
    const resolveAbstainReason = ()=>{
        if (suggestion !== null && suggestion.length > 0) return null;
        if (!displayPrefixReady) return 'prefetch';
        if (ranked.length === 0) return 'no-candidate';
        if (hasMissingArtifactCompetitor) return 'missing-artifact';
        if (hasUnscoredCompetitor) return 'cold-competitor';
        if (hasUnresolvedPotential && !clearsWinnerMargin) return 'unresolved-rival';
        if (eligible.length > 0) return selected && !clearsWinnerMargin ? 'winner-margin' : 'empty-completion';
        if (plausible.length > 0) // Cleared its gate, was plausible on its own terms, and was refused for
        // the shortlist it cleared that gate against holding nobody else.
        return 'lone-candidate';
        if (gateCleared.length > 0) // Held the largest share of its shortlist and still was not a surface
        // the model found plausible — which is only possible because a share is
        // relative and this is not.
        return 'implausible-surface';
        if (evidenceBacked.length > 0 && evidenceBacked.every((candidate)=>!isWorthShowing(candidate))) return 'short-completion';
        // The floor and the gate are one threshold, applied to the bound and to
        // the verified value, so a candidate short of it is dropped before
        // `evidenceBacked` is built. Asking whether anything was judgeable
        // separates a gate that rejected read candidates from a context where
        // nothing was read at all — the first is a threshold to calibrate, the
        // second is scheduling.
        return ranked.some(hasJudgeableEvidence) ? 'below-posterior-gate' : 'no-evidence';
    };
    const abstainReason = resolveAbstainReason();
    $9b1bc75748eb73f9$var$recordPredictionOutcome({
        abstainReason: abstainReason,
        awaitingAsyncEvidence: hasUnresolvedPotential && !clearsWinnerMargin,
        scoredCandidateCount: ranked.length,
        textBefore: textBefore
    });
    // The leader is the best-supported candidate, not the selected one: an
    // evaluation that showed nothing is exactly the one whose posterior needs
    // recording, and it has no selection to report.
    const posteriorLeader = ranked.reduce((best, candidate)=>{
        const posterior = optimisticPosterior(candidate);
        return posterior > 0 && (best === null || posterior > best.posterior) ? {
            candidate: candidate,
            posterior: posterior
        } : best;
    }, null);
    /**
   * The longer surface in the leader's normaliser that extends the given
   * candidate, if the pool holds one.
   *
   * `logSumExp` divides one pool's mass between a sequence and its own prefix,
   * and the longer total is the shorter one plus a log-probability that cannot
   * be positive — so the longer form holds at most half, or at most a third
   * where both shorter forms are present. Both sit under the gate it is held
   * to, so it cannot display however certain its continuation is.
   *
   * Asked from the shorter form because that is the one that leads: the
   * extending candidate is strictly lower in the same pool and so can never be
   * the leader.
   */ const poolExtensionOf = (shorter)=>ranked.find((candidate)=>extendsInSamePool(shorter, candidate));
    if ((0, $dl7hN.isAutocompleteDebugEnabled)()) {
        const verbose = (0, $dl7hN.isAutocompleteDebugVerbose)();
        const latencyMs = performance.now() - t0;
        const tokens = $9b1bc75748eb73f9$var$tokenize(trimmed);
        const contextWords = tokens.slice(-$9b1bc75748eb73f9$var$CONTEXT_WORDS);
        // Decision drives the (collapsed) group header. Abstains carry the reason
        // the session counters recorded, plus the numbers behind it, so it is clear
        // *why* nothing showed without expanding the group.
        const abstainDetail = {
            'below-posterior-gate': `posterior below ${$9b1bc75748eb73f9$var$MIN_LM_POSTERIOR[(posteriorLeader?.candidate ?? ranked[0]).termType]} (best ${(posteriorLeader?.posterior ?? 0).toFixed(2)})`,
            'cold-competitor': 'competitor has no LM evidence yet',
            'empty-completion': 'empty completion',
            'implausible-surface': `mean per-token log-probability below ${$9b1bc75748eb73f9$var$MIN_MEAN_TOKEN_LOG_PROBABILITY} (best ${gateCleared.map(({ candidate: candidate })=>judgedEvidenceFor(candidate)?.mean ?? -Infinity).reduce((best, mean)=>Math.max(best, mean), -Infinity).toFixed(2)})`,
            'lone-candidate': `cleared its gate against fewer than ${$9b1bc75748eb73f9$var$MIN_SCORED_POOL_SIZE} scored candidates, rivals unread`,
            'missing-artifact': 'canonical artifact coverage missing',
            'no-candidate': 'nothing cleared scoring',
            'no-evidence': 'full-surface evidence absent',
            // Recorded at the two exits above this block, so they never print here.
            'no-surface-token': 'no trailing surface token',
            'not-initialized': 'vocabulary not loaded',
            prefetch: `prefetch: ${currentWord.length}/${$9b1bc75748eb73f9$var$DISPLAY_MIN_PREFIX_LENGTH} chars`,
            'short-completion': `completion shorter than ${$9b1bc75748eb73f9$var$MIN_SUGGESTION_LENGTH} chars`,
            'unresolved-rival': 'expanding plausible token-prefix groups',
            'winner-margin': `winner margin ${winnerMargin.toFixed(2)} < ${requiredWinnerMargin.toFixed(2)}`
        };
        const decision = abstainReason === null ? `\u{2728} "${suggestion ?? ''}"` : abstainReason === 'prefetch' ? `\u{23F3} ${abstainDetail.prefetch}` : `\u{2014} abstain: ${abstainDetail[abstainReason]}`;
        $9b1bc75748eb73f9$var$lastPredictionDebug = {
            awaitingAsyncEvidence: hasUnresolvedPotential && !clearsWinnerMargin,
            textBefore: trimmed,
            currentWord: currentWord,
            decision: decision,
            mode: mode,
            contextWords: contextWords,
            topCandidates: ranked.slice(0, 5).map((r)=>({
                    word: r.word,
                    finalScore: r.finalScore,
                    semanticScore: r.semanticScore,
                    freqScore: r.freqScore,
                    lmScore: r.lmScore
                })),
            suggestion: suggestion && suggestion.length > 0 ? suggestion : null
        };
        // Mode describes the semantic-vector source without implying that a
        // network backend ran; the snapshot may come from the local MLC embedder.
        const slowLaneVec = (0, $gpRHn.getStoredContextVector)();
        const isUsingSlowLaneVector = slowLaneVec !== null && $9b1bc75748eb73f9$var$vectorStore !== null && slowLaneVec.length === $9b1bc75748eb73f9$var$vectorStore.dim;
        const modeLabel = !contextVector ? 'COLD' : isUsingSlowLaneVector ? 'WARM(semantic)' : 'WARM(local-avg)';
        const modeColor = modeLabel === 'WARM(semantic)' ? (0, $dl7hN.CTC_STYLES).good : modeLabel === 'WARM(local-avg)' ? (0, $dl7hN.CTC_STYLES).warn : (0, $dl7hN.CTC_STYLES).cold;
        // Group header: [CTC:<mode>] <decision> · <mode> · <type> · <latency>
        // arbitrationMode ('v1') tags the line so this deploy's logs diff cleanly
        // against the baseline deploy's.
        // eslint-disable-next-line no-console
        console.groupCollapsed(`%c[CTC:${$9b1bc75748eb73f9$var$ARBITRATION_MODE}]%c ${decision} %c\xb7 ${modeLabel}${selected ? ` \xb7 ${selected.termType}` : ''} \xb7 \u{23F1} ${latencyMs.toFixed(1)}ms`, (0, $dl7hN.CTC_STYLES).brand, (0, $dl7hN.CTC_STYLES).body, modeColor);
        const semanticInput = (0, $gpRHn.getStoredContextInput)();
        const causalPrompts = primeRequests.map((request, index)=>{
            const tail = request.prompt.slice(-$9b1bc75748eb73f9$var$DEBUG_TEXT_TAIL_CHARS);
            return `#${index + 1}:${JSON.stringify(tail)}`;
        });
        // Keep the exact model inputs separate from normalized lookup tokens.
        (0, $dl7hN.ctcSection)('INPUT', `raw: ${JSON.stringify(trimmed.slice(-$9b1bc75748eb73f9$var$DEBUG_TEXT_TAIL_CHARS))} \xb7 prev: ${previousWord ? JSON.stringify(previousWord) : "\u2014"}`);
        (0, $dl7hN.ctcSection)('LOOKUP', `normalized(last ${$9b1bc75748eb73f9$var$CONTEXT_WORDS}): ${contextWords.length ? JSON.stringify(contextWords.join(' ')) : '(none)'}`);
        (0, $dl7hN.ctcSection)('SEMANTIC', `snapshot: ${semanticInput ? JSON.stringify(semanticInput.slice(-$9b1bc75748eb73f9$var$DEBUG_TEXT_TAIL_CHARS)) : '(unavailable)'}`);
        (0, $dl7hN.ctcSection)('CAUSAL', `prompt${causalPrompts.length === 1 ? '' : 's'}: ${causalPrompts.join(" \xb7 ") || '(not ready)'}`);
        // SIGNALS — semantic state plus context-keyed canonical LM coverage.
        const logitCount = lmLogits ? Object.keys(lmLogits).length : 0;
        const semanticStatus = isUsingSlowLaneVector ? `semantic \u{2705} snapshot(${slowLaneVec?.length}d)` : $9b1bc75748eb73f9$var$vectorStore ? "semantic \u26A0\uFE0F local-avg" : "semantic \u274C cold";
        const tierACount = ranked.filter((candidate)=>candidate.lmEvidence?.source === 'canonical-first-token').length;
        const exactCount = ranked.filter((candidate)=>candidate.lmEvidence?.source === 'canonical-full-surface').length;
        const boundaryReady = primeRequests.filter((request)=>(0, $gpRHn.getBoundaryLmState)(request.contextKey) !== null).length;
        const artifactEligible = canonicalMatched.filter((candidate)=>candidate.canonicalTokenIds !== null).length;
        const documentStartFallbacks = canonicalMatched.filter((candidate)=>candidate.separatorKind === 'document-start').length;
        const punctuationFallbacks = canonicalMatched.filter((candidate)=>candidate.separatorKind === 'non-space').length;
        const logitsStatus = tierACount + exactCount > 0 ? `canonical \u{2705} first-token:${tierACount} exact:${exactCount}` : logitCount > 0 ? `network logits \u{2705} ${logitCount}` : "canonical \u23F3/absent";
        const formula = tierACount + exactCount + logitCount > 0 ? `Stage1\xd7${0, $cVZWR.STAGE1_WEIGHT}+LM\xd7${0, $cVZWR.STAGE2_WEIGHT}` : 'Stage1-only';
        (0, $dl7hN.ctcSection)('SIGNALS', `${semanticStatus} \xb7 ${logitsStatus} \xb7 ${formula}`);
        (0, $dl7hN.ctcSection)('CANONICAL', `eligible ${artifactEligible}/${canonicalMatched.length} \xb7 separator fallback doc:${documentStartFallbacks} punct:${punctuationFallbacks} \xb7 contexts ${boundaryReady}/${primeRequests.length} ready (\u{2264}${$9b1bc75748eb73f9$var$PHRASE_MAX_WORDS}) \xb7 family=${familyKey.slice(0, 72) || 'none'}`);
        if (verbose && logitCount > 0 && lmLogits) {
            const rawLmTop = Object.entries(lmLogits).sort((a, b)=>b[1] - a[1]).slice(0, 5).map(([word, score])=>`${word}:${score.toFixed(3)}`).join(', ');
            (0, $dl7hN.ctcSection)('  rawLM', `\u{1F9E0} ${rawLmTop}`);
        }
        // GENERATE — how many candidates matched, split by term type
        const genByType = {
            word: 0,
            bigram: 0,
            phrase: 0
        };
        for (const m of canonicalMatched)genByType[m.node.termType] += 1;
        (0, $dl7hN.ctcSection)('GENERATE', `matched ${canonicalMatched.length} \u{2192} word:${genByType.word} bigram:${genByType.bigram} phrase:${genByType.phrase}${canonicalLmSupported ? " \xb7 display needs exact surface evidence" : ''}`);
        // SCORE — Stage-1 + grammar funnel and canonical evidence depth.
        const lmCoverage = ranked.slice(0, 10).filter((r)=>r.lmScore > 0).length;
        (0, $dl7hN.ctcSection)('SCORE', `in ${pipelineDebug.initial} \u{2192} stage1(<${(0, $cVZWR.MIN_STAGE1_SCORE)}) \u{2212}${pipelineDebug.stage1Rejected.length} \u{2192} grammar \u{2212}${pipelineDebug.grammarRejected.length} \u{2192} final ${pipelineDebug.final} \xb7 LM cov ${lmCoverage}/${Math.min(ranked.length, 10)} \xb7 first-token ${tierACount} \xb7 exact ${exactCount}`);
        if (grammarMeta) (0, $dl7hN.ctcSection)('  grammar', `"${grammarMeta.prevWord}" [${grammarMeta.prevTags.join('|')}] ${grammarMeta.before}\u{2192}${grammarMeta.after}${verbose && grammarMeta.dropped.length > 0 ? ` \xb7 dropped: ${grammarMeta.dropped.join(', ')}` : ''}`);
        const gateReasonFor = (candidate)=>{
            const runtime = runtimeBySurface.get(candidate.word);
            if (runtime?.separatorKind !== 'whitespace') return `separator:${runtime?.separatorKind ?? 'unknown'}`;
            if (runtime.canonicalTokenIds === null) return 'missing-artifact';
            if (!hasJudgeableEvidence(candidate)) return `awaiting-tokens:${$9b1bc75748eb73f9$var$REQUIRED_VERIFIED_TOKENS}`;
            if (!passesLmFloor(candidate)) return `bound:${optimisticPosterior(candidate).toFixed(2)}<${$9b1bc75748eb73f9$var$MIN_LM_POSTERIOR[candidate.termType]}`;
            if (duplicatesPreceding(candidate)) return 'repetition';
            if (isCooledDown(candidate)) return 'cooldown';
            if (!isWorthShowing(candidate)) return `suffix:${suggestionLengthFor(candidate)}<${$9b1bc75748eb73f9$var$MIN_SUGGESTION_LENGTH}`;
            const floor = $9b1bc75748eb73f9$var$MIN_LM_POSTERIOR[candidate.termType];
            const posterior = judgedPosterior(candidate);
            if (posterior < floor) return `posterior:${posterior.toFixed(2)}<${floor}`;
            if (!isPlausibleSurface(candidate)) return `implausible:${(judgedEvidenceFor(candidate)?.mean ?? NaN).toFixed(2)}<${$9b1bc75748eb73f9$var$MIN_MEAN_TOKEN_LOG_PROBABILITY}`;
            return 'eligible';
        };
        const gateFunnel = (termType)=>{
            const typeRanked = ranked.filter((candidate)=>candidate.termType === termType);
            const exact = typeRanked.filter(hasJudgeableEvidence);
            const absolute = exact.filter(passesLmFloor);
            const stabilized = absolute.filter(isStabilized);
            const longEnough = stabilized.filter(isWorthShowing);
            const floorPassed = longEnough.filter((candidate)=>judgedPosterior(candidate) >= $9b1bc75748eb73f9$var$MIN_LM_POSTERIOR[termType]);
            const plausiblePassed = floorPassed.filter(isPlausibleSurface);
            return `${termType} m:${genByType[termType]} r:${typeRanked.length} exact:${exact.length} abs:${absolute.length} stable:${stabilized.length} suffix:${longEnough.length} floor:${floorPassed.length} plausible:${plausiblePassed.length} eligible:${eligible.filter(({ candidate: candidate })=>candidate.termType === termType).length}`;
        };
        (0, $dl7hN.ctcSection)('GATES', `${gateFunnel('word')}  |  ${gateFunnel('bigram')}  |  ${gateFunnel('phrase')}`);
        // One line per context: how many candidates share the normaliser, and how
        // much of the mass the leader holds. A leader well under its threshold
        // means the context is contested, which is the abstention we want.
        const contextLeaders = Array.from(bestCandidateByContext.entries()).slice(0, $9b1bc75748eb73f9$var$PHRASE_MAX_WORDS).map(([contextKey, leader])=>{
            const shortlistSize = contextTotals.get(contextKey)?.length ?? 0;
            const evidenceKind = hasExactEvidence(leader) ? 'exact' : 'upper';
            return `${contextKey.slice(0, 32)} \u{2192} n=${shortlistSize} ${leader.termType}:"${leader.word}" ${evidenceKind} p=${optimisticPosterior(leader).toFixed(3)}/${$9b1bc75748eb73f9$var$MIN_LM_POSTERIOR[leader.termType]}`;
        }).join(' | ');
        (0, $dl7hN.ctcSection)('NORMALIZE', contextLeaders.length > 0 ? contextLeaders : 'no scored candidate in any context');
        (0, $dl7hN.ctcSection)('READINESS', `prefix ${currentWord.length}/${$9b1bc75748eb73f9$var$DISPLAY_MIN_PREFIX_LENGTH} \xb7 boundary ${boundaryReady}/${primeRequests.length} \xb7 exact word:${ranked.filter((candidate)=>candidate.termType === 'word' && hasExactEvidence(candidate)).length} bigram:${ranked.filter((candidate)=>candidate.termType === 'bigram' && hasExactEvidence(candidate)).length} phrase:${ranked.filter((candidate)=>candidate.termType === 'phrase' && hasExactEvidence(candidate)).length} \xb7 ${suggestion ? 'display-ready' : decision}`);
        // ARBITRATE — expose every condition that can authorize or suppress ghost.
        const topOfType = (t)=>ranked.find((c)=>c.termType === t);
        const fmtType = (t)=>{
            const top = topOfType(t);
            if (!top) return `${t}:\u{2014}`;
            const floor = $9b1bc75748eb73f9$var$MIN_LM_POSTERIOR[t];
            const bound = optimisticPosterior(top);
            const evidence = hasRequiredEvidence(top) ? "TierB\u2705" : `${top.lmEvidence?.source ?? 'absent'}\u{274C}`;
            return `${t}:"${top.word}" p\u{2264}${bound.toFixed(3)}${bound >= floor ? "\u2265" : '<'}${floor} fs\u{2264}${confidenceScore(top).toFixed(2)} ${evidence}`;
        };
        (0, $dl7hN.ctcSection)('ARBITRATE', `${selected ? `\u{25B8} ${selected.termType} "${selected.word}" fs=${selectedDisplayScore.toFixed(2)} mean=${selectedEvidence?.meanTokenLogProbability?.toFixed(2) ?? 'network'} margin=${winnerMargin.toFixed(2)}${clearsWinnerMargin ? "\u2705" : "\u274C"}` : "\u25B8 (none)"} \xb7 prefix ${currentWord.length}/${$9b1bc75748eb73f9$var$DISPLAY_MIN_PREFIX_LENGTH}${displayPrefixReady ? "\u2705" : "\u23F3"} \xb7 grouped pending ${hasUnresolvedPotential ? 'yes' : 'no'}  |  ${fmtType('word')}  ${fmtType('bigram')}  ${fmtType('phrase')}`);
        // STABILIZE — post-accept cooldown + whole-surface repetition (QI-2)
        const repetitionBlocked = ranked.filter((c)=>hasRequiredEvidence(c) && duplicatesPreceding(c)).map((c)=>c.word);
        const cooldownLabel = cooledSurface ? `cooldown "${cooledSurface}" (${$9b1bc75748eb73f9$var$acceptCooldown?.predictionsSince ?? 0}/${$9b1bc75748eb73f9$var$COOLDOWN_KEYSTROKES} keys \xb7 ${$9b1bc75748eb73f9$var$COOLDOWN_MS}ms)` : "cooldown \u2014";
        (0, $dl7hN.ctcSection)('STABILIZE', `${cooldownLabel} \xb7 repetition-blocked: ${repetitionBlocked.length > 0 ? repetitionBlocked.join(', ') : "\u2014"}`);
        // CANDIDATES — full scored table (verbose only)
        if (verbose && ranked.length > 0) {
            const tableData = ranked.slice(0, 10).map((r)=>{
                let rawLogit = 'Not in Payload';
                if (r.lmEvidence?.rawLogit !== undefined) rawLogit = Number(r.lmEvidence.rawLogit.toFixed(5));
                else if (prefixLmLogits) {
                    const val = prefixLmLogits[r.word.toLowerCase()];
                    if (val !== undefined) rawLogit = Number(val.toFixed(5));
                }
                const original = scoringCandidates.find((sc)=>sc.word === r.word);
                const runtime = runtimeBySurface.get(r.word);
                const progress = runtime ? (0, $gpRHn.getProgressiveSurfaceEvidence)(runtime.contextKey, r.word) : null;
                const optimisticTotal = optimisticTotalByWord.get(r.word);
                const normalizer = runtime ? logSumExpByContext.get(runtime.contextKey) : undefined;
                const shortlistSize = runtime ? contextTotals.get(runtime.contextKey)?.length ?? 0 : 0;
                const contextLeader = runtime ? bestCandidateByContext.get(runtime.contextKey) : undefined;
                let source = 'Unknown';
                if (original) {
                    if (original.termType === 'bigram') source = "\uD83D\uDD17 L2 (Bigram)";
                    else if (original.termType === 'phrase') source = "\uD83E\uDDE9 L2 (Phrase)";
                    else if (original.docFreq === 0 && original.tenantFreq === $9b1bc75748eb73f9$var$L3_BASELINE_FREQ) source = "\uD83C\uDF0D L3 (Generic)";
                    else if (original.sessionFreq > 0 && original.tenantFreq === 0) source = "\uD83D\uDC64 L1 (Session Only)";
                    else source = "\uD83C\uDFE2 L2 (Domain)";
                }
                const floor = $9b1bc75748eb73f9$var$MIN_LM_POSTERIOR[r.termType];
                return {
                    Candidate: r.word,
                    Source: source,
                    Type: r.termType,
                    'Final Score': Number(r.finalScore.toFixed(4)),
                    'Bounded Score': Number(confidenceScore(r).toFixed(4)),
                    'Exact Gate Score': hasExactEvidence(r) ? Number(exactConfidenceScore(r).toFixed(4)) : "\u2014",
                    Floor: floor,
                    'Posterior Floor': optimisticPosterior(r) >= floor ? "\u2705" : "\u274C",
                    'LM Floor': hasExactEvidence(r) ? passesLmFloor(r) ? "\u2705" : "\u274C" : "\u23F3",
                    'Gate Reason': gateReasonFor(r),
                    'Display Eligible': hasRequiredEvidence(r) && isStabilized(r) && judgedPosterior(r) >= floor ? "\u2705" : "\u274C",
                    Semantics: Number(r.semanticScore.toFixed(4)),
                    Freq: Number(r.freqScore.toFixed(4)),
                    'LM Score': Number(r.lmScore.toFixed(4)),
                    'LM Evidence': r.lmEvidence?.source ?? 'absent',
                    'Verified Tokens': r.lmEvidence ? `${r.lmEvidence.verifiedTokenCount}/${r.lmEvidence.totalTokenCount}` : '0/0',
                    'Progressive Tokens': progress ? `${progress.scoredTokenCount}/${progress.totalTokenCount}` : '0/0',
                    'LM Mean Upper': progress !== null ? Number(progress.meanTokenLogProbabilityUpperBound.toFixed(5)) : "\u2014",
                    'Optimistic Total': optimisticTotal !== undefined ? Number(optimisticTotal.toFixed(5)) : "\u2014",
                    'Context logSumExp': normalizer !== undefined && Number.isFinite(normalizer) ? Number(normalizer.toFixed(5)) : "\u2014",
                    'Shortlist Size': shortlistSize,
                    'Posterior (bound)': Number(optimisticPosterior(r).toFixed(5)),
                    'Posterior (judged)': hasJudgeableEvidence(r) ? Number(judgedPosterior(r).toFixed(5)) : "\u2014",
                    'Context Leader': contextLeader ? `${contextLeader.termType}:${contextLeader.word}` : "\u2014",
                    'Verified Chars': r.lmEvidence ? `${r.lmEvidence.verifiedCharCount}/${r.lmEvidence.totalSurfaceCharCount}` : `0/${r.word.length}`,
                    Separator: runtime?.separatorKind ?? 'unknown',
                    'Canonical Eligibility': runtime?.separatorKind !== 'whitespace' ? 'incompatible-separator' : runtime.canonicalTokenIds === null ? 'missing-artifact' : 'eligible',
                    'Artifact Tokens': runtime?.canonicalTokenIds?.join(',') ?? 'absent',
                    'Context Key': runtime?.contextKey ?? "\u2014",
                    'Exact Total': r.lmEvidence?.totalLogProbability !== undefined ? Number(r.lmEvidence.totalLogProbability.toFixed(5)) : "\u2014",
                    'Exact Mean': r.lmEvidence?.meanTokenLogProbability !== undefined ? Number(r.lmEvidence.meanTokenLogProbability.toFixed(5)) : "\u2014",
                    Assoc: typeof original?.association === 'number' ? Number(original.association.toFixed(4)) : "\u2014",
                    'Raw Logit': rawLogit,
                    'Session Freq': original?.sessionFreq || 0
                };
            });
            // eslint-disable-next-line no-console
            console.table(tableData);
        }
        // eslint-disable-next-line no-console
        console.groupEnd();
    }
    const selectedContextKey = selected ? runtimeBySurface.get(selected.word)?.contextKey : undefined;
    return suggestion && suggestion.length > 0 && selected && selectedEvidence ? {
        text: suggestion,
        surface: selected.word,
        termType: selected.termType,
        posterior: judgedPosterior(selected),
        meanTokenLogProbability: judgedEvidenceFor(selected)?.mean ?? NaN,
        poolHeldExtension: poolExtensionOf(selected) !== undefined,
        shortlistSize: selectedContextKey === undefined ? 1 : contextTotals.get(selectedContextKey)?.length ?? 1,
        rankScore: selectedDisplayScore,
        evidenceTier: selectedEvidence?.source === 'network-logit' ? 'network-logit' : 'canonical-full-surface',
        evidenceDepth: {
            verifiedTokens: selectedEvidence?.verifiedTokenCount ?? 0,
            totalTokens: selectedEvidence?.totalTokenCount ?? 0,
            verifiedChars: selectedEvidence?.verifiedCharCount ?? 0,
            totalChars: selected.word.length
        },
        winnerMargin: winnerMargin
    } : null;
};
const $9b1bc75748eb73f9$var$isVocabularyJson = (payload)=>{
    if (payload == null || typeof payload !== 'object') return false;
    const words = payload.words;
    return words != null && typeof words === 'object';
};
const $9b1bc75748eb73f9$var$isStringArray = (payload)=>Array.isArray(payload) && payload.every((entry)=>typeof entry === 'string');
const $9b1bc75748eb73f9$var$isWordToOffsetMap = (value)=>value != null && typeof value === 'object' && Object.values(value).every((entry)=>typeof entry === 'number');
const $9b1bc75748eb73f9$var$isWordIndexPayload = (payload)=>{
    if (payload == null || typeof payload !== 'object') return false;
    const index = payload.index;
    return index === undefined ? $9b1bc75748eb73f9$var$isWordToOffsetMap(payload) : $9b1bc75748eb73f9$var$isWordToOffsetMap(index);
};
/**
 * The word index has shipped both bare and wrapped in `{ index: ... }`, so
 * accept either rather than silently building an empty vector store.
 */ const $9b1bc75748eb73f9$var$unwrapWordIndex = (payload)=>{
    const wrapped = payload.index;
    return wrapped ?? payload;
};
const $9b1bc75748eb73f9$var$isPhraseStats = (value)=>value != null && typeof value === 'object' && typeof value.freq === 'number';
const $9b1bc75748eb73f9$var$isTermStatsMap = (value)=>{
    if (value == null || typeof value !== 'object') return false;
    const values = Object.values(value);
    return values.length > 0 && values.every($9b1bc75748eb73f9$var$isPhraseStats);
};
/**
 * Normalize a `bigrams.json` / `phrases.json` payload into a flat
 * `{term: stats}` map. Tolerant of the exact wire shape (not yet finalized by
 * the producer): accepts either the flat map from spec §9 or a single wrapper
 * key (`terms`/`bigrams`/`phrases`/`words`). Returns `null` if unrecognized.
 *
 * :params:
 *   payload: Raw JSON parsed from the artifact endpoint
 * :returns:
 *   A `{term: stats}` map, or `null` when the shape is not a term-stats map
 */ const $9b1bc75748eb73f9$var$normalizePhraseArtifact = (payload)=>{
    if (payload == null || typeof payload !== 'object') return null;
    if ($9b1bc75748eb73f9$var$isTermStatsMap(payload)) return payload;
    const obj = payload;
    for (const key of [
        'terms',
        'bigrams',
        'phrases',
        'words'
    ]){
        if ($9b1bc75748eb73f9$var$isTermStatsMap(obj[key])) return obj[key];
    }
    return null;
};
const $9b1bc75748eb73f9$export$7405eecc8090412c = async (options)=>{
    if ($9b1bc75748eb73f9$var$vectorStore || $9b1bc75748eb73f9$var$vectorsLoadStarted) return;
    const isLocalLLM = options?.isLocalLLM ?? false;
    const surface = options?.surface;
    $9b1bc75748eb73f9$var$vectorsLoadStarted = true;
    (0, $a8cFP.startExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_VECTORS, 'singleton', {
        isLocalLLM: isLocalLLM,
        ...surface ? {
            surface: surface
        } : {}
    });
    try {
        const buffer = await (0, $ln5kH.fetchAutocompleteArtifactBinary)((0, $gKGLg.ARTIFACT_NAME).WORD_VECTORS, 'word_vectors_10k');
        const float32 = new Float32Array(buffer);
        const wordIndexPayload = await (0, $ln5kH.fetchAutocompleteArtifactJson)((0, $gKGLg.ARTIFACT_NAME).WORD_INDEX, {
            summarize: (payload)=>`${Object.keys($9b1bc75748eb73f9$var$unwrapWordIndex(payload)).length} entries`,
            validate: $9b1bc75748eb73f9$var$isWordIndexPayload
        });
        const wordIndex = $9b1bc75748eb73f9$var$unwrapWordIndex(wordIndexPayload);
        const nWords = Object.keys(wordIndex).length;
        if (nWords === 0) (0, $dl7hN.ctcTag)('init', "\u26A0\uFE0F word_index_10k.json was empty \u2014 semantic scoring will be a no-op", (0, $dl7hN.CTC_STYLES).warn);
        const dim = float32.length / nWords;
        $9b1bc75748eb73f9$var$vectorStore = {
            float32: float32,
            wordIndex: wordIndex,
            dim: dim
        };
        (0, $a8cFP.succeedExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_VECTORS, 'singleton', {
            isLocalLLM: isLocalLLM,
            wordCount: nWords,
            dim: dim,
            sizeBytes: float32.byteLength,
            ...surface ? {
                surface: surface
            } : {}
        });
        (0, $dl7hN.ctcTag)('init', `vectors loaded: ${nWords} words \xb7 dim ${dim} \xb7 ${float32.byteLength}B`);
    } catch (e) {
        $9b1bc75748eb73f9$var$vectorsLoadStarted = false;
        (0, $a8cFP.failExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_VECTORS, 'singleton', {
            isLocalLLM: isLocalLLM,
            errorType: 'network',
            ...surface ? {
                surface: surface
            } : {}
        });
        (0, $dl7hN.ctcTag)('init', `\u{26A0}\u{FE0F} failed to load vectors: ${String(e)}`, (0, $dl7hN.CTC_STYLES).bad);
    }
};
const $9b1bc75748eb73f9$export$184e3781694c9a11 = (store)=>{
    $9b1bc75748eb73f9$var$vectorStore = store;
};
const $9b1bc75748eb73f9$export$1bdeac806ca50dc2 = async (options)=>{
    if ($9b1bc75748eb73f9$var$phrasesLoadStarted) return;
    $9b1bc75748eb73f9$var$phrasesLoadStarted = true;
    const isLocalLLM = options?.isLocalLLM ?? false;
    (0, $a8cFP.startExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_PHRASES, 'singleton', {
        isLocalLLM: isLocalLLM
    });
    const loadOne = async (artifactName, termType, label)=>{
        const payload = await (0, $ln5kH.fetchAutocompleteArtifactJson)(artifactName, {
            label: label,
            validate: (p)=>p != null && typeof p === 'object'
        });
        const normalized = $9b1bc75748eb73f9$var$normalizePhraseArtifact(payload);
        if (!normalized) throw new Error(`[text-predictor] ${label} payload was not a recognised term-stats map`);
        return $9b1bc75748eb73f9$export$8fc7cb5981325f60(normalized, termType);
    };
    const [bigramsResult, phrasesResult] = await Promise.allSettled([
        loadOne((0, $gKGLg.ARTIFACT_NAME).BIGRAMS, 'bigram', 'bigrams'),
        loadOne((0, $gKGLg.ARTIFACT_NAME).PHRASES, 'phrase', 'phrases')
    ]);
    const bigramCount = bigramsResult.status === 'fulfilled' ? bigramsResult.value : 0;
    const phraseCount = phrasesResult.status === 'fulfilled' ? phrasesResult.value : 0;
    if (bigramsResult.status === 'rejected') (0, $dl7hN.ctcTag)('init', `\u{26A0}\u{FE0F} failed to load bigrams.json: ${String(bigramsResult.reason)}`, (0, $dl7hN.CTC_STYLES).warn);
    if (phrasesResult.status === 'rejected') (0, $dl7hN.ctcTag)('init', `\u{26A0}\u{FE0F} failed to load phrases.json: ${String(phrasesResult.reason)}`, (0, $dl7hN.CTC_STYLES).warn);
    if (bigramsResult.status === 'fulfilled' || phrasesResult.status === 'fulfilled') {
        $9b1bc75748eb73f9$var$phrasesLoaded = true;
        (0, $a8cFP.succeedExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_PHRASES, 'singleton', {
            isLocalLLM: isLocalLLM,
            bigramCount: bigramCount,
            phraseCount: phraseCount
        });
        (0, $dl7hN.ctcTag)('init', `phrase artifacts loaded: ${bigramCount} bigrams \xb7 ${phraseCount} phrases`);
    } else {
        // Both failed — e.g. artifacts not published to the tenant manifest yet.
        // Reset the guard so a later focus/predict can retry once they land.
        $9b1bc75748eb73f9$var$phrasesLoadStarted = false;
        (0, $a8cFP.failExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_PHRASES, 'singleton', {
            isLocalLLM: isLocalLLM,
            errorType: 'network'
        });
    }
};
let $9b1bc75748eb73f9$var$vocabularyLoadPromise;
const $9b1bc75748eb73f9$export$346f2d6e47b2ef51 = (options)=>{
    if ($9b1bc75748eb73f9$var$isInitialized) return Promise.resolve();
    if ($9b1bc75748eb73f9$var$vocabularyLoadPromise) return $9b1bc75748eb73f9$var$vocabularyLoadPromise;
    const isLocalLLM = options?.isLocalLLM ?? false;
    const source = options?.source ?? 'predict';
    const surface = options?.surface;
    $9b1bc75748eb73f9$var$vocabularyLoadPromise = (async ()=>{
        (0, $a8cFP.startExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_VOCABULARY, 'singleton', {
            isLocalLLM: isLocalLLM,
            ...surface ? {
                surface: surface
            } : {}
        });
        try {
            (0, $dl7hN.ctcTag)('init', `loading artifacts (trigger: ${source} \xb7 localLLM: ${isLocalLLM})`);
            if ((0, $dl7hN.isAutocompleteDebugVerbose)()) {
                // eslint-disable-next-line no-console
                console.groupCollapsed('%c[CTC:init]%c artifact manifest', (0, $dl7hN.CTC_STYLES).brand, (0, $dl7hN.CTC_STYLES).body);
                // eslint-disable-next-line no-console
                console.log('Eager:', [
                    (0, $gKGLg.ARTIFACT_NAME).VOCABULARY,
                    (0, $gKGLg.ARTIFACT_NAME).L3_VOCABULARY,
                    (0, $gKGLg.ARTIFACT_NAME).POS_TAGS,
                    (0, $gKGLg.ARTIFACT_NAME).GHOST_POS_TAGS,
                    (0, $gKGLg.ARTIFACT_NAME).GRAMMAR_TRANSITIONS
                ]);
                // eslint-disable-next-line no-console
                console.log('Conditional:', [
                    `${(0, $gKGLg.ARTIFACT_NAME).WORD_INDEX} (only when vectors load; phrase/bigram surfaces share this index)`,
                    `${(0, $gKGLg.ARTIFACT_NAME).BIGRAMS} + ${(0, $gKGLg.ARTIFACT_NAME).PHRASES} (completion-term stats; fire-and-forget)`,
                    `${(0, $gKGLg.ARTIFACT_NAME).PHRASE_CONTINUATION_TOKENS} (local model only; canonical token IDs for the full served union)`
                ]);
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
            const [vocabularyData, l3VocabularyData] = await Promise.all([
                (0, $ln5kH.fetchAutocompleteArtifactJson)((0, $gKGLg.ARTIFACT_NAME).VOCABULARY, {
                    summarize: (payload)=>`${Object.keys(payload.words).length} words`,
                    validate: $9b1bc75748eb73f9$var$isVocabularyJson
                }),
                (0, $ln5kH.fetchAutocompleteArtifactJson)((0, $gKGLg.ARTIFACT_NAME).L3_VOCABULARY, {
                    summarize: (payload)=>`${payload.length} words`,
                    validate: $9b1bc75748eb73f9$var$isStringArray
                }),
                // Awaited alongside the vocabulary so the grammar filter is settled
                // before the first suggestion can be produced. Without this the
                // predictor initialises on the smaller vocabulary payload and serves
                // candidates the filter would have dropped until the grammar lands.
                // Only settlement is required: a failed load leaves the filter as a
                // pass-through, which is the same degradation as an absent artifact.
                (0, $cVZWR.loadGrammarDataAsync)({
                    isLocalLLM: isLocalLLM,
                    surface: surface
                }).catch((error)=>{
                    (0, $dl7hN.ctcTag)('init', `\u{26A0}\u{FE0F} grammar data unavailable; filtering skipped: ${String(error)}`, (0, $dl7hN.CTC_STYLES).warn);
                })
            ]);
            const terms = Object.entries(vocabularyData.words).map(([word, stats])=>({
                    word: word,
                    freq: stats.freq,
                    docFreq: stats.doc_freq,
                    authorFreq: stats.author_freq
                }));
            // Load L3 before L2: initVocabulary flips `isInitialized = true`, so it
            // must run last — otherwise a throw in initL3Vocabulary would strand
            // `isInitialized` true and the retry path could never reload L3.
            $9b1bc75748eb73f9$export$e83b7608dafb1b7(l3VocabularyData);
            $9b1bc75748eb73f9$export$23ef18e0b7a5148d({
                terms: terms
            });
            // Phrase/bigram artifacts load independently and must never affect the
            // word path — fire-and-forget with its own error handling inside.
            $9b1bc75748eb73f9$export$1bdeac806ca50dc2({
                isLocalLLM: isLocalLLM
            }).catch(()=>{});
            (0, $a8cFP.succeedExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_VOCABULARY, 'singleton', {
                isLocalLLM: isLocalLLM,
                l2WordCount: terms.length,
                l3WordCount: l3VocabularyData.length,
                ...surface ? {
                    surface: surface
                } : {}
            });
        } catch (e) {
            (0, $a8cFP.failExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_VOCABULARY, 'singleton', {
                isLocalLLM: isLocalLLM,
                errorType: 'parse_error',
                ...surface ? {
                    surface: surface
                } : {}
            });
            // Allow a later call to retry the load rather than caching the failure.
            $9b1bc75748eb73f9$var$vocabularyLoadPromise = undefined;
            throw e;
        }
    })();
    return $9b1bc75748eb73f9$var$vocabularyLoadPromise;
};
module.exports["getLastPredictionOutcome"] = $9b1bc75748eb73f9$export$7d201d50fd19305a;
module.exports["noteSuggestionAccepted"] = $9b1bc75748eb73f9$export$aa59c0c98e9e4f4b;
module.exports["isSurfaceInAcceptCooldown"] = $9b1bc75748eb73f9$export$a7d8235b640c18e1;
module.exports["getLastPredictionDebug"] = $9b1bc75748eb73f9$export$fd2b59f22034dd2c;
module.exports["incrementSessionFreq"] = $9b1bc75748eb73f9$export$3a8c67928d5f769d;
module.exports["resetSessionBoosts"] = $9b1bc75748eb73f9$export$7151fdda90e36782;
module.exports["lookupVocabularySource"] = $9b1bc75748eb73f9$export$b641b45d2eba9391;
module.exports["ingestDocumentPage"] = $9b1bc75748eb73f9$export$4c0c6bb8e981b843;
module.exports["predict"] = $9b1bc75748eb73f9$export$f2757470e79e02f3;
module.exports["loadDefaultVocabulary"] = $9b1bc75748eb73f9$export$346f2d6e47b2ef51;
module.exports["loadVectorsAsync"] = $9b1bc75748eb73f9$export$7405eecc8090412c;

});

parcelRegister("2KSOM", function(module, exports) {

let $201a6659c6483197$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $201a6659c6483197$var$load("1fUAT").then(()=>parcelRequire('jUg6i'));

});

parcelRegister("e4kXe", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $60Uyi = parcelRequire("60Uyi");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fRQ3t = parcelRequire("fRQ3t");


var $1hQ0e = parcelRequire("1hQ0e");


var $6dlKt = parcelRequire("6dlKt");




const $923f60795082120e$var$ICON_SIZE = 12;
const $923f60795082120e$var$iconSlotExpand = null;
const $923f60795082120e$var$chipStyles = null;
const $923f60795082120e$var$innerStyles = null;
const $923f60795082120e$var$iconSlotStyles = null;
const $923f60795082120e$var$iconBoxStyles = null;
const $923f60795082120e$var$skeletonStyles = null;
const $923f60795082120e$var$remoteIconStyles = null;
const $923f60795082120e$var$hiddenStyles = null;
const $923f60795082120e$var$labelStyles = null;
const $923f60795082120e$var$getStringAttr = (value)=>typeof value === 'string' ? value : '';
const $923f60795082120e$var$getChipAttrs = (node)=>({
        source: $923f60795082120e$var$getStringAttr(node.attrs.source),
        display: $923f60795082120e$var$getStringAttr(node.attrs.display),
        iconUrl: $923f60795082120e$var$getStringAttr(node.attrs.iconUrl) || undefined
    });
const $923f60795082120e$var$ConnectorSourceChipIcon = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { source: source, iconUrl: iconUrl } = t0;
    const [isRemoteIconLoading, setIsRemoteIconLoading] = (0, $cozmU.useState)(Boolean(iconUrl));
    const [hasRemoteIconError, setHasRemoteIconError] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== iconUrl) {
        t1 = ()=>{
            setIsRemoteIconLoading(Boolean(iconUrl));
            setHasRemoteIconError(false);
        };
        $[0] = iconUrl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== iconUrl || $[3] !== source) {
        t2 = [
            iconUrl,
            source
        ];
        $[2] = iconUrl;
        $[3] = source;
        $[4] = t2;
    } else t2 = $[4];
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[5] !== source) {
        t3 = (0, $6dlKt.getKnowledgeSourceIcon)(source, {
            size: $923f60795082120e$var$ICON_SIZE
        });
        $[5] = source;
        $[6] = t3;
    } else t3 = $[6];
    const localIcon = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6dlKt.getKnowledgeSourceIcon)("app", {
            size: $923f60795082120e$var$ICON_SIZE
        });
        $[7] = t4;
    } else t4 = $[7];
    const fallbackIcon = t4;
    const showRemoteIcon = !localIcon && iconUrl && !hasRemoteIconError;
    let content;
    if (localIcon) content = localIcon;
    else if (showRemoteIcon) {
        let t5;
        if ($[8] !== isRemoteIconLoading) {
            t5 = isRemoteIconLoading && /*#__PURE__*/ $cozmU.createElement("span", {
                className: (0, $hekY6.default)([
                    "_0bjKvDcjp5 _3iDTPbvLZJ _39xV02xpxF _0jFU0VxpxF _0KLXruGsB2"
                ])
            });
            $[8] = isRemoteIconLoading;
            $[9] = t5;
        } else t5 = $[9];
        let t6;
        let t7;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = ()=>setIsRemoteIconLoading(false);
            t7 = ()=>{
                setIsRemoteIconLoading(false);
                setHasRemoteIconError(true);
            };
            $[10] = t6;
            $[11] = t7;
        } else {
            t6 = $[10];
            t7 = $[11];
        }
        const t8 = isRemoteIconLoading && "_3iDTPbYbGa";
        let t9;
        if ($[12] !== t8) {
            t9 = (0, $hekY6.default)([
                "_3iDTPbvLZJ _39xV02xpxF _0jFU0VxpxF _00EA0egIor",
                t8
            ]);
            $[12] = t8;
            $[13] = t9;
        } else t9 = $[13];
        let t10;
        if ($[14] !== iconUrl || $[15] !== t9) {
            t10 = /*#__PURE__*/ $cozmU.createElement("img", {
                src: iconUrl,
                alt: "",
                width: $923f60795082120e$var$ICON_SIZE,
                height: $923f60795082120e$var$ICON_SIZE,
                referrerPolicy: "no-referrer",
                onLoad: t6,
                onError: t7,
                className: t9
            });
            $[14] = iconUrl;
            $[15] = t9;
            $[16] = t10;
        } else t10 = $[16];
        let t11;
        if ($[17] !== t10 || $[18] !== t5) {
            t11 = /*#__PURE__*/ $cozmU.createElement("span", null, t5, t10);
            $[17] = t10;
            $[18] = t5;
            $[19] = t11;
        } else t11 = $[19];
        content = t11;
    } else content = fallbackIcon;
    let t5;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_3iDTPbccYA"
        ]);
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== content) {
        t6 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t5
        }, content);
        $[21] = content;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
} : ({ source: source, iconUrl: iconUrl })=>{
    const [isRemoteIconLoading, setIsRemoteIconLoading] = (0, $cozmU.useState)(Boolean(iconUrl));
    const [hasRemoteIconError, setHasRemoteIconError] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setIsRemoteIconLoading(Boolean(iconUrl));
        setHasRemoteIconError(false);
    }, [
        iconUrl,
        source
    ]);
    const localIcon = (0, $cozmU.useMemo)(()=>(0, $6dlKt.getKnowledgeSourceIcon)(source, {
            size: $923f60795082120e$var$ICON_SIZE
        }), [
        source
    ]);
    const fallbackIcon = (0, $cozmU.useMemo)(()=>(0, $6dlKt.getKnowledgeSourceIcon)('app', {
            size: $923f60795082120e$var$ICON_SIZE
        }), []);
    const showRemoteIcon = !localIcon && iconUrl && !hasRemoteIconError;
    let content;
    if (localIcon) content = localIcon;
    else if (showRemoteIcon) content = /*#__PURE__*/ $cozmU.createElement("span", null, isRemoteIconLoading && /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_0bjKvDcjp5 _3iDTPbvLZJ _39xV02xpxF _0jFU0VxpxF _0KLXruGsB2"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("img", {
        src: iconUrl,
        alt: "",
        width: $923f60795082120e$var$ICON_SIZE,
        height: $923f60795082120e$var$ICON_SIZE,
        referrerPolicy: "no-referrer",
        onLoad: ()=>setIsRemoteIconLoading(false),
        onError: ()=>{
            setIsRemoteIconLoading(false);
            setHasRemoteIconError(true);
        },
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02xpxF _0jFU0VxpxF _00EA0egIor",
            isRemoteIconLoading && "_3iDTPbYbGa"
        ])
    }));
    else content = fallbackIcon;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbccYA"
        ])
    }, content);
});
$923f60795082120e$var$ConnectorSourceChipIcon.displayName = 'ConnectorSourceChipIcon';
const $923f60795082120e$var$areChipAttrsEqual = (previous, next)=>previous.source === next.source && previous.display === next.display && previous.iconUrl === next.iconUrl;
const $923f60795082120e$var$ConnectorSourceChip = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { source: source, display: display, iconUrl: iconUrl } = t0;
    let t1;
    if ($[0] !== iconUrl) {
        t1 = iconUrl ? {
            "data-icon-url": iconUrl
        } : {};
        $[0] = iconUrl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_0Of8r24Jdh _1ZnuxbEwa9 _1wydGW4Jdh _2Zuz6QEwa9 _0bjKvDKxmn _2sNsIgNxAV _4bt5LAIZbP _2WAcuGIZbP _3hxITiYbGa _3iDTPbS8kF _0KLXruDMqu _23OpWYXpc7 _2NnhnEXpc7 _1UtDYzy7kJ _3zvHkHwPeg _1ANEUSlpBW"
        ]);
        t3 = (0, $hekY6.default)([
            "_2mHwu8FQfX _3iDTPbccYA _0hPCNLQame"
        ]);
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02xpxF _0jFU0VxpxF _3YEZNOdnbC _1RrJLit2nV _1VJPcapBrv _1gBibyYL50 _0nFVCGPdtu _43vdfTjwM9 _3Y6bKp38c8 _0LqqFdYbGa"
        ]);
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== iconUrl || $[6] !== source) {
        t5 = /*#__PURE__*/ $cozmU.createElement("span", {
            "aria-hidden": "true",
            className: t4
        }, /*#__PURE__*/ $cozmU.createElement($923f60795082120e$var$ConnectorSourceChipIcon, {
            source: source,
            iconUrl: iconUrl
        }));
        $[5] = iconUrl;
        $[6] = source;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_2sNsIgOLYo"
        ]);
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== display) {
        t7 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t6
        }, display);
        $[9] = display;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t5 || $[12] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t3
        }, t5, t7);
        $[11] = t5;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== display || $[15] !== source || $[16] !== t1 || $[17] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": "connector-source-chip",
            "data-connector-source-chip": "true",
            "data-source": source,
            "data-display": display,
            ...t1,
            className: t2
        }, t8);
        $[14] = display;
        $[15] = source;
        $[16] = t1;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : ({ source: source, display: display, iconUrl: iconUrl })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": "connector-source-chip",
        "data-connector-source-chip": "true",
        "data-source": source,
        "data-display": display,
        ...iconUrl ? {
            'data-icon-url': iconUrl
        } : {},
        className: (0, $hekY6.default)([
            "_0Of8r24Jdh _1ZnuxbEwa9 _1wydGW4Jdh _2Zuz6QEwa9 _0bjKvDKxmn _2sNsIgNxAV _4bt5LAIZbP _2WAcuGIZbP _3hxITiYbGa _3iDTPbS8kF _0KLXruDMqu _23OpWYXpc7 _2NnhnEXpc7 _1UtDYzy7kJ _3zvHkHwPeg _1ANEUSlpBW"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_2mHwu8FQfX _3iDTPbccYA _0hPCNLQame"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02xpxF _0jFU0VxpxF _3YEZNOdnbC _1RrJLit2nV _1VJPcapBrv _1gBibyYL50 _0nFVCGPdtu _43vdfTjwM9 _3Y6bKp38c8 _0LqqFdYbGa"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($923f60795082120e$var$ConnectorSourceChipIcon, {
        source: source,
        iconUrl: iconUrl
    })), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_2sNsIgOLYo"
        ])
    }, display)));
});
$923f60795082120e$var$ConnectorSourceChip.displayName = 'ConnectorSourceChip';
const $923f60795082120e$var$renderChip = (root, attrs)=>{
    const { source: source, display: display, iconUrl: iconUrl } = attrs;
    root.render(/*#__PURE__*/ $cozmU.createElement($923f60795082120e$var$ConnectorSourceChip, {
        source: source,
        display: display,
        iconUrl: iconUrl
    }));
};
const $923f60795082120e$export$6eb44f18c777778b = (node)=>{
    const doc = (0, $1hQ0e.getDocument)();
    if (!doc) throw new Error('Connector source chip node view requires a document');
    let currentAttrs = $923f60795082120e$var$getChipAttrs(node);
    const dom = doc.createElement('span'); // Prevent the browser's native cursor from entering the chip's DOM boundary.
    // Without this, pressing ArrowRight or ArrowLeft briefly places the cursor
    // inside the chip where it is not visible, causing it to disappear until
    // the next move.
    dom.setAttribute('contenteditable', 'false');
    const root = (0, $fRQ3t.createRoot)(dom);
    $923f60795082120e$var$renderChip(root, currentAttrs);
    return {
        dom: dom,
        update (nextNode) {
            if (nextNode.type.name !== (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) return false;
            const nextAttrs = $923f60795082120e$var$getChipAttrs(nextNode);
            if ($923f60795082120e$var$areChipAttrsEqual(currentAttrs, nextAttrs)) return true;
            currentAttrs = nextAttrs;
            $923f60795082120e$var$renderChip(root, currentAttrs);
            return true;
        },
        destroy () {
            queueMicrotask(()=>root.unmount());
        }
    };
};



var $kCECX = parcelRequire("kCECX");




const $bd1662ca54365842$export$d00f87178ffe6714 = (view, event)=>{
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return false;
    const { state: state } = view;
    const { selection: selection } = state;
    const dir = event.key === 'ArrowRight' ? 1 : -1;
    // Case 1: Chip is currently NodeSelected (ProseMirror put it into NodeSelection).
    // Move past it to a TextSelection on the far side.
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        if (selection.node?.type?.name === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) {
            const targetPos = dir > 0 ? selection.$to.pos : selection.$from.pos;
            event.preventDefault();
            view.dispatch(state.tr.setSelection((0, $kCECX.TextSelection).create(state.doc, targetPos)));
            return true;
        }
        return false;
    }
    // Case 2: Collapsed TextSelection adjacent to a chip.
    // Jump to the other side to prevent ProseMirror from creating a NodeSelection.
    if (!selection.empty) return false;
    const { $from: $from } = selection;
    const from = selection.from;
    if (dir > 0) {
        const nodeAfter = $from.nodeAfter;
        if (nodeAfter?.type?.name === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) {
            event.preventDefault();
            view.dispatch(state.tr.setSelection((0, $kCECX.TextSelection).create(state.doc, from + nodeAfter.nodeSize)));
            return true;
        }
        // Cursor is directly after a chip at the end of its parent (no nodeAfter).
        // Prevent the phantom step into the paragraph-close boundary position.
        const nodeBefore = $from.nodeBefore;
        if (nodeBefore?.type?.name === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME) && $from.parentOffset === $from.parent.content.size) {
            event.preventDefault();
            return true;
        }
    } else {
        const nodeBefore = $from.nodeBefore;
        if (nodeBefore?.type?.name === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) {
            event.preventDefault();
            view.dispatch(state.tr.setSelection((0, $kCECX.TextSelection).create(state.doc, from - nodeBefore.nodeSize)));
            return true;
        }
    }
    return false;
};


const $86e7bda06fcadbb9$var$hasObjectShape = (value)=>typeof value === 'object' && value !== null;
const $86e7bda06fcadbb9$var$getConnectorSourceDisplay = (value)=>{
    if (!$86e7bda06fcadbb9$var$hasObjectShape(value) || !$86e7bda06fcadbb9$var$hasObjectShape(value.attrs)) return '';
    return typeof value.attrs.display === 'string' ? value.attrs.display : '';
};
const $86e7bda06fcadbb9$var$normalizeConnectorSourceJson = (_key, value)=>{
    if ($86e7bda06fcadbb9$var$hasObjectShape(value) && value.type === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) return {
        type: 'text',
        text: $86e7bda06fcadbb9$var$getConnectorSourceDisplay(value)
    };
    return value;
};
const $86e7bda06fcadbb9$export$d2725e20f7d4ea3e = (doc)=>JSON.parse(JSON.stringify(doc, $86e7bda06fcadbb9$var$normalizeConnectorSourceJson));
const $86e7bda06fcadbb9$export$9de1f4debe7f2e29 = (textBefore, sources)=>{
    const lower = textBefore.toLowerCase();
    for (const entry of sources){
        const { key: key, display: display } = entry;
        if (lower.endsWith(key)) {
            const startOffset = textBefore.length - key.length;
            if (startOffset === 0 || /\s/.test(textBefore[startOffset - 1])) return {
                entry: entry,
                name: display,
                startOffset: startOffset
            };
        }
    }
    return null;
};
const $86e7bda06fcadbb9$export$c572ae05ff1a3f = (view, event)=>{
    if (event.key !== 'Backspace') return false;
    const { state: state } = view;
    const { selection: selection } = state;
    if (!selection.empty) return false;
    const { $from: $from } = selection;
    const nodeBefore = $from.nodeBefore;
    if (nodeBefore?.type.name === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) {
        const chipEndPosition = $from.pos;
        const chipStartPosition = chipEndPosition - nodeBefore.nodeSize;
        event.preventDefault();
        view.dispatch(state.tr.delete(chipStartPosition, chipEndPosition));
        return true;
    }
    if (nodeBefore?.isText && nodeBefore.text === ' ') {
        const positionBeforeSpace = $from.pos - 1;
        const resolvedPositionBeforeSpace = state.doc.resolve(positionBeforeSpace);
        const nodeBeforeSpace = resolvedPositionBeforeSpace.nodeBefore;
        if (nodeBeforeSpace?.type.name === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) {
            const chipStartPosition = positionBeforeSpace - nodeBeforeSpace.nodeSize;
            event.preventDefault();
            view.dispatch(state.tr.delete(chipStartPosition, $from.pos));
            return true;
        }
    }
    return false;
};
const $86e7bda06fcadbb9$export$ae76e6cef034bf3b = ({ view: view, schema: schema, from: from, text: text, sourceNames: sourceNames })=>{
    if (!sourceNames.length) return false;
    const { state: state } = view;
    const { $from: $from } = state.selection;
    const textBefore = $from.parent.textBetween(0, $from.parentOffset, undefined, '\ufffc') + '';
    // When a delimiter (space, comma, etc.) is typed, match against textBefore
    // as before. When a word character is typed, match against textBefore + text
    // so the chip fires as soon as the last letter of the app name is complete —
    // mirroring the tip banner's "atEnd" (charAfter === undefined) logic.
    const isDelimiter = /\W/.test(text);
    // --- Chip upgrade: detect <chip> + " " + partial-text at cursor ---
    // textBefore already has \uFFFC for chip nodes. If the pattern matches,
    // try to upgrade the existing chip to a longer-named source.
    const chipSpaceTextMatch = /\uFFFC ([\w][\w ]*)$/.exec(textBefore);
    if (chipSpaceTextMatch) {
        const textAfterChipSpace = chipSpaceTextMatch[1];
        const fullTypedAfterChip = isDelimiter ? textAfterChipSpace : textAfterChipSpace + text;
        // Walk the parent's children to find the chip whose end is followed
        // by " " + textAfterChipSpace up to the cursor position.
        const parent = $from.parent;
        const parentStart = $from.start();
        const cursorParentOffset = $from.parentOffset;
        let chipPos = -1;
        let chipNode = null;
        parent.forEach((child, childOffset)=>{
            if (chipPos !== -1) return; // already found
            if (child.type.name === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) {
                const afterChipStart = childOffset + child.nodeSize;
                const textAfterChip = parent.textBetween(afterChipStart, cursorParentOffset, undefined, '\ufffc');
                if (textAfterChip === ' ' + textAfterChipSpace) {
                    chipPos = parentStart + childOffset;
                    chipNode = child;
                }
            }
        });
        if (chipNode !== null && chipPos !== -1) {
            const chipDisplay = chipNode.attrs?.display ?? '';
            const candidate = (chipDisplay + ' ' + fullTypedAfterChip).toLowerCase();
            const existingChipKey = chipDisplay.toLowerCase();
            const upgradeMatch = sourceNames.find((s)=>s.key === candidate && s.key.length > existingChipKey.length);
            if (upgradeMatch) {
                const connectorSourceChipNode = schema.nodes[0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME];
                const newChip = connectorSourceChipNode.create({
                    source: upgradeMatch.source ?? upgradeMatch.key,
                    display: upgradeMatch.display,
                    iconUrl: upgradeMatch.iconUrl ?? null
                });
                const nodes = isDelimiter ? [
                    newChip,
                    schema.text(text)
                ] : [
                    newChip
                ];
                const tr = state.tr.replaceWith(chipPos, from, nodes);
                view.dispatch(tr);
                return true;
            }
        }
    }
    // --- End chip upgrade ---
    const textToMatch = isDelimiter ? textBefore : textBefore + text;
    const match = $86e7bda06fcadbb9$export$9de1f4debe7f2e29(textToMatch, sourceNames);
    if (!match) {
        // If no match and the node immediately before the cursor is a chip,
        // a word character has been typed that extends beyond the app name
        // (e.g. "miro" chip → user types "s" → should become plain "miros").
        // Replace the chip with its plain-text display name + the typed char.
        if (!isDelimiter) {
            const nodeBefore = $from.nodeBefore;
            if (nodeBefore?.type.name === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) {
                const chipDisplay = nodeBefore.attrs.display;
                const chipEnd = from;
                const chipStart = chipEnd - nodeBefore.nodeSize;
                const tr = state.tr.replaceWith(chipStart, chipEnd, schema.text(chipDisplay + text));
                view.dispatch(tr);
                return true;
            }
        }
        return false;
    }
    const absoluteStart = $from.start() + match.startOffset;
    const absoluteEnd = from;
    const connectorSourceChipNode = schema.nodes[0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME];
    if (!connectorSourceChipNode) return false;
    const chipNode = connectorSourceChipNode.create({
        source: match.entry.source ?? match.entry.key,
        display: match.entry.display,
        iconUrl: match.entry.iconUrl ?? null
    });
    const nodes = isDelimiter ? [
        chipNode,
        schema.text(text)
    ] : [
        chipNode
    ];
    const tr = state.tr.replaceWith(absoluteStart, absoluteEnd, nodes);
    view.dispatch(tr);
    return true;
};
const $86e7bda06fcadbb9$export$f6f01fc440f7b697 = ({ config: { knownSourcesRef: knownSourcesRef } })=>{
    return {
        name: 'connectorSourceInputRule',
        nodes () {
            return [
                {
                    name: (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME),
                    node: (0, $60Uyi.connectorSourceChipNodeSpec)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'connectorSourceInputRule',
                    plugin: ({ schema: schema })=>{
                        return new (0, $kpCD8.SafePlugin)({
                            props: {
                                // handleDOMEvents fires from the raw DOM event, before ProseMirror's
                                // own keymap/baseKeymap plugin processes the event. This ensures our
                                // arrow-key chip navigation intercepts ArrowRight/ArrowLeft before
                                // ProseMirror's default atom-node selection logic runs.
                                handleDOMEvents: {
                                    keydown (view, event) {
                                        if ($86e7bda06fcadbb9$export$c572ae05ff1a3f(view, event)) return true;
                                        return (0, $bd1662ca54365842$export$d00f87178ffe6714)(view, event);
                                    }
                                },
                                nodeViews: {
                                    [(0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)]: (pmNode)=>(0, $923f60795082120e$export$6eb44f18c777778b)(pmNode)
                                },
                                handleTextInput (view, from, _to, text) {
                                    return $86e7bda06fcadbb9$export$ae76e6cef034bf3b({
                                        view: view,
                                        schema: schema,
                                        from: from,
                                        text: text,
                                        sourceNames: knownSourcesRef.current
                                    });
                                }
                            }
                        });
                    }
                }
            ];
        }
    };
};
module.exports["normalizeConnectorSourceDoc"] = $86e7bda06fcadbb9$export$d2725e20f7d4ea3e;
module.exports["connectorSourceInputRulePlugin"] = $86e7bda06fcadbb9$export$f6f01fc440f7b697;

});

parcelRegister("iDlFY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $6rwn6 = parcelRequire("6rwn6");

const $60979607c1a2197f$var$state = (0, $8s9DV.createStore)({
    initialState: {
        placeholder: null
    },
    actions: {
        setPlaceholder: (placeholder)=>({ setState: setState })=>{
                setState({
                    placeholder: placeholder
                });
            }
    }
});
const $60979607c1a2197f$export$caaec55db704374b = (0, $kBr4q.createHook)($60979607c1a2197f$var$state);
const $60979607c1a2197f$var$getPlaceholderType = (placeholderLabel)=>{
    switch(placeholderLabel){
        case 'person':
            return 'person';
        case 'skill':
            return 'skill';
        case 'status':
        case 'priority':
            return 'generic';
        default:
            return 'link';
    }
};
const $60979607c1a2197f$var$isPromptWithPlaceholder = (prompt)=>{
    return prompt.includes((0, $6rwn6.PROMPT_PLACEHOLDER_CHAR));
};
const $60979607c1a2197f$export$96ba721a063d462c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(14);
    const [t0, t1] = $60979607c1a2197f$export$caaec55db704374b();
    const { placeholder: placeholder } = t0;
    const { setPlaceholder: setPlaceholder } = t1;
    let t2;
    if ($[0] !== setPlaceholder) {
        t2 = (prompt, overrideType, skillMetadata)=>{
            if (overrideType === "skill") {
                const { adf: adf, promptLength: promptLength } = (0, $6rwn6.encodeSkillPromptToAdf)(prompt);
                const offset = (0, $cXtTj.default).getExperimentValue("rovo_chat_sticky_skill_cursor_fix", "isEnabled", false) ? 1 : 0;
                setPlaceholder({
                    prompt: prompt,
                    adfDocument: adf,
                    type: "generic",
                    selectionStartIndex: promptLength + offset,
                    selectionEndIndex: promptLength + offset
                });
                return;
            }
            const { adf: adf_0, promptLength: promptLength_0, placeholderRange: placeholderRange } = (0, $6rwn6.encodePromptToAdf)(prompt, skillMetadata, true);
            const type = placeholderRange ? overrideType ?? $60979607c1a2197f$var$getPlaceholderType(placeholderRange.label) : "generic";
            setPlaceholder({
                prompt: prompt,
                adfDocument: adf_0,
                type: type,
                selectionStartIndex: placeholderRange?.start ?? promptLength_0 + 1,
                selectionEndIndex: placeholderRange?.end ?? promptLength_0 + 1
            });
        };
        $[0] = setPlaceholder;
        $[1] = t2;
    } else t2 = $[1];
    const insertPlaceholder = t2;
    let t3;
    if ($[2] !== setPlaceholder) {
        t3 = (url)=>{
            const adfDocument = {
                version: 1,
                type: "doc",
                content: [
                    {
                        type: "paragraph",
                        content: [
                            {
                                type: "inlineCard",
                                attrs: {
                                    url: url
                                }
                            },
                            {
                                type: "text",
                                text: " "
                            }
                        ]
                    }
                ]
            };
            setPlaceholder({
                prompt: url,
                adfDocument: adfDocument,
                type: "generic",
                selectionStartIndex: 3,
                selectionEndIndex: 3
            });
        };
        $[2] = setPlaceholder;
        $[3] = t3;
    } else t3 = $[3];
    const insertInlineCard = t3;
    let t4;
    if ($[4] !== setPlaceholder) {
        t4 = (prompt_0, adfDocument_0, options)=>{
            setPlaceholder({
                prompt: prompt_0,
                adfDocument: adfDocument_0,
                type: "generic",
                selectionStartIndex: options?.selectionStartIndex ?? 2,
                selectionEndIndex: options?.selectionEndIndex ?? options?.selectionStartIndex ?? 2,
                shouldFocus: options?.shouldFocus,
                insertAtCursor: options?.insertAtCursor,
                insertAtEnd: options?.insertAtEnd
            });
        };
        $[4] = setPlaceholder;
        $[5] = t4;
    } else t4 = $[5];
    const insertPlaceholderWithAdf = t4;
    let t5;
    if ($[6] !== setPlaceholder) {
        t5 = ()=>{
            setPlaceholder(null);
        };
        $[6] = setPlaceholder;
        $[7] = t5;
    } else t5 = $[7];
    const clearPlaceholder = t5;
    let t6;
    if ($[8] !== clearPlaceholder || $[9] !== insertInlineCard || $[10] !== insertPlaceholder || $[11] !== insertPlaceholderWithAdf || $[12] !== placeholder) {
        t6 = {
            insertPlaceholder: insertPlaceholder,
            insertPlaceholderWithAdf: insertPlaceholderWithAdf,
            insertInlineCard: insertInlineCard,
            clearPlaceholder: clearPlaceholder,
            placeholder: placeholder,
            isPromptWithPlaceholder: $60979607c1a2197f$var$isPromptWithPlaceholder
        };
        $[8] = clearPlaceholder;
        $[9] = insertInlineCard;
        $[10] = insertPlaceholder;
        $[11] = insertPlaceholderWithAdf;
        $[12] = placeholder;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ()=>{
    const [{ placeholder: placeholder }, { setPlaceholder: setPlaceholder }] = $60979607c1a2197f$export$caaec55db704374b();
    const insertPlaceholder = (0, $cozmU.useCallback)((prompt, overrideType, skillMetadata)=>{
        // TODO: Used for pubsub listener events to convert skill tags to ADF. Remove this once we have a better solution.
        if (overrideType === 'skill') {
            const { adf: adf, promptLength: promptLength } = (0, $6rwn6.encodeSkillPromptToAdf)(prompt);
            const offset = (0, $cXtTj.default).getExperimentValue('rovo_chat_sticky_skill_cursor_fix', 'isEnabled', false) ? 1 : 0;
            setPlaceholder({
                prompt: prompt,
                adfDocument: adf,
                type: 'generic',
                selectionStartIndex: promptLength + offset,
                selectionEndIndex: promptLength + offset
            });
            return;
        }
        const { adf: adf_0, promptLength: promptLength_0, placeholderRange: placeholderRange } = (0, $6rwn6.encodePromptToAdf)(prompt, skillMetadata, true);
        const type = placeholderRange ? overrideType ?? $60979607c1a2197f$var$getPlaceholderType(placeholderRange.label) : 'generic';
        setPlaceholder({
            prompt: prompt,
            adfDocument: adf_0,
            type: type,
            selectionStartIndex: placeholderRange?.start ?? promptLength_0 + 1,
            selectionEndIndex: placeholderRange?.end ?? promptLength_0 + 1
        });
    }, [
        setPlaceholder
    ]);
    const insertInlineCard = (0, $cozmU.useCallback)((url)=>{
        const adfDocument = {
            version: 1,
            type: 'doc',
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'inlineCard',
                            attrs: {
                                url: url
                            }
                        },
                        {
                            type: 'text',
                            text: ' '
                        }
                    ]
                }
            ]
        };
        setPlaceholder({
            prompt: url,
            adfDocument: adfDocument,
            type: 'generic',
            selectionStartIndex: 3,
            selectionEndIndex: 3
        });
    }, [
        setPlaceholder
    ]);
    /**
   * Inserts a placeholder with a pre-built ADF document.
   * Places cursor at start of content (position 2) to avoid position calculation issues.
   * Use this when you have content with inline cards or other complex ADF nodes.
   */ const insertPlaceholderWithAdf = (0, $cozmU.useCallback)((prompt_0, adfDocument_0, options)=>{
        setPlaceholder({
            prompt: prompt_0,
            adfDocument: adfDocument_0,
            type: 'generic',
            // Position 2 is always valid for the default empty paragraph case:
            // doc(0) > paragraph(1) > content start(2).
            selectionStartIndex: options?.selectionStartIndex ?? 2,
            selectionEndIndex: options?.selectionEndIndex ?? options?.selectionStartIndex ?? 2,
            shouldFocus: options?.shouldFocus,
            insertAtCursor: options?.insertAtCursor,
            insertAtEnd: options?.insertAtEnd
        });
    }, [
        setPlaceholder
    ]);
    const clearPlaceholder = (0, $cozmU.useCallback)(()=>{
        setPlaceholder(null);
    }, [
        setPlaceholder
    ]);
    return {
        insertPlaceholder: insertPlaceholder,
        insertPlaceholderWithAdf: insertPlaceholderWithAdf,
        insertInlineCard: insertInlineCard,
        clearPlaceholder: clearPlaceholder,
        placeholder: placeholder,
        isPromptWithPlaceholder: $60979607c1a2197f$var$isPromptWithPlaceholder
    };
};
module.exports["usePlaceholderStore"] = $60979607c1a2197f$export$caaec55db704374b;
module.exports["useEditorPlaceholder"] = $60979607c1a2197f$export$96ba721a063d462c;

});

parcelRegister("YooNh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $4MnFz = parcelRequire("4MnFz");


var $24dy7 = parcelRequire("24dy7");


var $iMnC5 = parcelRequire("iMnC5");


var $irnO2 = parcelRequire("irnO2");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $fCunh = parcelRequire("fCunh");


var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $jI4Q0 = parcelRequire("jI4Q0");





var $8A2GO = parcelRequire("8A2GO");

const $94eff426cbeaaefd$export$4c9efc922a2449ec = (error)=>{
    if (!(0, $8A2GO.isApiError)(error)) return false;
    return error.errorAttributes.statusCode === (0, $fCunh.STATUS_CODES).UNSUPPORTED_FILE_TYPE || error.errorAttributes.errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).FILE_SIZE_TOO_LARGE || error.errorAttributes.statusCode === (0, $fCunh.STATUS_CODES).FILE_RAI_POLICY_VIOLATION;
};





const $ed55c95f12fa143c$var$message = (0, $kSwu1.defineMessages)({
    unsupportedFile: {
        id: "ai-mate.upload-files-to-conversation.unsupported-file",
        defaultMessage: "Unsupported file type"
    },
    unknownError: {
        id: "ai-mate.upload-files-to-conversation.unknown-error",
        defaultMessage: "There was an error uploading the file. Please try again."
    },
    fileRaiPolicyViolationError: {
        id: "ai-mate.upload-files-to-conversation.file-rai-policy-violation",
        defaultMessage: "The file might not comply with our Acceptable Use Policy. Try a different file."
    },
    failToValidateFilesTitle: {
        id: "ai-mate.upload-files-to-conversation.fail-to-validate-files-title",
        defaultMessage: "Failed to validate files"
    },
    failToValidateFilesDescription: {
        id: "ai-mate.upload-files-to-conversation.fail-to-validate-files-description",
        defaultMessage: "Error occurred while validating files, please try again."
    },
    invalidFilesTitle: {
        id: "ai-mate.upload-files-to-conversation.refresh.invalid-files-title",
        defaultMessage: "{count, plural, one {File type} other {File types}} not supported"
    },
    invalidFilesDescription: {
        id: "ai-mate.upload-files-to-conversation.refresh.invalid-files-description",
        defaultMessage: "{count, plural, one {The file \"{fileNames}\" is not supported. Reason: {reasons}} other {The following files: \"{fileNames}\" are not supported. Reason: {reasons}}}"
    },
    fileInvalidIconLabel: {
        id: "ai-mate.upload-files-to-conversation.file-invalid-icon-label",
        defaultMessage: "File is invalid"
    },
    validationErrorInvalidContentType: {
        id: "ai-mate.upload-files-to-conversation.validation-error-invalid-content-type",
        defaultMessage: "File type is not supported"
    },
    validationErrorFileTooLarge: {
        id: "ai-mate.upload-files-to-conversation.validation-error-file-too-large",
        defaultMessage: "File size is too large"
    },
    validationErrorFileNameMissing: {
        id: "ai-mate.upload-files-to-conversation.validation-error-file-name-missing",
        defaultMessage: "File name is missing"
    },
    validationErrorUnknownError: {
        id: "ai-mate.upload-files-to-conversation.validation-error-unknown-error",
        defaultMessage: "Fail to validate file for unknown reason"
    },
    validationErrorMissingErrorCode: {
        id: "ai-mate.upload-files-to-conversation.validation-error-missing-error-code",
        defaultMessage: "Validation result unknown"
    },
    validationErrorNotFound: {
        id: "ai-mate.upload-files-to-conversation.validation-error-not-found",
        defaultMessage: "Validation result is not found"
    }
});
var $ed55c95f12fa143c$export$2e2bcd8739ae039 = $ed55c95f12fa143c$var$message;


const $78a992b0a0746383$export$1156f3d82b1d9e10 = (errorCode)=>{
    switch(errorCode){
        case 'INVALID_CONTENT_TYPE':
            return (0, $ed55c95f12fa143c$export$2e2bcd8739ae039).validationErrorInvalidContentType;
        case 'FILE_TOO_LARGE':
            return (0, $ed55c95f12fa143c$export$2e2bcd8739ae039).validationErrorFileTooLarge;
        case 'FILE_NAME_MISSING':
            return (0, $ed55c95f12fa143c$export$2e2bcd8739ae039).validationErrorFileNameMissing;
        case 'VALIDATION_RESULT_MISSING_ERROR_CODE':
            return (0, $ed55c95f12fa143c$export$2e2bcd8739ae039).validationErrorMissingErrorCode;
        case 'VALIDATION_RESULT_NOT_FOUND':
            return (0, $ed55c95f12fa143c$export$2e2bcd8739ae039).validationErrorNotFound;
        case 'UNKNOWN_ERROR':
        default:
            return (0, $ed55c95f12fa143c$export$2e2bcd8739ae039).validationErrorUnknownError;
    }
};



const $962572ce51b0ee6e$var$renderFileInput = (ref, onChange)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "file-upload-input",
        as: "input",
        ref: ref,
        hidden: true,
        type: "file",
        multiple: true,
        onChange: onChange
    });
const $962572ce51b0ee6e$export$1e28ba9a04bf7961 = (0, $lJ6db.createHookWithAssistanceService)(({ key: key, stableFileInputChange: stableFileInputChange = false, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $6cFsl.di)((0, $4MnFz.useFlags), (0, $Ou0Zz.useAnalytics));
    const [files, { addFiles: addFiles, removeFile: removeFile, clearFiles: clearFiles, updateFileWithName: updateFileWithName, clearAttachments: clearAttachments }] = (0, $jI4Q0.useFileAttachmentsStore)(key);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const anyFilesUploading = (0, $cozmU.useMemo)(()=>{
        return files.some((file)=>file.isLoading);
    }, [
        files
    ]);
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { mutate: mutateUploadFiles, isSubmitting: isSubmittingUploadFiles } = (0, $kuIhJ.useMutation)({
        mutationFn: (payload)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).UPLOAD_FILES_TO_CONVERSATION,
                name: (0, $irnO2.ExperienceName).UPLOAD_FILES_TO_CONVERSATION
            });
            addFiles(key, [
                {
                    id: '',
                    name: payload.file.name,
                    isLoading: true,
                    fileObject: payload.file
                }
            ], sendAnalyticsEvent);
            return assistanceService.uploadFiles({
                files: [
                    payload.file
                ]
            });
        },
        onSuccess: ({ data: data })=>{
            data.forEach((file)=>{
                updateFileWithName(key, file.name, {
                    id: file.id,
                    isLoading: false
                });
                sendAnalyticsEvent({
                    action: 'added',
                    actionSubject: 'rovoChatContext',
                    actionSubjectId: 'file',
                    attributes: {
                        fileType: file.type || 'unknown',
                        fileSize: file.size || 0
                    }
                });
            });
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).UPLOAD_FILES_TO_CONVERSATION
            });
        },
        onError: (error, payload)=>{
            const errorMessage = (()=>{
                if (error.errorAttributes.statusCode === (0, $fCunh.STATUS_CODES).UNSUPPORTED_FILE_TYPE) return formatMessage((0, $ed55c95f12fa143c$export$2e2bcd8739ae039).unsupportedFile);
                if (error.errorAttributes.errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).FILE_SIZE_TOO_LARGE) return error.errorAttributes.rawErrorMessage;
                // Not handled by /validation due to requirement of CSAM check, we need to store the file first.
                // Check: https://atlassian.slack.com/archives/C0677M19GU9/p1751941718503669?thread_ts=1751919192.446729&cid=C0677M19GU9
                if (error.errorAttributes.statusCode === (0, $fCunh.STATUS_CODES).FILE_RAI_POLICY_VIOLATION) return formatMessage((0, $ed55c95f12fa143c$export$2e2bcd8739ae039).fileRaiPolicyViolationError);
                return formatMessage((0, $ed55c95f12fa143c$export$2e2bcd8739ae039).unknownError);
            })();
            updateFileWithName(key, payload.file.name, {
                isLoading: false,
                isPreviewLoading: false,
                error: errorMessage
            });
            if ((0, $94eff426cbeaaefd$export$4c9efc922a2449ec)(error)) {
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).UPLOAD_FILES_TO_CONVERSATION
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).UPLOAD_FILES_TO_CONVERSATION,
                error: error
            });
        }
    });
    const { mutate: mutateValidateFiles, isSubmitting: isSubmittingValidateFiles } = (0, $kuIhJ.useMutation)({
        mutationFn: (payload)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).VALIDATE_FILES,
                name: (0, $irnO2.ExperienceName).VALIDATE_FILES
            });
            return assistanceService.validateFiles({
                fileMetadata: payload.files.map((file)=>({
                        originalFilename: file.name,
                        contentType: file.type,
                        size: file.size
                    }))
            });
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).VALIDATE_FILES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).VALIDATE_FILES,
                error: error
            });
        }
    });
    const handleFilesSelected = (0, $cozmU.useCallback)(async (uploadedFiles)=>{
        if (!uploadedFiles?.length) return;
        const newFiles = uploadedFiles.filter((file)=>!files.some((f)=>f.name === file.name));
        // Validate files before uploading them
        const validateResponse = await mutateValidateFiles({
            files: newFiles
        });
        const getErrorIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: formatMessage((0, $ed55c95f12fa143c$export$2e2bcd8739ae039).fileInvalidIconLabel),
                color: "var(--ds-icon-danger, #C9372C)"
            });
        if (!validateResponse) {
            showFlag({
                id: `conversation-files-fail-to-validate-files-${Date.now()}`,
                title: formatMessage((0, $ed55c95f12fa143c$export$2e2bcd8739ae039).failToValidateFilesTitle),
                description: formatMessage((0, $ed55c95f12fa143c$export$2e2bcd8739ae039).failToValidateFilesDescription),
                icon: getErrorIcon()
            });
            return;
        }
        const { validFiles: validFiles, invalidFiles: invalidFiles } = newFiles.reduce((acc, file)=>{
            const validationResult = validateResponse.validationResults.find((result)=>result.fileMetadata.originalFilename === file.name);
            if (!validationResult) {
                acc.invalidFiles.push({
                    fileName: file.name,
                    errorCode: 'VALIDATION_RESULT_NOT_FOUND'
                });
                return acc;
            }
            if (validationResult.isSupported) acc.validFiles.push(file);
            else acc.invalidFiles.push({
                fileName: validationResult.fileMetadata.originalFilename,
                errorCode: validationResult.errorCode ?? 'VALIDATION_RESULT_MISSING_ERROR_CODE'
            });
            return acc;
        }, {
            validFiles: [],
            invalidFiles: []
        });
        if (invalidFiles.length) showFlag({
            id: `conversation-files-validation-error-${Date.now()}`,
            title: formatMessage((0, $ed55c95f12fa143c$export$2e2bcd8739ae039).invalidFilesTitle, {
                count: invalidFiles.length
            }),
            description: formatMessage((0, $ed55c95f12fa143c$export$2e2bcd8739ae039).invalidFilesDescription, {
                count: invalidFiles.length,
                fileNames: invalidFiles.map((file)=>file.fileName).join(', '),
                reasons: Array.from(new Set(invalidFiles.map((file)=>formatMessage((0, $78a992b0a0746383$export$1156f3d82b1d9e10)(file.errorCode))))).join(', ')
            }),
            icon: getErrorIcon()
        });
        if (!validFiles.length) return;
        validFiles.forEach((file)=>{
            mutateUploadFiles({
                file: file
            });
        });
    }, [
        mutateUploadFiles,
        files,
        formatMessage,
        showFlag,
        mutateValidateFiles
    ]);
    const latestHandleFilesSelectedRef = (0, $cozmU.useRef)(handleFilesSelected);
    latestHandleFilesSelectedRef.current = handleFilesSelected;
    const stableFileInputOnChange = (0, $cozmU.useCallback)((e)=>{
        latestHandleFilesSelectedRef.current(Array.from(e.currentTarget.files ?? []));
        e.currentTarget.value = '';
    }, []);
    const getStableFileInput = (0, $cozmU.useCallback)((ref)=>$962572ce51b0ee6e$var$renderFileInput(ref, stableFileInputOnChange), [
        stableFileInputOnChange
    ]);
    const getControlFileInput = (0, $cozmU.useCallback)((ref)=>$962572ce51b0ee6e$var$renderFileInput(ref, (e)=>{
            handleFilesSelected(Array.from(e.target.files ?? []));
            // Temporary until we only have a single file input and no ref param
            if (ref.current) ref.current.value = '';
        }), [
        handleFilesSelected
    ]);
    const getFileInput = stableFileInputChange ? getStableFileInput : getControlFileInput;
    return {
        uploadFiles: {
            isSubmitting: isSubmittingUploadFiles || isSubmittingValidateFiles
        },
        anyFilesUploading: anyFilesUploading,
        handleFilesSelected: handleFilesSelected,
        files: files,
        removeFile: removeFile,
        clearFiles: clearFiles,
        clearAttachments: clearAttachments,
        getFileInput: getFileInput
    };
});
module.exports["useConversationFiles"] = $962572ce51b0ee6e$export$1e28ba9a04bf7961;

});

parcelRegister("jI4Q0", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $5Jxc6 = parcelRequire("5Jxc6");

const $07137b50e7a1c1c0$export$7d10ab840754c21b = (0, $kBr4q.createHook)((0, $5Jxc6.store), {
    selector: (state, key)=>[
            ...state[key]?.attachments?.values() || []
        ].filter((item)=>item.type === 'file').map((item)=>item.data) || []
});
module.exports["useFileAttachmentsStore"] = $07137b50e7a1c1c0$export$7d10ab840754c21b;

});

parcelRegister("hKlzx", function(module, exports) {
/**
 * MIME types that should be treated as text files for preview generation.
 * Includes plain text, code files, markup, and structured data formats.
 */ const $987cd19b38c397f7$var$TEXT_MIME_TYPES = [
    'text/',
    // Covers text/plain, text/markdown, text/csv, text/xml, etc.
    'application/json',
    'application/xml',
    'application/x-yaml',
    'application/javascript',
    'application/typescript',
    'application/x-sh'
];
/**
 * File extensions that should be treated as text files.
 * Used as fallback when MIME type is not recognized by the browser.
 */ const $987cd19b38c397f7$var$TEXT_EXTENSIONS = [
    '.txt',
    '.md',
    '.markdown',
    '.json',
    '.xml',
    '.yaml',
    '.yml',
    '.js',
    '.jsx',
    '.ts',
    '.tsx',
    '.css',
    '.scss',
    '.less',
    '.html',
    '.htm',
    '.csv',
    '.log',
    '.sh',
    '.bash',
    '.py',
    '.rb',
    '.java',
    '.c',
    '.cpp',
    '.h',
    '.go',
    '.rs',
    '.sql'
];
function $987cd19b38c397f7$export$689bea3eece53c0e(mimeType, fileName) {
    // First check MIME type
    if (mimeType && $987cd19b38c397f7$var$TEXT_MIME_TYPES.some((type)=>mimeType.startsWith(type))) return true;
    // Fallback to extension check if MIME type is empty or unrecognized
    if (fileName) {
        const lowerFileName = fileName.toLowerCase();
        return $987cd19b38c397f7$var$TEXT_EXTENSIONS.some((ext)=>lowerFileName.endsWith(ext));
    }
    return false;
}
module.exports["isTextFile"] = $987cd19b38c397f7$export$689bea3eece53c0e;

});

parcelRegister("KUOAT", function(module, exports) {

var $hKlzx = parcelRequire("hKlzx");


var $bbi2x = parcelRequire("bbi2x");

/**
 * Generates a thumbnail blob URL from a text-based file by rendering the first few lines to canvas.
 * Supports plain text, markdown, JSON, YAML, XML, code files, etc.
 *
 * @param file - Text file to generate thumbnail from
 * @returns Promise resolving to blob URL
 * @throws Error if thumbnail generation fails or if called in SSR context
 */ async function $ad28134f0286d554$export$fa096b217fa924a6(file) {
    if (typeof window === 'undefined' || typeof document === 'undefined') throw new Error('Text thumbnail generation requires browser environment');
    // Read first 1000 characters of the file
    const text = await file.slice(0, 1000).text();
    const lines = text.split('\n').slice(0, 12); // First 12 lines for preview
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Canvas 2D context unavailable');
    const width = 200;
    const height = 200;
    canvas.width = width;
    canvas.height = height;
    context.fillStyle = '#FFFFFF';
    context.fillRect(0, 0, width, height);
    const fontSize = 10;
    const lineHeight = 14;
    const padding = 8;
    context.fillStyle = '#172B4D';
    context.font = `${fontSize}px SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`;
    context.textBaseline = 'top';
    lines.forEach((line, index)=>{
        const y = padding + index * lineHeight;
        if (y + lineHeight > height - padding) return;
        // Truncate line if too long
        const maxWidth = width - padding * 2;
        let displayText = line;
        if (context.measureText(line).width > maxWidth) {
            // Truncate and add ellipsis
            while(context.measureText(displayText + '...').width > maxWidth && displayText.length > 0)displayText = displayText.slice(0, -1);
            displayText += '...';
        }
        context.fillText(displayText, padding, y);
    });
    // Add subtle border
    context.strokeStyle = '#DFE1E6';
    context.lineWidth = 1;
    context.strokeRect(0, 0, width, height);
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>{
            if (blob) resolve(URL.createObjectURL(blob));
            else reject(new Error('Failed to generate blob from canvas'));
        }, 'image/png');
    });
}


async function $dc992dad7d7a9a83$export$905085f77a7184a2(fileObject) {
    if ((0, $bbi2x.looksLikeImage)(fileObject)) try {
        return URL.createObjectURL(fileObject);
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Failed to create blob URL for image file';
        throw new Error(`Failed to create blob URL for image: ${errorMessage}`);
    }
    else if ((0, $hKlzx.isTextFile)(fileObject.type, fileObject.name)) return await (0, $ad28134f0286d554$export$fa096b217fa924a6)(fileObject);
    throw new Error(`Unsupported file type: ${fileObject.type}`);
}
module.exports["generateFilePreview"] = $dc992dad7d7a9a83$export$905085f77a7184a2;

});

parcelRegister("8ICFm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $7fxzU = parcelRequire("7fxzU");





var $cbY7C = parcelRequire("cbY7C");


var $iXlTL = parcelRequire("iXlTL");


var $jymSm = parcelRequire("jymSm");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");

const $931e3b3ca0848b0c$export$a33697e0be72ea8e = (agents, query, limit)=>{
    const q = query.trim().toLowerCase();
    if (!q) return agents;
    const result = agents.filter((a)=>a.name.toLowerCase().includes(q));
    return typeof limit === 'number' ? result.slice(0, limit) : result;
};



var $2yWJZ = parcelRequire("2yWJZ");

// Case-insensitive substring match of a trimmed query against a label; empty/whitespace queries never match.
const $9fd240c33e6c53a9$export$47b4c821d9156031 = (query, label)=>{
    const q = query.trim().toLowerCase();
    return q.length > 0 && label.toLowerCase().includes(q);
};





// Rovo hex logo, inlined from `@atlaskit/logo/raw-icons` `rovoHexIcon`. Inlined rather than imported
// because that module bundles ~44 icon data-URIs and does not tree-shake here, which would add ~9kB
// to critical page-load routes (Jira Issue View, Confluence Edit Page).
const $d5eee17a865522e3$var$ROVO_HEX_LOGO_DATA_URI = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $d5eee17a865522e3$export$c6c2a17780df0ba9 = (name)=>({
        id: (0, $2yWJZ.DEFAULT_AGENT_UUID),
        name: name,
        mentionName: name,
        avatarUrl: $d5eee17a865522e3$var$ROVO_HEX_LOGO_DATA_URI,
        userType: 'APP',
        appType: 'agent'
    });


const $3527867ce7144218$var$AGENT_DROPDOWN_LIMIT = 5;
const $3527867ce7144218$var$EMPTY_QUERY_PEOPLE_LIMIT = 5;
const $3527867ce7144218$var$TYPED_QUERY_PEOPLE_LIMIT = 10;
/**
 * Number of loading rows shown in the Agents section while agents resolve.
 */ const $3527867ce7144218$var$AGENT_LOADING_PLACEHOLDER_COUNT = 2;
/**
 * Prefix for placeholder ids. Each placeholder needs a unique id because the
 * typeahead keys list rows by id — so multiple placeholders can be rendered
 * at once. Detection is by the `isPlaceholder` flag (type-safe via the
 * `MentionDescription` discriminated union), never by matching this string.
 */ const $3527867ce7144218$var$AGENT_LOADING_PLACEHOLDER_ID_PREFIX = '__rovo-agents-loading-';
/**
 * Builds a non-selectable loading placeholder for the agents slot.
 * `appType: 'agent'` / `userType: 'APP'` so the typeahead files it under
 * Agents; `isPlaceholder` drives the skeleton render in `MentionItem` and
 * the no-op selection guards.
 */ const $3527867ce7144218$var$createAgentLoadingPlaceholder = (index)=>({
        id: `${$3527867ce7144218$var$AGENT_LOADING_PLACEHOLDER_ID_PREFIX}${index}__`,
        isPlaceholder: true,
        placeholderType: 'loading',
        userType: 'APP',
        appType: 'agent'
    });
const $3527867ce7144218$var$isLoadingPlaceholder = (mention)=>mention.isPlaceholder === true;
const $3527867ce7144218$var$getDefaultAgentMentionNodeId = (agent)=>agent.id;
const $3527867ce7144218$var$agentToMentionDescription = (agent, getAgentMentionNodeId)=>{
    const mentionNodeId = getAgentMentionNodeId(agent);
    if (!mentionNodeId) return null;
    return {
        id: mentionNodeId,
        name: agent.name,
        mentionName: agent.name,
        avatarUrl: agent.avatarUrl ?? undefined,
        userType: 'APP',
        appType: 'agent'
    };
};
/**
 * Prefix for the per-instance subscription key (see `innerSubscriptionKey`).
 * The people resource keys listeners in a `Map`, so instances sharing one
 * `SmartMentionResource` need distinct keys to avoid evicting each other.
 */ const $3527867ce7144218$var$INNER_SUBSCRIPTION_KEY_PREFIX = 'rovo-chat-mention-resource:people';
let $3527867ce7144218$var$innerSubscriptionKeyCounter = 0;
const $3527867ce7144218$var$isAgentMention = (mention)=>mention.userType === 'APP' && mention.appType === 'agent';
const $3527867ce7144218$var$isPersonMention = (mention)=>mention.userType === 'DEFAULT';
const $3527867ce7144218$var$isTeamMentionResult = (mention)=>(0, $jymSm.isTeamMention)(mention) === true;
const $3527867ce7144218$var$ROVO_CANONICAL_QUERY = 'Rovo';
const $3527867ce7144218$var$queryMatchesRovoMention = (query, label)=>(0, $9fd240c33e6c53a9$export$47b4c821d9156031)(query, label) || (0, $9fd240c33e6c53a9$export$47b4c821d9156031)(query, $3527867ce7144218$var$ROVO_CANONICAL_QUERY);
class $3527867ce7144218$export$d9e0008cbc5ac90a extends (0, $iXlTL.AbstractMentionResource) {
    /**
   * Updates the mention analytics handler without rebuilding this resource.
   * Pass `undefined` to stop collecting events.
   */ setMentionAnalyticsCallback(callback) {
        this.mentionAnalyticsCallback = callback;
    }
    onPeopleEmit(mentions, query, stats) {
        // Drop stale URS emissions tagged with a query the user has moved past.
        if (query !== this.currentQuery) return;
        if (this.loadTiming && this.loadTiming.peopleResultsLoadDurationMs === undefined) {
            const peopleRequestStartedAt = typeof stats?.duration === 'number' ? Date.now() - stats.duration : undefined;
            // Identical consecutive queries have the same callback query. The request duration lets us
            // avoid attributing the earlier request to the latest filter's timing window.
            if (peopleRequestStartedAt === undefined || peopleRequestStartedAt >= this.loadTiming.startedAtEpochMs) this.loadTiming.peopleResultsLoadDurationMs = Math.round(performance.now() - this.loadTiming.startedAt);
        }
        this.currentPeople = {
            mentions: mentions,
            stats: stats
        };
        if (this.currentQuery.trim() === '') this.emptyPeopleSnapshot = {
            mentions: mentions,
            stats: stats
        };
        this.tryEmit();
    }
    /**
   * Releases this instance's subscription on the inner people
   * resource, aborts any in-flight agent fetch, and drops the
   * disabled-state listeners. After `dispose()` the instance must not
   * be reused.
   */ dispose() {
        this.currentAbort?.abort();
        this.currentAbort = null;
        this.clearSearchDebounce();
        this.currentPeople = null;
        this.currentAgents = null;
        this.currentDisplayedPeople = [];
        this.currentDisplayedAgents = [];
        this.currentDisplayedAgentMentions = [];
        this.emptyPeopleSnapshot = null;
        this.emptyAgentsSnapshot = null;
        this.lastReportedFilterSequence = null;
        this.loadTiming = null;
        this.mentionAnalyticsCallback = undefined;
        this.disabledStateListeners.clear();
        // Always release our subscription on the inner people resource, even
        // when the host owns it. Otherwise the wrapper's closure-bound callback
        // stays registered on the host singleton across remounts.
        this.peopleResource.unsubscribe(this.innerSubscriptionKey);
    }
    filter(query, contextIdentifier) {
        const rawQuery = query ?? '';
        const trimmed = rawQuery.trim();
        const isEmpty = trimmed.length === 0;
        // Abort the previous keystroke's fetches so their `then` handlers bail,
        // and cancel any pending (not-yet-fired) debounced search.
        this.currentAbort?.abort();
        this.clearSearchDebounce();
        const abort = new AbortController();
        this.currentAbort = abort;
        // Reset cells (snapshots persist — they're the stable empty-query default).
        this.currentQuery = rawQuery;
        this.currentPeople = null;
        this.currentAgents = this.agentSource ? null : [];
        this.currentDisplayedPeople = [];
        this.currentDisplayedAgents = [];
        this.filterSequence += 1;
        this.loadTiming = this.agentSource && this.collectPerformanceAnalytics && (0, $iDrrr.fg)('rovo_chat_mention_performance_analytics') ? {
            startedAt: performance.now(),
            startedAtEpochMs: Date.now()
        } : null;
        const restoredEmptySnapshot = isEmpty && this.emptyPeopleSnapshot && this.emptyAgentsSnapshot;
        // Empty-query fast path: restore cached snapshot for instant @-dropdown.
        if (restoredEmptySnapshot) {
            this.currentPeople = this.emptyPeopleSnapshot;
            this.currentAgents = this.emptyAgentsSnapshot;
            if (this.loadTiming) {
                const cachedLoadDurationMs = Math.round(performance.now() - this.loadTiming.startedAt);
                this.loadTiming.peopleResultsLoadDurationMs = cachedLoadDurationMs;
                this.loadTiming.agentResultsLoadDurationMs = cachedLoadDurationMs;
            }
            queueMicrotask(()=>{
                if (abort.signal.aborted) return;
                this.tryEmit();
            });
        }
        this.peopleResource.filter(query, contextIdentifier);
        if (restoredEmptySnapshot) return;
        if (this.agentSource) this.fetchAgents(trimmed, abort.signal).then((agents)=>{
            if (abort.signal.aborted) return;
            if (this.loadTiming && this.loadTiming.agentResultsLoadDurationMs === undefined) this.loadTiming.agentResultsLoadDurationMs = Math.round(performance.now() - this.loadTiming.startedAt);
            this.currentAgents = agents;
            if (isEmpty) this.emptyAgentsSnapshot = agents;
            this.tryEmit();
        });
    }
    /** Emit current cells to subscribers. Waits for people; agents render below.
   *  Agent-enabled slicing is 5+5 for empty query and 10+5 for typed queries.
   *  The people-only path remains transparent to the wrapped resource. */ tryEmit() {
        if (!this.currentPeople) return;
        const { mentions: people, stats: stats } = this.currentPeople;
        if (this.agentSource === null) {
            this.currentDisplayedPeople = people;
            this.currentDisplayedAgents = [];
            this.currentDisplayedAgentMentions = [];
            const peopleResultCount = people.filter($3527867ce7144218$var$isPersonMention).length;
            const teamResultCount = people.filter($3527867ce7144218$var$isTeamMentionResult).length;
            this.reportMentionMenuAnalytics(0, peopleResultCount, teamResultCount);
            this._notifyListeners({
                mentions: [
                    ...people
                ],
                query: this.currentQuery
            }, stats);
            return;
        }
        const isEmpty = this.currentQuery.trim().length === 0;
        const peopleLimit = isEmpty ? $3527867ce7144218$var$EMPTY_QUERY_PEOPLE_LIMIT : $3527867ce7144218$var$TYPED_QUERY_PEOPLE_LIMIT;
        const peopleSlice = people.slice(0, peopleLimit);
        let agents;
        let visibleAgents = [];
        if (this.currentAgents) {
            visibleAgents = this.currentAgents;
            agents = visibleAgents.flatMap((agent)=>{
                const mention = $3527867ce7144218$var$agentToMentionDescription(agent, this.getAgentMentionNodeId);
                return mention ? [
                    mention
                ] : [];
            });
        } else if (this.agentSource && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) agents = Array.from({
            length: $3527867ce7144218$var$AGENT_LOADING_PLACEHOLDER_COUNT
        }, (_, index)=>$3527867ce7144218$var$createAgentLoadingPlaceholder(index));
        else agents = [];
        const agentsWithRovoMention = this.withRovoMention(agents);
        const agentsSlice = agentsWithRovoMention.slice(0, $3527867ce7144218$var$AGENT_DROPDOWN_LIMIT);
        this.currentDisplayedPeople = peopleSlice;
        this.currentDisplayedAgentMentions = agentsSlice.filter((mention)=>$3527867ce7144218$var$isAgentMention(mention) && !$3527867ce7144218$var$isLoadingPlaceholder(mention));
        this.currentDisplayedAgents = visibleAgents.filter((agent)=>this.currentDisplayedAgentMentions.some((mention)=>mention.id === this.getAgentMentionNodeId(agent)));
        const peopleResultCount = peopleSlice.filter($3527867ce7144218$var$isPersonMention).length;
        const teamResultCount = peopleSlice.filter($3527867ce7144218$var$isTeamMentionResult).length;
        this.reportMentionMenuAnalytics(this.currentDisplayedAgentMentions.length, peopleResultCount, teamResultCount);
        this._notifyListeners({
            mentions: [
                ...peopleSlice,
                ...agentsSlice
            ],
            query: this.currentQuery
        }, stats);
    }
    // Prepend the "Rovo" mention row when the gate is on and the user is in an agent context (an
    // agent is mentioned in the input, or the conversation is a dedicated agent chat). In a dedicated
    // agent chat, show it for the initial empty query so it is available before agent results hydrate;
    // otherwise the query must target "Rovo". Deduped against a same-id agent from the source.
    withRovoMention(agents) {
        const label = this.rovoMentionLabel;
        const inAgentContext = (this.getSelectedAgentIds?.().length ?? 0) > 0 || this.isDedicatedAgentChat;
        const showForDedicatedAgentChat = this.isDedicatedAgentChat && this.currentQuery.trim().length === 0;
        if (!(0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') || !label || !inAgentContext || !showForDedicatedAgentChat && !$3527867ce7144218$var$queryMatchesRovoMention(this.currentQuery, label)) return agents;
        const rovo = (0, $d5eee17a865522e3$export$c6c2a17780df0ba9)(label);
        return [
            rovo,
            ...agents.filter((agent)=>agent.id !== rovo.id)
        ];
    }
    reportMentionMenuAnalytics(agentResultCount, peopleResultCount, teamResultCount) {
        if (this.currentAgents === null) return;
        if (this.lastReportedFilterSequence === this.filterSequence) return;
        const trimmed = this.currentQuery.trim();
        const timing = this.loadTiming;
        if (timing && (timing.peopleResultsLoadDurationMs === undefined || timing.agentResultsLoadDurationMs === undefined)) return;
        this.lastReportedFilterSequence = this.filterSequence;
        const loadDurationContext = timing?.peopleResultsLoadDurationMs !== undefined && timing.agentResultsLoadDurationMs !== undefined ? {
            peopleResultsLoadDurationMs: timing.peopleResultsLoadDurationMs,
            agentResultsLoadDurationMs: timing.agentResultsLoadDurationMs,
            totalResultsLoadDurationMs: Math.round(performance.now() - timing.startedAt)
        } : {};
        this.mentionAnalyticsCallback?.({
            action: trimmed.length === 0 ? 'opened' : 'searched',
            queryLength: trimmed.length,
            agentResultCount: agentResultCount,
            peopleResultCount: peopleResultCount,
            teamResultCount: teamResultCount,
            ...loadDurationContext
        });
    }
    async fetchAgents(trimmed, signal) {
        const source = this.agentSource;
        if (!source) return [];
        try {
            if (trimmed.length === 0) return await source.getAllAgents(signal);
            if (source.canFilterClientSide()) {
                const all = await source.getAllAgents(signal);
                return (0, $931e3b3ca0848b0c$export$a33697e0be72ea8e)(all, trimmed, $3527867ce7144218$var$AGENT_DROPDOWN_LIMIT);
            }
            // Server-side typed search. When a debounce is configured, wait out
            // the idle window first so we don't fire a Relay request on every
            // keystroke; if a newer keystroke arrives the wait is cancelled and
            // this fetch resolves to [] (the newer filter() drives the result).
            if (this.debounceTime !== undefined) {
                const settled = await this.waitForSearchDebounce(this.debounceTime, signal);
                if (!settled) return [];
            }
            const searched = await source.searchByName(trimmed, signal);
            return searched;
        } catch (err) {
            return [];
        }
    }
    /**
   * Resolves `true` after the idle debounce window, or `false` if the
   * search is cancelled first (next keystroke / dispose aborts the
   * signal). Only the server-side search path awaits this.
   */ waitForSearchDebounce(debounceMs, signal) {
        return new Promise((resolve)=>{
            if (signal.aborted) {
                resolve(false);
                return;
            }
            const unbind = (0, $cbY7C.bind)(signal, {
                type: 'abort',
                listener: ()=>{
                    this.clearSearchDebounce();
                    resolve(false);
                },
                options: {
                    once: true
                }
            });
            this.clearSearchDebounce();
            this.searchDebounceTimer = setTimeout(()=>{
                this.searchDebounceTimer = null;
                unbind();
                resolve(!signal.aborted);
            }, debounceMs);
        });
    }
    clearSearchDebounce() {
        if (this.searchDebounceTimer !== null) {
            clearTimeout(this.searchDebounceTimer);
            this.searchDebounceTimer = null;
        }
    }
    isFiltering(query) {
        return this.peopleResource.isFiltering?.(query) ?? false;
    }
    shouldHighlightMention(mention) {
        return this.peopleResource.shouldHighlightMention?.(mention) ?? false;
    }
    supportsMentionNameResolving() {
        return this.peopleResource.supportsMentionNameResolving?.() ?? false;
    }
    resolveMentionName(id) {
        return this.peopleResource.resolveMentionName?.(id);
    }
    cacheMentionName(id, mentionName) {
        this.peopleResource.cacheMentionName?.(id, mentionName);
    }
    recordMentionSelection(mention, _contextIdentifier) {
        // The loading placeholder is never a real selection — ignore it.
        if ($3527867ce7144218$var$isLoadingPlaceholder(mention)) return;
        // Always notify the inner people resource so people-row analytics
        // and recent-pick state keep working uniformly.
        this.peopleResource.recordMentionSelection?.(mention);
        const queryLength = this.currentQuery.trim().length;
        const displayedPeople = this.currentDisplayedPeople.filter($3527867ce7144218$var$isPersonMention);
        const displayedTeams = this.currentDisplayedPeople.filter($3527867ce7144218$var$isTeamMentionResult);
        const peopleResultCount = displayedPeople.length;
        const teamResultCount = displayedTeams.length;
        if ($3527867ce7144218$var$isPersonMention(mention)) {
            const selectedPersonPosition = displayedPeople.findIndex((person)=>person.id === mention.id);
            this.mentionAnalyticsCallback?.({
                action: 'selected',
                resultType: 'person',
                position: selectedPersonPosition >= 0 ? selectedPersonPosition : undefined,
                queryLength: queryLength,
                agentResultCount: this.currentDisplayedAgentMentions.length,
                peopleResultCount: peopleResultCount,
                teamResultCount: teamResultCount
            });
            return;
        }
        if ($3527867ce7144218$var$isTeamMentionResult(mention)) {
            const selectedTeamPosition = displayedTeams.findIndex((team)=>team.id === mention.id);
            this.mentionAnalyticsCallback?.({
                action: 'selected',
                resultType: 'team',
                position: selectedTeamPosition >= 0 ? selectedTeamPosition : undefined,
                queryLength: queryLength,
                agentResultCount: this.currentDisplayedAgentMentions.length,
                peopleResultCount: peopleResultCount,
                teamResultCount: teamResultCount
            });
            return;
        }
        if (!$3527867ce7144218$var$isAgentMention(mention)) return;
        const selectedAgentMentionPosition = this.currentDisplayedAgentMentions.findIndex((agentMention)=>agentMention.id === mention.id);
        const selectedAgent = this.currentDisplayedAgents.find((agent)=>this.getAgentMentionNodeId(agent) === mention.id);
        // The default Rovo row is synthetic (see `buildRovoMention`) so it never
        // appears in `currentDisplayedAgents`. Attribute it explicitly instead.
        const isDefaultRovo = mention.id === (0, $2yWJZ.DEFAULT_AGENT_UUID);
        const agentCreatorType = selectedAgent?.creatorType ?? (isDefaultRovo ? (0, $2yWJZ.DEFAULT_AGENT_CREATOR_TYPE) : undefined);
        this.mentionAnalyticsCallback?.({
            action: 'selected',
            resultType: 'agent',
            agentId: selectedAgent?.id ?? (isDefaultRovo ? mention.id : undefined),
            agentName: selectedAgent?.name ?? (isDefaultRovo ? mention.name : undefined),
            agentIsVerified: selectedAgent?.isVerified ?? false,
            agentCreatorType: agentCreatorType,
            position: selectedAgentMentionPosition >= 0 ? selectedAgentMentionPosition : undefined,
            queryLength: queryLength,
            agentResultCount: this.currentDisplayedAgentMentions.length,
            peopleResultCount: peopleResultCount,
            teamResultCount: teamResultCount
        });
        if (!this.onAgentSelected) return;
        this.onAgentSelected({
            id: selectedAgent?.id ?? mention.id,
            name: selectedAgent?.name ?? mention.name ?? '',
            identityAccountId: selectedAgent?.identityAccountId,
            creatorType: agentCreatorType
        });
    }
    /**
   * Subscribe to disabled-state changes. Called by `MentionNodeView`
   * (via the `MentionProvider` interface) so each already-rendered
   * chip can re-evaluate when the active agent set changes.
   */ subscribeToDisabledStateChanges(listener) {
        this.disabledStateListeners.add(listener);
        return ()=>{
            this.disabledStateListeners.delete(listener);
        };
    }
    /**
   * Forwarded to the consumer only when the destroyed id is a known
   * agent (i.e. present in `getSelectedAgentIds()`). People mentions
   * are silently ignored so consumers don't need to discriminate.
   */ notifyMentionDestroyed(mention) {
        const ids = this.getSelectedAgentIds?.() ?? [];
        if (!ids.includes(mention.id)) return;
        this.onAgentMentionDestroyed?.(mention.id);
    }
    /**
   * Notify all subscribers that the disabled-state predicate inputs
   * have changed (typically because `selectedAgentIds` changed in the
   * input draft store). Triggers each subscribed `MentionNodeView` to re-run
   * its `updateState`.
   */ notifyDisabledStateChanged() {
        this.disabledStateListeners.forEach((listener)=>listener());
    }
    setDisabledAgentTooltip(disabledAgentTooltip) {
        this.disabledAgentTooltip = disabledAgentTooltip;
        this.notifyDisabledStateChanged();
    }
    /**
   * Agent chip is enabled iff its id is the active agent (`selectedAgentIds.at(-1)`),
   * otherwise disabled. An empty list means no active agent, so a dismissed
   * agent's lingering chip stays disabled. Scoped to agent chips via
   * `userType === 'APP'` (the node carries `userType`, not `appType`).
   */ getMentionDisabledState(mention) {
        // Agent chips only — never disable people mentions.
        if (mention.userType !== 'APP') return undefined;
        const ids = this.getSelectedAgentIds?.() ?? [];
        const activeAgentId = ids.at(-1);
        // The active agent is enabled; every other agent chip is disabled.
        if (mention.id === activeAgentId) return undefined;
        return {
            disabled: true,
            tooltip: this.disabledAgentTooltip
        };
    }
    constructor(config){
        super();
        /** Unique per-instance key for our listener on the shared people resource. */ this.innerSubscriptionKey = `${$3527867ce7144218$var$INNER_SUBSCRIPTION_KEY_PREFIX}:${++$3527867ce7144218$var$innerSubscriptionKeyCounter}`;
        this.peopleResource = void 0;
        this.agentSource = void 0;
        this.onAgentSelected = void 0;
        this.getSelectedAgentIds = void 0;
        this.getAgentMentionNodeId = void 0;
        this.disabledAgentTooltip = void 0;
        this.onAgentMentionDestroyed = void 0;
        this.isDedicatedAgentChat = void 0;
        this.rovoMentionLabel = void 0;
        this.mentionAnalyticsCallback = void 0;
        /** Notified when the active agent selection changes so rendered chips re-evaluate. */ this.disabledStateListeners = new Set();
        this.currentAbort = null;
        /** Idle debounce (ms) for the server-side agent search, sourced from
     *  `config.debounceTime`. `undefined` means fire immediately. */ this.debounceTime = void 0;
        this.collectPerformanceAnalytics = void 0;
        /** Idle timer for the debounced server-side agent search. Tracked
     *  alongside `currentAbort` so it can be cleared on the next keystroke
     *  and on dispose. */ this.searchDebounceTimer = null;
        /** Most recent search state. People and agent cells are written
     *  independently as each resolves; `tryEmit()` renders the cells
     *  tagged with `currentQuery`. */ this.currentQuery = '';
        this.currentPeople = null;
        this.currentAgents = null;
        this.currentDisplayedPeople = [];
        this.currentDisplayedAgents = [];
        /** UI-facing agent rows, including synthetic Rovo mentions absent from raw agent results. */ this.currentDisplayedAgentMentions = [];
        /** First empty-query result, kept so backspacing back to `@` restores instantly. */ this.emptyPeopleSnapshot = null;
        this.emptyAgentsSnapshot = null;
        this.filterSequence = 0;
        this.lastReportedFilterSequence = null;
        this.loadTiming = null;
        this.peopleResource = config.peopleResource;
        this.agentSource = config.agentSource ?? null;
        this.onAgentSelected = config.onAgentSelected;
        this.getSelectedAgentIds = config.getSelectedAgentIds;
        this.getAgentMentionNodeId = config.getAgentMentionNodeId ?? $3527867ce7144218$var$getDefaultAgentMentionNodeId;
        this.disabledAgentTooltip = config.disabledAgentTooltip;
        this.onAgentMentionDestroyed = config.onAgentMentionDestroyed;
        this.isDedicatedAgentChat = config.isDedicatedAgentChat ?? false;
        this.rovoMentionLabel = config.rovoMentionLabel;
        this.debounceTime = config.debounceTime;
        this.collectPerformanceAnalytics = config.collectPerformanceAnalytics ?? false;
        this.peopleResource.subscribe(this.innerSubscriptionKey, (mentions, query, stats)=>{
            this.onPeopleEmit(mentions, query ?? '', stats);
        }, (error, query)=>{
            if (this.agentSource === null) this._notifyErrorListeners(error, query);
        }, (info)=>{
            if (this.agentSource === null) this._notifyInfoListeners(info);
        }, (mentions, query)=>{
            if (this.agentSource === null) this._notifyAllResultsListeners({
                mentions: [
                    ...mentions
                ],
                query: query ?? this.currentQuery
            });
        }, (event, actionSubject, action, attributes)=>{
            if (this.agentSource === null) this._notifyAnalyticsListeners(event, actionSubject, action, attributes);
        });
    }
}


const $58fecb704af24f21$export$e3920d6f39f18ae4 = (params)=>{
    const { peopleConfig: peopleConfig, ...rest } = params;
    const peopleResource = new (0, $7fxzU.default)(peopleConfig);
    const resource = new (0, $3527867ce7144218$export$d9e0008cbc5ac90a)({
        peopleResource: peopleResource,
        ...rest
    });
    return resource;
};



/** Active users only — no Connect bots, no apps. Agents come from the
 *  Relay-backed `MentionAgentSource`, not URS. */ const $396f9b5f92c91e30$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $396f9b5f92c91e30$var$AGENT_SEARCH_DEBOUNCE_MS = 300;
const $396f9b5f92c91e30$export$15cdb97bf19cdda0 = ({ productKey: productKey, siteId: siteId, orgId: orgId, currentUserId: currentUserId, mentionResourceOverride: mentionResourceOverride, enableAgents: enableAgents, agentSource: agentSource, onAgentSelected: onAgentSelected, getSelectedAgentIds: getSelectedAgentIds, getAgentMentionNodeId: getAgentMentionNodeId, disabledAgentTooltip: disabledAgentTooltip, onAgentMentionDestroyed: onAgentMentionDestroyed, onMentionAnalyticsEvent: onMentionAnalyticsEvent, collectPerformanceAnalytics: collectPerformanceAnalytics, isDedicatedAgentChat: isDedicatedAgentChat, rovoMentionLabel: rovoMentionLabel })=>{
    (0, $6cFsl.di)((0, $7fxzU.default));
    const onAgentSelectedRef = (0, $cozmU.useRef)(onAgentSelected);
    onAgentSelectedRef.current = onAgentSelected;
    const getSelectedAgentIdsRef = (0, $cozmU.useRef)(getSelectedAgentIds);
    getSelectedAgentIdsRef.current = getSelectedAgentIds;
    const onAgentMentionDestroyedRef = (0, $cozmU.useRef)(onAgentMentionDestroyed);
    onAgentMentionDestroyedRef.current = onAgentMentionDestroyed;
    const disabledAgentTooltipRef = (0, $cozmU.useRef)(disabledAgentTooltip);
    disabledAgentTooltipRef.current = disabledAgentTooltip;
    const onMentionAnalyticsEventRef = (0, $cozmU.useRef)(onMentionAnalyticsEvent);
    onMentionAnalyticsEventRef.current = onMentionAnalyticsEvent;
    const handleAgentSelected = (0, $cozmU.useCallback)((agent)=>{
        onAgentSelectedRef.current?.(agent);
    }, []);
    const getCurrentSelectedAgentIds = (0, $cozmU.useCallback)(()=>getSelectedAgentIdsRef.current?.() ?? [], []);
    const handleAgentMentionDestroyed = (0, $cozmU.useCallback)((agentId)=>{
        onAgentMentionDestroyedRef.current?.(agentId);
    }, []);
    const handleMentionAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        onMentionAnalyticsEventRef.current?.(event);
    }, []);
    const hasMentionAnalyticsCallback = onMentionAnalyticsEvent !== undefined;
    const shouldUseRovoChatMentionResource = enableAgents || hasMentionAnalyticsCallback;
    const provider = (0, $cozmU.useMemo)(()=>{
        const agentMentionResourceOptions = enableAgents ? {
            agentSource: agentSource ?? undefined,
            debounceTime: $396f9b5f92c91e30$var$AGENT_SEARCH_DEBOUNCE_MS,
            onAgentSelected: handleAgentSelected,
            getSelectedAgentIds: getCurrentSelectedAgentIds,
            getAgentMentionNodeId: getAgentMentionNodeId,
            disabledAgentTooltip: disabledAgentTooltipRef.current,
            onAgentMentionDestroyed: handleAgentMentionDestroyed,
            isDedicatedAgentChat: isDedicatedAgentChat,
            rovoMentionLabel: rovoMentionLabel,
            collectPerformanceAnalytics: collectPerformanceAnalytics
        } : {};
        // CASE 1: host handed us a SmartMentionResource. Keep it untouched
        // unless agent composition or mention analytics requires the Rovo Chat
        // resource. Analytics-only mode forwards the native people result set
        // unchanged.
        if (mentionResourceOverride instanceof (0, $7fxzU.default)) {
            if (!shouldUseRovoChatMentionResource) return mentionResourceOverride;
            return new (0, $3527867ce7144218$export$d9e0008cbc5ac90a)({
                peopleResource: mentionResourceOverride,
                ...agentMentionResourceOptions
            });
        }
        // CASE 2: any other provider override → pass through unchanged.
        // People-only because we cannot wrap a non-SMR with agent
        // support (the agent-merge layer needs SMR's subscribe API).
        if (mentionResourceOverride) return mentionResourceOverride;
        // CASE 3: default — build URS internally. Keep the native resource when
        // neither agent composition nor mention analytics is needed. Otherwise,
        // use the Rovo Chat resource; its people-only path is transparent to the
        // native Smart Mention result set.
        const peopleConfig = {
            productKey: productKey,
            siteId: siteId,
            includeTeams: true,
            includeUsers: true,
            orgId: orgId,
            searchQueryFilter: $396f9b5f92c91e30$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER,
            productAttributes: {
                client: 'rovo-chat'
            },
            shouldHighlightMention: (mention)=>mention.id === currentUserId
        };
        if (!shouldUseRovoChatMentionResource) return new (0, $7fxzU.default)(peopleConfig);
        return (0, $58fecb704af24f21$export$e3920d6f39f18ae4)({
            peopleConfig: peopleConfig,
            ...agentMentionResourceOptions
        });
    }, [
        productKey,
        siteId,
        orgId,
        currentUserId,
        mentionResourceOverride,
        enableAgents,
        agentSource,
        handleAgentSelected,
        getCurrentSelectedAgentIds,
        getAgentMentionNodeId,
        handleAgentMentionDestroyed,
        isDedicatedAgentChat,
        rovoMentionLabel,
        collectPerformanceAnalytics,
        shouldUseRovoChatMentionResource
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(provider instanceof (0, $3527867ce7144218$export$d9e0008cbc5ac90a))) return;
        provider.setMentionAnalyticsCallback(hasMentionAnalyticsCallback ? handleMentionAnalyticsEvent : undefined);
        return ()=>{
            provider.setMentionAnalyticsCallback(undefined);
        };
    }, [
        provider,
        hasMentionAnalyticsCallback,
        handleMentionAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (provider instanceof (0, $3527867ce7144218$export$d9e0008cbc5ac90a)) provider.setDisabledAgentTooltip(disabledAgentTooltip);
    }, [
        disabledAgentTooltip,
        provider
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(provider instanceof (0, $3527867ce7144218$export$d9e0008cbc5ac90a))) return;
        return ()=>provider.dispose();
    }, [
        provider
    ]);
    return (0, $cozmU.useMemo)(()=>Promise.resolve(provider), [
        provider
    ]);
};
module.exports["useChatMentionResource"] = $396f9b5f92c91e30$export$15cdb97bf19cdda0;

});

parcelRegister("cH7ad", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4wH3g = parcelRequire("4wH3g");


var $6cFsl = parcelRequire("6cFsl");


var $1sCHt = parcelRequire("1sCHt");


var $cXtTj = parcelRequire("cXtTj");


var $1KLPb = parcelRequire("1KLPb");


var $h5LaW = parcelRequire("h5LaW");


var $1z5OI = parcelRequire("1z5OI");


var $gFEZF = parcelRequire("gFEZF");


var $l3wuH = parcelRequire("l3wuH");


var $2hJf7 = parcelRequire("2hJf7");


var $kTb7m = parcelRequire("kTb7m");


var $hMv2K = parcelRequire("hMv2K");


var $hMaHH = parcelRequire("hMaHH");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $2zVsi = parcelRequire("2zVsi");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $lpNn5 = parcelRequire("lpNn5");










const $2439344e296210cc$export$b9bd19bdeffb47f1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { contextProviders: t2, onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable } = t1;
    let t3;
    if ($[2] !== t2) {
        t3 = t2 === undefined ? [] : t2;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const contextProviders = t3;
    const [currentBrowser, setCurrentBrowser] = (0, $cozmU.useState)(null);
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[4] = t4;
    } else t4 = $[4];
    const [currentContexts, setCurrentContexts] = (0, $cozmU.useState)(t4);
    let t5;
    if ($[5] !== onContextBrowserShow) {
        t5 = (browser)=>{
            setCurrentBrowser(browser);
            onContextBrowserShow?.(browser);
        };
        $[5] = onContextBrowserShow;
        $[6] = t5;
    } else t5 = $[6];
    const handleShowContextBrowser = t5;
    let t6;
    if ($[7] !== currentContexts || $[8] !== onContextAvailable) {
        t6 = (contexts)=>{
            const contextMap = new Map();
            currentContexts.forEach((context)=>{
                contextMap.set(context.key, context);
            });
            contexts.forEach((context_0)=>{
                contextMap.set(context_0.key, context_0);
            });
            const updatedContexts = Array.from(contextMap.values());
            setCurrentContexts(updatedContexts);
            onContextAvailable?.(updatedContexts);
        };
        $[7] = currentContexts;
        $[8] = onContextAvailable;
        $[9] = t6;
    } else t6 = $[9];
    const handlePromptInputContextAvailable = t6;
    let t7;
    if ($[10] !== contextProviders || $[11] !== handlePromptInputContextAvailable || $[12] !== handleShowContextBrowser) {
        t7 = ()=>contextProviders.map((provider)=>provider.getMenuItem(handleShowContextBrowser, handlePromptInputContextAvailable)).filter($2439344e296210cc$var$_temp);
        $[10] = contextProviders;
        $[11] = handlePromptInputContextAvailable;
        $[12] = handleShowContextBrowser;
        $[13] = t7;
    } else t7 = $[13];
    const getMenuItems = t7;
    let t8;
    if ($[14] !== onContextAvailable) {
        t8 = ()=>{
            setCurrentContexts([]);
            onContextAvailable?.([]);
        };
        $[14] = onContextAvailable;
        $[15] = t8;
    } else t8 = $[15];
    const clearContexts = t8;
    let t9;
    if ($[16] !== currentContexts || $[17] !== onContextAvailable) {
        t9 = (contextKey)=>{
            const updatedContexts_0 = currentContexts.filter((context_1)=>context_1.key !== contextKey);
            setCurrentContexts(updatedContexts_0);
            onContextAvailable?.(updatedContexts_0);
        };
        $[16] = currentContexts;
        $[17] = onContextAvailable;
        $[18] = t9;
    } else t9 = $[18];
    const removeContext = t9;
    let t10;
    if ($[19] !== clearContexts || $[20] !== currentBrowser || $[21] !== currentContexts || $[22] !== getMenuItems || $[23] !== removeContext) {
        t10 = {
            currentBrowser: currentBrowser,
            currentContexts: currentContexts,
            getMenuItems: getMenuItems,
            clearContexts: clearContexts,
            removeContext: removeContext,
            setCurrentBrowser: setCurrentBrowser
        };
        $[19] = clearContexts;
        $[20] = currentBrowser;
        $[21] = currentContexts;
        $[22] = getMenuItems;
        $[23] = removeContext;
        $[24] = t10;
    } else t10 = $[24];
    return t10;
} : ({ contextProviders: contextProviders = [], onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable } = {})=>{
    const [currentBrowser, setCurrentBrowser] = (0, $cozmU.useState)(null);
    const [currentContexts, setCurrentContexts] = (0, $cozmU.useState)([]);
    const handleShowContextBrowser = (0, $cozmU.useCallback)((browser)=>{
        setCurrentBrowser(browser);
        onContextBrowserShow?.(browser);
    }, [
        onContextBrowserShow
    ]);
    const handlePromptInputContextAvailable = (0, $cozmU.useCallback)((contexts)=>{
        const contextMap = new Map();
        // add existing contexts first
        currentContexts.forEach((context)=>{
            contextMap.set(context.key, context);
        });
        // add/override with new contexts
        contexts.forEach((context_0)=>{
            contextMap.set(context_0.key, context_0);
        });
        const updatedContexts = Array.from(contextMap.values());
        setCurrentContexts(updatedContexts);
        onContextAvailable?.(updatedContexts);
    }, [
        currentContexts,
        onContextAvailable
    ]);
    const getMenuItems = (0, $cozmU.useCallback)(()=>{
        return contextProviders.map((provider)=>provider.getMenuItem(handleShowContextBrowser, handlePromptInputContextAvailable)).filter((item)=>item !== null);
    }, [
        contextProviders,
        handleShowContextBrowser,
        handlePromptInputContextAvailable
    ]);
    const clearContexts = (0, $cozmU.useCallback)(()=>{
        setCurrentContexts([]);
        onContextAvailable?.([]);
    }, [
        onContextAvailable
    ]);
    const removeContext = (0, $cozmU.useCallback)((contextKey)=>{
        const updatedContexts_0 = currentContexts.filter((context_1)=>context_1.key !== contextKey);
        setCurrentContexts(updatedContexts_0);
        onContextAvailable?.(updatedContexts_0);
    }, [
        currentContexts,
        onContextAvailable
    ]);
    return {
        currentBrowser: currentBrowser,
        currentContexts: currentContexts,
        getMenuItems: getMenuItems,
        clearContexts: clearContexts,
        removeContext: removeContext,
        setCurrentBrowser: setCurrentBrowser
    };
};
function $2439344e296210cc$var$_temp(item) {
    return item !== null;
}



var $Ou0Zz = parcelRequire("Ou0Zz");


var $6Oz1a = parcelRequire("6Oz1a");


var $gzMZq = parcelRequire("gzMZq");


var $2n773 = parcelRequire("2n773");


var $YooNh = parcelRequire("YooNh");


var $kBr4q = parcelRequire("kBr4q");


var $8s9DV = parcelRequire("8s9DV");

const $0a91b5498053916e$var$actions = {
    register: (handler)=>({ setState: setState, getState: getState })=>{
            if (getState().handlers.includes(handler)) return;
            setState({
                handlers: [
                    ...getState().handlers,
                    handler
                ]
            });
        },
    unregister: (handler)=>({ setState: setState, getState: getState })=>{
            setState({
                handlers: getState().handlers.filter((h)=>h !== handler)
            });
        },
    openFileDialog: ()=>({ getState: getState })=>{
            // Call the most recently registered handler (last mount wins)
            const { handlers: handlers } = getState();
            const lastHandler = handlers[handlers.length - 1];
            lastHandler?.();
        }
};
const $0a91b5498053916e$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    name: 'file-upload-trigger',
    initialState: {
        handlers: []
    },
    actions: $0a91b5498053916e$var$actions
});


const $80cc757ee05d0767$export$9eb6088fe12d0ff9 = (0, $kBr4q.createHook)((0, $0a91b5498053916e$export$390f32400eaf98c9));



var $kJeen = parcelRequire("kJeen");

function $b83c164c3bd4d051$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $fAgrN = parcelRequire("fAgrN");


var $hOUgz = parcelRequire("hOUgz");


var $9zNPM = parcelRequire("9zNPM");

/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 









var $bh4C9 = parcelRequire("bh4C9");











var $1SiET = parcelRequire("1SiET");


var $Ks5oo = parcelRequire("Ks5oo");




const $febcf15e5fc303a8$var$message = (0, $kSwu1.defineMessages)({
    fileUploadButtonLabel: {
        id: "rovo-chat.file-upload-button.label",
        defaultMessage: "Upload file"
    },
    fileUploadButtonMaxFilesLabel: {
        id: "rovo-chat.file-upload-button.max-files-label",
        defaultMessage: "Limit of {maxFiles, plural, one {# file} other {# files}} reached"
    }
});
var $febcf15e5fc303a8$export$2e2bcd8739ae039 = $febcf15e5fc303a8$var$message;


const $564bde81b3f92167$export$8fc396871921c53a = ({ onClick: onClick, assistanceServiceParams: assistanceServiceParams, attachmentsStoreKey: attachmentsStoreKey })=>{
    (0, $6cFsl.di)((0, $YooNh.useConversationFiles));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { files: files } = (0, $YooNh.useConversationFiles)({
        assistanceServiceParams: {
            ...assistanceServiceParams,
            touchpointSource: 'fileUploadButton'
        },
        key: attachmentsStoreKey
    });
    const isMaxFilesReached = files.length >= (0, $1SiET.MAX_FILES);
    const handleClick = ()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatFileUploadButton'
        });
        onClick();
    };
    const menuItem = /*#__PURE__*/ $cozmU.createElement((0, $Ks5oo.MenuItem), {
        icon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))), {
            label: ""
        }),
        label: formatMessage((0, $febcf15e5fc303a8$export$2e2bcd8739ae039).fileUploadButtonLabel),
        isDisabled: isMaxFilesReached,
        onClick: handleClick,
        testId: "file-upload-dropdown-item"
    }); // Wrap with tooltip when disabled to show the max files message
    if (isMaxFilesReached) return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: formatMessage((0, $febcf15e5fc303a8$export$2e2bcd8739ae039).fileUploadButtonMaxFilesLabel, {
            maxFiles: (0, $1SiET.MAX_FILES)
        })
    }, menuItem);
    return menuItem;
};








const $c21abe052d77167d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    viewAllSpacesButtonLabel: {
        id: "conversation-assistant-chat-prompt-input.common.chat-input-action-buttons.viewAllSpacesButtonLabel",
        defaultMessage: "View all Rovo spaces"
    },
    chatInputActionsButtonsTooltip: {
        id: "ai-mate.chat-input.open-chat-input-buttons-tooltip",
        defaultMessage: "Add"
    },
    mentionTypeAheadButtonLabel: {
        id: "ai-mate.chat-input.mention-type-ahead-button.label",
        defaultMessage: "Mention someone"
    },
    linkTypeAheadButtonLabel: {
        id: "ai-mate.chat-input.link-type-ahead-button.label",
        defaultMessage: "Add a link"
    },
    addContentButtonLabel: {
        id: "ai-mate.chat-input.add-content-button.label",
        defaultMessage: "Use what you're viewing as context"
    },
    addMoreFormattingButtonLabel: {
        id: "ai-mate.chat-input.add-more-formatting-button.label",
        defaultMessage: "More formatting"
    },
    deepResearchButtonLabel: {
        id: "ai-mate.chat-input.deep-research-button.label",
        defaultMessage: "Deep research"
    },
    deepResearchButtonAgentMentionDisabledTooltip: {
        id: "ai-mate.chat-input.deep-research-button.agent-mention-disabled-tooltip",
        defaultMessage: "Not available with mentioned agents"
    },
    addCurrentPageAsContextDisabledTooltip: {
        id: "ai-mate.chat-input.add-current-page-as-context-disabled-tooltip",
        defaultMessage: "This page isn't supported yet"
    },
    discoverSkillsButtonLabel: {
        id: "ai-mate.chat-input.discover-skills-button.label",
        defaultMessage: "View all skills"
    },
    discoverSkillsButtonDisabledTooltip: {
        id: "ai-mate.chat-input.discover-skills-button.disabled-tooltip",
        defaultMessage: "You're already using a skill"
    },
    discoverSkillsButtonAgentMentionDisabledTooltip: {
        id: "ai-mate.chat-input.discover-skills-button.agent-mention-disabled-tooltip",
        defaultMessage: "Not available with mentioned agents"
    },
    browsePromptLibraryButtonLabel: {
        id: "ai-mate.chat-input.browse-prompt-library-button.label",
        defaultMessage: "Browse prompt library"
    }
});












var $fEPJS = parcelRequire("fEPJS");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $b8pma = parcelRequire("b8pma");


var $hdBxM = parcelRequire("hdBxM");


var $a9aSv = parcelRequire("a9aSv");


var $2UKhw = parcelRequire("2UKhw");


var $2Db11 = parcelRequire("2Db11");


var $1aX82 = parcelRequire("1aX82");




const $b6082ba5d71c2cbc$var$CAPABILITIES = [
    'share'
];
const $b6082ba5d71c2cbc$var$MODAL_PROPS = {
    width: (0, $2UKhw.MODAL_WIDTH),
    height: (0, $2UKhw.MODAL_HEIGHT)
};
const $b6082ba5d71c2cbc$var$SkillsModalFallback = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100px",
            height: "16px",
            isShimmering: true
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "260px",
            height: "400px",
            isShimmering: true
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.400"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "128px",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "128px",
            isShimmering: true
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "chat-input-skills-modal-fallback"
        }));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100px",
        height: "16px",
        isShimmering: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "260px",
        height: "400px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "128px",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "128px",
        isShimmering: true
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "chat-input-skills-modal-fallback"
    }));
const $b6082ba5d71c2cbc$export$b521ffdd2062ee28 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { cloudId: cloudId, icon: icon, isDisabled: isDisabled, label: label, onClick: onClick, targetPromptDraftAndModeKey: targetPromptDraftAndModeKey } = t0;
    const publishSkillInsert = (0, $hdBxM.usePublish)("ai-mate-chat-inserts");
    let t1;
    if ($[0] !== publishSkillInsert || $[1] !== targetPromptDraftAndModeKey) {
        t1 = (skill)=>{
            publishSkillInsert({
                type: "insert-skill-into-prompt-input",
                source: "skillsInputMenu",
                openChat: false,
                data: {
                    ...targetPromptDraftAndModeKey ? {
                        targetPromptDraftAndModeKey: targetPromptDraftAndModeKey
                    } : {},
                    skill: {
                        id: skill.id,
                        name: skill.name,
                        slug: skill.slug,
                        description: skill.description,
                        iconName: skill.iconName,
                        color: skill.color
                    },
                    skillSelectionSource: "skillsModal"
                }
            });
        };
        $[0] = publishSkillInsert;
        $[1] = targetPromptDraftAndModeKey;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== cloudId || $[4] !== t1) {
        t2 = {
            capabilities: $b6082ba5d71c2cbc$var$CAPABILITIES,
            cloudId: cloudId,
            onSkillClick: t1
        };
        $[3] = cloudId;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const entryPointParams = t2;
    if (isDisabled) {
        let t3;
        if ($[6] !== icon || $[7] !== label || $[8] !== onClick) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                icon: icon,
                label: label,
                isDisabled: true,
                onClick: onClick
            });
            $[6] = icon;
            $[7] = label;
            $[8] = onClick;
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    let t3;
    if ($[10] !== icon || $[11] !== label || $[12] !== onClick) {
        t3 = (t4)=>{
            const { ref: ref } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                ref: ref,
                icon: icon,
                label: label,
                isDisabled: false,
                onClick: onClick
            });
        };
        $[10] = icon;
        $[11] = label;
        $[12] = onClick;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== entryPointParams || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aX82.ModalTrigger), {
            entryPoint: (0, $2Db11.agentStudioSkillsEntrypoint),
            entryPointParams: entryPointParams,
            modalProps: $b6082ba5d71c2cbc$var$MODAL_PROPS,
            Fallback: $b6082ba5d71c2cbc$var$SkillsModalFallback
        }, t3);
        $[14] = entryPointParams;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ cloudId: cloudId, icon: icon, isDisabled: isDisabled, label: label, onClick: onClick, targetPromptDraftAndModeKey: targetPromptDraftAndModeKey })=>{
    const publishSkillInsert = (0, $hdBxM.usePublish)('ai-mate-chat-inserts');
    const entryPointParams = (0, $cozmU.useMemo)(()=>({
            capabilities: $b6082ba5d71c2cbc$var$CAPABILITIES,
            cloudId: cloudId,
            onSkillClick: (skill)=>{
                publishSkillInsert({
                    type: 'insert-skill-into-prompt-input',
                    source: 'skillsInputMenu',
                    openChat: false,
                    data: {
                        ...targetPromptDraftAndModeKey ? {
                            targetPromptDraftAndModeKey: targetPromptDraftAndModeKey
                        } : {},
                        skill: {
                            id: skill.id,
                            name: skill.name,
                            slug: skill.slug,
                            description: skill.description,
                            iconName: skill.iconName,
                            color: skill.color
                        },
                        skillSelectionSource: 'skillsModal'
                    }
                });
            }
        }), [
        cloudId,
        publishSkillInsert,
        targetPromptDraftAndModeKey
    ]);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
        icon: icon,
        label: label,
        isDisabled: true,
        onClick: onClick
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aX82.ModalTrigger), {
        entryPoint: (0, $2Db11.agentStudioSkillsEntrypoint),
        entryPointParams: entryPointParams,
        modalProps: $b6082ba5d71c2cbc$var$MODAL_PROPS,
        Fallback: $b6082ba5d71c2cbc$var$SkillsModalFallback
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
            ref: ref,
            icon: icon,
            label: label,
            isDisabled: false,
            onClick: onClick
        }));
};



const $afe812e382b92214$var$LoadableAgentSection = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "ehGv6",
    name: "LoadableAgentSection",
    loader: async ()=>(await (parcelRequire("lEiQs"))).AgentSection,
    loading: ()=>null
});

const $afe812e382b92214$var$LoadableRecommendedAgentsPreloader = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "xlnjp",
    name: "LoadableRecommendedAgentsPreloader",
    loader: async ()=>(await (parcelRequire("beaVo"))).RecommendedAgentsPreloader,
    loading: ()=>null
});

const $afe812e382b92214$var$LazyAgentSection = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lEiQs")).then((module)=>{
        return {
            default: module.AgentSection
        };
    }));

const $afe812e382b92214$var$LazyRecommendedAgentsPreloader = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("beaVo")).then((module)=>{
        return {
            default: module.RecommendedAgentsPreloader
        };
    }));
const $afe812e382b92214$var$styles = {
    menuContainer: "_2mHwu81Y8M _3iDTPbQ4SZ _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0aFT5vbt8w _0hPCNLFlnN _0KLXrulfZc _4ouGXIGVdc _1EqgXlBfNa",
    menuSection: "_2mHwu8FQfX _3iDTPbQ4SZ _0aFT5vbt8w",
    sectionHeader: "_2sNsIgd8bj _2Y7lL42ADO _4c065UgVvo _1UtDYzKGUX",
    divider: "_3SamIHgVvo _0jFU0VHZdu _0KLXru66of",
    menuPopupContainer: "_0bjKvD8fU6 _30huDKOeNX _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v _42Yu6BbFo4"
};
const $afe812e382b92214$var$PopupComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ...props,
            ref: ref,
            xcss: $afe812e382b92214$var$styles.menuPopupContainer,
            "data-testid": undefined,
            "data-chat-input-action-buttons-popup": true
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ...props,
        ref: ref,
        xcss: $afe812e382b92214$var$styles.menuPopupContainer,
        "data-testid": undefined,
        "data-chat-input-action-buttons-popup": true
    }));
const $afe812e382b92214$var$NOOP_FILE_UPLOAD_TRIGGER_RESULT = [
    {
        handlers: []
    },
    {
        register: ()=>{},
        unregister: ()=>{},
        openFileDialog: ()=>{}
    }
];
const $afe812e382b92214$var$noopFileUploadTrigger = ()=>$afe812e382b92214$var$NOOP_FILE_UPLOAD_TRIGGER_RESULT;
const $afe812e382b92214$var$useFileUploadTriggerWithCondition = (0, $2zVsi.functionWithCondition)(()=>(0, $cXtTj.default).getExperimentValue('jfind-rovo-for-jira-onboarding', 'isEnabled', false, {
        fireExperimentExposure: false // exposure fired in configuration loader on Jira
    }), (0, $80cc757ee05d0767$export$9eb6088fe12d0ff9), $afe812e382b92214$var$noopFileUploadTrigger);
const $afe812e382b92214$export$8a4234462d786b48 = ({ entryPoint: entryPoint, siteId: siteId, useCurrentPageContext: useCurrentPageContext, onLinkTypeAheadClick: onLinkTypeAheadClick, onMentionTypeAheadClick: onMentionTypeAheadClick, onAddTypeAheadClick: onAddTypeAheadClick, onDiscoverSkillsClick: onDiscoverSkillsClick, shouldOpenSkillsModal: shouldOpenSkillsModal = false, onDeepResearchClick: onDeepResearchClick, onBrowsePromptLibraryClick: onBrowsePromptLibraryClick, onViewAllSpacesClick: onViewAllSpacesClick, hasSkillInPrompt: hasSkillInPrompt = false, isAgentMentionActive: isAgentMentionActive = false, isDeepResearchActive: isDeepResearchActive = false, assistanceServiceParams: assistanceServiceParams, fileUploadAssistanceOverrides: fileUploadAssistanceOverrides, stableFileInputChange: stableFileInputChange = false, contextProviders: contextProviders, onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable, isDisabled: isDisabled, placement: placement = 'top-start', attachmentsAndCurrentPageAsContextStoreKey: attachmentsStoreAndCurrentPageContextKey, onMenuOpen: onMenuOpen, onAgentSelect: onAgentSelect, isBrowseAgentsModalOpen: isBrowseAgentsModalOpen = false, setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen = ()=>{}, shouldRenderInPortal: shouldRenderInPortal = false, enableBrowserContextBanner: enableBrowserContextBanner = false, browserContextSanitizer: browserContextSanitizer, hasReadablePageContext: hasReadablePageContext = false, menuItemsVisibility: externalMenuItemsVisibility = {} })=>{
    const menuItemsVisibility = {
        fileUpload: externalMenuItemsVisibility?.fileUpload ?? true,
        mention: externalMenuItemsVisibility?.mention ?? true,
        format: externalMenuItemsVisibility?.format ?? true,
        link: externalMenuItemsVisibility?.link ?? true,
        deepResearch: Boolean(onDeepResearchClick) && (externalMenuItemsVisibility?.deepResearch ?? true)
    }; // If every controllable menu item is explicitly hidden, don't render the trigger button at all.
    const hasAnyVisibleItem = Object.values(menuItemsVisibility).some(Boolean);
    (0, $6cFsl.di)((0, $hOUgz.useCurrentPageAsContext), (0, $YooNh.useConversationFiles), (0, $gzMZq.useChatContextBrowserContext));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { setUseCurrentPageContextUserPreference: setUseCurrentPageContextUserPreference, currentContext: currentContext } = (0, $hOUgz.useCurrentPageAsContext)();
    const [browserContext] = (0, $gzMZq.useChatContextBrowserContext)();
    const isContextAlreadySelected = (0, $9zNPM.useCurrentPageContextEnabled)(attachmentsStoreAndCurrentPageContextKey); // Only consider browser context available if enableBrowserContextBanner config is enabled (otherwise behave as non-extension)
    const hasBrowserContext = !!browserContext?.context?.browserUrl && enableBrowserContextBanner; // Hide when no context is available or context is already selected
    const isNoContextAvailable = currentContext.type === 'none' && !hasBrowserContext && !hasReadablePageContext;
    const showAddContextButton = (useCurrentPageContext || hasReadablePageContext) && !((0, $iDrrr.fg)('rovo_chat_use_viewing_context_visibility') && (isNoContextAvailable || isContextAlreadySelected)); // Check if browser context URL is blocklisted (only when enableBrowserContextBanner is true and sanitizer is provided)
    const isBrowserContextBlocklisted = enableBrowserContextBanner && browserContextSanitizer && hasBrowserContext && browserContext?.context?.browserUrl ? browserContextSanitizer.isBlocklisted(browserContext.context.browserUrl) : false; // Button should be disabled only if:
    // 1. Current context type is 'none' (page not supported)
    // 2. AND no browser context is available (can't use external site context)
    // If browser context is available, enable the button even if currentContext.type === 'none' (unless blocklisted)
    const isContextDisabled = isBrowserContextBlocklisted || currentContext.type === 'none' && !hasBrowserContext && !hasReadablePageContext;
    let discoverSkillsButtonTooltipContent;
    if (hasSkillInPrompt) discoverSkillsButtonTooltipContent = formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).discoverSkillsButtonDisabledTooltip);
    else if (isAgentMentionActive) discoverSkillsButtonTooltipContent = formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).discoverSkillsButtonAgentMentionDisabledTooltip);
    const [menuState, setMenuState] = (0, $cozmU.useState)('main');
    const [currentContextBrowser, setCurrentContextBrowser] = (0, $cozmU.useState)(null);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const { addExternalContext: addExternalContext } = (0, $2n773.useConversationExternalAttachments)(attachmentsStoreAndCurrentPageContextKey);
    const returnFocusRef = (0, $cozmU.useRef)(null);
    const assistanceServiceParamsForFileUpload = (0, $cozmU.useMemo)(()=>({
            ...assistanceServiceParams,
            ...fileUploadAssistanceOverrides
        }), [
        assistanceServiceParams,
        fileUploadAssistanceOverrides
    ]);
    const inputRef = (0, $cozmU.useRef)(null);
    const { getFileInput: getFileInput } = (0, $YooNh.useConversationFiles)({
        assistanceServiceParams: {
            ...assistanceServiceParamsForFileUpload,
            touchpointSource: 'chatInputActionButtons'
        },
        key: attachmentsStoreAndCurrentPageContextKey,
        stableFileInputChange: stableFileInputChange
    }); /**
       * Onboarding file-upload trigger:
       * - SPICE-1518: Rovo for Jira Onboarding
       */ 
    const isFileUploadOnboardingExperiment = (0, $cXtTj.default).getExperimentValue('jfind-rovo-for-jira-onboarding', 'isEnabled', false, {
        fireExperimentExposure: false // exposure fired in configuration loader on Jira
    });
    const [, { register: registerFileOpenHandler, unregister: unregisterFileOpenHandler }] = $afe812e382b92214$var$useFileUploadTriggerWithCondition();
    (0, $cozmU.useEffect)(()=>{
        if (!isFileUploadOnboardingExperiment) return;
        const handler = ()=>inputRef.current?.click();
        registerFileOpenHandler(handler);
        return ()=>{
            unregisterFileOpenHandler(handler);
        };
    }, [
        isFileUploadOnboardingExperiment,
        registerFileOpenHandler,
        unregisterFileOpenHandler
    ]);
    const { getMenuItems: getMenuItems } = (0, $2439344e296210cc$export$b9bd19bdeffb47f1)({
        contextProviders: contextProviders,
        onContextBrowserShow: (browser)=>{
            if (browser) {
                setCurrentContextBrowser(browser);
                setMenuState('external-context');
            } else {
                setCurrentContextBrowser(null);
                setMenuState('main');
            }
            onContextBrowserShow?.(browser);
        },
        onContextAvailable: (contexts)=>{
            setMenuState('main');
            setCurrentContextBrowser(null);
            setIsDropdownOpen(false); // Add external contexts to unified store
            addExternalContext(attachmentsStoreAndCurrentPageContextKey, contexts);
            onContextAvailable?.(contexts);
        }
    });
    const focusOnClose = (event)=>{
        // Refocus on the trigger when closing the popup except for native mouse events
        if (!event || event.detail === 0) requestAnimationFrame(()=>{
            returnFocusRef?.current?.focus();
        });
    };
    const externalMenuItems = getMenuItems(); // Hide the entire trigger button when every controllable menu item is turned off.
    // All hooks are called above unconditionally (rules of hooks). The early return is
    // safe here because it comes after all hook calls.
    // Note: externalMenuItems (3rd-party context providers) are not counted here because
    // they are dynamic; the consumer controls visibility via menuItemsVisibility only.
    if (!hasAnyVisibleItem) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isDropdownOpen,
        onClose: ()=>{
            setIsDropdownOpen(false);
            setMenuState('main');
            setCurrentContextBrowser(null);
            focusOnClose();
        },
        placement: placement,
        shouldRenderToParent: !shouldRenderInPortal,
        shouldFlip: !shouldRenderInPortal,
        popupComponent: $afe812e382b92214$var$PopupComponent,
        zIndex: 600,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Oz1a.GettingStartedTourSpotlight), {
                step: 1,
                entryPoint: entryPoint
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                onClick: (e, analyticsEvent)=>{
                    sendAnalyticsEvent(analyticsEvent.update({
                        actionSubjectId: 'rovoChatAddMenuTrigger'
                    }));
                    setIsDropdownOpen(!isDropdownOpen);
                    if (!isDropdownOpen) onMenuOpen?.();
                },
                isTooltipDisabled: false,
                isSelected: isDropdownOpen,
                appearance: "subtle",
                icon: isDropdownOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))) : (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).chatInputActionsButtonsTooltip),
                ref: (0, $b83c164c3bd4d051$export$2e2bcd8739ae039)([
                    triggerProps.ref,
                    returnFocusRef
                ]),
                isDisabled: isDisabled
            })),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                role: "menu",
                xcss: $afe812e382b92214$var$styles.menuContainer
            }, menuState === 'main' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $afe812e382b92214$var$styles.menuSection,
                role: "group"
            }, onViewAllSpacesClick && (0, $cXtTj.default).getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                    label: ""
                }),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).viewAllSpacesButtonLabel),
                onClick: ()=>{
                    onViewAllSpacesClick();
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'rovoChatViewAllSpacesButton'
                    });
                    setIsDropdownOpen(false);
                }
            }), onBrowsePromptLibraryClick && (0, $cXtTj.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1KLPb))), {
                    label: ""
                }),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).browsePromptLibraryButtonLabel),
                onClick: ()=>{
                    (0, $cozmU.startTransition)(()=>{
                        onBrowsePromptLibraryClick();
                    });
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'libraryOpenedFromSidebar',
                        attributes: {
                            source: 'browseInputMenuButton'
                        }
                    });
                    setIsDropdownOpen(false);
                }
            }), (shouldOpenSkillsModal || onDiscoverSkillsClick && (0, $iDrrr.fg)('rovo_skills_directory_ui')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                position: "top",
                content: discoverSkillsButtonTooltipContent,
                canAppear: ()=>hasSkillInPrompt || isAgentMentionActive
            }, shouldOpenSkillsModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6082ba5d71c2cbc$export$b521ffdd2062ee28), {
                cloudId: siteId,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h5LaW))), {
                    label: ""
                }),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).discoverSkillsButtonLabel),
                isDisabled: hasSkillInPrompt || isAgentMentionActive,
                targetPromptDraftAndModeKey: attachmentsStoreAndCurrentPageContextKey,
                onClick: ()=>{
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'rovoChatDiscoverSkillsButton'
                    });
                    setIsDropdownOpen(false);
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h5LaW))), {
                    label: ""
                }),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).discoverSkillsButtonLabel),
                isDisabled: hasSkillInPrompt || isAgentMentionActive,
                onClick: ()=>{
                    (0, $cozmU.startTransition)(()=>{
                        onDiscoverSkillsClick?.();
                    });
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'rovoChatDiscoverSkillsButton'
                    });
                    setIsDropdownOpen(false);
                }
            })), menuItemsVisibility.fileUpload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $564bde81b3f92167$export$8fc396871921c53a), {
                attachmentsStoreKey: attachmentsStoreAndCurrentPageContextKey,
                onClick: ()=>{
                    inputRef.current?.click();
                    setIsDropdownOpen(false);
                },
                assistanceServiceParams: assistanceServiceParamsForFileUpload
            }), menuItemsVisibility.link && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                    label: ""
                }),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).linkTypeAheadButtonLabel),
                onClick: ()=>{
                    onLinkTypeAheadClick();
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'rovoChatAddLinkButton'
                    });
                    setIsDropdownOpen(false);
                }
            }), externalMenuItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                    key: item.key,
                    icon: item.icon,
                    label: item.label,
                    onClick: ()=>{
                        item.action();
                        sendAnalyticsEvent({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: `rovoChatExternalContext_${item.key}`
                        });
                    }
                })), menuItemsVisibility.mention && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMv2K))), {
                    label: ""
                }),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).mentionTypeAheadButtonLabel),
                onClick: ()=>{
                    onMentionTypeAheadClick();
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'rovoChatMentionButton'
                    });
                    setIsDropdownOpen(false);
                }
            }), menuItemsVisibility.format && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                    label: ""
                }),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).addMoreFormattingButtonLabel),
                onClick: ()=>{
                    onAddTypeAheadClick();
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'rovoChatAddFormattingButton'
                    });
                    setIsDropdownOpen(false);
                }
            }), menuItemsVisibility.deepResearch && onDeepResearchClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                position: "top",
                content: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).deepResearchButtonAgentMentionDisabledTooltip),
                canAppear: ()=>isAgentMentionActive
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1z5OI))), {
                    label: ""
                }),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).deepResearchButtonLabel),
                isActive: isDeepResearchActive,
                isDisabled: isAgentMentionActive,
                onClick: ()=>{
                    if (isAgentMentionActive) return;
                    onDeepResearchClick();
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'rovoChatDeepResearchButton',
                        attributes: {
                            source: 'addMenu',
                            isEnabled: !isDeepResearchActive
                        }
                    });
                    setIsDropdownOpen(false);
                }
            })), showAddContextButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                position: "top",
                content: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).addCurrentPageAsContextDisabledTooltip),
                canAppear: ()=>isContextDisabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Ks5oo.MenuItem), {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                    label: ""
                }),
                label: formatMessage((0, $c21abe052d77167d$export$defe85febe8b728c).addContentButtonLabel),
                isDisabled: isContextDisabled,
                onClick: ()=>{
                    setUseCurrentPageContextUserPreference(attachmentsStoreAndCurrentPageContextKey, true);
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'rovoChatAddContextButton'
                    });
                    setIsDropdownOpen(false);
                }
            }))), onAgentSelect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $afe812e382b92214$var$styles.divider
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $afe812e382b92214$var$styles.sectionHeader
            }, formatMessage((0, $fAgrN.messages).agentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $afe812e382b92214$var$styles.menuSection,
                role: "group"
            }, (0, $iDrrr.fg)('aimate_conversation_assistant_async_loading') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe812e382b92214$var$LazyAgentSection, {
                assistanceServiceParams: assistanceServiceParams,
                onAgentSelect: onAgentSelect,
                siteId: siteId,
                isBrowseAgentsModalOpen: isBrowseAgentsModalOpen,
                setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen,
                setIsDropdownOpen: setIsDropdownOpen
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe812e382b92214$var$LoadableAgentSection, {
                assistanceServiceParams: assistanceServiceParams,
                onAgentSelect: onAgentSelect,
                siteId: siteId,
                isBrowseAgentsModalOpen: isBrowseAgentsModalOpen,
                setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen,
                setIsDropdownOpen: setIsDropdownOpen
            })))), menuState === 'external-context' && currentContextBrowser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $afe812e382b92214$var$styles.menuSection,
                role: "group"
            }, currentContextBrowser)),
        shouldUseCaptureOnOutsideClick: true
    }), menuItemsVisibility.fileUpload && getFileInput(inputRef), onAgentSelect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe812e382b92214$var$AgentSectionPreloader, {
        assistanceServiceParams: assistanceServiceParams
    }));
};
const $afe812e382b92214$var$AgentSectionPreloader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { assistanceServiceParams: assistanceServiceParams } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    (0, $cozmU.useEffect)($afe812e382b92214$var$_temp, t1);
    const limit = (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents") ? (0, $kJeen.AGENTS_FETCH_LIMIT) : undefined;
    if ((0, $iDrrr.fg)("aimate_conversation_assistant_async_loading")) {
        let t2;
        if ($[1] !== assistanceServiceParams) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe812e382b92214$var$LazyRecommendedAgentsPreloader, {
                assistanceServiceParams: assistanceServiceParams,
                limit: limit
            }));
            $[1] = assistanceServiceParams;
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    }
    let t2;
    if ($[3] !== assistanceServiceParams) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe812e382b92214$var$LoadableRecommendedAgentsPreloader, {
            assistanceServiceParams: assistanceServiceParams,
            limit: limit
        });
        $[3] = assistanceServiceParams;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ assistanceServiceParams: assistanceServiceParams })=>{
    // Preload the bundle
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('aimate_conversation_assistant_async_loading')) $afe812e382b92214$var$LoadableAgentSection.preload();
    }, []); // Align preloader's cache key with AgentSection's when the @<agent> picker is on.
    const limit = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents') ? (0, $kJeen.AGENTS_FETCH_LIMIT) : undefined; // Preload the data
    if ((0, $iDrrr.fg)('aimate_conversation_assistant_async_loading')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe812e382b92214$var$LazyRecommendedAgentsPreloader, {
        assistanceServiceParams: assistanceServiceParams,
        limit: limit
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe812e382b92214$var$LoadableRecommendedAgentsPreloader, {
        assistanceServiceParams: assistanceServiceParams,
        limit: limit
    });
};
function $afe812e382b92214$var$_temp() {
    if (!(0, $iDrrr.fg)("aimate_conversation_assistant_async_loading")) $afe812e382b92214$var$LoadableAgentSection.preload();
}
module.exports["ChatInputActionButtons"] = $afe812e382b92214$export$8a4234462d786b48;

});

parcelRegister("6Oz1a", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $57p4j = parcelRequire("57p4j");


var $iDrrr = parcelRequire("iDrrr");


var $3eYzF = parcelRequire("3eYzF");


var $uyMbP = parcelRequire("uyMbP");


var $gi4qj = parcelRequire("gi4qj");


var $4AC39 = parcelRequire("4AC39");


var $l3ydK = parcelRequire("l3ydK");


var $2Vz7H = parcelRequire("2Vz7H");


var $6VFk2 = parcelRequire("6VFk2");


var $4enp7 = parcelRequire("4enp7");


var $dOlTT = parcelRequire("dOlTT");


var $9Zall = parcelRequire("9Zall");


var $8jXZv = parcelRequire("8jXZv");


var $2K2hA = parcelRequire("2K2hA");


var $6Yblc = parcelRequire("6Yblc");


var $aPGTj = parcelRequire("aPGTj");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $5glln = parcelRequire("5glln");




const $cc322b25b7870b23$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    back: {
        id: "ai-mate.getting-started-tour.back",
        defaultMessage: "Back"
    },
    done: {
        id: "ai-mate.getting-started-tour.done",
        defaultMessage: "Done"
    },
    next: {
        id: "ai-mate.getting-started-tour.next",
        defaultMessage: "Next"
    },
    stepIndicator: {
        id: "ai-mate.getting-started-tour.indicator",
        defaultMessage: "{stepNumber} of {totalSteps}"
    },
    stepOneTitle: {
        id: "ai-mate.getting-started-tour.step-one.title",
        defaultMessage: "Add work from anywhere"
    },
    stepOneDescription: {
        id: "ai-mate.getting-started-tour.step-one.description",
        defaultMessage: "Choose a template, upload a file, link a page, and more to power your creation."
    },
    stepTwoTitle: {
        id: "ai-mate.getting-started-tour.step-two.title",
        defaultMessage: "Get unstuck on your prompt"
    },
    stepTwoDescription: {
        id: "ai-mate.getting-started-tour.step-two.description",
        defaultMessage: "Try an example or use them to jump-start your draft."
    },
    stepThreeTitle: {
        id: "ai-mate.getting-started-tour.step-three.title",
        defaultMessage: "Talk to Rovo instead of typing"
    },
    stepThreeDescription: {
        id: "ai-mate.getting-started-tour.step-three.description",
        defaultMessage: "Use your voice to get started."
    }
});


const $4dfa33d825867330$var$stepConfig = [
    {
        title: (0, $cc322b25b7870b23$export$a7357cdd1f0b0168).stepOneTitle,
        description: (0, $cc322b25b7870b23$export$a7357cdd1f0b0168).stepOneDescription,
        placement: 'bottom-start'
    },
    {
        title: (0, $cc322b25b7870b23$export$a7357cdd1f0b0168).stepTwoTitle,
        description: (0, $cc322b25b7870b23$export$a7357cdd1f0b0168).stepTwoDescription,
        placement: 'left-start'
    },
    {
        title: (0, $cc322b25b7870b23$export$a7357cdd1f0b0168).stepThreeTitle,
        description: (0, $cc322b25b7870b23$export$a7357cdd1f0b0168).stepThreeDescription,
        placement: 'bottom-end'
    }
];
const $4dfa33d825867330$var$ALLOWED_ENTRY_POINT = '-smartCreate';
const $4dfa33d825867330$export$187fca2312a637a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(66);
    const { entryPoint: entryPoint, children: children, step: step } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { stepNumber: currentStepNumber, totalSteps: totalSteps } = (0, $5glln.useGettingStartedTourState)();
    const { setStepNumber: hideGettingStartedSpotlightTour, nextStep: moveToNextStep, previousStep: moveToPreviousStep, dismiss: completeGettingStartedTour } = (0, $5glln.useGettingStartedTourStoreActions)();
    let t1;
    if ($[0] !== completeGettingStartedTour || $[1] !== moveToNextStep || $[2] !== sendAnalyticsEvent || $[3] !== step || $[4] !== totalSteps) {
        t1 = ()=>{
            sendAnalyticsEvent({
                eventType: "ui",
                actionSubject: "button",
                action: "clicked",
                actionSubjectId: "gettingStartedTourSpotlightPrimaryButton",
                attributes: {
                    tourStep: step
                },
                source: "smart-create"
            });
            if (step === totalSteps) completeGettingStartedTour();
            else moveToNextStep();
        };
        $[0] = completeGettingStartedTour;
        $[1] = moveToNextStep;
        $[2] = sendAnalyticsEvent;
        $[3] = step;
        $[4] = totalSteps;
        $[5] = t1;
    } else t1 = $[5];
    const handleOnNextClicked = t1;
    let t2;
    if ($[6] !== moveToPreviousStep || $[7] !== sendAnalyticsEvent || $[8] !== step) {
        t2 = ()=>{
            sendAnalyticsEvent({
                eventType: "ui",
                actionSubject: "button",
                action: "clicked",
                actionSubjectId: "gettingStartedTourSpotlightSecondaryButton",
                attributes: {
                    tourStep: step
                },
                source: "smart-create"
            });
            moveToPreviousStep();
        };
        $[6] = moveToPreviousStep;
        $[7] = sendAnalyticsEvent;
        $[8] = step;
        $[9] = t2;
    } else t2 = $[9];
    const handleOnPreviousClicked = t2;
    let t3;
    if ($[10] !== hideGettingStartedSpotlightTour || $[11] !== sendAnalyticsEvent || $[12] !== step) {
        t3 = ()=>{
            sendAnalyticsEvent({
                eventType: "ui",
                actionSubject: "button",
                action: "clicked",
                actionSubjectId: "gettingStartedTourSpotlightDismissButton",
                attributes: {
                    tourStep: step
                },
                source: "smart-create"
            });
            hideGettingStartedSpotlightTour(0);
        };
        $[10] = hideGettingStartedSpotlightTour;
        $[11] = sendAnalyticsEvent;
        $[12] = step;
        $[13] = t3;
    } else t3 = $[13];
    const handleOnDismissClicked = t3;
    if (!(0, $iDrrr.fg)("platform_aifc_getting_started_spotlight") || !entryPoint?.includes($4dfa33d825867330$var$ALLOWED_ENTRY_POINT)) return children;
    const currentConfig = $4dfa33d825867330$var$stepConfig[step - 1];
    let t4;
    if ($[14] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children);
        $[14] = children;
        $[15] = t4;
    } else t4 = $[15];
    const t5 = currentStepNumber === step;
    const t6 = currentConfig?.placement;
    const t7 = currentConfig?.title;
    let t8;
    if ($[16] !== formatMessage || $[17] !== t7) {
        t8 = formatMessage(t7);
        $[16] = formatMessage;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, t8);
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== handleOnDismissClicked) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
            onClick: handleOnDismissClicked
        }));
        $[21] = handleOnDismissClicked;
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== t10 || $[24] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, t9, t10);
        $[23] = t10;
        $[24] = t9;
        $[25] = t11;
    } else t11 = $[25];
    const t12 = currentConfig?.description;
    let t13;
    if ($[26] !== formatMessage || $[27] !== t12) {
        t13 = formatMessage(t12);
        $[26] = formatMessage;
        $[27] = t12;
        $[28] = t13;
    } else t13 = $[28];
    let t14;
    if ($[29] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, t13);
        $[29] = t13;
        $[30] = t14;
    } else t14 = $[30];
    let t15;
    if ($[31] !== formatMessage || $[32] !== step || $[33] !== totalSteps) {
        t15 = formatMessage((0, $cc322b25b7870b23$export$a7357cdd1f0b0168).stepIndicator, {
            stepNumber: step,
            totalSteps: totalSteps
        });
        $[31] = formatMessage;
        $[32] = step;
        $[33] = totalSteps;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aPGTj.SpotlightStepCount), null, t15);
        $[35] = t15;
        $[36] = t16;
    } else t16 = $[36];
    let t17;
    if ($[37] !== currentStepNumber || $[38] !== formatMessage || $[39] !== handleOnPreviousClicked) {
        t17 = currentStepNumber > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Yblc.SpotlightSecondaryAction), {
            onClick: handleOnPreviousClicked
        }, formatMessage((0, $cc322b25b7870b23$export$a7357cdd1f0b0168).back));
        $[37] = currentStepNumber;
        $[38] = formatMessage;
        $[39] = handleOnPreviousClicked;
        $[40] = t17;
    } else t17 = $[40];
    let t18;
    if ($[41] !== currentStepNumber || $[42] !== formatMessage || $[43] !== totalSteps) {
        t18 = currentStepNumber < totalSteps ? formatMessage((0, $cc322b25b7870b23$export$a7357cdd1f0b0168).next) : formatMessage((0, $cc322b25b7870b23$export$a7357cdd1f0b0168).done);
        $[41] = currentStepNumber;
        $[42] = formatMessage;
        $[43] = totalSteps;
        $[44] = t18;
    } else t18 = $[44];
    let t19;
    if ($[45] !== handleOnNextClicked || $[46] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
            onClick: handleOnNextClicked
        }, t18);
        $[45] = handleOnNextClicked;
        $[46] = t18;
        $[47] = t19;
    } else t19 = $[47];
    let t20;
    if ($[48] !== t17 || $[49] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, t17, t19);
        $[48] = t17;
        $[49] = t19;
        $[50] = t20;
    } else t20 = $[50];
    let t21;
    if ($[51] !== t16 || $[52] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, t16, t20);
        $[51] = t16;
        $[52] = t20;
        $[53] = t21;
    } else t21 = $[53];
    let t22;
    if ($[54] !== t11 || $[55] !== t14 || $[56] !== t21) {
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: "spotlight"
        }, t11, t14, t21);
        t22 = (0, $iDrrr.fg)("platform-dst-motion-uplift-spotlight") ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, spotlightCard));
        $[54] = t11;
        $[55] = t14;
        $[56] = t21;
        $[57] = t22;
    } else t22 = $[57];
    const t23 = t22;
    let t24;
    if ($[58] !== handleOnDismissClicked || $[59] !== t23 || $[60] !== t5 || $[61] !== t6) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
            dismiss: handleOnDismissClicked,
            isVisible: t5,
            placement: t6,
            strategy: "absolute"
        }, t23);
        $[58] = handleOnDismissClicked;
        $[59] = t23;
        $[60] = t5;
        $[61] = t6;
        $[62] = t24;
    } else t24 = $[62];
    let t25;
    if ($[63] !== t24 || $[64] !== t4) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, t4, t24);
        $[63] = t24;
        $[64] = t4;
        $[65] = t25;
    } else t25 = $[65];
    return t25;
} : ({ entryPoint: entryPoint, children: children, step: step })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { stepNumber: currentStepNumber, totalSteps: totalSteps } = (0, $5glln.useGettingStartedTourState)();
    const { setStepNumber: hideGettingStartedSpotlightTour, nextStep: moveToNextStep, previousStep: moveToPreviousStep, dismiss: completeGettingStartedTour } = (0, $5glln.useGettingStartedTourStoreActions)();
    const handleOnNextClicked = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'gettingStartedTourSpotlightPrimaryButton',
            attributes: {
                tourStep: step
            },
            source: 'smart-create'
        });
        if (step === totalSteps) completeGettingStartedTour();
        else moveToNextStep();
    }, [
        step,
        totalSteps,
        completeGettingStartedTour,
        moveToNextStep,
        sendAnalyticsEvent
    ]);
    const handleOnPreviousClicked = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'gettingStartedTourSpotlightSecondaryButton',
            attributes: {
                tourStep: step
            },
            source: 'smart-create'
        });
        moveToPreviousStep();
    }, [
        step,
        moveToPreviousStep,
        sendAnalyticsEvent
    ]);
    const handleOnDismissClicked = (0, $cozmU.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'gettingStartedTourSpotlightDismissButton',
            attributes: {
                tourStep: step
            },
            source: 'smart-create'
        });
        hideGettingStartedSpotlightTour(0);
    }, [
        step,
        hideGettingStartedSpotlightTour,
        sendAnalyticsEvent
    ]);
    if (!(0, $iDrrr.fg)('platform_aifc_getting_started_spotlight') || !entryPoint?.includes($4dfa33d825867330$var$ALLOWED_ENTRY_POINT)) return children;
    const currentConfig = $4dfa33d825867330$var$stepConfig[step - 1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: handleOnDismissClicked,
        isVisible: currentStepNumber === step,
        placement: currentConfig?.placement,
        strategy: "absolute"
    }, (()=>{
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: "spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage(currentConfig?.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
            onClick: handleOnDismissClicked
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, formatMessage(currentConfig?.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aPGTj.SpotlightStepCount), null, formatMessage((0, $cc322b25b7870b23$export$a7357cdd1f0b0168).stepIndicator, {
            stepNumber: step,
            totalSteps: totalSteps
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, currentStepNumber > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Yblc.SpotlightSecondaryAction), {
            onClick: handleOnPreviousClicked
        }, formatMessage((0, $cc322b25b7870b23$export$a7357cdd1f0b0168).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
            onClick: handleOnNextClicked
        }, currentStepNumber < totalSteps ? formatMessage((0, $cc322b25b7870b23$export$a7357cdd1f0b0168).next) : formatMessage((0, $cc322b25b7870b23$export$a7357cdd1f0b0168).done)))));
        return (0, $iDrrr.fg)('platform-dst-motion-uplift-spotlight') ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, spotlightCard));
    })()));
};
module.exports["GettingStartedTourSpotlight"] = $4dfa33d825867330$export$187fca2312a637a5;

});

parcelRegister("5glln", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $52e8d88a3ca09941$var$initialState = {
    stepNumber: 0,
    totalSteps: 3,
    hasDismissed: false,
    hasStarted: false
};
const $52e8d88a3ca09941$var$setStepNumber = (step)=>{
    return ({ setState: setState })=>{
        setState({
            stepNumber: step
        });
    };
};
const $52e8d88a3ca09941$var$nextStep = ()=>{
    return ({ setState: setState, getState: getState })=>{
        const { stepNumber: stepNumber } = getState();
        const nextStepValue = stepNumber + 1;
        setState({
            stepNumber: nextStepValue > $52e8d88a3ca09941$var$initialState.totalSteps ? 0 : nextStepValue
        });
    };
};
const $52e8d88a3ca09941$var$previousStep = ()=>{
    return ({ setState: setState, getState: getState })=>{
        const { stepNumber: stepNumber } = getState();
        const nextStepValue = stepNumber - 1;
        setState({
            stepNumber: nextStepValue < 1 ? 1 : nextStepValue
        });
    };
};
const $52e8d88a3ca09941$var$resetStep = ()=>{
    return ({ setState: setState })=>{
        setState({
            stepNumber: 1,
            hasStarted: true
        });
    };
};
const $52e8d88a3ca09941$var$dismiss = ()=>{
    return ({ setState: setState })=>{
        setState({
            stepNumber: 0,
            hasDismissed: true
        });
    };
};
const $52e8d88a3ca09941$var$store = (0, $8s9DV.createStore)({
    initialState: $52e8d88a3ca09941$var$initialState,
    actions: {
        setStepNumber: (step)=>({ dispatch: dispatch })=>{
                dispatch($52e8d88a3ca09941$var$setStepNumber(step));
            },
        nextStep: ()=>({ dispatch: dispatch })=>{
                dispatch($52e8d88a3ca09941$var$nextStep());
            },
        previousStep: ()=>({ dispatch: dispatch })=>{
                dispatch($52e8d88a3ca09941$var$previousStep());
            },
        resetStep: ()=>({ dispatch: dispatch })=>{
                dispatch($52e8d88a3ca09941$var$resetStep());
            },
        dismiss: ()=>({ dispatch: dispatch })=>{
                dispatch($52e8d88a3ca09941$var$dismiss());
            }
    }
});
const $52e8d88a3ca09941$export$892b983d1b41ebe1 = (0, $kBr4q.createHook)($52e8d88a3ca09941$var$store);
const $52e8d88a3ca09941$export$7170019ae9cc343d = (0, $kBr4q.createActionsHook)($52e8d88a3ca09941$var$store);
const $52e8d88a3ca09941$export$7d095908422babd2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const [state] = $52e8d88a3ca09941$export$892b983d1b41ebe1();
    return state;
} : ()=>{
    const [state] = $52e8d88a3ca09941$export$892b983d1b41ebe1();
    return state;
};
module.exports["useGettingStartedTourStoreActions"] = $52e8d88a3ca09941$export$7170019ae9cc343d;
module.exports["useGettingStartedTourState"] = $52e8d88a3ca09941$export$7d095908422babd2;

});

parcelRegister("2n773", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");


var $5Jxc6 = parcelRequire("5Jxc6");

const $521998d27ffadc54$export$cffce0bcbf2f13f8 = (0, $kBr4q.createHook)((0, $5Jxc6.store), {
    selector: (state, key)=>[
            ...state[key]?.attachments?.values() || []
        ]?.filter((item)=>item.type === 'external')?.map((item)=>item.data) || []
});


const $515129c478bdfdb9$export$ee6324403e0cde6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (key)=>{
    const $ = (0, $bDgLe.c)(5);
    const [externalContexts, t0] = (0, $521998d27ffadc54$export$cffce0bcbf2f13f8)(key);
    const { addExternalContext: addExternalContext } = t0;
    let t1;
    if ($[0] !== externalContexts) {
        t1 = externalContexts.map($515129c478bdfdb9$var$_temp);
        $[0] = externalContexts;
        $[1] = t1;
    } else t1 = $[1];
    const externalContextsServiceRepresentations = t1;
    let t2;
    if ($[2] !== addExternalContext || $[3] !== externalContextsServiceRepresentations) {
        t2 = {
            addExternalContext: addExternalContext,
            externalContextsServiceRepresentations: externalContextsServiceRepresentations
        };
        $[2] = addExternalContext;
        $[3] = externalContextsServiceRepresentations;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (key)=>{
    const [externalContexts, { addExternalContext: addExternalContext }] = (0, $521998d27ffadc54$export$cffce0bcbf2f13f8)(key);
    const externalContextsServiceRepresentations = externalContexts.map((context)=>context.serviceRepresentation);
    return {
        addExternalContext: addExternalContext,
        externalContextsServiceRepresentations: externalContextsServiceRepresentations
    };
};
function $515129c478bdfdb9$var$_temp(context) {
    return context.serviceRepresentation;
}
module.exports["useConversationExternalAttachments"] = $515129c478bdfdb9$export$ee6324403e0cde6;

});

parcelRegister("kJeen", function(module, exports) {
/**
 * Shared `useRecommendedAgents` limit so the @-mention picker, AgentSection
 * and preloader collapse into one React Query cache entry.
 */ const $f0dfc9752e6dfce4$export$bc788bcc360b4bc = 5;
module.exports["AGENTS_FETCH_LIMIT"] = $f0dfc9752e6dfce4$export$bc788bcc360b4bc;

});

parcelRegister("fAgrN", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b8f3121a116af1f5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentsHeader: {
        id: "ai-mate.chat-input.agents.header",
        defaultMessage: "Start chatting with agents"
    },
    browseAgents: {
        id: "ai-mate.chat-input.agents.browse-agents",
        defaultMessage: "Browse agents"
    },
    createAgent: {
        id: "ai-mate.chat-input.agents.create-agent",
        defaultMessage: "Create agent"
    }
});
module.exports["messages"] = $b8f3121a116af1f5$export$defe85febe8b728c;

});

parcelRegister("9zNPM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $7685l = parcelRequire("7685l");

const $c6d8ed72c7f35239$export$b04f50d0ca8f6baf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (key)=>{
    const [t0] = (0, $7685l.useChatModeStore)(key);
    const { useCurrentPageContext: useCurrentPageContext } = t0;
    return useCurrentPageContext;
} : (key)=>{
    const [{ useCurrentPageContext: useCurrentPageContext }] = (0, $7685l.useChatModeStore)(key);
    return useCurrentPageContext;
};
module.exports["useCurrentPageContextEnabled"] = $c6d8ed72c7f35239$export$b04f50d0ca8f6baf;

});

parcelRegister("1SiET", function(module, exports) {
const $7c8a3dd99ea43989$export$4b24e3a88bb9f9d0 = 10;
const $7c8a3dd99ea43989$export$62220f2257a1b032 = 20971520; // 20MB
const $7c8a3dd99ea43989$export$b39af14b910b9848 = 104857600; // 100MB
module.exports["MAX_FILES"] = $7c8a3dd99ea43989$export$4b24e3a88bb9f9d0;

});

parcelRegister("Ks5oo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $eh6Ml = parcelRequire("eh6Ml");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $4XF4G = parcelRequire("4XF4G");


var $dftWP = parcelRequire("dftWP");

const $362b10cdba435f33$var$styles = {
    menuItem: "_2mHwu8gVvo _0bjKvDKTcp _2Y7lL48HPE _39xV02N91d _3iDTPbQ4SZ _0aFT5v1qpb _4kiQYAUofl _37wbyuI7V3 _0hPCNLDIqT _0wOv4Q7zJH _0KLXru66of _1eOmH6o126 _3gzVzLN4oS",
    menuItemActive: "_0KLXruY9q9 _1UtDYzjTy9",
    menuItemDisabled: "_0wOv4Qsyl5 _1UtDYzot27 _1YKVNsVx3j",
    menuItemContent: "_2mHwu8gVvo _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
    menuItemIcon: "_3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT _1UtDYzZpcK",
    menuItemLabelContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC _2fwxA5ecOK",
    menuItemLabel: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39xV02N91d _1ANEUSLRg7 _39HuIbz8Lp"
};
const $362b10cdba435f33$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuItem(t0, ref) {
    const $ = (0, $bDgLe.c)(32);
    const { label: label, icon: icon, onClick: onClick, isActive: isActive, isLoading: isLoading, isDisabled: isDisabled, testId: testId, badge: badge } = t0;
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    const textRef = (0, $cozmU.useRef)(null);
    const containerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const checkOverflow = ()=>{
                if (textRef.current && containerRef.current) {
                    const isOverflowing = textRef.current.scrollWidth > containerRef.current.clientWidth;
                    setShowTooltip(isOverflowing);
                }
            };
            checkOverflow();
            const resizeObserver = new ResizeObserver(checkOverflow);
            if (containerRef.current) resizeObserver.observe(containerRef.current);
            return ()=>resizeObserver.disconnect();
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== label) {
        t2 = [
            label
        ];
        $[1] = label;
        $[2] = t2;
    } else t2 = $[2];
    (0, $cozmU.useEffect)(t1, t2);
    const t3 = isActive && $362b10cdba435f33$var$styles.menuItemActive;
    const t4 = isDisabled && $362b10cdba435f33$var$styles.menuItemDisabled;
    let t5;
    if ($[3] !== t3 || $[4] !== t4) {
        t5 = (0, $w6R6I.cx)($362b10cdba435f33$var$styles.menuItem, t3, t4);
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const t6 = isDisabled ? undefined : onClick;
    const t7 = testId || "menu-item-container";
    let t8;
    if ($[6] !== icon || $[7] !== isLoading) {
        t8 = isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dftWP.LoadingState), {
            size: "small",
            testId: "loading-state"
        }) : icon;
        $[6] = icon;
        $[7] = isLoading;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362b10cdba435f33$var$styles.menuItemIcon
        }, t8);
        $[9] = t8;
        $[10] = t9;
    } else t9 = $[10];
    const t10 = isActive ? "color.text.selected" : "color.text.subtle";
    let t11;
    if ($[11] !== label || $[12] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362b10cdba435f33$var$styles.menuItemLabel,
            ref: textRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: t10,
            testId: "menu-item-label"
        }, label));
        $[11] = label;
        $[12] = t10;
        $[13] = t11;
    } else t11 = $[13];
    let t12;
    if ($[14] !== label || $[15] !== showTooltip || $[16] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362b10cdba435f33$var$styles.menuItemLabelContainer,
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4XF4G.ConditionalTooltip), {
            withTooltip: showTooltip,
            content: label
        }, t11));
        $[14] = label;
        $[15] = showTooltip;
        $[16] = t11;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== badge || $[19] !== t12 || $[20] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $362b10cdba435f33$var$styles.menuItemContent,
            testId: "menu-item-content"
        }, t9, t12, badge);
        $[18] = badge;
        $[19] = t12;
        $[20] = t9;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] !== isActive) {
        t14 = isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "checkmark"
        });
        $[22] = isActive;
        $[23] = t14;
    } else t14 = $[23];
    let t15;
    if ($[24] !== isDisabled || $[25] !== ref || $[26] !== t13 || $[27] !== t14 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ref: ref,
            xcss: t5,
            onClick: t6,
            "aria-disabled": isDisabled,
            role: "menuitem",
            testId: t7
        }, t13, t14);
        $[24] = isDisabled;
        $[25] = ref;
        $[26] = t13;
        $[27] = t14;
        $[28] = t5;
        $[29] = t6;
        $[30] = t7;
        $[31] = t15;
    } else t15 = $[31];
    return t15;
} : function MenuItem({ label: label, icon: icon, onClick: onClick, isActive: isActive, isLoading: isLoading, isDisabled: isDisabled, testId: testId, badge: badge }, ref) {
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    const textRef = (0, $cozmU.useRef)(null);
    const containerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const checkOverflow = ()=>{
            if (textRef.current && containerRef.current) {
                const isOverflowing = textRef.current.scrollWidth > containerRef.current.clientWidth;
                setShowTooltip(isOverflowing);
            }
        };
        checkOverflow();
        const resizeObserver = new ResizeObserver(checkOverflow);
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ref: ref,
        xcss: (0, $w6R6I.cx)($362b10cdba435f33$var$styles.menuItem, isActive && $362b10cdba435f33$var$styles.menuItemActive, isDisabled && $362b10cdba435f33$var$styles.menuItemDisabled),
        onClick: isDisabled ? undefined : onClick,
        "aria-disabled": isDisabled,
        role: "menuitem",
        testId: testId || 'menu-item-container'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362b10cdba435f33$var$styles.menuItemContent,
        testId: "menu-item-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362b10cdba435f33$var$styles.menuItemIcon
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dftWP.LoadingState), {
        size: "small",
        testId: "loading-state"
    }) : icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362b10cdba435f33$var$styles.menuItemLabelContainer,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4XF4G.ConditionalTooltip), {
        withTooltip: showTooltip,
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $362b10cdba435f33$var$styles.menuItemLabel,
        ref: textRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: isActive ? 'color.text.selected' : 'color.text.subtle',
        testId: "menu-item-label"
    }, label)))), badge), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "checkmark"
    }));
});
module.exports["MenuItem"] = $362b10cdba435f33$export$2ce376c2cc3355c8;

});

parcelRegister("2UKhw", function(module, exports) {
const $dc602b285bee0e19$export$3d931b64f46140b3 = '1248px';
const $dc602b285bee0e19$export$1dd7793cb602b5ab = '100%';
const $dc602b285bee0e19$export$a5e66ebb2aa164d3 = [
    'jsm',
    'jira',
    'confluence'
];
const $dc602b285bee0e19$export$3bc641a25b82d16d = 5;
module.exports["MODAL_WIDTH"] = $dc602b285bee0e19$export$3d931b64f46140b3;
module.exports["MODAL_HEIGHT"] = $dc602b285bee0e19$export$1dd7793cb602b5ab;
module.exports["STUDIO_EXTERNAL_ALLOWLIST_SKILL_PRODUCTS"] = $dc602b285bee0e19$export$a5e66ebb2aa164d3;
module.exports["MAX_SHARE_SKILLS_SELECTION"] = $dc602b285bee0e19$export$3bc641a25b82d16d;

});

parcelRegister("2Db11", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $kTGj5 = parcelRequire("kTGj5");


var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $fMu5B = parcelRequire("fMu5B");


const $a2f9eca24f1efbf8$export$7be7b7175ed99ae0 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("evcyq")), {
        moduleId: "715ea3aa",
        moduleName: "AgentStudioSkills",
        priority: "interaction",
        moduleId: 'agent-studio-skills-entrypoint-id',
        moduleName: 'agent-studio-skills-entrypoint'
    }),
    getPreloadProps: ({ capabilities: capabilities, cloudId: cloudId, onSkillClick: onSkillClick, externalAllowlistedSkillProducts: externalAllowlistedSkillProducts })=>{
        return {
            queries: {
                skillsQuery: {
                    parameters: (0, $fMu5B.default),
                    variables: {
                        cloudId: cloudId,
                        contextAri: (0, $kTGj5.PlatformSiteAri).create({
                            siteId: cloudId
                        }).toString(),
                        isStudioCustomSkillsM1FrontendEnabled: (0, $iDrrr.fg)('studio_custom_skills_m1_frontend')
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            extraProps: {
                capabilities: capabilities,
                cloudId: cloudId,
                onSkillClick: onSkillClick,
                externalAllowlistedSkillProducts: externalAllowlistedSkillProducts
            }
        };
    }
});
module.exports["agentStudioSkillsEntrypoint"] = $a2f9eca24f1efbf8$export$7be7b7175ed99ae0;

});

parcelRegister("fMu5B", function(module, exports) {
/**
 * @generated SignedSource<<33c9c130863a4a65ac47546ec909c384>>
 * @relayHash e24c5363d85397ffd09961b0158238e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 82578073483388cff5bdf8623eae547a9626c4c2f7b4c3a49c72a4eeb8c73f49
const $a5b6394fdeb019f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contextAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isStudioCustomSkillsM1FrontendEnabled"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "contextAri",
        "variableName": "contextAri"
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        },
        {
            "items": [
                {
                    "kind": "Literal",
                    "name": "relevantFor.0",
                    "value": "PLATFORM_SKILL"
                }
            ],
            "kind": "ListValue",
            "name": "relevantFor"
        },
        {
            "kind": "Literal",
            "name": "surface",
            "value": "ROVO_AGENTS"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v9 = [
        v5 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgentStudioSkillsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "isStudioCustomSkillsM1FrontendEnabled",
                            "variableName": "isStudioCustomSkillsM1FrontendEnabled"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "SkillsList_AtlassianAgentStudioSkills_fragmentRef"
                },
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "SkillsFilter_AtlassianAgentStudioSkills_fragmentRef"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgentStudioSkillsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "GraphIntegrationDirectoryItemConnection",
                    "kind": "LinkedField",
                    "name": "graphIntegration_componentDirectoryItems",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphIntegrationDirectoryItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "concreteType": "GraphIntegrationSkillUiMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "uiMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "color"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "iconKey"
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "GraphIntegrationSkillMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "metadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "tags"
                                                        },
                                                        {
                                                            "concreteType": "GraphIntegrationSkillTool",
                                                            "kind": "LinkedField",
                                                            "name": "tools",
                                                            "plural": true,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "source"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isStudioCustomSkillsM1FrontendEnabled",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "createdBy",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "GraphIntegrationSkillItem"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "GraphIntegrationActionDirectoryItem"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "GraphIntegrationMcpServer"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "GraphIntegrationMcpTool"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v9 /*: any*/ ,
                                            "type": "GraphIntegrationSkillDirectoryItem"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "relevantFor",
                        "surface",
                        "searchKeyword",
                        "dimensionIds"
                    ],
                    "handle": "connection",
                    "key": "SkillsList_AtlassianAgentStudioSkills_graphIntegration_componentDirectoryItems",
                    "kind": "LinkedHandle",
                    "name": "graphIntegration_componentDirectoryItems"
                },
                {
                    "condition": "isStudioCustomSkillsM1FrontendEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        v2 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "dimension",
                            "value": "PRODUCTS"
                        }
                    ],
                    "concreteType": "GraphIntegrationSkillDimensionMetadata",
                    "kind": "LinkedField",
                    "name": "graphIntegration_skillDimensionMetadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v7 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "iconUrl"
                                        }
                                    ],
                                    "type": "GraphIntegrationSkillProductItem"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "82578073483388cff5bdf8623eae547a9626c4c2f7b4c3a49c72a4eeb8c73f49",
            "metadata": {},
            "name": "AgentStudioSkillsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a5b6394fdeb019f5$var$node.hash = "1f6102576d190ca076f2ebfc79876b73";
var $a5b6394fdeb019f5$export$2e2bcd8739ae039 = $a5b6394fdeb019f5$var$node;
module.exports["default"] = $a5b6394fdeb019f5$export$2e2bcd8739ae039;

});

parcelRegister("evcyq", function(module, exports) {

let $a8edb2f5fb7eff98$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a8edb2f5fb7eff98$var$load("kkkxt"),
    $a8edb2f5fb7eff98$var$load("1FRba"),
    $a8edb2f5fb7eff98$var$load("fibpY"),
    $a8edb2f5fb7eff98$var$load("4O6U4"),
    $a8edb2f5fb7eff98$var$load("8hP2l"),
    $a8edb2f5fb7eff98$var$load("1XtfK"),
    $a8edb2f5fb7eff98$var$load("2OemJ"),
    $a8edb2f5fb7eff98$var$load("Lm7SH"),
    $a8edb2f5fb7eff98$var$load("6wr18"),
    $a8edb2f5fb7eff98$var$load("insjf"),
    $a8edb2f5fb7eff98$var$load("dj7pP"),
    $a8edb2f5fb7eff98$var$load("g8p2r"),
    $a8edb2f5fb7eff98$var$load("9hl0D"),
    $a8edb2f5fb7eff98$var$load("3R4oU"),
    $a8edb2f5fb7eff98$var$load("bz5yy"),
    $a8edb2f5fb7eff98$var$load("4lI02"),
    $a8edb2f5fb7eff98$var$load("Wowvf"),
    $a8edb2f5fb7eff98$var$load("fKQ9j"),
    $a8edb2f5fb7eff98$var$load("ffEVr"),
    $a8edb2f5fb7eff98$var$load("iWnyc"),
    $a8edb2f5fb7eff98$var$load("hhss7"),
    $a8edb2f5fb7eff98$var$load("7EorR"),
    $a8edb2f5fb7eff98$var$load("g3aC4")
]).then(()=>parcelRequire('lwYSQ'));

});

parcelRegister("lEiQs", function(module, exports) {

let $fc2bf3a27e3b7dc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fc2bf3a27e3b7dc2$var$load("9ElG9"),
    $fc2bf3a27e3b7dc2$var$load("8hP2l"),
    $fc2bf3a27e3b7dc2$var$load("1XtfK"),
    $fc2bf3a27e3b7dc2$var$load("2OemJ"),
    $fc2bf3a27e3b7dc2$var$load("6wr18"),
    $fc2bf3a27e3b7dc2$var$load("3R4oU"),
    $fc2bf3a27e3b7dc2$var$load("ffEVr"),
    $fc2bf3a27e3b7dc2$var$load("gi4AU")
]).then(()=>parcelRequire('jXlkz'));

});

parcelRegister("beaVo", function(module, exports) {

let $82c979ecc79aae0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $82c979ecc79aae0c$var$load("9ElG9"),
    $82c979ecc79aae0c$var$load("8hP2l"),
    $82c979ecc79aae0c$var$load("1XtfK"),
    $82c979ecc79aae0c$var$load("2OemJ"),
    $82c979ecc79aae0c$var$load("3R4oU"),
    $82c979ecc79aae0c$var$load("hbpMI")
]).then(()=>parcelRequire('keBD8'));

});

parcelRegister("4y2BX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<31b7f40d325d8fa902a9769dd80de13e>>
 * @relayHash cff0f770b89d7793c0d68bd12e056911
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a447c6679b37a1c3fa74f11a35d2adafd303a7dec5364d7810a0ec9f857c0cfd
const $492336b63c20ea27$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldFetch"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v8 = [
        {
            "concreteType": "ConvoAiSkillEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "ConvoAiSkill",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "slashCommand"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "iconKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "helpText"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tags"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "integrationKeys"
                        },
                        {
                            "concreteType": "ConvoAiSkillIntegration",
                            "kind": "LinkedField",
                            "name": "integrations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "cursor"
                }
            ]
        },
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasPreviousPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "startCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalCount"
        },
        {
            "concreteType": "ConvoAiSkillListMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "anthropicCount"
                },
                {
                    "kind": "ScalarField",
                    "name": "stratusCount"
                },
                {
                    "kind": "ScalarField",
                    "name": "isDegraded"
                }
            ]
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "composableEditorChat_GetAvailableSkillsQuery",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "convoai_availableSkills",
                            "args": [
                                v4 /*: any*/ 
                            ],
                            "concreteType": "ConvoAiAvailableSkillsResult",
                            "kind": "LinkedField",
                            "name": "__Skills__convoai_availableSkills_connection",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "composableEditorChat_GetAvailableSkillsQuery",
            "selections": [
                {
                    "condition": "shouldFetch",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "ConvoAiAvailableSkillsResult",
                            "kind": "LinkedField",
                            "name": "convoai_availableSkills",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "Skills__convoai_availableSkills",
                            "kind": "LinkedHandle",
                            "name": "convoai_availableSkills"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a447c6679b37a1c3fa74f11a35d2adafd303a7dec5364d7810a0ec9f857c0cfd",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "convoai_availableSkills"
                        ]
                    }
                ]
            },
            "name": "composableEditorChat_GetAvailableSkillsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$492336b63c20ea27$var$node.hash = "1291acbd22a2e173d2113b832095680b";
var $492336b63c20ea27$export$2e2bcd8739ae039 = $492336b63c20ea27$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $1KOhB = parcelRequire("1KOhB");


var $jlRK6 = parcelRequire("jlRK6");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $hlvTd = parcelRequire("hlvTd");


var $1Bxlw = parcelRequire("1Bxlw");


var $f6VI9 = parcelRequire("f6VI9");


var $37WrG = parcelRequire("37WrG");


var $a6scT = parcelRequire("a6scT");

// Check if we're at 90% of the API limit (150 items)
const $2294720c9137d2cf$var$API_LIMIT = 150;
const $2294720c9137d2cf$var$PAGINATION_THRESHOLD = $2294720c9137d2cf$var$API_LIMIT * 0.9; // 90 items
const $2294720c9137d2cf$var$ComposableEditorSkillsUnified = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { isSpecialistPromptInput: isSpecialistPromptInput, isSpaceScopedConversation: t1, promptHasSkill: promptHasSkill, enableSkills: t2, siteId: siteId, disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor, skillsRevision: skillsRevision, onManifestReady: onManifestReady } = t0;
    const isSpaceScopedConversation = t1 === undefined ? false : t1;
    const enableSkills = t2 === undefined ? true : t2;
    const skillsResponse = (0, $6SsN4.useLazyLoadQuery)((0, $492336b63c20ea27$export$2e2bcd8739ae039), {
        first: $2294720c9137d2cf$var$API_LIMIT,
        cloudId: siteId,
        shouldFetch: enableSkills
    }, {
        fetchKey: skillsRevision,
        fetchPolicy: skillsRevision === 0 ? "store-or-network" : "network-only"
    })?.convoai_availableSkills;
    let t3;
    if ($[0] !== disableSkillTagHoverCardInEditor || $[1] !== enableSkills || $[2] !== isSpaceScopedConversation || $[3] !== isSpecialistPromptInput || $[4] !== onManifestReady || $[5] !== promptHasSkill || $[6] !== siteId || $[7] !== skillTagHoverCardMaxHeightInEditor || $[8] !== skillsResponse || $[9] !== skillsRevision) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2294720c9137d2cf$var$SkillsManifestReporter, {
            skillsResponse: skillsResponse,
            isSpecialistPromptInput: isSpecialistPromptInput,
            isSpaceScopedConversation: isSpaceScopedConversation,
            promptHasSkill: promptHasSkill,
            enableSkills: enableSkills,
            siteId: siteId,
            disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor,
            skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor,
            skillsRevision: skillsRevision,
            onManifestReady: onManifestReady
        });
        $[0] = disableSkillTagHoverCardInEditor;
        $[1] = enableSkills;
        $[2] = isSpaceScopedConversation;
        $[3] = isSpecialistPromptInput;
        $[4] = onManifestReady;
        $[5] = promptHasSkill;
        $[6] = siteId;
        $[7] = skillTagHoverCardMaxHeightInEditor;
        $[8] = skillsResponse;
        $[9] = skillsRevision;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ isSpecialistPromptInput: isSpecialistPromptInput, isSpaceScopedConversation: isSpaceScopedConversation = false, promptHasSkill: promptHasSkill, enableSkills: enableSkills = true, siteId: siteId, disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor, skillsRevision: skillsRevision, onManifestReady: onManifestReady })=>{
    const skillsResponse = (0, $6SsN4.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by parseUniversalSkillEdges and kept for future use */ (0, $492336b63c20ea27$export$2e2bcd8739ae039), /* eslint-enable @atlassian/relay/unused-fields */ {
        first: $2294720c9137d2cf$var$API_LIMIT,
        cloudId: siteId,
        shouldFetch: enableSkills
    }, {
        fetchKey: skillsRevision,
        fetchPolicy: skillsRevision === 0 ? 'store-or-network' : 'network-only'
    })?.convoai_availableSkills;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2294720c9137d2cf$var$SkillsManifestReporter, {
        skillsResponse: skillsResponse,
        isSpecialistPromptInput: isSpecialistPromptInput,
        isSpaceScopedConversation: isSpaceScopedConversation,
        promptHasSkill: promptHasSkill,
        enableSkills: enableSkills,
        siteId: siteId,
        disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor,
        skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor,
        skillsRevision: skillsRevision,
        onManifestReady: onManifestReady
    });
};
const $2294720c9137d2cf$var$SkillsManifestReporter = ({ skillsResponse: skillsResponse, isSpecialistPromptInput: isSpecialistPromptInput, isSpaceScopedConversation: isSpaceScopedConversation = false, promptHasSkill: promptHasSkill, enableSkills: enableSkills, siteId: siteId, disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor, skillsRevision: skillsRevision, onManifestReady: onManifestReady })=>{
    const skillsPaginationRef = (0, $cozmU.useRef)(false);
    if (skillsResponse?.errors && skillsResponse.errors.length > 0) {
        const errorMessages = skillsResponse.errors.map((err)=>err.message).join(', ');
        throw new Error(errorMessages || 'Failed to load skills');
    }
    const skillCount = skillsResponse?.edges?.length ?? 0;
    if (skillCount >= $2294720c9137d2cf$var$PAGINATION_THRESHOLD && !skillsPaginationRef.current) {
        (0, $hlvTd.logException)({
            exception: new Error(`Skills API limit threshold reached: ${skillCount} of ${$2294720c9137d2cf$var$API_LIMIT} items returned. Pagination is needed.`),
            name: 'aiMateBrowseSkillsPaginationLimit',
            tags: {
                skillCount: skillCount.toString(),
                apiLimit: $2294720c9137d2cf$var$API_LIMIT.toString()
            }
        });
        // prevent more than one log per render when threshold is reached
        skillsPaginationRef.current = true;
    }
    const skillsListAferLoad = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>(0, $f6VI9.parseUniversalSkillEdges)(skillsResponse?.edges ?? null, {
            restrictToRovoSpaceSkills: isSpaceScopedConversation
        }), [
        isSpaceScopedConversation,
        skillsResponse?.edges
    ]);
    const editorExtensionManifest = (0, $37WrG.useSkillsManifest)({
        skills: skillsListAferLoad,
        isSpecialistPromptInput: isSpecialistPromptInput,
        promptHasSkill: promptHasSkill,
        enableSkills: enableSkills,
        siteId: siteId,
        disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor,
        skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor
    });
    const prevInputsRef = (0, $cozmU.useRef)(null);
    const inputsKey = `${skillsRevision}-${skillsListAferLoad.length}-${isSpecialistPromptInput}-${isSpaceScopedConversation}-${promptHasSkill}-${enableSkills}-${siteId}-${disableSkillTagHoverCardInEditor}-${skillTagHoverCardMaxHeightInEditor}`;
    (0, $cozmU.useEffect)(()=>{
        if (editorExtensionManifest === undefined || prevInputsRef.current === inputsKey) return;
        prevInputsRef.current = inputsKey;
        onManifestReady(editorExtensionManifest);
    }, [
        editorExtensionManifest,
        inputsKey,
        onManifestReady
    ]);
    return null;
};
const $2294720c9137d2cf$var$SkillsDataFetcher = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2294720c9137d2cf$var$ComposableEditorSkillsUnified, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2294720c9137d2cf$var$ComposableEditorSkillsUnified, props);
};
const $2294720c9137d2cf$export$d985a50bcdf94a02 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    let disableSkillTagHoverCardInEditor;
    let editorApi;
    let isSpecialistPromptInput;
    let promptHasSkill;
    let props;
    let siteId;
    let skillTagHoverCardMaxHeightInEditor;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ isSpecialistPromptInput: isSpecialistPromptInput, isSpaceScopedConversation: t1, promptHasSkill: promptHasSkill, enableSkills: t2, siteId: siteId, editorApi: editorApi, disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor, ...props } = t0);
        $[0] = t0;
        $[1] = disableSkillTagHoverCardInEditor;
        $[2] = editorApi;
        $[3] = isSpecialistPromptInput;
        $[4] = promptHasSkill;
        $[5] = props;
        $[6] = siteId;
        $[7] = skillTagHoverCardMaxHeightInEditor;
        $[8] = t1;
        $[9] = t2;
    } else {
        disableSkillTagHoverCardInEditor = $[1];
        editorApi = $[2];
        isSpecialistPromptInput = $[3];
        promptHasSkill = $[4];
        props = $[5];
        siteId = $[6];
        skillTagHoverCardMaxHeightInEditor = $[7];
        t1 = $[8];
        t2 = $[9];
    }
    const isSpaceScopedConversation = t1 === undefined ? false : t1;
    const enableSkills = t2 === undefined ? true : t2;
    const { skillsRevision: skillsRevision } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    const skillTagFallbackProvider = (0, $a6scT.useSkillTagExtensionProvider)(siteId, disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor);
    const fallbackExtensionProviders = enableSkills ? skillTagFallbackProvider : undefined;
    const [extensionProviders, setExtensionProviders] = (0, $cozmU.useState)(fallbackExtensionProviders);
    let t3;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (manifest)=>{
            setExtensionProviders(manifest);
        };
        $[10] = t3;
    } else t3 = $[10];
    const onManifestReady = t3;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const typeAheadWasOpenRef = (0, $cozmU.useRef)(false);
    let t4;
    if ($[11] !== sendAnalyticsEvent) {
        t4 = (t5)=>{
            const { typeAheadState: typeAheadState } = t5;
            const isOpen = Boolean(typeAheadState?.isOpen);
            if (isOpen && !typeAheadWasOpenRef.current) sendAnalyticsEvent({
                eventType: "screen",
                name: "rovoChatEditorTypeAhead"
            });
            typeAheadWasOpenRef.current = isOpen;
        };
        $[11] = sendAnalyticsEvent;
        $[12] = t4;
    } else t4 = $[12];
    const onTypeAheadPluginState = t4;
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            "typeAhead"
        ];
        $[13] = t5;
    } else t5 = $[13];
    const t6 = !editorApi;
    let t7;
    if ($[14] !== t6) {
        t7 = {
            disabled: t6
        };
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    (0, $1KOhB.usePluginStateEffect)(editorApi, t5, onTypeAheadPluginState, t7);
    let t8;
    if ($[16] !== disableSkillTagHoverCardInEditor || $[17] !== enableSkills || $[18] !== isSpaceScopedConversation || $[19] !== isSpecialistPromptInput || $[20] !== promptHasSkill || $[21] !== siteId || $[22] !== skillTagHoverCardMaxHeightInEditor || $[23] !== skillsRevision) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2294720c9137d2cf$var$SkillsDataFetcher, {
            enableSkills: enableSkills,
            siteId: siteId,
            isSpecialistPromptInput: isSpecialistPromptInput,
            isSpaceScopedConversation: isSpaceScopedConversation,
            promptHasSkill: promptHasSkill,
            disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor,
            skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor,
            skillsRevision: skillsRevision,
            onManifestReady: onManifestReady
        }));
        $[16] = disableSkillTagHoverCardInEditor;
        $[17] = enableSkills;
        $[18] = isSpaceScopedConversation;
        $[19] = isSpecialistPromptInput;
        $[20] = promptHasSkill;
        $[21] = siteId;
        $[22] = skillTagHoverCardMaxHeightInEditor;
        $[23] = skillsRevision;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== extensionProviders || $[26] !== props) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
            extensionProviders: extensionProviders,
            ...props
        });
        $[25] = extensionProviders;
        $[26] = props;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== t8 || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9);
        $[28] = t8;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ({ isSpecialistPromptInput: isSpecialistPromptInput, isSpaceScopedConversation: isSpaceScopedConversation = false, promptHasSkill: promptHasSkill, enableSkills: enableSkills = true, siteId: siteId, editorApi: editorApi, disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor, ...props })=>{
    const { skillsRevision: skillsRevision } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    const skillTagFallbackProvider = (0, $a6scT.useSkillTagExtensionProvider)(siteId, disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor);
    const fallbackExtensionProviders = enableSkills ? skillTagFallbackProvider : undefined;
    const [extensionProviders, setExtensionProviders] = (0, $cozmU.useState)(fallbackExtensionProviders);
    const onManifestReady = (0, $cozmU.useCallback)((manifest)=>{
        setExtensionProviders(manifest);
    }, []);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const typeAheadWasOpenRef = (0, $cozmU.useRef)(false);
    const onTypeAheadPluginState = (0, $cozmU.useCallback)(({ typeAheadState: typeAheadState })=>{
        const isOpen = Boolean(typeAheadState?.isOpen);
        if (isOpen && !typeAheadWasOpenRef.current) sendAnalyticsEvent({
            eventType: 'screen',
            name: 'rovoChatEditorTypeAhead'
        });
        typeAheadWasOpenRef.current = isOpen;
    }, [
        sendAnalyticsEvent
    ]);
    (0, $1KOhB.usePluginStateEffect)(editorApi, [
        'typeAhead'
    ], onTypeAheadPluginState, {
        disabled: !editorApi
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2294720c9137d2cf$var$SkillsDataFetcher, {
        enableSkills: enableSkills,
        siteId: siteId,
        isSpecialistPromptInput: isSpecialistPromptInput,
        isSpaceScopedConversation: isSpaceScopedConversation,
        promptHasSkill: promptHasSkill,
        disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor,
        skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor,
        skillsRevision: skillsRevision,
        onManifestReady: onManifestReady
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
        extensionProviders: extensionProviders,
        ...props
    }));
};
module.exports["ComposableEditorWithSkills"] = $2294720c9137d2cf$export$d985a50bcdf94a02;

});

parcelRegister("37WrG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bdpeX = parcelRequire("bdpeX");


var $9KSWX = parcelRequire("9KSWX");


var $8lhhf = parcelRequire("8lhhf");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $89QZA = parcelRequire("89QZA");


var $9MCKh = parcelRequire("9MCKh");


var $3GBUS = parcelRequire("3GBUS");

const $7d40fc345b791191$var$getSkillIcon = (iconName)=>iconName && (0, $9MCKh.skillIcon)[iconName] ? (0, $9MCKh.skillIcon)[iconName] : (0, $9MCKh.defaultIcon);
const $7d40fc345b791191$var$SKILL_DESCRIPTION_CHAR_LIMIT = 150;
const $7d40fc345b791191$var$truncateSkillDescription = (description)=>{
    if (!description) return '';
    if (description.length <= $7d40fc345b791191$var$SKILL_DESCRIPTION_CHAR_LIMIT) return description;
    const slice = description.slice(0, $7d40fc345b791191$var$SKILL_DESCRIPTION_CHAR_LIMIT);
    const lastWhitespace = slice.search(/\s\S*$/);
    const truncated = lastWhitespace > 0 ? slice.slice(0, lastWhitespace) : slice;
    return `${truncated.trimEnd()}\u{2026}`;
};
const $7d40fc345b791191$var$skillsEditorMessages = (0, $kSwu1.defineMessages)({
    betaLabel: {
        id: "conversation-assistant-chat-prompt-input.skills-editor-extension.beta-label",
        defaultMessage: "Beta"
    }
});
const $7d40fc345b791191$var$adminSkillBetaLozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
    appearance: "discovery"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7d40fc345b791191$var$skillsEditorMessages.betaLabel));
const $7d40fc345b791191$export$a728a4b0cfbf102d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { skills: skills, isSpecialistPromptInput: isSpecialistPromptInput, promptHasSkill: promptHasSkill, enableSkills: t1, siteId: siteId, disableSkillTagHoverCardInEditor: t2, skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor } = t0;
    const enableSkills = t1 === undefined ? true : t1;
    const disableSkillTagHoverCardInEditor = t2 === undefined ? false : t2;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    let t3;
    if ($[0] !== disableSkillTagHoverCardInEditor || $[1] !== sendAnalyticsEvent || $[2] !== setAnalyticsPropertiesWithoutRerender || $[3] !== siteId || $[4] !== skillTagHoverCardMaxHeightInEditor) {
        t3 = (skills_0)=>{
            const manifest = {
                title: "Skills",
                type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
                key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
                categories: [
                    "Skills"
                ],
                icons: {
                    "16": (0, $9MCKh.defaultIcon),
                    "24": (0, $9MCKh.defaultIcon),
                    "48": (0, $9MCKh.defaultIcon)
                },
                modules: {
                    quickInsert: skills_0.map((skill)=>{
                        const { slug: slug, description: description, name: name, product: product, iconName: iconName, tags: tags } = skill;
                        const lozenge = tags?.some($7d40fc345b791191$var$_temp) ? $7d40fc345b791191$var$adminSkillBetaLozenge : undefined;
                        return {
                            key: slug,
                            keywords: [
                                "skills",
                                "skill",
                                slug,
                                product ?? ""
                            ],
                            priority: 99,
                            title: name,
                            description: $7d40fc345b791191$var$truncateSkillDescription(description),
                            icon: $7d40fc345b791191$var$getSkillIcon(iconName),
                            lozenge: lozenge,
                            action: async ()=>{
                                sendAnalyticsEvent({
                                    eventType: "ui",
                                    action: "clicked",
                                    actionSubject: "button",
                                    actionSubjectId: "rovoChatSkillSelected",
                                    attributes: {
                                        slashCommand: slug,
                                        skillProductKey: product,
                                        skillSelectionSource: "editorTypeahead"
                                    }
                                });
                                setAnalyticsPropertiesWithoutRerender({
                                    skillSelectionSource: "editorTypeahead"
                                });
                                return (0, $8lhhf.createSkillNode)(skill);
                            }
                        };
                    }),
                    nodes: (0, $3GBUS.createSkillTagNodeRenderer)(siteId, disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor)
                }
            };
            return manifest;
        };
        $[0] = disableSkillTagHoverCardInEditor;
        $[1] = sendAnalyticsEvent;
        $[2] = setAnalyticsPropertiesWithoutRerender;
        $[3] = siteId;
        $[4] = skillTagHoverCardMaxHeightInEditor;
        $[5] = t3;
    } else t3 = $[5];
    const createManifest = t3;
    let t4;
    bb0: {
        if (!enableSkills) {
            t4 = undefined;
            break bb0;
        }
        if (isSpecialistPromptInput || promptHasSkill) {
            let t5;
            if ($[6] !== createManifest) {
                t5 = new (0, $bdpeX.default)([
                    createManifest([])
                ]);
                $[6] = createManifest;
                $[7] = t5;
            } else t5 = $[7];
            let t6;
            if ($[8] !== t5) {
                t6 = [
                    t5
                ];
                $[8] = t5;
                $[9] = t6;
            } else t6 = $[9];
            t4 = t6;
            break bb0;
        }
        let t5;
        if ($[10] !== createManifest || $[11] !== skills) {
            t5 = new (0, $bdpeX.default)([
                createManifest(skills)
            ]);
            $[10] = createManifest;
            $[11] = skills;
            $[12] = t5;
        } else t5 = $[12];
        let t6;
        if ($[13] !== t5) {
            t6 = [
                t5
            ];
            $[13] = t5;
            $[14] = t6;
        } else t6 = $[14];
        t4 = t6;
    }
    const manifestProvider = t4;
    return manifestProvider;
} : ({ skills: skills, isSpecialistPromptInput: isSpecialistPromptInput, promptHasSkill: promptHasSkill, enableSkills: enableSkills = true, siteId: siteId, disableSkillTagHoverCardInEditor: disableSkillTagHoverCardInEditor = false, skillTagHoverCardMaxHeightInEditor: skillTagHoverCardMaxHeightInEditor })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)(); // Skill selection source is recorded on the AnalyticsPropertiesContext so the chat
    // input can attach it to the next `aiResult viewed` event without needing a
    // per-input store. The provider is mounted once per chat instance, scoping the value
    // to the input that consumes it.
    const { setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const createManifest = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((skills_0)=>{
        const manifest = {
            title: 'Skills',
            type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
            key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
            categories: [
                'Skills'
            ],
            icons: {
                '16': (0, $9MCKh.defaultIcon),
                '24': (0, $9MCKh.defaultIcon),
                '48': (0, $9MCKh.defaultIcon)
            },
            modules: {
                quickInsert: skills_0.map((skill)=>{
                    const { slug: slug, description: description, name: name, product: product, iconName: iconName, tags: tags } = skill;
                    const lozenge = tags?.some((t)=>t.toLowerCase() === 'beta') ? $7d40fc345b791191$var$adminSkillBetaLozenge : undefined;
                    return {
                        key: slug,
                        keywords: [
                            'skills',
                            'skill',
                            slug,
                            product ?? ''
                        ],
                        // 1 is the default priority
                        priority: 99,
                        title: name,
                        description: $7d40fc345b791191$var$truncateSkillDescription(description),
                        icon: $7d40fc345b791191$var$getSkillIcon(iconName),
                        lozenge: lozenge,
                        action: async ()=>{
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'rovoChatSkillSelected',
                                attributes: {
                                    slashCommand: slug,
                                    skillProductKey: product,
                                    skillSelectionSource: 'editorTypeahead'
                                }
                            });
                            setAnalyticsPropertiesWithoutRerender({
                                skillSelectionSource: 'editorTypeahead'
                            });
                            return (0, $8lhhf.createSkillNode)(skill);
                        }
                    };
                }),
                nodes: (0, $3GBUS.createSkillTagNodeRenderer)(siteId, disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor)
            }
        };
        return manifest;
    }, [
        sendAnalyticsEvent,
        setAnalyticsPropertiesWithoutRerender,
        siteId,
        disableSkillTagHoverCardInEditor,
        skillTagHoverCardMaxHeightInEditor
    ]);
    const manifestProvider = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        // Return undefined if skills are disabled
        if (!enableSkills) return undefined;
         // skills are only applicable to non-agentic conversations
        // remove skills if a skill is already present in the prompt until chaining is allowed
        if (isSpecialistPromptInput || promptHasSkill) return [
            new (0, $bdpeX.default)([
                createManifest([])
            ])
        ];
        return [
            new (0, $bdpeX.default)([
                createManifest(skills)
            ])
        ];
    }, [
        isSpecialistPromptInput,
        promptHasSkill,
        createManifest,
        enableSkills,
        skills
    ]);
    return manifestProvider;
};
function $7d40fc345b791191$var$_temp(t) {
    return t.toLowerCase() === "beta";
}
module.exports["useSkillsManifest"] = $7d40fc345b791191$export$a728a4b0cfbf102d;

});

parcelRegister("fdZYN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $91ZZN = parcelRequire("91ZZN");


var $irnO2 = parcelRequire("irnO2");


var $hlvTd = parcelRequire("hlvTd");


var $d5gEx = parcelRequire("d5gEx");


var $5TXhv = parcelRequire("5TXhv");


var $7dHQW = parcelRequire("7dHQW");

/**
 * Internal component that uses skill metadata from SkillMetadataProvider context.
 * This component must be used within a SkillMetadataProvider to function properly.
 *
 * @internal Use ConnectedSkillTag instead
 */ const $da0b63dd887c1014$var$ConnectedSkillTagInternal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { slug: slug, invertColors: invertColors, disableHovercard: disableHovercard, shimmer: shimmer, hovercardMaxHeight: hovercardMaxHeight, fallbackTag: fallbackTag } = t0;
    const skillMetadata = (0, $7dHQW.useSkillMetadata)();
    if (!slug) return null;
    const metadata = skillMetadata?.skillMetadataMap?.[slug];
    if (!metadata) return fallbackTag;
    let t1;
    if ($[0] !== disableHovercard || $[1] !== hovercardMaxHeight || $[2] !== invertColors || $[3] !== metadata.color || $[4] !== metadata.description || $[5] !== metadata.iconName || $[6] !== metadata.name || $[7] !== metadata.product || $[8] !== metadata.productIconUrl || $[9] !== metadata.tags || $[10] !== shimmer || $[11] !== slug) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TXhv.SkillTag), {
            slug: slug,
            name: metadata.name,
            description: metadata.description,
            iconName: metadata.iconName,
            product: metadata.product,
            productIconUrl: metadata.productIconUrl,
            color: metadata.color,
            tags: metadata.tags,
            invertColors: invertColors,
            disableHovercard: disableHovercard,
            shimmer: shimmer,
            hovercardMaxHeight: hovercardMaxHeight
        });
        $[0] = disableHovercard;
        $[1] = hovercardMaxHeight;
        $[2] = invertColors;
        $[3] = metadata.color;
        $[4] = metadata.description;
        $[5] = metadata.iconName;
        $[6] = metadata.name;
        $[7] = metadata.product;
        $[8] = metadata.productIconUrl;
        $[9] = metadata.tags;
        $[10] = shimmer;
        $[11] = slug;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : ({ slug: slug, invertColors: invertColors, disableHovercard: disableHovercard, shimmer: shimmer, hovercardMaxHeight: hovercardMaxHeight, fallbackTag: fallbackTag })=>{
    const skillMetadata = (0, $7dHQW.useSkillMetadata)();
    if (!slug) return null;
     // Get the skill metadata for this slug
    const metadata = skillMetadata?.skillMetadataMap?.[slug]; // If we don't have metadata, render a basic tag with just the slug
    if (!metadata) return fallbackTag;
     // Render the SkillTag with full metadata
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TXhv.SkillTag), {
        slug: slug,
        name: metadata.name,
        description: metadata.description,
        iconName: metadata.iconName,
        product: metadata.product,
        productIconUrl: metadata.productIconUrl,
        color: metadata.color,
        tags: metadata.tags,
        invertColors: invertColors,
        disableHovercard: disableHovercard,
        shimmer: shimmer,
        hovercardMaxHeight: hovercardMaxHeight
    });
};
const $da0b63dd887c1014$export$cd7b6803f49d5e03 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { siteId: siteId, slug: slug, invertColors: invertColors, disableHovercard: disableHovercard, shimmer: shimmer, hovercardMaxHeight: hovercardMaxHeight } = t0;
    let t1;
    if ($[0] !== invertColors || $[1] !== shimmer || $[2] !== slug) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TXhv.SkillTag), {
            slug: slug,
            name: "",
            invertColors: invertColors,
            shimmer: shimmer,
            disableHovercard: true
        });
        $[0] = invertColors;
        $[1] = shimmer;
        $[2] = slug;
        $[3] = t1;
    } else t1 = $[3];
    const fallbackTag = t1;
    let t2;
    if ($[4] !== fallbackTag) {
        t2 = ()=>fallbackTag;
        $[4] = fallbackTag;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== siteId) {
        t3 = (error)=>{
            (0, $hlvTd.logException)({
                exception: error,
                name: (0, $irnO2.ExperienceName).HYDRATE_SKILL_METADATA,
                tags: {
                    siteId: siteId
                }
            });
        };
        $[6] = siteId;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== disableHovercard || $[9] !== fallbackTag || $[10] !== hovercardMaxHeight || $[11] !== invertColors || $[12] !== shimmer || $[13] !== slug) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da0b63dd887c1014$var$ConnectedSkillTagInternal, {
            slug: slug,
            invertColors: invertColors,
            disableHovercard: disableHovercard,
            shimmer: shimmer,
            hovercardMaxHeight: hovercardMaxHeight,
            fallbackTag: fallbackTag
        });
        $[8] = disableHovercard;
        $[9] = fallbackTag;
        $[10] = hovercardMaxHeight;
        $[11] = invertColors;
        $[12] = shimmer;
        $[13] = slug;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== siteId || $[16] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-connected-skill-tag",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7dHQW.SkillMetadataProvider), {
            siteId: siteId,
            fetchWithoutTags: true
        }, t4)));
        $[15] = siteId;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== t2 || $[19] !== t3 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: t2,
            onError: t3
        }, t5);
        $[18] = t2;
        $[19] = t3;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
} : ({ siteId: siteId, slug: slug, invertColors: invertColors, disableHovercard: disableHovercard, shimmer: shimmer, hovercardMaxHeight: hovercardMaxHeight })=>{
    const fallbackTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TXhv.SkillTag), {
        slug: slug,
        name: "",
        invertColors: invertColors,
        shimmer: shimmer,
        disableHovercard: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>fallbackTag,
        onError: (error)=>{
            (0, $hlvTd.logException)({
                exception: error,
                name: (0, $irnO2.ExperienceName).HYDRATE_SKILL_METADATA,
                tags: {
                    siteId: siteId
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-connected-skill-tag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7dHQW.SkillMetadataProvider), {
        siteId: siteId,
        fetchWithoutTags: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da0b63dd887c1014$var$ConnectedSkillTagInternal, {
        slug: slug,
        invertColors: invertColors,
        disableHovercard: disableHovercard,
        shimmer: shimmer,
        hovercardMaxHeight: hovercardMaxHeight,
        fallbackTag: fallbackTag
    })))));
};
module.exports["ConnectedSkillTag"] = $da0b63dd887c1014$export$cd7b6803f49d5e03;

});

parcelRegister("a6scT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bdpeX = parcelRequire("bdpeX");


var $8lhhf = parcelRequire("8lhhf");


var $9MCKh = parcelRequire("9MCKh");


var $3GBUS = parcelRequire("3GBUS");

const $3057f94522f0e8b3$export$6cf149dd75678e12 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId, t0, skillTagHoverCardMaxHeightInEditor)=>{
    const $ = (0, $bDgLe.c)(6);
    const disableSkillTagHoverCardInEditor = t0 === undefined ? false : t0;
    let t1;
    if ($[0] !== disableSkillTagHoverCardInEditor || $[1] !== siteId || $[2] !== skillTagHoverCardMaxHeightInEditor) {
        const manifest = {
            title: "Skills",
            type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
            key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
            icons: {
                "16": (0, $9MCKh.defaultIcon),
                "24": (0, $9MCKh.defaultIcon),
                "48": (0, $9MCKh.defaultIcon)
            },
            modules: {
                quickInsert: [],
                nodes: (0, $3GBUS.createSkillTagNodeRenderer)(siteId, disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor)
            }
        };
        t1 = new (0, $bdpeX.default)([
            manifest
        ]);
        $[0] = disableSkillTagHoverCardInEditor;
        $[1] = siteId;
        $[2] = skillTagHoverCardMaxHeightInEditor;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t1) {
        t2 = [
            t1
        ];
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : (siteId, disableSkillTagHoverCardInEditor = false, skillTagHoverCardMaxHeightInEditor)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const manifest = {
            title: 'Skills',
            type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
            key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
            icons: {
                '16': (0, $9MCKh.defaultIcon),
                '24': (0, $9MCKh.defaultIcon),
                '48': (0, $9MCKh.defaultIcon)
            },
            modules: {
                quickInsert: [],
                nodes: (0, $3GBUS.createSkillTagNodeRenderer)(siteId, disableSkillTagHoverCardInEditor, skillTagHoverCardMaxHeightInEditor)
            }
        };
        return [
            new (0, $bdpeX.default)([
                manifest
            ])
        ];
    }, [
        siteId,
        disableSkillTagHoverCardInEditor,
        skillTagHoverCardMaxHeightInEditor
    ]);
};
module.exports["useSkillTagExtensionProvider"] = $3057f94522f0e8b3$export$6cf149dd75678e12;

});

parcelRegister("b8kYV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $lKwLK = parcelRequire("lKwLK");


var $kBr4q = parcelRequire("kBr4q");


var $6P3l4 = parcelRequire("6P3l4");


var $5Jxc6 = parcelRequire("5Jxc6");

const $9a456f72efe13228$export$c07f930e4d0c507 = (0, $kBr4q.createHook)((0, $5Jxc6.store), {
    selector: (state, key)=>[
            ...state[key]?.attachments?.values() || (0, $6P3l4.defaultStateContextPerKey).attachments.values()
        ]
});



var $4kL8d = parcelRequire("4kL8d");

const $2026600dcf261388$var$styles = {
    listWrapper: "_2mHwu88HPE _1LMyvKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _4bt5LAIZbP _1ANEUSLRg7 _1EqgXlN91d _3h2tDz3EvU _46hvQm5zaO _0xmtko8HPE _0LQT5E8HPE _03SyCP8HPE",
    listItem: "_1LMyvKYbGa _43nrzTdnbC"
};
const $2026600dcf261388$var$useAutoScrollOnDataChange = (0, $gtMdU.isReactCompilerActivePlatform)() ? (data)=>{
    const $ = (0, $bDgLe.c)(3);
    const prevDataLength = (0, $cozmU.useRef)(data.length);
    const [isAutoScroll, setIsAutoScroll] = (0, $cozmU.useState)(false);
    const dataLength = data.length;
    let t0;
    let t1;
    if ($[0] !== dataLength) {
        t0 = ()=>{
            if (prevDataLength.current < dataLength) setIsAutoScroll(true);
            else setIsAutoScroll(false);
            prevDataLength.current = dataLength;
        };
        t1 = [
            dataLength
        ];
        $[0] = dataLength;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return isAutoScroll;
} : (data)=>{
    const prevDataLength = (0, $cozmU.useRef)(data.length);
    const [isAutoScroll, setIsAutoScroll] = (0, $cozmU.useState)(false);
    const dataLength = data.length;
    (0, $cozmU.useEffect)(()=>{
        if (prevDataLength.current < dataLength) setIsAutoScroll(true);
        else setIsAutoScroll(false);
        prevDataLength.current = dataLength;
    }, [
        dataLength
    ]);
    return isAutoScroll;
};
const $2026600dcf261388$export$20d4570a6e3e703b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { attachtmentsStoreKey: attachtmentsStoreKey } = t0;
    const [attachmentsState, t1] = (0, $9a456f72efe13228$export$c07f930e4d0c507)(attachtmentsStoreKey);
    const { removeExternalContext: removeExternalContext, removeFile: removeFile } = t1;
    const isAutoScroll = $2026600dcf261388$var$useAutoScrollOnDataChange(attachmentsState);
    if (attachmentsState.length === 0) return null;
    let t2;
    if ($[0] !== attachmentsState || $[1] !== attachtmentsStoreKey || $[2] !== isAutoScroll || $[3] !== removeExternalContext || $[4] !== removeFile) {
        let t3;
        if ($[6] !== attachmentsState.length || $[7] !== attachtmentsStoreKey || $[8] !== isAutoScroll || $[9] !== removeExternalContext || $[10] !== removeFile) {
            t3 = (context, index)=>{
                const isLast = index === attachmentsState.length - 1;
                let key;
                let content;
                bb5: switch(context.type){
                    case "file":
                        {
                            const file = context.data;
                            key = file.name;
                            content = /*#__PURE__*/ $cozmU.createElement((0, $4kL8d.FileCard), {
                                fileName: file.name,
                                onRemove: ()=>removeFile(attachtmentsStoreKey, file.name),
                                isLoading: file.isLoading,
                                error: file.error,
                                autoScroll: isAutoScroll && Boolean(file.error || isLast),
                                previewBlobUrl: file.previewBlobUrl,
                                isPreviewLoading: file.isPreviewLoading,
                                fileObject: file.fileObject
                            });
                            break bb5;
                        }
                    case "external":
                        {
                            const promptInputContext = context.data;
                            const externalContext = promptInputContext.representation;
                            key = promptInputContext.key;
                            content = /*#__PURE__*/ $cozmU.createElement((0, $lKwLK.PreviewCard), {
                                label: externalContext.label,
                                subLabel: externalContext.description,
                                onRemove: ()=>removeExternalContext(attachtmentsStoreKey, promptInputContext.key),
                                autoScroll: isAutoScroll && Boolean(isLast),
                                cardIcon: externalContext.image
                            });
                            break bb5;
                        }
                    default:
                        return null;
                }
                return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    as: "li",
                    key: key,
                    xcss: $2026600dcf261388$var$styles.listItem
                }, content);
            };
            $[6] = attachmentsState.length;
            $[7] = attachtmentsStoreKey;
            $[8] = isAutoScroll;
            $[9] = removeExternalContext;
            $[10] = removeFile;
            $[11] = t3;
        } else t3 = $[11];
        t2 = attachmentsState.map(t3);
        $[0] = attachmentsState;
        $[1] = attachtmentsStoreKey;
        $[2] = isAutoScroll;
        $[3] = removeExternalContext;
        $[4] = removeFile;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[12] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "ul",
            xcss: $2026600dcf261388$var$styles.listWrapper
        }, t2);
        $[12] = t2;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ attachtmentsStoreKey: attachtmentsStoreKey })=>{
    const [attachmentsState, { removeExternalContext: removeExternalContext, removeFile: removeFile }] = (0, $9a456f72efe13228$export$c07f930e4d0c507)(attachtmentsStoreKey);
    const isAutoScroll = $2026600dcf261388$var$useAutoScrollOnDataChange(attachmentsState);
    if (attachmentsState.length === 0) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "ul",
        xcss: $2026600dcf261388$var$styles.listWrapper
    }, attachmentsState.map((context, index)=>{
        const isLast = index === attachmentsState.length - 1;
        let key;
        let content;
        switch(context.type){
            case 'file':
                const file = context.data;
                key = file.name;
                content = /*#__PURE__*/ $cozmU.createElement((0, $4kL8d.FileCard), {
                    fileName: file.name,
                    onRemove: ()=>removeFile(attachtmentsStoreKey, file.name),
                    isLoading: file.isLoading,
                    error: file.error,
                    autoScroll: isAutoScroll && Boolean(file.error || isLast),
                    previewBlobUrl: file.previewBlobUrl,
                    isPreviewLoading: file.isPreviewLoading,
                    fileObject: file.fileObject
                });
                break;
            case 'external':
                const promptInputContext = context.data;
                const externalContext = promptInputContext.representation;
                key = promptInputContext.key;
                content = /*#__PURE__*/ $cozmU.createElement((0, $lKwLK.PreviewCard), {
                    label: externalContext.label,
                    subLabel: externalContext.description,
                    onRemove: ()=>removeExternalContext(attachtmentsStoreKey, promptInputContext.key),
                    autoScroll: isAutoScroll && Boolean(isLast),
                    cardIcon: externalContext.image
                });
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "li",
            key: key,
            xcss: $2026600dcf261388$var$styles.listItem
        }, content);
    }));
};
module.exports["InputContextListDisplay"] = $2026600dcf261388$export$20d4570a6e3e703b;

});

parcelRegister("4kL8d", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $hlvTd = parcelRequire("hlvTd");











const $e029af2285a57aa1$var$ArchiveIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("infyS")));

const $e029af2285a57aa1$var$AudioIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kOTUl")));

const $e029af2285a57aa1$var$DocumentIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("dwg3B")));

const $e029af2285a57aa1$var$ExcelIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7oGQO")));

const $e029af2285a57aa1$var$GenericIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("5DIZd")));

const $e029af2285a57aa1$var$GoogleDocIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("h2ScA")));

const $e029af2285a57aa1$var$GoogleSheetIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("22LPp")));

const $e029af2285a57aa1$var$GoogleSlideIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4UzML")));

const $e029af2285a57aa1$var$ImageIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("8aA0W")));

const $e029af2285a57aa1$var$PDFIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("iBf9z")));

const $e029af2285a57aa1$var$PowerpointIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("8e6lY")));

const $e029af2285a57aa1$var$SourceCodeIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("3xX9K")));

const $e029af2285a57aa1$var$SpreadsheetIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("3LVo6")));

const $e029af2285a57aa1$var$VideoIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("asjsV")));

const $e029af2285a57aa1$var$WordDocumentIconMedium = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("60b70"))); // Icons

const $e029af2285a57aa1$var$ArchiveIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("8KvsV")));

const $e029af2285a57aa1$var$AudioIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("l3lyT")));

const $e029af2285a57aa1$var$DocumentIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("6IDM1")));

const $e029af2285a57aa1$var$ExcelIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("5eRas")));

const $e029af2285a57aa1$var$GenericIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("dzvRA")));

const $e029af2285a57aa1$var$GoogleDocIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7KlQ2")));

const $e029af2285a57aa1$var$GoogleSheetIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("30pMN")));

const $e029af2285a57aa1$var$GoogleSlideIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hbVly")));

const $e029af2285a57aa1$var$ImageIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hRf5f")));

const $e029af2285a57aa1$var$PDFIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eiZGU")));

const $e029af2285a57aa1$var$PowerpointIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("bmQsw")));

const $e029af2285a57aa1$var$SourceCodeIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4hbMv")));

const $e029af2285a57aa1$var$SpreadsheetIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ljzu0")));

const $e029af2285a57aa1$var$VideoIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("b2vUF")));

const $e029af2285a57aa1$var$WordDocumentIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("3tCrI"))); // New icons

const $e029af2285a57aa1$var$ImageIconNew = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("6NvYG"))));

const $e029af2285a57aa1$var$FileNew = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("kkFbH"))));

const $e029af2285a57aa1$var$VideoIconNew = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("60Yxm"))));

const $e029af2285a57aa1$var$AudioIconNew = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("54t3f")));

const $e029af2285a57aa1$var$SpreadsheetIconNew = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kvgPS")));
const $e029af2285a57aa1$export$a697c9ed370839d5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    let fileName;
    let props;
    if ($[0] !== t0) {
        ({ fileName: fileName, ...props } = t0);
        $[0] = t0;
        $[1] = fileName;
        $[2] = props;
    } else {
        fileName = $[1];
        props = $[2];
    }
    const fileExtension = fileName.split(".").pop();
    if (!fileExtension) {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIcon, {
                label: ""
            });
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    switch(fileExtension.toLowerCase()){
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
            {
                let t1;
                if ($[4] !== props) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ImageIconNew, {
                        ...props,
                        label: ""
                    });
                    $[4] = props;
                    $[5] = t1;
                } else t1 = $[5];
                return t1;
            }
        case "csv":
        case "tsv":
        case "xls":
        case "xlsx":
            {
                let t1;
                if ($[6] !== props) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SpreadsheetIconNew, {
                        ...props,
                        label: ""
                    });
                    $[6] = props;
                    $[7] = t1;
                } else t1 = $[7];
                return t1;
            }
        case "mp3":
        case "wav":
        case "flac":
        case "ogg":
            {
                let t1;
                if ($[8] !== props) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$AudioIconNew, {
                        ...props,
                        label: ""
                    });
                    $[8] = props;
                    $[9] = t1;
                } else t1 = $[9];
                return t1;
            }
        case "mp4":
        case "avi":
        case "mov":
        case "mkv":
            {
                let t1;
                if ($[10] !== props) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$VideoIconNew, {
                        ...props,
                        label: ""
                    });
                    $[10] = props;
                    $[11] = t1;
                } else t1 = $[11];
                return t1;
            }
        default:
            {
                let t1;
                if ($[12] !== props) {
                    t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$FileNew, {
                        ...props,
                        label: ""
                    });
                    $[12] = props;
                    $[13] = t1;
                } else t1 = $[13];
                return t1;
            }
    }
} : ({ fileName: fileName, ...props })=>{
    const fileExtension = fileName.split('.').pop();
    if (!fileExtension) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIcon, {
        label: ""
    });
    switch(fileExtension.toLowerCase()){
        // Images
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ImageIconNew, {
                ...props,
                label: ""
            });
        // Spreadsheets
        case 'csv':
        case 'tsv':
        case 'xls':
        case 'xlsx':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SpreadsheetIconNew, {
                ...props,
                label: ""
            });
        // Audio
        case 'mp3':
        case 'wav':
        case 'flac':
        case 'ogg':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$AudioIconNew, {
                ...props,
                label: ""
            });
        // Videos
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'mkv':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$VideoIconNew, {
                ...props,
                label: ""
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$FileNew, {
                ...props,
                label: ""
            });
    }
};
const $e029af2285a57aa1$export$8c1a3d13e85d78b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { fileName: fileName, size: t1 } = t0;
    const size = t1 === undefined ? "small" : t1;
    const fileExtension = fileName.split(".").pop();
    if (!fileExtension) {
        let t2;
        if ($[0] !== size) {
            t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIconMedium, {
                label: ""
            });
            $[0] = size;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    }
    switch(fileExtension.toLowerCase()){
        case "txt":
        case "md":
        case "log":
        case "json":
        case "yaml":
        case "yml":
        case "xml":
        case "rtf":
            {
                let t2;
                if ($[2] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$DocumentIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$DocumentIconMedium, {
                        label: ""
                    });
                    $[2] = size;
                    $[3] = t2;
                } else t2 = $[3];
                return t2;
            }
        case "csv":
        case "tsv":
            {
                let t2;
                if ($[4] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SpreadsheetIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SpreadsheetIconMedium, {
                        label: ""
                    });
                    $[4] = size;
                    $[5] = t2;
                } else t2 = $[5];
                return t2;
            }
        case "doc":
        case "docx":
            {
                let t2;
                if ($[6] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$WordDocumentIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$WordDocumentIconMedium, {
                        label: ""
                    });
                    $[6] = size;
                    $[7] = t2;
                } else t2 = $[7];
                return t2;
            }
        case "pdf":
            {
                let t2;
                if ($[8] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$PDFIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$PDFIconMedium, {
                        label: ""
                    });
                    $[8] = size;
                    $[9] = t2;
                } else t2 = $[9];
                return t2;
            }
        case "ppt":
        case "pptx":
            {
                let t2;
                if ($[10] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$PowerpointIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$PowerpointIconMedium, {
                        label: ""
                    });
                    $[10] = size;
                    $[11] = t2;
                } else t2 = $[11];
                return t2;
            }
        case "xls":
        case "xlsx":
            {
                let t2;
                if ($[12] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ExcelIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ExcelIconMedium, {
                        label: ""
                    });
                    $[12] = size;
                    $[13] = t2;
                } else t2 = $[13];
                return t2;
            }
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
            {
                let t2;
                if ($[14] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ImageIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ImageIconMedium, {
                        label: ""
                    });
                    $[14] = size;
                    $[15] = t2;
                } else t2 = $[15];
                return t2;
            }
        case "mp3":
        case "wav":
        case "flac":
        case "ogg":
            {
                let t2;
                if ($[16] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$AudioIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$AudioIconMedium, {
                        label: ""
                    });
                    $[16] = size;
                    $[17] = t2;
                } else t2 = $[17];
                return t2;
            }
        case "mp4":
        case "avi":
        case "mov":
        case "mkv":
            {
                let t2;
                if ($[18] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$VideoIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$VideoIconMedium, {
                        label: ""
                    });
                    $[18] = size;
                    $[19] = t2;
                } else t2 = $[19];
                return t2;
            }
        case "zip":
        case "rar":
        case "7z":
            {
                let t2;
                if ($[20] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ArchiveIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ArchiveIconMedium, {
                        label: ""
                    });
                    $[20] = size;
                    $[21] = t2;
                } else t2 = $[21];
                return t2;
            }
        case "css":
        case "html":
        case "htm":
        case "c":
        case "cpp":
        case "cs":
        case "java":
        case "js":
        case "jsx":
        case "vue":
        case "svelte":
        case "as":
        case "sh":
        case "bash":
        case "bats":
        case "h":
        case "cc":
        case "cxx":
        case "hpp":
        case "hxx":
        case "coffee":
        case "litcoffee":
        case "clj":
        case "cljs":
        case "cljc":
        case "edn":
        case "dockerfile":
        case "dockerignore":
        case "erl":
        case "hrl":
        case "f":
        case "for":
        case "f90":
        case "f95":
        case "f03":
        case "f08":
        case "go":
        case "kt":
        case "kts":
        case "tex":
        case "sty":
        case "cls":
        case "less":
        case "makefile":
        case "mak":
        case "mk":
        case "m":
        case "mat":
        case "mm":
        case "pas":
        case "pp":
        case "p":
        case "pl":
        case "pm":
        case "t":
        case "pod":
        case "php":
        case "php3":
        case "php4":
        case "php5":
        case "phtml":
        case "py":
        case "pyw":
        case "pyc":
        case "pyo":
        case "pyd":
        case "r":
        case "rb":
        case "erb":
        case "rake":
        case "gemspec":
        case "rs":
        case "rslib":
        case "sas":
        case "sas7bdat":
        case "scss":
        case "sass":
        case "scala":
        case "sc":
        case "sbt":
        case "st":
        case "sm":
        case "sql":
        case "swift":
        case "tcl":
        case "itcl":
        case "ts":
        case "tsx":
        case "v":
        case "vh":
        case "vhd":
        case "vhdl":
            {
                let t2;
                if ($[22] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SourceCodeIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SourceCodeIconMedium, {
                        label: ""
                    });
                    $[22] = size;
                    $[23] = t2;
                } else t2 = $[23];
                return t2;
            }
        case "gdoc":
            {
                let t2;
                if ($[24] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleDocIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleDocIconMedium, {
                        label: ""
                    });
                    $[24] = size;
                    $[25] = t2;
                } else t2 = $[25];
                return t2;
            }
        case "gsheet":
            {
                let t2;
                if ($[26] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleSheetIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleSheetIconMedium, {
                        label: ""
                    });
                    $[26] = size;
                    $[27] = t2;
                } else t2 = $[27];
                return t2;
            }
        case "gslide":
            {
                let t2;
                if ($[28] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleSlideIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleSlideIconMedium, {
                        label: ""
                    });
                    $[28] = size;
                    $[29] = t2;
                } else t2 = $[29];
                return t2;
            }
        default:
            {
                let t2;
                if ($[30] !== size) {
                    t2 = size === "small" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIcon, {
                        label: ""
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIconMedium, {
                        label: ""
                    });
                    $[30] = size;
                    $[31] = t2;
                } else t2 = $[31];
                return t2;
            }
    }
} : ({ fileName: fileName, size: size = 'small' })=>{
    const fileExtension = fileName.split('.').pop();
    if (!fileExtension) return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIcon, {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIconMedium, {
        label: ""
    });
    switch(fileExtension.toLowerCase()){
        // TXT Files
        case 'txt':
        case 'md':
        case 'log':
        case 'json':
        case 'yaml':
        case 'yml':
        case 'xml':
        case 'rtf':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$DocumentIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$DocumentIconMedium, {
                label: ""
            });
        // Plain Spreadsheets
        case 'csv':
        case 'tsv':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SpreadsheetIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SpreadsheetIconMedium, {
                label: ""
            });
        // Word Documents
        case 'doc':
        case 'docx':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$WordDocumentIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$WordDocumentIconMedium, {
                label: ""
            });
        // PDF Files
        case 'pdf':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$PDFIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$PDFIconMedium, {
                label: ""
            });
        // PowerPoint Presentations
        case 'ppt':
        case 'pptx':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$PowerpointIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$PowerpointIconMedium, {
                label: ""
            });
        // Excel Spreadsheets
        case 'xls':
        case 'xlsx':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ExcelIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ExcelIconMedium, {
                label: ""
            });
        // Images
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ImageIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ImageIconMedium, {
                label: ""
            });
        // Audio
        case 'mp3':
        case 'wav':
        case 'flac':
        case 'ogg':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$AudioIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$AudioIconMedium, {
                label: ""
            });
        // Videos
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'mkv':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$VideoIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$VideoIconMedium, {
                label: ""
            });
        case 'zip':
        case 'rar':
        case '7z':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ArchiveIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$ArchiveIconMedium, {
                label: ""
            });
        // Source Code
        case 'css':
        case 'html':
        case 'htm':
        case 'c':
        case 'cpp':
        case 'cs':
        case 'java':
        case 'js':
        case 'jsx':
        case 'vue':
        case 'svelte':
        case 'as':
        case 'sh':
        case 'bash':
        case 'bats':
        case 'h':
        case 'cc':
        case 'cxx':
        case 'hpp':
        case 'hxx':
        case 'coffee':
        case 'litcoffee':
        case 'clj':
        case 'cljs':
        case 'cljc':
        case 'edn':
        case 'dockerfile':
        case 'dockerignore':
        case 'erl':
        case 'hrl':
        case 'f':
        case 'for':
        case 'f90':
        case 'f95':
        case 'f03':
        case 'f08':
        case 'go':
        case 'kt':
        case 'kts':
        case 'tex':
        case 'sty':
        case 'cls':
        case 'less':
        case 'makefile':
        case 'mak':
        case 'mk':
        case 'm':
        case 'mat':
        case 'mm':
        case 'pas':
        case 'pp':
        case 'p':
        case 'pl':
        case 'pm':
        case 't':
        case 'pod':
        case 'php':
        case 'php3':
        case 'php4':
        case 'php5':
        case 'phtml':
        case 'py':
        case 'pyw':
        case 'pyc':
        case 'pyo':
        case 'pyd':
        case 'r':
        case 'rb':
        case 'erb':
        case 'rake':
        case 'gemspec':
        case 'rs':
        case 'rslib':
        case 'sas':
        case 'sas7bdat':
        case 'scss':
        case 'sass':
        case 'scala':
        case 'sc':
        case 'sbt':
        case 'st':
        case 'sm':
        case 'sql':
        case 'swift':
        case 'tcl':
        case 'itcl':
        case 'ts':
        case 'tsx':
        case 'v':
        case 'vh':
        case 'vhd':
        case 'vhdl':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SourceCodeIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$SourceCodeIconMedium, {
                label: ""
            });
        case 'gdoc':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleDocIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleDocIconMedium, {
                label: ""
            });
        case 'gsheet':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleSheetIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleSheetIconMedium, {
                label: ""
            });
        case 'gslide':
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleSlideIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GoogleSlideIconMedium, {
                label: ""
            });
        default:
            return size === 'small' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIcon, {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e029af2285a57aa1$var$GenericIconMedium, {
                label: ""
            });
    }
};



var $lKwLK = parcelRequire("lKwLK");


var $hKlzx = parcelRequire("hKlzx");


var $bbi2x = parcelRequire("bbi2x");














var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");




var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");










const $93de92ebe7b35710$var$message = (0, $kSwu1.defineMessages)({
    previewNotAvailable: {
        id: "ai-mate.file-preview-modal.preview-not-available",
        defaultMessage: "Preview not available for this file type"
    }
});
var $93de92ebe7b35710$export$2e2bcd8739ae039 = $93de92ebe7b35710$var$message;


const $0e98ebe0c45ff38a$var$styles = {
    imagePreview: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlN91d _0NUa3rhLcO _00EA0egIor _3iDTPbvLZJ",
    pdfPreview: "_30huDKYbGa _39xV02N91d _0jFU0VhLcO _3iDTPbvLZJ",
    loadingContainer: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _4kiQYAHakr",
    textPreview: "_4bt5LAIZbP _2WAcuGIZbP _0bjKvDKxmn _2sNsIgNxAV _0NUa3rhLcO _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXruDMqu _1ANEUSlpBW _3W2Oc8wPeg"
}; /**
    * Determines file type category from MIME type or file name
    */ 
const $0e98ebe0c45ff38a$var$getFileType = (file)=>{
    if (file.type.startsWith('image/')) return 'image';
    if (file.type === 'application/pdf') return 'pdf';
    if ((0, $hKlzx.isTextFile)(file.type, file.name)) return 'text';
    return 'unknown';
}; /**
    * Modal component for previewing images, PDFs, and text files.
    */ 
const $0e98ebe0c45ff38a$export$7e11cd3da4852b36 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { isOpen: isOpen, onClose: onClose, fileName: fileName, fileObject: fileObject, previewBlobUrl: previewBlobUrl, textContent: textContent, isLoadingText: isLoadingText } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== fileObject || $[1] !== previewBlobUrl) {
        t1 = fileObject ? $0e98ebe0c45ff38a$var$getFileType(fileObject) : previewBlobUrl ? "image" : "unknown";
        $[0] = fileObject;
        $[1] = previewBlobUrl;
        $[2] = t1;
    } else t1 = $[2];
    const fileType = t1;
    const [pdfBlobUrl, setPdfBlobUrl] = (0, $cozmU.useState)(null);
    let t2;
    let t3;
    if ($[3] !== fileObject || $[4] !== fileType) {
        t2 = ()=>{
            if (fileType === "pdf" && fileObject) try {
                const blobUrl = URL.createObjectURL(fileObject);
                setPdfBlobUrl(blobUrl);
            } catch (t4) {
                const error = t4;
                (0, $hlvTd.logException)({
                    exception: error,
                    name: "pdf-blob-url-creation-error",
                    tags: {
                        fileType: fileObject.type
                    }
                });
                setPdfBlobUrl(null);
            }
            else setPdfBlobUrl(null);
        };
        t3 = [
            fileType,
            fileObject
        ];
        $[3] = fileObject;
        $[4] = fileType;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[7] !== pdfBlobUrl) {
        t4 = ()=>()=>{
                if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);
            };
        t5 = [
            pdfBlobUrl
        ];
        $[7] = pdfBlobUrl;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[10] !== fileName || $[11] !== fileType || $[12] !== formatMessage || $[13] !== isLoadingText || $[14] !== pdfBlobUrl || $[15] !== previewBlobUrl || $[16] !== textContent) {
        t6 = ()=>{
            if (fileType === "image" && previewBlobUrl) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                as: "img",
                src: previewBlobUrl,
                alt: fileName,
                xcss: $0e98ebe0c45ff38a$var$styles.imagePreview
            });
            if (fileType === "pdf" && pdfBlobUrl) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                as: "object",
                type: "application/pdf",
                data: `${pdfBlobUrl}#toolbar=1`,
                title: fileName,
                xcss: $0e98ebe0c45ff38a$var$styles.pdfPreview
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                as: "embed",
                type: "application/pdf",
                src: `${pdfBlobUrl}#toolbar=1`,
                xcss: $0e98ebe0c45ff38a$var$styles.pdfPreview
            }));
            if (fileType === "text") {
                if (isLoadingText) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $0e98ebe0c45ff38a$var$styles.loadingContainer
                }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                    size: "large"
                }));
                return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $0e98ebe0c45ff38a$var$styles.textPreview
                }, textContent);
            }
            return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $0e98ebe0c45ff38a$var$styles.loadingContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $93de92ebe7b35710$export$2e2bcd8739ae039).previewNotAvailable)));
        };
        $[10] = fileName;
        $[11] = fileType;
        $[12] = formatMessage;
        $[13] = isLoadingText;
        $[14] = pdfBlobUrl;
        $[15] = previewBlobUrl;
        $[16] = textContent;
        $[17] = t6;
    } else t6 = $[17];
    const renderPreview = t6;
    let t7;
    if ($[18] !== fileName || $[19] !== isOpen || $[20] !== onClose || $[21] !== renderPreview) {
        t7 = isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
            onClose: onClose,
            width: "x-large",
            shouldScrollInViewport: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, fileName)), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), {
            hasInlinePadding: false
        }, renderPreview()));
        $[18] = fileName;
        $[19] = isOpen;
        $[20] = onClose;
        $[21] = renderPreview;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, t7);
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ isOpen: isOpen, onClose: onClose, fileName: fileName, fileObject: fileObject, previewBlobUrl: previewBlobUrl, textContent: textContent, isLoadingText: isLoadingText })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const fileType = fileObject ? $0e98ebe0c45ff38a$var$getFileType(fileObject) : previewBlobUrl ? 'image' : 'unknown';
    const [pdfBlobUrl, setPdfBlobUrl] = (0, $cozmU.useState)(null); // Create PDF blob URL and track errors
    (0, $cozmU.useEffect)(()=>{
        if (fileType === 'pdf' && fileObject) try {
            const blobUrl = URL.createObjectURL(fileObject);
            setPdfBlobUrl(blobUrl);
        } catch (error) {
            // Log error to Sentry for monitoring
            (0, $hlvTd.logException)({
                exception: error,
                name: 'pdf-blob-url-creation-error',
                tags: {
                    fileType: fileObject.type
                }
            }); // User will see "Preview not available" message
            setPdfBlobUrl(null);
        }
        else setPdfBlobUrl(null);
    }, [
        fileType,
        fileObject
    ]); // Cleanup PDF blob URL on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);
        };
    }, [
        pdfBlobUrl
    ]);
    const renderPreview = ()=>{
        if (fileType === 'image' && previewBlobUrl) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "img",
            src: previewBlobUrl,
            alt: fileName,
            xcss: $0e98ebe0c45ff38a$var$styles.imagePreview
        });
        if (fileType === 'pdf' && pdfBlobUrl) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "object",
            type: "application/pdf",
            data: `${pdfBlobUrl}#toolbar=1`,
            title: fileName,
            xcss: $0e98ebe0c45ff38a$var$styles.pdfPreview
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "embed",
            type: "application/pdf",
            src: `${pdfBlobUrl}#toolbar=1`,
            xcss: $0e98ebe0c45ff38a$var$styles.pdfPreview
        }));
        if (fileType === 'text') {
            if (isLoadingText) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $0e98ebe0c45ff38a$var$styles.loadingContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
                size: "large"
            }));
            return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $0e98ebe0c45ff38a$var$styles.textPreview
            }, textContent);
        }
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $0e98ebe0c45ff38a$var$styles.loadingContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $93de92ebe7b35710$export$2e2bcd8739ae039).previewNotAvailable)));
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "x-large",
        shouldScrollInViewport: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, fileName)), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), {
        hasInlinePadding: false
    }, renderPreview())));
};





const $c90b4384dffd4f04$var$message = (0, $kSwu1.defineMessages)({
    removeFileLabel: {
        id: "ai-mate.chat-input.remove-file-label",
        defaultMessage: "Remove file {fileName}"
    },
    fileErrorIconLabel: {
        id: "ai-mate.chat-input.file-error-icon-label",
        defaultMessage: "Error loading file"
    },
    textLoadFailed: {
        id: "ai-mate.chat-input.text-load-failed",
        defaultMessage: "Failed to load file content"
    },
    textFileTooLarge: {
        id: "ai-mate.chat-input.text-file-too-large",
        defaultMessage: "This file is too large to preview ({sizeMB}MB)."
    }
});
var $c90b4384dffd4f04$export$2e2bcd8739ae039 = $c90b4384dffd4f04$var$message;


const $45d2e19bcf081ef7$var$MAX_TEXT_SIZE = 2097152;
const $45d2e19bcf081ef7$var$styles = {
    fileCardBgWrapper: "_0bjKvDKxmn _0KLXruqi9L _3iDTPbQ4SZ"
};
const $45d2e19bcf081ef7$var$FileCardBgWrappper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $45d2e19bcf081ef7$var$styles.fileCardBgWrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $45d2e19bcf081ef7$var$styles.fileCardBgWrapper
    }, children);
};
const $45d2e19bcf081ef7$var$getFileNameAndExtension = (fileName)=>{
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === 0) return {
        name: fileName,
        extension: ''
    };
    return {
        name: fileName.slice(0, lastDotIndex),
        extension: fileName.slice(lastDotIndex + 1)
    };
};
const $45d2e19bcf081ef7$export$593fd10f7e6c6505 = ({ fileName: fileName, onRemove: onRemove, isLoading: isLoading, error: error, autoScroll: autoScroll, previewBlobUrl: previewBlobUrl, isPreviewLoading: isPreviewLoading, fileObject: fileObject })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { name: fileNameWithoutExtension, extension: extension } = $45d2e19bcf081ef7$var$getFileNameAndExtension(fileName);
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [textContent, setTextContent] = (0, $cozmU.useState)(null);
    const [isLoadingText, setIsLoadingText] = (0, $cozmU.useState)(false);
    const handleCardClick = (0, $cozmU.useCallback)(()=>{
        if (!fileObject) return;
        if ((0, $hKlzx.isTextFile)(fileObject.type, fileObject.name)) {
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'preview',
                actionSubjectId: 'filePreview',
                attributes: {
                    fileType: fileObject.type,
                    fileSize: fileObject.size
                }
            });
            setIsLoadingText(true);
            setIsModalOpen(true); // Performance safeguard: Limit text file preview to 2MB
            if (fileObject.size > $45d2e19bcf081ef7$var$MAX_TEXT_SIZE) {
                const sizeMB = (fileObject.size / 1048576).toFixed(1);
                setTextContent(formatMessage((0, $c90b4384dffd4f04$export$2e2bcd8739ae039).textFileTooLarge, {
                    sizeMB: sizeMB
                }));
                setIsLoadingText(false);
                return;
            }
            fileObject.text().then((content)=>{
                setTextContent(content);
                setIsLoadingText(false);
            }).catch((error_0)=>{
                (0, $hlvTd.logException)({
                    exception: error_0,
                    name: 'text-file-content-load-error',
                    tags: {
                        fileType: fileObject.type
                    }
                });
                const errorMessage = error_0 instanceof Error ? error_0.message : formatMessage((0, $c90b4384dffd4f04$export$2e2bcd8739ae039).textLoadFailed);
                setTextContent(errorMessage);
                setIsLoadingText(false);
            });
        } else if ((0, $bbi2x.looksLikeImage)(fileObject) || fileObject.type === 'application/pdf') {
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'preview',
                actionSubjectId: 'filePreview',
                attributes: {
                    fileType: fileObject.type,
                    fileSize: fileObject.size
                }
            });
            setIsModalOpen(true);
        }
    }, [
        fileObject,
        formatMessage,
        sendAnalyticsEvent
    ]);
    const isPreviewableType = fileObject && ((0, $bbi2x.looksLikeImage)(fileObject) || fileObject.type === 'application/pdf' || (0, $hKlzx.isTextFile)(fileObject.type, fileObject.name));
    const canOpenPreview = isPreviewableType && !isLoading && !isPreviewLoading && !error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lKwLK.PreviewCard), {
        autoScroll: autoScroll,
        label: fileNameWithoutExtension,
        subLabel: extension?.toUpperCase(),
        isLoading: isLoading || isPreviewLoading,
        error: error,
        onRemove: onRemove,
        imageSrc: previewBlobUrl,
        onClick: canOpenPreview ? handleCardClick : undefined,
        cardIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45d2e19bcf081ef7$var$FileCardBgWrappper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e029af2285a57aa1$export$8c1a3d13e85d78b7), {
            fileName: fileName,
            size: "medium"
        })),
        subLabelIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e029af2285a57aa1$export$a697c9ed370839d5), {
            size: "small",
            fileName: fileName,
            color: "var(--ds-icon-subtle, #505258)"
        }),
        errorLabel: formatMessage((0, $c90b4384dffd4f04$export$2e2bcd8739ae039).fileErrorIconLabel),
        removeLabel: formatMessage((0, $c90b4384dffd4f04$export$2e2bcd8739ae039).removeFileLabel, {
            fileName: fileName
        })
    }), canOpenPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e98ebe0c45ff38a$export$7e11cd3da4852b36), {
        isOpen: isModalOpen,
        onClose: ()=>setIsModalOpen(false),
        fileName: fileName,
        fileObject: fileObject,
        previewBlobUrl: previewBlobUrl,
        textContent: textContent,
        isLoadingText: isLoadingText
    }));
};
module.exports["FileCard"] = $45d2e19bcf081ef7$export$593fd10f7e6c6505;

});

parcelRegister("infyS", function(module, exports) {

let $d606722c1dde4e4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d606722c1dde4e4e$var$load("5JWJI").then(()=>parcelRequire('9TA3F'));

});

parcelRegister("kOTUl", function(module, exports) {

let $f283d84cd9896afc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f283d84cd9896afc$var$load("cL682").then(()=>parcelRequire('gCdaE'));

});

parcelRegister("dwg3B", function(module, exports) {

let $9d7ab82564ecab94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d7ab82564ecab94$var$load("kHMR7").then(()=>parcelRequire('dj32l'));

});

parcelRegister("7oGQO", function(module, exports) {

let $562c0391ce984de1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $562c0391ce984de1$var$load("3i44s").then(()=>parcelRequire('67SYT'));

});

parcelRegister("5DIZd", function(module, exports) {

let $41b37d9b9af4b54f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41b37d9b9af4b54f$var$load("3MJxZ").then(()=>parcelRequire('cAa12'));

});

parcelRegister("h2ScA", function(module, exports) {

let $c68caaf277d94ac1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c68caaf277d94ac1$var$load("b4nm1").then(()=>parcelRequire('l8FBD'));

});

parcelRegister("22LPp", function(module, exports) {

let $17d0de54722123d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17d0de54722123d7$var$load("kYkz1").then(()=>parcelRequire('lhYzt'));

});

parcelRegister("4UzML", function(module, exports) {

let $393826a85003934f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $393826a85003934f$var$load("5kI0b").then(()=>parcelRequire('3Ll8s'));

});

parcelRegister("8aA0W", function(module, exports) {

let $5f2b318f37a690f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f2b318f37a690f1$var$load("4MePG").then(()=>parcelRequire('4C7IM'));

});

parcelRegister("iBf9z", function(module, exports) {

let $d8a76fd6b50df6a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8a76fd6b50df6a9$var$load("aaRXj").then(()=>parcelRequire('90EXt'));

});

parcelRegister("8e6lY", function(module, exports) {

let $5fd48f2b4743c564$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5fd48f2b4743c564$var$load("4QwAJ").then(()=>parcelRequire('6lknI'));

});

parcelRegister("3xX9K", function(module, exports) {

let $29525756830af50f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $29525756830af50f$var$load("jOE2W").then(()=>parcelRequire('42Fpa'));

});

parcelRegister("3LVo6", function(module, exports) {

let $2bf246e3056cb1ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2bf246e3056cb1ab$var$load("jTOhL").then(()=>parcelRequire('jZpwZ'));

});

parcelRegister("asjsV", function(module, exports) {

let $79cb9e59e1914653$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79cb9e59e1914653$var$load("e3OZZ").then(()=>parcelRequire('5Dz6O'));

});

parcelRegister("60b70", function(module, exports) {

let $45eb5cc32d998b84$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45eb5cc32d998b84$var$load("fHlIz").then(()=>parcelRequire('fGSwx'));

});

parcelRegister("8KvsV", function(module, exports) {

let $65eb06ff5571b2cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65eb06ff5571b2cc$var$load("5JWJI").then(()=>parcelRequire('iqehY'));

});

parcelRegister("l3lyT", function(module, exports) {

let $f53a9a837a6444f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f53a9a837a6444f6$var$load("gkVge").then(()=>parcelRequire('9Jnyo'));

});

parcelRegister("6IDM1", function(module, exports) {

let $4e45b45a9383b68b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e45b45a9383b68b$var$load("4Ldt2").then(()=>parcelRequire('5m8Xe'));

});

parcelRegister("5eRas", function(module, exports) {

let $3d078090de5174e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d078090de5174e1$var$load("3i44s").then(()=>parcelRequire('1kVaD'));

});

parcelRegister("dzvRA", function(module, exports) {

let $9e1742a55a9a4ca5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e1742a55a9a4ca5$var$load("cuNBo").then(()=>parcelRequire('5t27u'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("hRf5f", function(module, exports) {

let $d003163621691050$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d003163621691050$var$load("io0qR").then(()=>parcelRequire('1rDre'));

});

parcelRegister("eiZGU", function(module, exports) {

let $a6a299b1e4e47c5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6a299b1e4e47c5f$var$load("aaRXj").then(()=>parcelRequire('8B1YK'));

});

parcelRegister("bmQsw", function(module, exports) {

let $846a710eb4b35adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846a710eb4b35adb$var$load("4QwAJ").then(()=>parcelRequire('aeJll'));

});

parcelRegister("4hbMv", function(module, exports) {

let $31d1e382aa7c0fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $31d1e382aa7c0fed$var$load("90ymC").then(()=>parcelRequire('fxeqy'));

});

parcelRegister("ljzu0", function(module, exports) {

let $f846e583886c582d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f846e583886c582d$var$load("eLSJT").then(()=>parcelRequire('cKhlU'));

});

parcelRegister("b2vUF", function(module, exports) {

let $8098a2d7ed957ac6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8098a2d7ed957ac6$var$load("2XRLb").then(()=>parcelRequire('eziPO'));

});

parcelRegister("3tCrI", function(module, exports) {

let $2881e71a7d44971f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2881e71a7d44971f$var$load("fHlIz").then(()=>parcelRequire('8If3N'));

});

parcelRegister("54t3f", function(module, exports) {

let $3b13dc73fcd61482$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b13dc73fcd61482$var$load("gkVge").then(()=>parcelRequire('kmvdJ'));

});

parcelRegister("kvgPS", function(module, exports) {

let $eed3c3248b7efaa7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eed3c3248b7efaa7$var$load("l3CW5").then(()=>parcelRequire('7ZWGl'));

});

parcelRegister("aW7DE", function(module, exports) {

var $60Uyi = parcelRequire("60Uyi");


var $8lhhf = parcelRequire("8lhhf");

const $1d13d788f14bb2e1$export$d1baf60959ac76d8 = (doc)=>{
    let actualTextContent = '';
    doc.descendants((node)=>{
        if (node.isText) actualTextContent = actualTextContent + node.text;
        else if (node.type.name === 'mention') {
            let mentionText = node.attrs.text || "@\u2026";
            actualTextContent = actualTextContent + mentionText;
        } else if (node.type.name === 'inlineCard') {
            const url = node.attrs.url || '';
            actualTextContent = actualTextContent + url;
        } else if (node.type.name === 'inlineExtension' && node.attrs.extensionType === (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE)) {
            const skillSlug = node.attrs.parameters?.slug || '';
            actualTextContent = actualTextContent + skillSlug;
        } else if (node.type.name === (0, $60Uyi.CONNECTOR_SOURCE_CHIP_NODE_NAME)) {
            const display = node.attrs.display ?? '';
            actualTextContent = actualTextContent + display;
        }
        // For other node types, continue traversing but don't count them
        return true;
    });
    return actualTextContent;
};
module.exports["getActualTextContent"] = $1d13d788f14bb2e1$export$d1baf60959ac76d8;

});

parcelRegister("eSr5w", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $hlvTd = parcelRequire("hlvTd");


var $gzMZq = parcelRequire("gzMZq");





var $as9lu = parcelRequire("as9lu");


var $kTGj5 = parcelRequire("kTGj5");




/**
 * Constants for auto-apply functionality
 */ const $5888d8a7eec82daf$export$3317b9c0d88ecd38 = 'ai-mate-auto-apply-enabled';
const $5888d8a7eec82daf$export$e46d7815fa70b734 = 'enable_auto_apply_toggling';


/**
 * @generated SignedSource<<44740e0f599cf23fde7ac25cf45f343d>>
 * @relayHash de75149bd6de46cf773dd86b1156f83a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ebe912401833398260e3dd424a76d9025c2d0e3981e3849b1cfa056f97e79e8b
const $e35c070ede736996$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SettingsCreationSettings",
            "kind": "LinkedField",
            "name": "settings_updateCreationSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "autoApply"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "creationSettingsMutationMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "creationSettingsMutationMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "ebe912401833398260e3dd424a76d9025c2d0e3981e3849b1cfa056f97e79e8b",
            "metadata": {},
            "name": "creationSettingsMutationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e35c070ede736996$var$node.hash = "2764b2132df7149a218d7fe86758b452";
var $e35c070ede736996$export$2e2bcd8739ae039 = $e35c070ede736996$var$node;


/**
 * @generated SignedSource<<db4dd10a4e100afc581c7518b1f1eaff>>
 * @relayHash 2da18ddcf067ae3b3f655513eb48acac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 956e6f209e8636ab81a23303d07e8588229617e5b9b8b1456e7b0510e082a8f0
const $05eec30e44405e1f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                }
            ],
            "concreteType": "SettingsCreationSettings",
            "kind": "LinkedField",
            "name": "settings_creationSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "autoApply"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "creationSettingsQueryQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "creationSettingsQueryQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "956e6f209e8636ab81a23303d07e8588229617e5b9b8b1456e7b0510e082a8f0",
            "metadata": {},
            "name": "creationSettingsQueryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$05eec30e44405e1f$var$node.hash = "d5e237e68920e0355d028a1df4e44e10";
var $05eec30e44405e1f$export$2e2bcd8739ae039 = $05eec30e44405e1f$var$node;


/**
 * Convert cloudId to tenantId ARI format
 */ function $e5ad8189a57b11c1$var$tenantIdToAri(cloudId) {
    return (0, $kTGj5.PlatformSiteAri).create({
        siteId: cloudId
    }).toString();
}
/**
 * Convert userId to ownerAri format
 */ function $e5ad8189a57b11c1$var$userIdToAri(userId) {
    return (0, $as9lu.IdentityUserAri).create({
        userId: userId
    }).toString();
}
function $e5ad8189a57b11c1$export$cbd1b24c4f50480f() {
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const stored = window.localStorage.getItem((0, $5888d8a7eec82daf$export$3317b9c0d88ecd38));
        return stored !== null ? JSON.parse(stored) : true;
    } catch  {
        return true; // fallback to default
    }
}
function $e5ad8189a57b11c1$export$dedcc43382a0a2d(enabled) {
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.setItem((0, $5888d8a7eec82daf$export$3317b9c0d88ecd38), JSON.stringify(enabled));
        window.dispatchEvent(new CustomEvent('autoApplyChanged'));
    } catch  {
    // Silently fail if localStorage is unavailable
    }
}
function $e5ad8189a57b11c1$export$490b52318e47ac6c(environment, tenantId, ownerAri) {
    const variables = {
        tenantId: tenantId,
        ownerAri: ownerAri
    };
    (0, $hlvTd.addSentryBreadcrumb)(`getAutoApplyStateFromBackend: fetching for tenant=${tenantId}`);
    return (0, $6SsN4.fetchQuery)(environment, (0, $05eec30e44405e1f$export$2e2bcd8739ae039), variables).toPromise().then((response)=>{
        // Reject if no response
        if (!response) {
            (0, $hlvTd.addSentryBreadcrumb)('getAutoApplyStateFromBackend: no response received');
            throw new Error('Failed to fetch creation settings: No response');
        }
        // Return the autoApply value from backend, default to true if not found
        const autoApply = response?.settings_creationSettings?.autoApply ?? true;
        (0, $hlvTd.addSentryBreadcrumb)(`getAutoApplyStateFromBackend: received autoApply=${autoApply}`);
        return autoApply;
    });
}
function $e5ad8189a57b11c1$export$2c52b5b9e34ef0b0(environment, tenantId, ownerAri, autoApply) {
    const input = {
        tenantId: tenantId,
        ownerAri: ownerAri,
        autoApply: autoApply
    };
    (0, $hlvTd.addSentryBreadcrumb)(`setAutoApplyStateToBackend: setting autoApply=${autoApply} for tenant=${tenantId}`);
    return new Promise((resolve, reject)=>{
        (0, $6SsN4.commitMutation)(environment, {
            mutation: (0, $e35c070ede736996$export$2e2bcd8739ae039),
            variables: {
                input: input
            },
            onCompleted: (response, errors)=>{
                const payload = response.settings_updateCreationSettings;
                if (errors || !payload) {
                    (0, $hlvTd.addSentryBreadcrumb)(`setAutoApplyStateToBackend: mutation failed with errors`);
                    reject(errors || 'Failed to update creation settings');
                } else {
                    (0, $hlvTd.addSentryBreadcrumb)(`setAutoApplyStateToBackend: mutation succeeded, autoApply=${autoApply}`);
                    // Also update localStorage as cache/fallback
                    $e5ad8189a57b11c1$export$dedcc43382a0a2d(autoApply);
                    resolve(autoApply);
                }
            },
            onError: (error)=>{
                (0, $hlvTd.addSentryBreadcrumb)(`setAutoApplyStateToBackend: mutation error - ${error?.message || 'unknown'}`);
                // Reject so caller can handle the failure
                reject(error);
            }
        });
    });
}
function $e5ad8189a57b11c1$export$ff4d41d780f8bf44() {
    const currentState = $e5ad8189a57b11c1$export$cbd1b24c4f50480f();
    const newState = !currentState;
    $e5ad8189a57b11c1$export$dedcc43382a0a2d(newState);
    return newState;
}
async function $e5ad8189a57b11c1$export$5b78d0cd3e8869ab(environment, sessionData) {
    (0, $hlvTd.addSentryBreadcrumb)('toggleAutoApplyStateWithSession: toggling state');
    const currentState = await $e5ad8189a57b11c1$export$de3027235ba834ab(environment, sessionData);
    const newState = !currentState;
    (0, $hlvTd.addSentryBreadcrumb)(`toggleAutoApplyStateWithSession: ${currentState} -> ${newState}`);
    // Update both backend and localStorage
    await $e5ad8189a57b11c1$export$284464f4da8ebd9(environment, sessionData, newState);
    return newState;
}
async function $e5ad8189a57b11c1$export$32ad7f49a3b9fcd9(environment, tenantId, ownerAri) {
    (0, $hlvTd.addSentryBreadcrumb)('toggleAutoApplyStateToBackend: toggling state');
    const currentState = await $e5ad8189a57b11c1$export$490b52318e47ac6c(environment, tenantId, ownerAri);
    const newState = !currentState;
    (0, $hlvTd.addSentryBreadcrumb)(`toggleAutoApplyStateToBackend: ${currentState} -> ${newState}`);
    // Update both backend and localStorage
    await $e5ad8189a57b11c1$export$2c52b5b9e34ef0b0(environment, tenantId, ownerAri, newState);
    return newState;
}
async function $e5ad8189a57b11c1$export$de3027235ba834ab(environment, sessionData) {
    if (!sessionData.userId) {
        // Fallback to localStorage for anonymous users
        (0, $hlvTd.addSentryBreadcrumb)('getAutoApplyStateWithSession: no userId, falling back to localStorage');
        return $e5ad8189a57b11c1$export$cbd1b24c4f50480f();
    }
    const tenantId = $e5ad8189a57b11c1$var$tenantIdToAri(sessionData.cloudId);
    const ownerAri = $e5ad8189a57b11c1$var$userIdToAri(sessionData.userId);
    (0, $hlvTd.addSentryBreadcrumb)(`getAutoApplyStateWithSession: fetching for cloudId=${sessionData.cloudId}`);
    return $e5ad8189a57b11c1$export$490b52318e47ac6c(environment, tenantId, ownerAri);
}
async function $e5ad8189a57b11c1$export$284464f4da8ebd9(environment, sessionData, autoApply) {
    if (!sessionData.userId) {
        // Fallback to localStorage for anonymous users
        (0, $hlvTd.addSentryBreadcrumb)(`setAutoApplyStateWithSession: no userId, using localStorage, autoApply=${autoApply}`);
        $e5ad8189a57b11c1$export$dedcc43382a0a2d(autoApply);
        return autoApply;
    }
    const tenantId = $e5ad8189a57b11c1$var$tenantIdToAri(sessionData.cloudId);
    const ownerAri = $e5ad8189a57b11c1$var$userIdToAri(sessionData.userId);
    (0, $hlvTd.addSentryBreadcrumb)(`setAutoApplyStateWithSession: setting autoApply=${autoApply} for cloudId=${sessionData.cloudId}`);
    return $e5ad8189a57b11c1$export$2c52b5b9e34ef0b0(environment, tenantId, ownerAri, autoApply);
}
function $e5ad8189a57b11c1$export$308de05ffc91835d(environment, tenantId, ownerAri, setState) {
    return async ()=>{
        const enabled = await $e5ad8189a57b11c1$export$490b52318e47ac6c(environment, tenantId, ownerAri);
        setState(enabled);
    };
}


// ============================================================================
// Helpers
// ============================================================================
/**
 * Safely gets the Relay environment without throwing if no provider is available.
 * This allows the hook to work in test environments or contexts without RelayEnvironmentProvider.
 */ const $0c4a9485a3c36363$var$useSafeRelayEnvironment = ()=>{
    try {
        return (0, $6SsN4.useRelayEnvironment)();
    } catch  {
        // No RelayEnvironmentProvider available, return null
        // The hook will fall back to localStorage-only mode
        return null;
    }
};
const $0c4a9485a3c36363$export$e7148f1ad1bea80c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (contentContext, useCurrentPageContext, isConversationAgentic, productKey)=>{
    const $ = (0, $bDgLe.c)(8);
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            type: "unavailable",
            reason: "no_editor_context"
        };
        $[0] = t0;
    } else t0 = $[0];
    let autoApplyAvailability = t0;
    if (isConversationAgentic) {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = {
                type: "unavailable",
                reason: "agentic_conversation"
            };
            $[1] = t1;
        } else t1 = $[1];
        autoApplyAvailability = t1;
    } else {
        if (contentContext === "staging-area") {
            let t1;
            if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = {
                    type: "available"
                };
                $[2] = t1;
            } else t1 = $[2];
            autoApplyAvailability = t1;
        } else if (!useCurrentPageContext) {
            let t1;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = {
                    type: "unavailable",
                    reason: "no_page_context"
                };
                $[3] = t1;
            } else t1 = $[3];
            autoApplyAvailability = t1;
        } else {
            if (contentContext === "global" && productKey === "jira") {
                let t1;
                if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = {
                        type: "available"
                    };
                    $[4] = t1;
                } else t1 = $[4];
                autoApplyAvailability = t1;
            } else if (contentContext === "global" && Boolean(editorContext)) {
                let t1;
                if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                    t1 = {
                        type: "available"
                    };
                    $[5] = t1;
                } else t1 = $[5];
                autoApplyAvailability = t1;
            }
        }
    }
    let t1;
    if ($[6] !== autoApplyAvailability) {
        t1 = {
            autoApplyAvailability: autoApplyAvailability
        };
        $[6] = autoApplyAvailability;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : (contentContext, useCurrentPageContext, isConversationAgentic, productKey)=>{
    // Get editor context to determine if there's an active editor to stream to
    const [editorContext] = (0, $gzMZq.useChatContextEditorContext)();
    let autoApplyAvailability = {
        type: 'unavailable',
        reason: 'no_editor_context'
    };
    // Agentic conversations handle their own application
    if (isConversationAgentic) autoApplyAvailability = {
        type: 'unavailable',
        reason: 'agentic_conversation'
    };
    else if (contentContext === 'staging-area') autoApplyAvailability = {
        type: 'available'
    };
    else if (!useCurrentPageContext) autoApplyAvailability = {
        type: 'unavailable',
        reason: 'no_page_context'
    };
    else if (contentContext === 'global' && productKey === 'jira') autoApplyAvailability = {
        type: 'available'
    };
    else if (contentContext === 'global' && Boolean(editorContext)) autoApplyAvailability = {
        type: 'available'
    };
    return {
        autoApplyAvailability: autoApplyAvailability
    };
};
const $0c4a9485a3c36363$export$97bf7cbb478ab6de = (sessionData, _contentContext, _useCurrentPageContext, _isConversationAgentic)=>{
    const environment = $0c4a9485a3c36363$var$useSafeRelayEnvironment();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const [enabled, setEnabledState] = (0, $cozmU.useState)(()=>(0, $e5ad8189a57b11c1$export$cbd1b24c4f50480f)());
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    // Cache the current state to avoid unnecessary re-renders
    const stateRef = (0, $cozmU.useRef)(enabled);
    stateRef.current = enabled;
    // Determine if we should make backend calls (need environment + session + feature gate)
    const shouldUseBackend = environment && sessionData && sessionData.userId && (0, $iDrrr.fg)('enable_auto_apply_toggling');
    // Determine if we should use localStorage fallback
    const shouldUseLocalStorage = (!sessionData || !sessionData.userId || !environment) && (0, $iDrrr.fg)('enable_auto_apply_toggling');
    // If feature gate is off, don't provide any auto-apply functionality
    const isFeatureDisabled = !(0, $iDrrr.fg)('enable_auto_apply_toggling');
    // Load state from backend when component mounts or sessionData changes
    const refresh = (0, $cozmU.useCallback)(async ()=>{
        if (isFeatureDisabled) return;
        if (shouldUseBackend) {
            const experienceId = `${(0, $irnO2.ExperienceName).GET_AUTO_APPLY_STATE}-${Date.now()}`;
            (0, $hlvTd.addSentryBreadcrumb)(`useAutoApplyState: fetching state from backend for user ${sessionData.userId}`);
            experienceTracker.start({
                id: experienceId,
                name: (0, $irnO2.ExperienceName).GET_AUTO_APPLY_STATE
            });
            setLoading(true);
            setError(null);
            try {
                const backendState = await (0, $e5ad8189a57b11c1$export$de3027235ba834ab)(environment, sessionData);
                (0, $hlvTd.addSentryBreadcrumb)(`useAutoApplyState: backend returned autoApply=${backendState}`);
                if (backendState !== stateRef.current) setEnabledState(backendState);
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).GET_AUTO_APPLY_STATE
                });
            } catch (err) {
                // Store error and keep current state - don't fall back to localStorage
                const error_0 = err instanceof Error ? err : new Error('Failed to fetch auto-apply state');
                (0, $hlvTd.addSentryBreadcrumb)(`useAutoApplyState: failed to fetch state - ${error_0.message}`);
                setError(error_0);
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).GET_AUTO_APPLY_STATE,
                    error: error_0
                });
            } finally{
                setLoading(false);
            }
        } else if (shouldUseLocalStorage) {
            const localState = (0, $e5ad8189a57b11c1$export$cbd1b24c4f50480f)();
            if (localState !== stateRef.current) setEnabledState(localState);
        }
    }, [
        environment,
        sessionData,
        shouldUseBackend,
        shouldUseLocalStorage,
        isFeatureDisabled,
        experienceTracker
    ]);
    // Set state with backend persistence
    const setEnabled = (0, $cozmU.useCallback)(async (newEnabled)=>{
        if (isFeatureDisabled) return;
        if (newEnabled === stateRef.current) return; // No change needed
        const experienceId_0 = `${(0, $irnO2.ExperienceName).SET_AUTO_APPLY_STATE}-${Date.now()}`;
        setLoading(true);
        setError(null);
        try {
            if (shouldUseBackend) {
                (0, $hlvTd.addSentryBreadcrumb)(`useAutoApplyState: setting state to ${newEnabled} via backend`);
                experienceTracker.start({
                    id: experienceId_0,
                    name: (0, $irnO2.ExperienceName).SET_AUTO_APPLY_STATE
                });
                await (0, $e5ad8189a57b11c1$export$284464f4da8ebd9)(environment, sessionData, newEnabled);
                (0, $hlvTd.addSentryBreadcrumb)(`useAutoApplyState: successfully set autoApply=${newEnabled}`);
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).SET_AUTO_APPLY_STATE,
                    attributes: {
                        autoApplyEnabled: newEnabled
                    }
                });
            } else if (shouldUseLocalStorage) {
                (0, $hlvTd.addSentryBreadcrumb)(`useAutoApplyState: setting state to ${newEnabled} via localStorage`);
                (0, $e5ad8189a57b11c1$export$dedcc43382a0a2d)(newEnabled);
            }
            setEnabledState(newEnabled);
        } catch (err_0) {
            // Store error and keep current state, don't update UI
            const error_1 = err_0 instanceof Error ? err_0 : new Error('Failed to update auto-apply state');
            (0, $hlvTd.addSentryBreadcrumb)(`useAutoApplyState: failed to set state - ${error_1.message}`);
            setError(error_1);
            if (shouldUseBackend) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).SET_AUTO_APPLY_STATE,
                error: error_1,
                attributes: {
                    autoApplyEnabled: newEnabled
                }
            });
            throw error_1; // Re-throw so the component can handle it
        } finally{
            setLoading(false);
        }
    }, [
        environment,
        sessionData,
        shouldUseBackend,
        shouldUseLocalStorage,
        isFeatureDisabled,
        experienceTracker
    ]);
    // Initialize state from backend
    (0, $cozmU.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    return {
        enabled: isFeatureDisabled ? false : enabled,
        // Always disabled when feature gate is off
        loading: isFeatureDisabled ? false : loading,
        // Never loading when disabled
        error: isFeatureDisabled ? null : error,
        setEnabled: // No error when disabled
        setEnabled,
        refresh: refresh
    };
};
module.exports["useAutoApplyAvailability"] = $0c4a9485a3c36363$export$e7148f1ad1bea80c;
module.exports["useAutoApplyState"] = $0c4a9485a3c36363$export$97bf7cbb478ab6de;

});

parcelRegister("a8cFP", function(module, exports) {
/**
 * UFO experience tracking helpers for `@atlaskit/editor-plugin-autocomplete`.
 *
 * Pattern follows `packages/linking-platform/smart-card/src/state/analytics/ufoExperiences.ts`
 * (ConcurrentExperience keyed per request/instance) plus a try/catch safety wrap
 * inspired by `packages/editor/collab-provider/src/analytics/ufo.ts` so a UFO
 * runtime error can never break the autocomplete feature.
 *
 * Experience names must be registered in DataPortal's `task` attribute before
 * they can power FE Reliability SLOs:
 * https://hello.atlassian.net/wiki/spaces/AA6/pages/3961393753
 */ 
var $fh15z = parcelRequire("fh15z");


var $4MiWC = parcelRequire("4MiWC");


var $1P2f3 = parcelRequire("1P2f3");

const $293a52888646e540$export$52919046b94109dc = {
    SLOW_LANE_FETCH: 'slow-lane-fetch',
    LOAD_VOCABULARY: 'load-vocabulary',
    LOAD_VECTORS: 'load-vectors',
    LOAD_PHRASES: 'load-phrases',
    LOAD_GRAMMAR: 'load-grammar'
};
const $293a52888646e540$var$isUfoEnabled = ()=>!$1P2f3?.env?.REACT_SSR;
const $293a52888646e540$var$operationConfig = {
    platform: {
        component: 'editor-plugin-autocomplete'
    },
    type: (0, $4MiWC.ExperienceTypes).Operation,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).Custom,
    performanceConfig: {
        histogram: {
            [(0, $4MiWC.ExperiencePerformanceTypes).Custom]: {
                duration: '50_100_250_500_1000_2000_4000'
            }
        }
    }
};
const $293a52888646e540$var$experiences = {
    [$293a52888646e540$export$52919046b94109dc.SLOW_LANE_FETCH]: new (0, $fh15z.ConcurrentExperience)($293a52888646e540$export$52919046b94109dc.SLOW_LANE_FETCH, $293a52888646e540$var$operationConfig),
    [$293a52888646e540$export$52919046b94109dc.LOAD_VOCABULARY]: new (0, $fh15z.ConcurrentExperience)($293a52888646e540$export$52919046b94109dc.LOAD_VOCABULARY, $293a52888646e540$var$operationConfig),
    [$293a52888646e540$export$52919046b94109dc.LOAD_VECTORS]: new (0, $fh15z.ConcurrentExperience)($293a52888646e540$export$52919046b94109dc.LOAD_VECTORS, $293a52888646e540$var$operationConfig),
    [$293a52888646e540$export$52919046b94109dc.LOAD_PHRASES]: new (0, $fh15z.ConcurrentExperience)($293a52888646e540$export$52919046b94109dc.LOAD_PHRASES, $293a52888646e540$var$operationConfig),
    [$293a52888646e540$export$52919046b94109dc.LOAD_GRAMMAR]: new (0, $fh15z.ConcurrentExperience)($293a52888646e540$export$52919046b94109dc.LOAD_GRAMMAR, $293a52888646e540$var$operationConfig)
};
const $293a52888646e540$export$70d07f1bdffbdb07 = (name, id, metadata)=>{
    if (!$293a52888646e540$var$isUfoEnabled()) return;
    try {
        const instance = $293a52888646e540$var$experiences[name].getInstance(id);
        instance.start();
        if (metadata) instance.addMetadata(metadata);
    } catch  {
    // UFO errors must never break the plugin
    }
};
const $293a52888646e540$export$fccb08519f2b9a7e = (name, id, metadata)=>{
    if (!$293a52888646e540$var$isUfoEnabled()) return;
    try {
        $293a52888646e540$var$experiences[name].getInstance(id).success({
            metadata: metadata
        });
    } catch  {
    // UFO errors must never break the plugin
    }
};
const $293a52888646e540$export$f6082b9b88a4d579 = (name, id, metadata)=>{
    if (!$293a52888646e540$var$isUfoEnabled()) return;
    try {
        $293a52888646e540$var$experiences[name].getInstance(id).failure({
            metadata: metadata
        });
    } catch  {
    // UFO errors must never break the plugin
    }
};
const $293a52888646e540$export$3dc7beb620ac2a71 = (name, id, reason, metadata)=>{
    if (!$293a52888646e540$var$isUfoEnabled()) return;
    try {
        // `reason` is the dedicated, canonical channel for the abort reason and
        // intentionally takes precedence over a `reason` key in `metadata`. Callers
        // must pass the reason via the param, not inside `metadata` (the `reason`
        // key there is reserved and would be overwritten).
        const merged = {
            ...metadata,
            ...reason ? {
                reason: reason
            } : {}
        };
        const hasMetadata = Object.keys(merged).length > 0;
        $293a52888646e540$var$experiences[name].getInstance(id).abort(hasMetadata ? {
            metadata: merged
        } : undefined);
    } catch  {
    // UFO errors must never break the plugin
    }
};
module.exports["EXPERIENCE_NAME"] = $293a52888646e540$export$52919046b94109dc;
module.exports["startExp"] = $293a52888646e540$export$70d07f1bdffbdb07;
module.exports["succeedExp"] = $293a52888646e540$export$fccb08519f2b9a7e;
module.exports["failExp"] = $293a52888646e540$export$f6082b9b88a4d579;
module.exports["abortExp"] = $293a52888646e540$export$3dc7beb620ac2a71;

});

parcelRegister("ln5kH", function(module, exports) {
/**
 * Validation and diagnostics layer over the artifacts manifest.
 *
 * `artifacts-manifest` owns *where* a payload comes from (one manifest request,
 * then a presigned CDN download). This module owns *whether the payload is
 * usable*: every loader declares the shape it expects, so a mis-published
 * artifact fails at the boundary with the artifact's name rather than surfacing
 * later as an empty trie or a silent no-op in scoring.
 */ 
var $gKGLg = parcelRequire("gKGLg");


var $dl7hN = parcelRequire("dl7hN");

const $6907863b4afb496b$var$TRAILING_SLASH_REGEX = /\/$/u;
const $6907863b4afb496b$var$DEFAULT_BASE_URL = '';
const $6907863b4afb496b$var$AUTOCOMPLETE_GATEWAY_BASE = '/gateway/api/v1/autocomplete';
const $6907863b4afb496b$export$d3c83a8104181448 = (path, baseUrl = $6907863b4afb496b$var$DEFAULT_BASE_URL)=>{
    const normalizedBase = baseUrl.replace($6907863b4afb496b$var$TRAILING_SLASH_REGEX, '');
    return `${normalizedBase}${$6907863b4afb496b$var$AUTOCOMPLETE_GATEWAY_BASE}${path}`;
};
const $6907863b4afb496b$export$74433f5460419c27 = async (artifactName, options = {})=>{
    const label = options.label ?? artifactName;
    // Presigned CDN URLs carry an auth token, so only the artifact name is logged.
    (0, $dl7hN.ctcTag)('init', `\u{2193} loading ${label}`);
    const payload = await (0, $gKGLg.fetchArtifactJson)(artifactName);
    if (options.validate && !options.validate(payload)) throw new Error(`[autocomplete-artifacts] ${label} payload shape was invalid`);
    const summary = options.summarize?.(payload);
    (0, $dl7hN.ctcTag)('init', `\u{2713} loaded ${label}${summary ? ` (${summary})` : ''}`);
    return payload;
};
const $6907863b4afb496b$export$b57bc751cbfe32a2 = async (artifactName, label = artifactName)=>{
    (0, $dl7hN.ctcTag)('init', `\u{2193} loading ${label}`);
    const url = await (0, $gKGLg.getArtifactUrl)(artifactName);
    const response = await fetch(url);
    if (!response.ok) throw new Error(`[autocomplete-artifacts] Failed to fetch ${label}: ${response.status}`);
    const payload = await response.arrayBuffer();
    (0, $dl7hN.ctcTag)('init', `\u{2713} loaded ${label} (${payload.byteLength} bytes)`);
    return payload;
};
module.exports["buildAutocompleteGatewayUrl"] = $6907863b4afb496b$export$d3c83a8104181448;
module.exports["fetchAutocompleteArtifactJson"] = $6907863b4afb496b$export$74433f5460419c27;
module.exports["fetchAutocompleteArtifactBinary"] = $6907863b4afb496b$export$b57bc751cbfe32a2;

});

parcelRegister("gKGLg", function(module, exports) {
/**
 * Artifacts Manifest Client: resolves the autocomplete model artifacts hosted on
 * the CDN.
 *
 * `GET /gateway/api/v1/autocomplete/artifacts` returns one presigned CDN URL per
 * artifact for the tenant's active model version:
 *
 *   { activeVersion, artifacts: [{ name, url, contentType, sizeBytes, checksum }] }
 *
 * Every loader in the plugin resolves its payload through here, so no model data
 * is bundled with the package.
 */ 
var $dl7hN = parcelRequire("dl7hN");

const $be7dca5b05e763be$export$953923d576277fd6 = {
    BIGRAMS: 'bigrams.json',
    FIRST_TOKEN_TO_WORDS: 'first-token-to-words.json',
    GHOST_POS_TAGS: 'ghost-pos-tags.json',
    GRAMMAR_TRANSITIONS: 'grammar-transitions-10k.json',
    L3_VOCABULARY: 'l3-vocabulary.json',
    PHRASE_CONTINUATION_TOKENS: 'phrase-continuation-tokens.json',
    PHRASES: 'phrases.json',
    POS_TAGS: 'combined-l2-l3-pos-tags.json',
    VOCABULARY: 'vocabulary-10k.json',
    WORD_INDEX: 'word-index-10k.json',
    WORD_VECTORS: 'word-vectors-10k.bin'
};
// ─── Constants ───────────────────────────────────────────────────────────────
const $be7dca5b05e763be$var$MANIFEST_ENDPOINT = '/gateway/api/v1/autocomplete/artifacts';
/**
 * Presigned artifact URLs expire ~10 minutes after the manifest is issued, so
 * the manifest is re-requested well inside that window instead of being cached
 * for the session and handing out dead URLs to a late loader.
 */ const $be7dca5b05e763be$var$MANIFEST_TTL_MS = 300000;
// ─── Manifest ────────────────────────────────────────────────────────────────
let $be7dca5b05e763be$var$manifestPromise;
let $be7dca5b05e763be$var$manifestRequestedAt = 0;
const $be7dca5b05e763be$export$201894762e066638 = ()=>{
    $be7dca5b05e763be$var$manifestPromise = undefined;
    $be7dca5b05e763be$var$manifestRequestedAt = 0;
};
const $be7dca5b05e763be$var$requestManifest = async ()=>{
    const res = await fetch($be7dca5b05e763be$var$MANIFEST_ENDPOINT, {
        method: 'GET',
        headers: {
            'x-experience-id': 'confluence-smart-typeahead-artifacts',
            'x-product': 'confluence'
        }
    });
    if (!res.ok) throw new Error(`[autocomplete-artifacts] Manifest request failed: ${res.status}`);
    const body = await res.json();
    if (!Array.isArray(body?.artifacts) || body.artifacts.length === 0) throw new Error('[autocomplete-artifacts] Manifest response contained no artifacts');
    if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
    console.log('[autocomplete-artifacts] Manifest loaded:', {
        activeVersion: body.activeVersion,
        names: body.artifacts.map((artifact)=>artifact.name)
    });
    return new Map(body.artifacts.map((artifact)=>[
            artifact.name,
            artifact
        ]));
};
const $be7dca5b05e763be$var$getManifest = ()=>{
    if ($be7dca5b05e763be$var$manifestPromise && Date.now() - $be7dca5b05e763be$var$manifestRequestedAt < $be7dca5b05e763be$var$MANIFEST_TTL_MS) return $be7dca5b05e763be$var$manifestPromise;
    $be7dca5b05e763be$var$manifestRequestedAt = Date.now();
    $be7dca5b05e763be$var$manifestPromise = $be7dca5b05e763be$var$requestManifest().catch((e)=>{
        // Never cache a rejection — a transient failure would otherwise stop every
        // later loader in the session from retrying.
        $be7dca5b05e763be$export$201894762e066638();
        throw e;
    });
    return $be7dca5b05e763be$var$manifestPromise;
};
const $be7dca5b05e763be$export$1cc24defa44e7f84 = async (name)=>{
    const manifest = await $be7dca5b05e763be$var$getManifest();
    const url = manifest.get(name)?.url;
    if (!url) throw new Error(`[autocomplete-artifacts] Manifest has no URL for "${name}"`);
    return url;
};
const $be7dca5b05e763be$export$58f210afbf6c1afb = async (name)=>{
    const url = await $be7dca5b05e763be$export$1cc24defa44e7f84(name);
    const res = await fetch(url);
    if (!res.ok) throw new Error(`[autocomplete-artifacts] Failed to download "${name}": ${res.status}`);
    return await res.json();
};
module.exports["ARTIFACT_NAME"] = $be7dca5b05e763be$export$953923d576277fd6;
module.exports["getArtifactUrl"] = $be7dca5b05e763be$export$1cc24defa44e7f84;
module.exports["fetchArtifactJson"] = $be7dca5b05e763be$export$58f210afbf6c1afb;

});

parcelRegister("eGuir", function(module, exports) {
const $441b9a1e7c49cdd7$var$createTokenTrieNode = ()=>({
        children: new Map()
    });
class $441b9a1e7c49cdd7$export$d9ec84579a177d7b {
    insert(surface, tokenIds) {
        if (tokenIds.length === 0) return;
        const normalizedSurface = surface.toLowerCase();
        this.tokenIdsBySurface.set(normalizedSurface, [
            ...tokenIds
        ]);
        let node = this.root;
        for (const tokenId of tokenIds){
            let child = node.children.get(tokenId);
            if (!child) {
                child = $441b9a1e7c49cdd7$var$createTokenTrieNode();
                node.children.set(tokenId, child);
            }
            node = child;
        }
    }
    getTokenIds(surface) {
        const tokenIds = this.tokenIdsBySurface.get(surface.toLowerCase());
        return tokenIds ? [
            ...tokenIds
        ] : null;
    }
    groupByScoredPrefix(candidates) {
        const groups = new Map();
        for (const candidate of candidates){
            if (candidate.scoredTokenCount <= 0 || candidate.scoredTokenCount >= candidate.tokenIds.length) continue;
            const tokenPrefix = candidate.tokenIds.slice(0, candidate.scoredTokenCount);
            let node = this.root;
            for (const tokenId of tokenPrefix){
                node = node.children.get(tokenId);
                if (!node) break;
            }
            if (!node) continue;
            const key = tokenPrefix.join(',');
            const group = groups.get(key) ?? {
                surfaces: [],
                tokenPrefix: tokenPrefix
            };
            group.surfaces.push(candidate.surface);
            groups.set(key, group);
        }
        return Array.from(groups.values());
    }
    constructor(entries = []){
        this.root = $441b9a1e7c49cdd7$var$createTokenTrieNode();
        this.tokenIdsBySurface = new Map();
        for (const [surface, tokenIds] of entries)this.insert(surface, tokenIds);
    }
}
const $441b9a1e7c49cdd7$var$WHITESPACE_REGEX = /\s/u;
const $441b9a1e7c49cdd7$var$makeContextKey = (prompt, separatorKind)=>`${separatorKind}\u0000${prompt}`;
const $441b9a1e7c49cdd7$export$b56f118c52147e2b = ()=>new Map();
const $441b9a1e7c49cdd7$export$eeb0d90cdfe94f0d = (textBeforeCursor, matchedPrefixLen, surface, getTokenIds, surfaceStartOverride, positionCache)=>{
    const derivedSurfaceStart = textBeforeCursor.length - matchedPrefixLen;
    const surfaceStart = Math.max(0, Math.min(textBeforeCursor.length, surfaceStartOverride ?? derivedSurfaceStart));
    let position = positionCache?.get(surfaceStart);
    if (position === undefined) {
        const precedingChar = surfaceStart > 0 ? textBeforeCursor[surfaceStart - 1] : null;
        const separatorKind = precedingChar === null ? 'document-start' : $441b9a1e7c49cdd7$var$WHITESPACE_REGEX.test(precedingChar) ? 'whitespace' : 'non-space';
        const contextBeforeSurface = textBeforeCursor.slice(0, surfaceStart).trimEnd();
        position = {
            contextBeforeSurface: contextBeforeSurface,
            contextKey: $441b9a1e7c49cdd7$var$makeContextKey(contextBeforeSurface, separatorKind),
            separatorKind: separatorKind,
            surfaceStart: surfaceStart
        };
        positionCache?.set(surfaceStart, position);
    }
    return {
        ...position,
        canonicalTokenIds: position.separatorKind === 'whitespace' ? getTokenIds(surface) : null
    };
};
const $441b9a1e7c49cdd7$export$d4148b8556be3aec = (textBeforeCursor)=>{
    if (textBeforeCursor.length === 0 || !$441b9a1e7c49cdd7$var$WHITESPACE_REGEX.test(textBeforeCursor.at(-1) ?? '')) return null;
    const prompt = textBeforeCursor.trimEnd();
    if (prompt.length === 0) return null;
    return {
        contextKey: $441b9a1e7c49cdd7$var$makeContextKey(prompt, 'whitespace'),
        prompt: prompt
    };
};
const $441b9a1e7c49cdd7$export$f7eb38cb31be4bcc = (familyKey, candidates, maxPrimes)=>{
    const byContext = new Map();
    for (const candidate of candidates){
        if (candidate.canonicalTokenIds === null) continue;
        const current = byContext.get(candidate.contextKey);
        if (!current || candidate.surfaceStart > current.surfaceStart) byContext.set(candidate.contextKey, candidate);
    }
    return Array.from(byContext.values()).sort((a, b)=>b.surfaceStart - a.surfaceStart).slice(0, Math.max(0, maxPrimes)).map((candidate, priority)=>({
            familyKey: familyKey,
            contextKey: candidate.contextKey,
            prompt: candidate.contextBeforeSurface,
            priority: priority
        }));
};
const $441b9a1e7c49cdd7$export$e20aca1e89397787 = (values)=>{
    let max = -Infinity;
    for (const value of values)if (Number.isFinite(value) && value > max) max = value;
    if (!Number.isFinite(max)) return -Infinity;
    let sumExp = 0;
    for (const value of values)if (Number.isFinite(value)) sumExp += Math.exp(value - max);
    return sumExp > 0 ? max + Math.log(sumExp) : -Infinity;
};
/**
 * The log-partition depends only on the buffer, but scoring reads the same
 * buffer once per candidate — so without this the two full-vocabulary passes
 * below run N times per boundary for an answer that cannot change.
 *
 * Keying on the buffer itself is safe because captured logits are never
 * written to again (see `CanonicalLogitProcessor.processLogits`, which copies
 * out of WebLLM's reused buffer), and the weak reference lets a retired
 * boundary's entry go with it.
 */ const $441b9a1e7c49cdd7$var$logPartitionTermsCache = new WeakMap();
const $441b9a1e7c49cdd7$var$getLogPartitionTerms = (logits)=>{
    const cached = $441b9a1e7c49cdd7$var$logPartitionTermsCache.get(logits);
    if (cached !== undefined) return cached;
    let maxLogit = -Infinity;
    for(let i = 0; i < logits.length; i++)if (logits[i] > maxLogit) maxLogit = logits[i];
    let terms = null;
    if (Number.isFinite(maxLogit)) {
        let sumExp = 0;
        for(let i = 0; i < logits.length; i++)sumExp += Math.exp(logits[i] - maxLogit);
        if (sumExp > 0) terms = {
            maxLogit: maxLogit,
            logSumTerm: Math.log(sumExp)
        };
    }
    $441b9a1e7c49cdd7$var$logPartitionTermsCache.set(logits, terms);
    return terms;
};
const $441b9a1e7c49cdd7$export$c5cef14a9a2a71de = (logits, target)=>{
    if (target < 0 || target >= logits.length) return -Infinity;
    const terms = $441b9a1e7c49cdd7$var$getLogPartitionTerms(logits);
    if (terms === null) return -Infinity;
    return logits[target] - terms.maxLogit - terms.logSumTerm;
};
class $441b9a1e7c49cdd7$export$51ab67669328e8a1 {
    constructor(){
        this.captured = null;
        this.processLogits = (logits)=>{
            // WebLLM reuses its logits buffer between forwards, so keep a private copy.
            this.captured = new Float32Array(logits);
            return logits;
        };
        this.processSampledToken = ()=>{
        // The scheduler chooses the next token; WebLLM's sample is discarded.
        };
        this.resetState = ()=>{
            // WebLLM resets the processor after the caller has armed a capture and
            // immediately before it prefills a completion prompt, so this only ever
            // clears a stale reading from the previous run.
            this.captured = null;
        };
        this.startCapture = ()=>{
            this.captured = null;
        };
        /**
     * The captured distribution, or null when the forward pass never ran.
     *
     * `processLogits` already copied it, and every capture allocates afresh, so
     * the buffer handed out here is never written to again.
     */ this.getCapturedLogits = ()=>this.captured;
    }
}
module.exports["CanonicalSurfaceTokenTrie"] = $441b9a1e7c49cdd7$export$d9ec84579a177d7b;
module.exports["createCanonicalContextPositionCache"] = $441b9a1e7c49cdd7$export$b56f118c52147e2b;
module.exports["deriveCanonicalCandidateContext"] = $441b9a1e7c49cdd7$export$eeb0d90cdfe94f0d;
module.exports["deriveWhitespaceBoundaryContext"] = $441b9a1e7c49cdd7$export$d4148b8556be3aec;
module.exports["selectBoundaryPrimeRequests"] = $441b9a1e7c49cdd7$export$f7eb38cb31be4bcc;
module.exports["logSumExp"] = $441b9a1e7c49cdd7$export$e20aca1e89397787;
module.exports["logSoftmaxAt"] = $441b9a1e7c49cdd7$export$c5cef14a9a2a71de;
module.exports["CanonicalLogitProcessor"] = $441b9a1e7c49cdd7$export$51ab67669328e8a1;

});

parcelRegister("cVZWR", function(module, exports) {
/**
 * Scoring Pipeline: Stage 1 (Semantic + Frequency), Grammar Filter, Stage 2 (LM Re-ranking).
 *
 * Operates synchronously on pre-loaded data. Each stage gracefully degrades
 * when its required data isn't available (cold → warm → full warm).
 *
 * The grammar/POS payloads are fetched from the CDN by loadGrammarDataAsync, so
 * the grammar filter is a pass-through until that resolves.
 */ 
var $a8cFP = parcelRequire("a8cFP");


var $gKGLg = parcelRequire("gKGLg");


var $dl7hN = parcelRequire("dl7hN");

// ─── Scoring Constants ──────────────────────────────────────
const $826d1cac63728dc3$var$ALPHA = 0.5;
const $826d1cac63728dc3$var$BETA = 0.5;
const $826d1cac63728dc3$var$NEUTRAL_SCORE = 0.5;
// Multiplicative Stage-1 boost applied to a multi-word term proportional to its
// (clamped [0,1]) NPMI association, so a strongly-collocated phrase outranks a
// coincidental word sequence of comparable freq/semantics. Tunable.
const $826d1cac63728dc3$var$ASSOCIATION_BOOST = 0.5;
const $826d1cac63728dc3$export$f05202d1ffe7dd92 = 0.35;
const $826d1cac63728dc3$export$629c0f7a660265df = 0.65;
const $826d1cac63728dc3$export$605d4086c61cb556 = 0.35;
const $826d1cac63728dc3$export$4770cbcc7abda298 = 0.08;
const $826d1cac63728dc3$var$L1_SESSION_CAP = 1.2;
// Minimum prefix-payload max LM probability before Stage 2 activates.
// Below this threshold the LM signal is too weak to suppress Stage 1 — finalScore
// falls back to stage1Score directly. Prevents weak prefixes (e.g. "ins" → "instances"
// at 0.00024) from triggering re-ranking.
const $826d1cac63728dc3$var$LM_GATE_THRESHOLD = 0.0005;
// ─── Grammar Data (fetched once from the CDN) ────────────────
let $826d1cac63728dc3$var$posTags = new Map();
/**
 * GHOST POS DICTIONARY
 * A mapping of common structural English words that were stripped from the main
 * domain vocabulary. This allows the grammar filter to understand context
 * without suggesting these words to the user.
 */ let $826d1cac63728dc3$var$ghostPosTags = {};
let $826d1cac63728dc3$var$grammarDataPromise;
/**
 * Precomputed map from each POS tag to the set of allowed next POS tags, so
 * applyGrammarFilter never re-iterates the transition rules per call.
 */ let $826d1cac63728dc3$var$precomputedAllowedByPos = new Map();
const $826d1cac63728dc3$var$isPosTagsRecord = (payload)=>{
    if (payload == null || typeof payload !== 'object') return false;
    return Object.values(payload).every((value)=>Array.isArray(value) && value.every((entry)=>typeof entry === 'string'));
};
const $826d1cac63728dc3$var$isGrammarTransitions = (payload)=>{
    if (payload == null || typeof payload !== 'object') return false;
    const transitions = payload.transitions;
    if (transitions == null || typeof transitions !== 'object') return false;
    return Object.values(transitions).every((value)=>{
        const allowed = value?.allowed;
        return Array.isArray(allowed) && allowed.every((entry)=>typeof entry === 'string');
    });
};
const $826d1cac63728dc3$var$setGrammarData = (data)=>{
    $826d1cac63728dc3$var$posTags = new Map(Object.entries(data.posTags));
    $826d1cac63728dc3$var$ghostPosTags = data.ghostPosTags;
    $826d1cac63728dc3$var$precomputedAllowedByPos = new Map(Object.entries(data.grammarTransitions.transitions ?? {}).map(([pos, rule])=>[
            pos,
            new Set(rule.allowed)
        ]));
};
const $826d1cac63728dc3$export$49939dbd36ea95a4 = ()=>$826d1cac63728dc3$var$precomputedAllowedByPos.size > 0;
const $826d1cac63728dc3$export$90d646237f0ac989 = (options)=>{
    if ($826d1cac63728dc3$var$grammarDataPromise) return $826d1cac63728dc3$var$grammarDataPromise;
    const isLocalLLM = options?.isLocalLLM ?? false;
    const surface = options?.surface;
    $826d1cac63728dc3$var$grammarDataPromise = (async ()=>{
        (0, $a8cFP.startExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_GRAMMAR, 'singleton', {
            isLocalLLM: isLocalLLM,
            ...surface ? {
                surface: surface
            } : {}
        });
        try {
            const [posTagsData, ghostPosTagsData, grammarTransitionsData] = await Promise.all([
                (0, $gKGLg.fetchArtifactJson)((0, $gKGLg.ARTIFACT_NAME).POS_TAGS),
                (0, $gKGLg.fetchArtifactJson)((0, $gKGLg.ARTIFACT_NAME).GHOST_POS_TAGS),
                (0, $gKGLg.fetchArtifactJson)((0, $gKGLg.ARTIFACT_NAME).GRAMMAR_TRANSITIONS)
            ]);
            // A missing wrapper and a malformed ruleset are reported separately: the
            // first points at the publishing step, the second at the payload itself.
            if (grammarTransitionsData?.transitions == null) throw new Error(`[scoring-pipeline] ${(0, $gKGLg.ARTIFACT_NAME).GRAMMAR_TRANSITIONS} is missing its \`transitions\` wrapper`);
            if (!$826d1cac63728dc3$var$isGrammarTransitions(grammarTransitionsData)) throw new Error(`[scoring-pipeline] ${(0, $gKGLg.ARTIFACT_NAME).GRAMMAR_TRANSITIONS} payload shape was invalid`);
            if (!$826d1cac63728dc3$var$isPosTagsRecord(posTagsData)) throw new Error(`[scoring-pipeline] ${(0, $gKGLg.ARTIFACT_NAME).POS_TAGS} payload shape was invalid`);
            if (!$826d1cac63728dc3$var$isPosTagsRecord(ghostPosTagsData)) throw new Error(`[scoring-pipeline] ${(0, $gKGLg.ARTIFACT_NAME).GHOST_POS_TAGS} payload shape was invalid`);
            $826d1cac63728dc3$var$setGrammarData({
                posTags: posTagsData,
                ghostPosTags: ghostPosTagsData,
                grammarTransitions: grammarTransitionsData
            });
            (0, $a8cFP.succeedExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_GRAMMAR, 'singleton', {
                isLocalLLM: isLocalLLM,
                posTagCount: $826d1cac63728dc3$var$posTags.size,
                transitionCount: $826d1cac63728dc3$var$precomputedAllowedByPos.size,
                ...surface ? {
                    surface: surface
                } : {}
            });
            if ((0, $dl7hN.isAutocompleteDebugEnabled)()) // eslint-disable-next-line no-console
            console.log('[scoring-pipeline] Grammar data loaded:', {
                posTagCount: $826d1cac63728dc3$var$posTags.size,
                ghostPosTagCount: Object.keys($826d1cac63728dc3$var$ghostPosTags).length,
                transitionCount: $826d1cac63728dc3$var$precomputedAllowedByPos.size
            });
        } catch (e) {
            (0, $a8cFP.failExp)((0, $a8cFP.EXPERIENCE_NAME).LOAD_GRAMMAR, 'singleton', {
                isLocalLLM: isLocalLLM,
                errorType: 'network',
                ...surface ? {
                    surface: surface
                } : {}
            });
            // Allow a later call to retry the load rather than caching the failure.
            $826d1cac63728dc3$var$grammarDataPromise = undefined;
            throw e;
        }
    })();
    return $826d1cac63728dc3$var$grammarDataPromise;
};
// ─── Math ───────────────────────────────────────────────────
function $826d1cac63728dc3$var$cosineSimilarity(a, b) {
    let dot = 0;
    let normA = 0;
    let normB = 0;
    for(let i = 0; i < a.length; i++){
        dot += a[i] * b[i];
        normA += a[i] * a[i];
        normB += b[i] * b[i];
    }
    const dNormA = Math.sqrt(normA);
    const dNormB = Math.sqrt(normB);
    if (dNormA === 0 || dNormB === 0) return $826d1cac63728dc3$var$NEUTRAL_SCORE;
    return (1 + dot / (dNormA * dNormB)) / 2;
}
// ─── Stage 1: Semantic + Frequency ──────────────────────────
function $826d1cac63728dc3$var$scoreStage1(candidate, contextVector, getWordVector, maxTenantFreq) {
    // 1. Calculate Base Global Score (Normalized Log)
    const maxPossibleLog = Math.log10(maxTenantFreq + 1);
    // Diversity Adjustment
    const diversityRaw = (Math.log10(candidate.tenantFreq + 1) * 0.5 + Math.log10(candidate.docFreq + 1) * 0.25 + Math.log10(candidate.authorFreq + 1) * 0.25) / maxPossibleLog;
    const sessionMultiplier = candidate.sessionFreq > 0 ? 1 + Math.log10(candidate.sessionFreq + 1) * 2.5 : 1;
    // Apply multiplier; capped at L1_SESSION_CAP (default 1.2) to prevent excessive over-indexing
    const freqScore = Math.min(diversityRaw * sessionMultiplier, $826d1cac63728dc3$var$L1_SESSION_CAP);
    // 3. Semantic Scoring
    let semanticScore = $826d1cac63728dc3$var$NEUTRAL_SCORE;
    if (contextVector) {
        const wordVec = getWordVector(candidate.word);
        semanticScore = wordVec ? $826d1cac63728dc3$var$cosineSimilarity(contextVector, wordVec) : $826d1cac63728dc3$var$NEUTRAL_SCORE;
    }
    return {
        semanticScore: semanticScore,
        freqScore: freqScore,
        stage1Score: $826d1cac63728dc3$var$ALPHA * semanticScore + $826d1cac63728dc3$var$BETA * freqScore
    };
}
function $826d1cac63728dc3$var$applyGrammarFilter(candidates, previousWord) {
    // Pass everything through until loadGrammarDataAsync resolves — filtering on a
    // partially loaded ruleset would drop valid candidates.
    if (!previousWord || !$826d1cac63728dc3$export$49939dbd36ea95a4()) return {
        filtered: candidates,
        grammarMeta: null
    };
    const lowerPrev = previousWord.toLowerCase();
    const prevTags = $826d1cac63728dc3$var$ghostPosTags[lowerPrev] || $826d1cac63728dc3$var$posTags.get(lowerPrev);
    if (!prevTags || prevTags.length === 0) return {
        filtered: candidates,
        grammarMeta: null
    };
    let allowedNextTags;
    if (prevTags.length === 1) // Common case: single POS tag — reuse the precomputed Set directly (no allocation)
    allowedNextTags = $826d1cac63728dc3$var$precomputedAllowedByPos.get(prevTags[0]) ?? new Set();
    else {
        allowedNextTags = new Set();
        for (const pt of prevTags){
            const allowed = $826d1cac63728dc3$var$precomputedAllowedByPos.get(pt);
            if (allowed) allowed.forEach((tag)=>allowedNextTags.add(tag));
        }
    }
    const filtered = [];
    const dropped = [];
    for (const entry of candidates){
        // The producer validates a multi-word term's *internal* grammar offline
        // (boundary-clean, noun-headed, AUP-passed — spec §9), but nothing judges
        // the transition into it. Exempting multi-word terms therefore let a noun
        // this filter had just rejected re-enter wrapped in a bigram — "be" [AUX]
        // dropped "quality" and then displayed "quality assurance". Only the term's
        // first word takes part in the transition, so gate every term on that.
        const surface = entry.candidate.word;
        const firstSpace = surface.indexOf(' ');
        const transitionWord = firstSpace === -1 ? surface : surface.slice(0, firstSpace);
        const candidateTags = $826d1cac63728dc3$var$posTags.get(transitionWord.toLowerCase());
        // If candidate has no tags (unknown word), let it pass to be safe
        if (!candidateTags || candidateTags.length === 0) {
            filtered.push(entry);
            continue;
        }
        if (candidateTags.some((ct)=>allowedNextTags.has(ct))) filtered.push(entry);
        else dropped.push(entry.candidate.word);
    }
    // Grammar is authoritative.
    return {
        filtered: filtered,
        grammarMeta: {
            prevWord: lowerPrev,
            prevTags: prevTags,
            before: candidates.length,
            after: filtered.length,
            dropped: dropped
        }
    };
}
// ─── Stage 2: LM Re-ranking ────────────────────────────────
function $826d1cac63728dc3$var$getLmScore(word, lmLogits) {
    if (!lmLogits) return 0;
    // Look up the word directly! No more tokens.
    const val = lmLogits[word.toLowerCase()];
    if (typeof val === 'number') return val;
    return 0;
}
function $826d1cac63728dc3$export$59fa301e67bec9c(candidates, contextVector, getWordVector, lmLogits, maxFreqByType, previousWord, getCanonicalLmEvidence) {
    // Stage 1
    const stage1Results = candidates.map((candidate)=>{
        const termType = candidate.termType ?? 'word';
        // Normalize freq within the candidate's own term-type population so a
        // phrase (whose absolute counts are far below top unigrams) isn't crushed
        // by the unigram max.
        const maxFreq = maxFreqByType[termType] || 1;
        const { semanticScore: semanticScore, freqScore: freqScore, stage1Score: stage1Score } = $826d1cac63728dc3$var$scoreStage1(candidate, contextVector, getWordVector, maxFreq);
        // Multi-word units get an NPMI association boost (Stage-1 only).
        let adjustedStage1 = stage1Score;
        if (termType !== 'word' && typeof candidate.association === 'number') {
            const assoc = Math.max(0, Math.min(1, candidate.association));
            adjustedStage1 = stage1Score * (1 + $826d1cac63728dc3$var$ASSOCIATION_BOOST * assoc);
        }
        return {
            candidate: candidate,
            semanticScore: semanticScore,
            freqScore: freqScore,
            stage1Score: adjustedStage1
        };
    });
    const stage1Survivors = [];
    const stage1Rejected = [];
    for (const entry of stage1Results)if (entry.stage1Score >= $826d1cac63728dc3$export$605d4086c61cb556) stage1Survivors.push(entry);
    else stage1Rejected.push(entry.candidate.word);
    // Grammar Filter
    const { filtered: filtered, grammarMeta: grammarMeta } = $826d1cac63728dc3$var$applyGrammarFilter(stage1Survivors, previousWord);
    // Stage 2 + final assembly
    let lmMax = 0;
    if (lmLogits) {
        const values = Object.values(lmLogits);
        if (values.length > 0) lmMax = Math.max(...values);
    }
    const canonicalEvidenceBySurface = new Map();
    const maxLmRankingValueByTierAndContext = new Map();
    for (const entry of filtered){
        const evidence = getCanonicalLmEvidence?.(entry.candidate.word) ?? null;
        if (!evidence) continue;
        canonicalEvidenceBySurface.set(entry.candidate.word, evidence);
        const rankingValue = evidence.source === 'canonical-full-surface' ? evidence.meanTokenLogProbability : evidence.rawLogit;
        if (rankingValue !== undefined && Number.isFinite(rankingValue)) {
            const key = `${evidence.source}\u0000${evidence.contextKey}`;
            const current = maxLmRankingValueByTierAndContext.get(key) ?? -Infinity;
            if (rankingValue > current) maxLmRankingValueByTierAndContext.set(key, rankingValue);
        }
    }
    const scored = filtered.map((entry)=>{
        const termType = entry.candidate.termType ?? 'word';
        const isMultiWord = termType !== 'word';
        let lmScore = 0;
        let finalScore = entry.stage1Score;
        let lmEvidence = canonicalEvidenceBySurface.get(entry.candidate.word) ?? null;
        if (lmEvidence) {
            const rankingValue = lmEvidence.source === 'canonical-full-surface' ? lmEvidence.meanTokenLogProbability : lmEvidence.rawLogit;
            const maxRankingValue = maxLmRankingValueByTierAndContext.get(`${lmEvidence.source}\u0000${lmEvidence.contextKey}`);
            if (rankingValue !== undefined && maxRankingValue !== undefined) lmEvidence = {
                ...lmEvidence,
                score: Math.exp(rankingValue - maxRankingValue)
            };
        }
        if (lmEvidence) {
            lmScore = lmEvidence.score;
            finalScore = $826d1cac63728dc3$export$f05202d1ffe7dd92 * entry.stage1Score + $826d1cac63728dc3$export$629c0f7a660265df * lmScore;
        } else if (!isMultiWord && lmLogits && lmMax >= $826d1cac63728dc3$var$LM_GATE_THRESHOLD) {
            // Backward-compatible network slow-lane path.
            const rawLm = $826d1cac63728dc3$var$getLmScore(entry.candidate.word, lmLogits);
            if (rawLm !== 0) {
                const logitDiff = Math.log(rawLm) - Math.log(lmMax);
                lmScore = Math.exp(logitDiff);
                lmEvidence = {
                    contextKey: 'network',
                    score: lmScore,
                    separatorKind: 'whitespace',
                    source: 'network-logit',
                    totalSurfaceCharCount: entry.candidate.word.length,
                    // The legacy BE word map does not report canonical token depth.
                    totalTokenCount: 0,
                    verifiedCharCount: 0,
                    verifiedTokenCount: 0
                };
                finalScore = $826d1cac63728dc3$export$f05202d1ffe7dd92 * entry.stage1Score + $826d1cac63728dc3$export$629c0f7a660265df * lmScore;
            }
        }
        return {
            word: entry.candidate.word,
            freqScore: entry.freqScore,
            semanticScore: entry.semanticScore,
            lmScore: lmScore,
            lmEvidence: lmEvidence,
            finalScore: finalScore,
            stage1Score: entry.stage1Score,
            termType: termType
        };
    });
    scored.sort((a, b)=>{
        if (b.finalScore !== a.finalScore) return b.finalScore - a.finalScore;
        return a.word.length - b.word.length;
    });
    return {
        candidates: scored,
        grammarMeta: grammarMeta,
        pipelineDebug: {
            initial: candidates.length,
            stage1Rejected: stage1Rejected,
            grammarRejected: grammarMeta?.dropped ?? [],
            final: scored.length
        }
    };
}
module.exports["STAGE1_WEIGHT"] = $826d1cac63728dc3$export$f05202d1ffe7dd92;
module.exports["STAGE2_WEIGHT"] = $826d1cac63728dc3$export$629c0f7a660265df;
module.exports["MIN_STAGE1_SCORE"] = $826d1cac63728dc3$export$605d4086c61cb556;
module.exports["MIN_WINNER_MARGIN"] = $826d1cac63728dc3$export$4770cbcc7abda298;
module.exports["loadGrammarDataAsync"] = $826d1cac63728dc3$export$90d646237f0ac989;
module.exports["rankCandidates"] = $826d1cac63728dc3$export$59fa301e67bec9c;

});

parcelRegister("gpRHn", function(module, exports) {
/**
 * Slow Lane Client: Backend context encoding for autocomplete.
 *
 * Fires a BE request on word boundaries to encode document context.
 * Expects the typeahead-encodings API format:
 *   Request:  { text, session_id }
 *   Response: { semantic_vector: number[], lm_logits: Record<string, number> }
 */ 
var $a8cFP = parcelRequire("a8cFP");


var $ln5kH = parcelRequire("ln5kH");


var $dl7hN = parcelRequire("dl7hN");

// ─── Constants ───────────────────────────────────────────────────────────────
// eslint-disable-next-line require-unicode-regexp
const $5734dd8e6fe21a10$var$WORD_BOUNDARY_CHARS = /[\s.,;:!?]/;
const $5734dd8e6fe21a10$var$DEFAULT_DEBOUNCE_MS = 300;
const $5734dd8e6fe21a10$export$3906562fa4b68d28 = (text)=>{
    if (!text || text.length === 0) return false;
    const lastChar = text[text.length - 1];
    return $5734dd8e6fe21a10$var$WORD_BOUNDARY_CHARS.test(lastChar);
};
const $5734dd8e6fe21a10$export$4055b4520db5c4df = (config)=>{
    const { baseUrl: baseUrl, sessionId: configSessionId, productKey: productKey = 'confluence', surface: surface, endpoint: endpoint = '/gateway/api/v1/autocomplete/typeahead-encodings', debounceMs: debounceMs = $5734dd8e6fe21a10$var$DEFAULT_DEBOUNCE_MS, fetchFn: fetchFn = fetch, onUpdate: onUpdate } = config;
    const sessionId = configSessionId ?? crypto.randomUUID();
    const headers = {
        'Content-Type': 'application/json',
        'x-experience-id': 'confluence-smart-typeahead-encodings',
        'x-product': productKey
    };
    let debounceTimer = null;
    let lastRequestedText = '';
    let storedContextInput = null;
    let storedContextVector = null;
    let storedLmLogits = null;
    let requestSeq = 0;
    let inflightRequestId = null;
    const doUpdateContext = async (text, requestId)=>{
        if (!text || text.trim().length === 0) return;
        const url = (0, $ln5kH.buildAutocompleteGatewayUrl)(endpoint, baseUrl);
        const payload = {
            text: text,
            session_id: sessionId
        };
        (0, $a8cFP.startExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, requestId, {
            textLength: text.length,
            isLocalLLM: false,
            ...surface ? {
                surface: surface
            } : {}
        });
        (0, $dl7hN.ctcTag)('signal', `\u{1F4E4} network context sent \xb7 ${text.length} chars`, (0, $dl7hN.CTC_STYLES).section);
        try {
            const res = await fetchFn(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            });
            if (!res.ok) {
                storedContextInput = null;
                storedContextVector = null;
                storedLmLogits = null;
                (0, $a8cFP.failExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, requestId, {
                    status: res.status,
                    errorType: 'http_error',
                    isLocalLLM: false,
                    ...surface ? {
                        surface: surface
                    } : {}
                });
                (0, $dl7hN.ctcTag)('signal', `\u{274C} network request failed (${res.status})`, (0, $dl7hN.CTC_STYLES).bad);
                return;
            }
            const data = await res.json();
            if (data.semantic_vector && Array.isArray(data.semantic_vector)) {
                storedContextVector = new Float32Array(data.semantic_vector);
                storedContextInput = text;
            } else {
                storedContextVector = null;
                storedContextInput = null;
            }
            if (data.lm_logits && typeof data.lm_logits === 'object') storedLmLogits = data.lm_logits;
            else storedLmLogits = null;
            (0, $dl7hN.ctcTag)('signal', `\u{1F4E5} network response \xb7 ${storedContextVector ? `semantic \u{2705} ${storedContextVector.length}d` : "semantic \u274C"} \xb7 ${storedLmLogits ? `logits \u{2705} ${Object.keys(storedLmLogits).length}tok` : "logits \u274C"}`, (0, $dl7hN.CTC_STYLES).section);
            (0, $a8cFP.succeedExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, requestId, {
                textLength: text.length,
                hasVector: storedContextVector !== null,
                hasLmLogits: storedLmLogits !== null,
                isLocalLLM: false,
                ...surface ? {
                    surface: surface
                } : {}
            });
            onUpdate?.({
                textLength: text.length,
                hasVector: storedContextVector !== null,
                hasLmLogits: storedLmLogits !== null
            });
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
            storedContextInput = null;
            storedContextVector = null;
            storedLmLogits = null;
            (0, $a8cFP.failExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, requestId, {
                errorType: 'network',
                isLocalLLM: false,
                ...surface ? {
                    surface: surface
                } : {}
            });
            (0, $dl7hN.ctcTag)('signal', "\u274C network error \u2014 context cleared", (0, $dl7hN.CTC_STYLES).bad);
        } finally{
            if (inflightRequestId === requestId) inflightRequestId = null;
        }
    };
    const updateContextDebounced = (text)=>{
        if (debounceTimer) clearTimeout(debounceTimer);
        lastRequestedText = text;
        debounceTimer = setTimeout(()=>{
            debounceTimer = null;
            if (inflightRequestId !== null) (0, $a8cFP.abortExp)((0, $a8cFP.EXPERIENCE_NAME).SLOW_LANE_FETCH, inflightRequestId, 'superseded', {
                isLocalLLM: false,
                ...surface ? {
                    surface: surface
                } : {}
            });
            const requestId = String(++requestSeq);
            inflightRequestId = requestId;
            doUpdateContext(lastRequestedText, requestId);
        }, debounceMs);
    };
    return {
        updateContext: updateContextDebounced,
        getContextInput: ()=>storedContextInput,
        getContextVector: ()=>storedContextVector,
        getLmLogits: ()=>storedLmLogits,
        setContextVector: (vector)=>{
            storedContextInput = null;
            storedContextVector = vector;
        },
        setLmLogits: (logits)=>{
            storedLmLogits = logits;
        },
        isWordBoundary: $5734dd8e6fe21a10$export$3906562fa4b68d28
    };
};
let $5734dd8e6fe21a10$var$defaultSlowLaneClient = null;
let $5734dd8e6fe21a10$var$defaultSlowLaneClientRegistration = null;
const $5734dd8e6fe21a10$var$supportsCanonicalSurfaceScoring = (client)=>typeof client?.primeBoundaryLm === 'function' && typeof client?.requestProgressiveSurfaceScores === 'function';
const $5734dd8e6fe21a10$export$b18c52410f22198e = (client, registration)=>{
    $5734dd8e6fe21a10$var$defaultSlowLaneClient = client;
    $5734dd8e6fe21a10$var$defaultSlowLaneClientRegistration = client ? registration ?? {
        clientId: 'untracked',
        kind: $5734dd8e6fe21a10$var$supportsCanonicalSurfaceScoring(client) ? 'localLlm' : 'server'
    } : null;
};
const $5734dd8e6fe21a10$export$862f6f1afd09375e = (client)=>{
    if ($5734dd8e6fe21a10$var$defaultSlowLaneClient !== client) return false;
    $5734dd8e6fe21a10$var$defaultSlowLaneClient = null;
    $5734dd8e6fe21a10$var$defaultSlowLaneClientRegistration = null;
    return true;
};
const $5734dd8e6fe21a10$export$b7a41745d2ff3782 = ()=>{
    const canonicalScoringSupported = $5734dd8e6fe21a10$var$supportsCanonicalSurfaceScoring($5734dd8e6fe21a10$var$defaultSlowLaneClient);
    const isLocalClient = $5734dd8e6fe21a10$var$defaultSlowLaneClientRegistration?.kind === 'localLlm';
    return {
        registered: $5734dd8e6fe21a10$var$defaultSlowLaneClient !== null,
        clientId: $5734dd8e6fe21a10$var$defaultSlowLaneClientRegistration?.clientId ?? null,
        clientKind: $5734dd8e6fe21a10$var$defaultSlowLaneClientRegistration?.kind ?? null,
        canonicalScoringSupported: canonicalScoringSupported,
        localModelReady: isLocalClient && typeof $5734dd8e6fe21a10$var$defaultSlowLaneClient?.isReady === 'function' ? $5734dd8e6fe21a10$var$defaultSlowLaneClient.isReady() : null,
        canonicalSurfaceCount: canonicalScoringSupported && typeof $5734dd8e6fe21a10$var$defaultSlowLaneClient?.getCanonicalSurfaceCount === 'function' ? $5734dd8e6fe21a10$var$defaultSlowLaneClient.getCanonicalSurfaceCount() : null
    };
};
const $5734dd8e6fe21a10$export$8fad1879c7a61a0 = ()=>$5734dd8e6fe21a10$var$defaultSlowLaneClient?.getContextVector() ?? null;
const $5734dd8e6fe21a10$export$e74c4447ada0308d = ()=>$5734dd8e6fe21a10$var$defaultSlowLaneClient?.getContextInput?.() ?? null;
const $5734dd8e6fe21a10$export$bf4eabc3e7305700 = ()=>$5734dd8e6fe21a10$var$defaultSlowLaneClient?.getLmLogits() ?? null;
const $5734dd8e6fe21a10$export$17dc13b85b019a9d = (contextKey)=>$5734dd8e6fe21a10$var$defaultSlowLaneClient?.getBoundaryLmState?.(contextKey) ?? null;
const $5734dd8e6fe21a10$export$a84028181782df3 = (surface)=>$5734dd8e6fe21a10$var$defaultSlowLaneClient?.getCanonicalSurfaceTokenIds?.(surface) ?? null;
const $5734dd8e6fe21a10$export$519b745605e3c273 = (contextKey, surface)=>$5734dd8e6fe21a10$var$defaultSlowLaneClient?.getSurfaceScore?.(contextKey, surface) ?? null;
const $5734dd8e6fe21a10$export$3721dde051dbe7c2 = (contextKey, surface)=>$5734dd8e6fe21a10$var$defaultSlowLaneClient?.getProgressiveSurfaceEvidence?.(contextKey, surface) ?? null;
const $5734dd8e6fe21a10$export$f0e49d9acd8cafb9 = (input)=>{
    $5734dd8e6fe21a10$var$defaultSlowLaneClient?.primeBoundaryLm?.(input);
};
const $5734dd8e6fe21a10$export$c02e152853b3f202 = (input)=>{
    $5734dd8e6fe21a10$var$defaultSlowLaneClient?.requestProgressiveSurfaceScores?.(input);
};
const $5734dd8e6fe21a10$export$ff39aa54d1fcb6f3 = ()=>$5734dd8e6fe21a10$var$supportsCanonicalSurfaceScoring($5734dd8e6fe21a10$var$defaultSlowLaneClient);
const $5734dd8e6fe21a10$export$628f4e68229b9c01 = ()=>$5734dd8e6fe21a10$var$defaultSlowLaneClient?.getCanonicalSurfaceCount?.() ?? 0;
module.exports["isWordBoundary"] = $5734dd8e6fe21a10$export$3906562fa4b68d28;
module.exports["createSlowLaneClient"] = $5734dd8e6fe21a10$export$4055b4520db5c4df;
module.exports["setDefaultSlowLaneClient"] = $5734dd8e6fe21a10$export$b18c52410f22198e;
module.exports["clearDefaultSlowLaneClient"] = $5734dd8e6fe21a10$export$862f6f1afd09375e;
module.exports["getDefaultSlowLaneClientStatus"] = $5734dd8e6fe21a10$export$b7a41745d2ff3782;
module.exports["getStoredContextVector"] = $5734dd8e6fe21a10$export$8fad1879c7a61a0;
module.exports["getStoredContextInput"] = $5734dd8e6fe21a10$export$e74c4447ada0308d;
module.exports["getStoredLmLogits"] = $5734dd8e6fe21a10$export$bf4eabc3e7305700;
module.exports["getBoundaryLmState"] = $5734dd8e6fe21a10$export$17dc13b85b019a9d;
module.exports["getCanonicalSurfaceTokenIds"] = $5734dd8e6fe21a10$export$a84028181782df3;
module.exports["getSurfaceScore"] = $5734dd8e6fe21a10$export$519b745605e3c273;
module.exports["getProgressiveSurfaceEvidence"] = $5734dd8e6fe21a10$export$3721dde051dbe7c2;
module.exports["primeBoundaryLm"] = $5734dd8e6fe21a10$export$f0e49d9acd8cafb9;
module.exports["requestProgressiveSurfaceScores"] = $5734dd8e6fe21a10$export$c02e152853b3f202;
module.exports["isCanonicalSurfaceScoringSupported"] = $5734dd8e6fe21a10$export$ff39aa54d1fcb6f3;
module.exports["getCanonicalSurfaceCount"] = $5734dd8e6fe21a10$export$628f4e68229b9c01;

});

parcelRegister("bbi2x", function(module, exports) {

var $kn09b = parcelRequire("kn09b");

function $8db7c24ad6d5f338$export$b7ba222ba9a0eb12(fileObject) {
    if (fileObject.type.startsWith('image/')) return true;
    // Some browsers/OS don't set MIME on screenshots — fall back to extension.
    const ext = fileObject.name.split('.').pop()?.toLowerCase() ?? '';
    return (0, $kn09b.IMAGE_EXTENSIONS).has(ext);
}
module.exports["looksLikeImage"] = $8db7c24ad6d5f338$export$b7ba222ba9a0eb12;

});

parcelRegister("5Jxc6", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $hlvTd = parcelRequire("hlvTd");


var $hKlzx = parcelRequire("hKlzx");


var $KUOAT = parcelRequire("KUOAT");


var $bbi2x = parcelRequire("bbi2x");


var $hUfaI = parcelRequire("hUfaI");


var $6P3l4 = parcelRequire("6P3l4");


var $dvKXx = parcelRequire("dvKXx");

const $353036f759c791f4$var$actions = {
    addFiles: (key, files, sendAnalyticsEvent)=>({ getState: _getState, dispatch: dispatch })=>{
            const needsPreview = (file)=>file.fileObject && ((0, $bbi2x.looksLikeImage)(file.fileObject) || (0, $hKlzx.isTextFile)(file.fileObject.type, file.fileObject.name));
            // Add files with preview loading state if needed
            const fileAttachments = files.map((file)=>[
                    file.name,
                    {
                        type: 'file',
                        data: needsPreview(file) ? {
                            ...file,
                            isPreviewLoading: true
                        } : file
                    }
                ]);
            dispatch((0, $dvKXx.updateAttachements)(key, fileAttachments));
            files.forEach((file)=>{
                if (needsPreview(file) && file.fileObject) (0, $KUOAT.generateFilePreview)(file.fileObject).then((previewBlobUrl)=>{
                    // Check if file still exists and wasn't removed/errored during preview generation
                    const currentState = _getState()[key] || (0, $6P3l4.defaultStateContextPerKey);
                    const currentAttachment = currentState.attachments.get(file.name);
                    if (!currentAttachment || currentAttachment.type !== 'file' || currentAttachment.data.error) {
                        // File was removed or errored while preview was generating, cleanup the blob
                        URL.revokeObjectURL(previewBlobUrl);
                        return;
                    }
                    dispatch($353036f759c791f4$export$6f57813fe9f31bf9.actions.updateFileWithName(key, file.name, {
                        previewBlobUrl: previewBlobUrl,
                        isPreviewLoading: false
                    }));
                }).catch((error)=>{
                    // Log error to Sentry for monitoring
                    (0, $hlvTd.logException)({
                        exception: error,
                        name: 'file-preview-generation-error',
                        tags: {
                            fileType: file.fileObject?.type
                        }
                    });
                    sendAnalyticsEvent({
                        action: 'failed',
                        actionSubject: 'preview',
                        actionSubjectId: 'thumbnailGeneration',
                        attributes: {
                            fileType: file.fileObject?.type || 'unknown'
                        }
                    });
                    dispatch($353036f759c791f4$export$6f57813fe9f31bf9.actions.updateFileWithName(key, file.name, {
                        isPreviewLoading: false,
                        previewError: error instanceof Error ? error.message : String(error)
                    }));
                });
            });
        },
    addExternalContext: (key, context)=>({ getState: _getState, dispatch: dispatch })=>{
            const externalContextAttachments = context.map((context)=>[
                    context.key,
                    {
                        type: 'external',
                        data: context
                    }
                ]);
            dispatch((0, $dvKXx.updateAttachements)(key, externalContextAttachments));
        },
    updateFileWithName: (key, fileName, fileData)=>({ getState: getState, dispatch: dispatch })=>{
            const { attachments: currentAttachtments } = getState()[key] || (0, $6P3l4.defaultStateContextPerKey);
            const attachment = currentAttachtments.get(fileName);
            if (attachment && attachment.type === 'file') dispatch((0, $dvKXx.updateAttachements)(key, [
                [
                    fileName,
                    {
                        ...attachment,
                        data: {
                            ...attachment.data,
                            ...fileData
                        }
                    }
                ]
            ]));
        },
    removeFile: (key, fileName)=>({ getState: getState, dispatch: dispatch })=>{
            const { attachments: currentAttachtments } = getState()[key] || (0, $6P3l4.defaultStateContextPerKey);
            // Cleanup blob URL before removing
            const attachment = currentAttachtments.get(fileName);
            if (attachment) (0, $hUfaI.cleanupBlobUrls)([
                attachment
            ]);
            dispatch((0, $dvKXx.updateAttachements)(key, [
                ...currentAttachtments.entries()
            ].filter(([entryKey, value])=>value.type !== 'file' || entryKey !== fileName), true));
        },
    removeExternalContext: (key, id)=>({ getState: getState, dispatch: dispatch })=>{
            const { attachments: currentAttachtments } = getState()[key] || (0, $6P3l4.defaultStateContextPerKey);
            dispatch((0, $dvKXx.updateAttachements)(key, [
                ...currentAttachtments.entries()
            ].filter(([entryKey, value])=>value.type !== 'external' || entryKey !== id), true));
        },
    clearFiles: (key)=>({ dispatch: dispatch, getState: getState })=>{
            const { attachments: currentAttachtments } = getState()[key] || (0, $6P3l4.defaultStateContextPerKey);
            // Cleanup all file blob URLs
            (0, $hUfaI.cleanupBlobUrls)([
                ...currentAttachtments.values()
            ]);
            dispatch((0, $dvKXx.updateAttachements)(key, [
                ...currentAttachtments.entries()
            ].filter(([_, value])=>value.type !== 'file'), true));
        },
    clearAttachments: (key)=>({ dispatch: dispatch, getState: getState })=>{
            const { attachments: currentAttachtments } = getState()[key] || (0, $6P3l4.defaultStateContextPerKey);
            // Cleanup all blob URLs
            (0, $hUfaI.cleanupBlobUrls)([
                ...currentAttachtments.values()
            ]);
            dispatch((0, $dvKXx.updateAttachements)(key, [], true));
        }
};
const $353036f759c791f4$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    name: 'conversationAttachments',
    initialState: {},
    actions: $353036f759c791f4$var$actions
});
module.exports["store"] = $353036f759c791f4$export$6f57813fe9f31bf9;

});

parcelRegister("3GBUS", function(module, exports) {
/* createSkillTagNodeRenderer.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $5TXhv = parcelRequire("5TXhv");


var $fdZYN = parcelRequire("fdZYN");

const $7bf864c1789d1fd3$export$b52dc487f462b755 = (siteId, disableSkillTagHoverCardInEditor = false, skillTagHoverCardMaxHeightInEditor)=>({
        skillTag: {
            type: 'inlineExtension',
            render: async ()=>({ node: node })=>{
                    const params = node.parameters;
                    if (!params) return null;
                     // Use ConnectedSkillTag to fetch and render full metadata so the pill matches the typeahead style.
                    if (siteId && !params.color && !params.iconName) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdZYN.ConnectedSkillTag), {
                        slug: params.slug,
                        siteId: siteId,
                        disableHovercard: disableSkillTagHoverCardInEditor,
                        hovercardMaxHeight: skillTagHoverCardMaxHeightInEditor
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TXhv.SkillTag), {
                        ...params,
                        disableHovercard: disableSkillTagHoverCardInEditor,
                        hovercardMaxHeight: skillTagHoverCardMaxHeightInEditor
                    });
                }
        }
    });
module.exports["createSkillTagNodeRenderer"] = $7bf864c1789d1fd3$export$b52dc487f462b755;

});

parcelRegister("6P3l4", function(module, exports) {
const $34e2b31e096cb698$export$e7dd74b0cb28ef67 = {
    attachments: new Map()
};
module.exports["defaultStateContextPerKey"] = $34e2b31e096cb698$export$e7dd74b0cb28ef67;

});

parcelRegister("lKwLK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $l3wuH = parcelRequire("l3wuH");


var $24dy7 = parcelRequire("24dy7");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $91ZZN = parcelRequire("91ZZN");


var $lfoFx = parcelRequire("lfoFx");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $dSh4s = parcelRequire("dSh4s");


var $acGll = parcelRequire("acGll");

const $afe3e9afed23cf0d$var$styles = {
    previewCardWrapper: "_1mT5xdRAKS",
    previewCard: "_0bjKvD8fU6 _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _1EqgXlVJXy _0jFU0V9LX5 _1mT5xdRAKS _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0LQT5E8HPE _0KLXruqi9L _1eOmH6bvxc",
    previewCardContent: "_4ouGXIdnbC",
    iconWrapper: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _0KLXruDMqu _0jFU0VpJKa _39xV02pJKa _1mT5xdRAKS _3YEZNOdnbC",
    icon: "_1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ",
    crossIcon: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1mT5xdWVPG _4ApkO2B0rP _2IhTonB0rP _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrulfZc _0jFU0VoWWg _39xV02oWWg _1YKVNsdnbC _1eOmH6d1Zr",
    crossIconVisible: "_1YKVNs7dHp",
    labelWrapper: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    thumbnailImageCover: "_39xV02N91d _0jFU0VN91d _00EA0eiObl",
    clickable: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _0wOv4Q7zJH _4EiLyUXzJH _34b3D2FQfX"
};
const $afe3e9afed23cf0d$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    });
};
const $afe3e9afed23cf0d$var$MediaContentRenderer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { isLoading: isLoading, error: error, imageSrc: imageSrc, cardIcon: cardIcon, errorLabel: errorLabel } = t0;
    if (isLoading) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$LoadingIndicator, null);
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if (error) {
        const t1 = errorLabel || error;
        let t2;
        if ($[1] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: t1,
                color: "var(--ds-icon-danger, #C9372C)"
            });
            $[1] = t1;
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    }
    if (imageSrc) {
        let t1;
        if ($[3] !== imageSrc) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "img",
                src: imageSrc,
                alt: "",
                xcss: $afe3e9afed23cf0d$var$styles.thumbnailImageCover
            });
            $[3] = imageSrc;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    if (cardIcon) return cardIcon;
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dSh4s))),
            alt: ""
        });
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ isLoading: isLoading, error: error, imageSrc: imageSrc, cardIcon: cardIcon, errorLabel: errorLabel })=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$LoadingIndicator, null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: errorLabel || error,
        color: "var(--ds-icon-danger, #C9372C)"
    });
    if (imageSrc) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "img",
        src: imageSrc,
        alt: "",
        xcss: $afe3e9afed23cf0d$var$styles.thumbnailImageCover
    });
    if (cardIcon) return cardIcon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dSh4s))),
        alt: ""
    });
};
const $afe3e9afed23cf0d$var$MediaWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let contentProps;
    let t1;
    if ($[0] !== t0) {
        ({ show: t1, ...contentProps } = t0);
        $[0] = t0;
        $[1] = contentProps;
        $[2] = t1;
    } else {
        contentProps = $[1];
        t1 = $[2];
    }
    const show = t1 === undefined ? true : t1;
    if (!show) return null;
    const shouldShowCentered = contentProps.isLoading || contentProps.error;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$LoadingIndicator, null);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== contentProps || $[5] !== shouldShowCentered) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $afe3e9afed23cf0d$var$styles.iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-preview-card",
            fallback: t2
        }, contentProps.imageSrc && !shouldShowCentered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$MediaContentRenderer, contentProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !contentProps.isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dSh4s))),
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $afe3e9afed23cf0d$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$MediaContentRenderer, contentProps)))));
        $[4] = contentProps;
        $[5] = shouldShowCentered;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ show: show = true, ...contentProps })=>{
    if (!show) return null;
    const shouldShowCentered = contentProps.isLoading || contentProps.error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $afe3e9afed23cf0d$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-preview-card",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$LoadingIndicator, null)
    }, contentProps.imageSrc && !shouldShowCentered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$MediaContentRenderer, contentProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !contentProps.isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dSh4s))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $afe3e9afed23cf0d$var$styles.icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$MediaContentRenderer, contentProps)))));
};
const $afe3e9afed23cf0d$var$RemoveButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onRemove: onRemove, isVisible: t1, removeLabel: removeLabel } = t0;
    const isVisible = t1 === undefined ? false : t1;
    if (!onRemove) return null;
    const t2 = isVisible && $afe3e9afed23cf0d$var$styles.crossIconVisible;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($afe3e9afed23cf0d$var$styles.crossIcon, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const t4 = removeLabel || "";
    let t5;
    if ($[2] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: t4,
            spacing: "compact",
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        });
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== onRemove || $[5] !== t3 || $[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            onClick: onRemove,
            xcss: t3,
            "data-remove-button": "true"
        }, t5);
        $[4] = onRemove;
        $[5] = t3;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    return t6;
} : ({ onRemove: onRemove, isVisible: isVisible = false, removeLabel: removeLabel })=>{
    if (!onRemove) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: onRemove,
        xcss: (0, $w6R6I.cx)($afe3e9afed23cf0d$var$styles.crossIcon, isVisible && $afe3e9afed23cf0d$var$styles.crossIconVisible),
        "data-remove-button": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: removeLabel || '',
        spacing: "compact",
        size: "small",
        color: "var(--ds-icon, #292A2E)"
    }));
};
const $afe3e9afed23cf0d$var$useAutoScroll = (0, $gtMdU.isReactCompilerActivePlatform)() ? (autoScroll)=>{
    const $ = (0, $bDgLe.c)(3);
    const ref = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== autoScroll) {
        t0 = ()=>{
            if (autoScroll && ref.current) ref.current?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "nearest"
            });
        };
        t1 = [
            autoScroll
        ];
        $[0] = autoScroll;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return ref;
} : (autoScroll)=>{
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (autoScroll && ref.current) ref.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        autoScroll
    ]);
    return ref;
};
const $afe3e9afed23cf0d$var$LabelContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { label: label, subLabel: subLabel, subLabelIcon: subLabelIcon } = t0;
    let t1;
    if ($[0] !== label) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $afe3e9afed23cf0d$var$styles.labelWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text",
            size: "medium"
        }, label));
        $[0] = label;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== subLabel || $[3] !== subLabelIcon) {
        t2 = subLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, subLabelIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-preview-card-sublabel-icon",
            fallback: null
        }, subLabelIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small"
        }, subLabel));
        $[2] = subLabel;
        $[3] = subLabelIcon;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $afe3e9afed23cf0d$var$styles.previewCardContent,
            space: "space.050"
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ label: label, subLabel: subLabel, subLabelIcon: subLabelIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $afe3e9afed23cf0d$var$styles.previewCardContent,
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $afe3e9afed23cf0d$var$styles.labelWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text",
        size: "medium"
    }, label)), subLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, subLabelIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-preview-card-sublabel-icon",
        fallback: null
    }, subLabelIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, subLabel)));
const $afe3e9afed23cf0d$export$b56e55a3645a3ec = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { onRemove: onRemove, onClick: onClick, isLoading: isLoading, error: error, autoScroll: autoScroll, label: label, subLabel: subLabel, subLabelIcon: subLabelIcon, cardIcon: cardIcon, imageSrc: imageSrc, removeLabel: removeLabel, errorLabel: errorLabel, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const ref = $afe3e9afed23cf0d$var$useAutoScroll(autoScroll);
    const showMedia = !!(cardIcon || imageSrc);
    let t1;
    if ($[0] !== onClick) {
        t1 = (e)=>{
            if (e.target.closest("[data-remove-button]")) return;
            onClick?.();
        };
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    const handleClick = t1;
    let t2;
    if ($[2] !== onClick) {
        t2 = (e_0)=>{
            if (e_0.key === "Enter" || e_0.key === " ") {
                if (e_0.target.closest("[data-remove-button]")) return;
                e_0.preventDefault();
                onClick?.();
            }
        };
        $[2] = onClick;
        $[3] = t2;
    } else t2 = $[3];
    const handleKeyDown = t2;
    const t3 = error || label;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsHovered(true);
        t5 = ()=>setIsHovered(false);
        t6 = ()=>setIsHovered(true);
        t7 = ()=>setIsHovered(false);
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    const t8 = onClick ? 0 : undefined;
    const t9 = onClick ? "button" : undefined;
    const t10 = onClick ? handleClick : undefined;
    const t11 = onClick ? handleKeyDown : undefined;
    const t12 = onClick ? $afe3e9afed23cf0d$var$styles.clickable : undefined;
    let t13;
    if ($[8] !== label || $[9] !== subLabel || $[10] !== subLabelIcon) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$LabelContent, {
            label: label,
            subLabel: subLabel,
            subLabelIcon: subLabelIcon
        });
        $[8] = label;
        $[9] = subLabel;
        $[10] = subLabelIcon;
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== cardIcon || $[13] !== error || $[14] !== errorLabel || $[15] !== imageSrc || $[16] !== isLoading || $[17] !== showMedia) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$MediaWrapper, {
            show: showMedia,
            isLoading: isLoading,
            error: error,
            imageSrc: imageSrc,
            cardIcon: cardIcon,
            errorLabel: errorLabel
        });
        $[12] = cardIcon;
        $[13] = error;
        $[14] = errorLabel;
        $[15] = imageSrc;
        $[16] = isLoading;
        $[17] = showMedia;
        $[18] = t14;
    } else t14 = $[18];
    let t15;
    if ($[19] !== t13 || $[20] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $afe3e9afed23cf0d$var$styles.previewCard,
            alignBlock: "center",
            space: "space.150",
            spread: "space-between"
        }, t13, t14);
        $[19] = t13;
        $[20] = t14;
        $[21] = t15;
    } else t15 = $[21];
    let t16;
    if ($[22] !== formatMessage || $[23] !== isLoading || $[24] !== label) {
        t16 = isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, formatMessage((0, $acGll.default).loadingLabel, {
            label: label
        }))) : null;
        $[22] = formatMessage;
        $[23] = isLoading;
        $[24] = label;
        $[25] = t16;
    } else t16 = $[25];
    let t17;
    if ($[26] !== ref || $[27] !== t10 || $[28] !== t11 || $[29] !== t12 || $[30] !== t15 || $[31] !== t16 || $[32] !== t8 || $[33] !== t9 || $[34] !== testId) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: ref,
            testId: testId,
            tabIndex: t8,
            role: t9,
            onClick: t10,
            onKeyDown: t11,
            xcss: t12
        }, t15, t16);
        $[26] = ref;
        $[27] = t10;
        $[28] = t11;
        $[29] = t12;
        $[30] = t15;
        $[31] = t16;
        $[32] = t8;
        $[33] = t9;
        $[34] = testId;
        $[35] = t17;
    } else t17 = $[35];
    const t18 = isHovered && !!onRemove;
    let t19;
    if ($[36] !== onRemove || $[37] !== removeLabel || $[38] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$RemoveButton, {
            onRemove: onRemove,
            isVisible: t18,
            removeLabel: removeLabel
        });
        $[36] = onRemove;
        $[37] = removeLabel;
        $[38] = t18;
        $[39] = t19;
    } else t19 = $[39];
    let t20;
    if ($[40] !== t17 || $[41] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $afe3e9afed23cf0d$var$styles.previewCardWrapper,
            onMouseEnter: t4,
            onMouseLeave: t5,
            onFocus: t6,
            onBlur: t7
        }, t17, t19);
        $[40] = t17;
        $[41] = t19;
        $[42] = t20;
    } else t20 = $[42];
    let t21;
    if ($[43] !== t20 || $[44] !== t3) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t3,
            position: "top"
        }, t20);
        $[43] = t20;
        $[44] = t3;
        $[45] = t21;
    } else t21 = $[45];
    return t21;
} : ({ onRemove: onRemove, onClick: onClick, isLoading: isLoading, error: error, autoScroll: autoScroll, label: label, subLabel: subLabel, subLabelIcon: subLabelIcon, cardIcon: cardIcon, imageSrc: imageSrc, removeLabel: removeLabel, errorLabel: errorLabel, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const ref = $afe3e9afed23cf0d$var$useAutoScroll(autoScroll);
    const showMedia = !!(cardIcon || imageSrc);
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        // Don't trigger onClick if clicking the remove button
        if (e.target.closest('[data-remove-button]')) return;
        onClick?.();
    }, [
        onClick
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e_0)=>{
        // Handle Enter and Space keys for accessibility
        if (e_0.key === 'Enter' || e_0.key === ' ') {
            if (e_0.target.closest('[data-remove-button]')) return;
            e_0.preventDefault();
            onClick?.();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: error || label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $afe3e9afed23cf0d$var$styles.previewCardWrapper,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsHovered(true),
        onBlur: ()=>setIsHovered(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: ref,
        testId: testId,
        tabIndex: onClick ? 0 : undefined,
        role: onClick ? 'button' : undefined,
        onClick: onClick ? handleClick : undefined,
        onKeyDown: onClick ? handleKeyDown : undefined,
        xcss: onClick ? $afe3e9afed23cf0d$var$styles.clickable : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $afe3e9afed23cf0d$var$styles.previewCard,
        alignBlock: "center",
        space: "space.150",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$LabelContent, {
        label: label,
        subLabel: subLabel,
        subLabelIcon: subLabelIcon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$MediaWrapper, {
        show: showMedia,
        isLoading: isLoading,
        error: error,
        imageSrc: imageSrc,
        cardIcon: cardIcon,
        errorLabel: errorLabel
    })), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, formatMessage((0, $acGll.default).loadingLabel, {
        label: label
    }))) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($afe3e9afed23cf0d$var$RemoveButton, {
        onRemove: onRemove,
        isVisible: isHovered && !!onRemove,
        removeLabel: removeLabel
    })));
};
module.exports["PreviewCard"] = $afe3e9afed23cf0d$export$b56e55a3645a3ec;

});

parcelRegister("60Uyi", function(module, exports) {
const $24b78208256af9ba$export$4a57230fe42df70d = 'connectorSourceChip';
const $24b78208256af9ba$var$getAttr = (dom, attrName)=>{
    const value = dom.getAttribute(attrName);
    return value ?? undefined;
};
const $24b78208256af9ba$export$ad2ec06a68289c0d = (attrs)=>[
        'span',
        {
            'data-connector-source-chip': 'true',
            'data-source': attrs.source,
            'data-display': attrs.display,
            ...attrs.iconUrl ? {
                'data-icon-url': attrs.iconUrl
            } : {}
        },
        attrs.display
    ];
const $24b78208256af9ba$export$2f76c91f5ec44cda = {
    inline: true,
    group: 'inline',
    atom: true,
    attrs: {
        source: {
            default: ''
        },
        display: {
            default: ''
        },
        iconUrl: {
            default: null
        }
    },
    parseDOM: [
        {
            tag: 'span[data-connector-source-chip]',
            getAttrs: (dom)=>{
                if (!(dom instanceof HTMLElement)) return false;
                return {
                    source: $24b78208256af9ba$var$getAttr(dom, 'data-source') ?? '',
                    display: $24b78208256af9ba$var$getAttr(dom, 'data-display') ?? dom.textContent ?? '',
                    iconUrl: $24b78208256af9ba$var$getAttr(dom, 'data-icon-url')
                };
            }
        }
    ],
    toDOM: (node)=>$24b78208256af9ba$export$ad2ec06a68289c0d({
            source: node.attrs.source,
            display: node.attrs.display,
            iconUrl: node.attrs.iconUrl
        }),
    leafText: (node)=>node.attrs.display
};
module.exports["CONNECTOR_SOURCE_CHIP_NODE_NAME"] = $24b78208256af9ba$export$4a57230fe42df70d;
module.exports["connectorSourceChipNodeSpec"] = $24b78208256af9ba$export$2f76c91f5ec44cda;

});

parcelRegister("kn09b", function(module, exports) {
/**
 * File extensions (lowercase, without the leading dot) that are treated as
 * images when generating file previews and thumbnails.
 */ const $1cdf1fde470ab642$export$7f2965a86780a5f1 = new Set([
    'png',
    'jpg',
    'jpeg',
    'gif',
    'webp',
    'svg',
    'bmp',
    'ico',
    'avif'
]);
module.exports["IMAGE_EXTENSIONS"] = $1cdf1fde470ab642$export$7f2965a86780a5f1;

});

parcelRegister("hUfaI", function(module, exports) {
const $7564b1df2a04c7f1$export$576687f4553cf0ad = (attachments)=>{
    attachments.forEach((attachment)=>{
        if (attachment.type === 'file' && attachment.data.previewBlobUrl) URL.revokeObjectURL(attachment.data.previewBlobUrl);
    });
};
module.exports["cleanupBlobUrls"] = $7564b1df2a04c7f1$export$576687f4553cf0ad;

});

parcelRegister("dvKXx", function(module, exports) {

var $6P3l4 = parcelRequire("6P3l4");

const $2a0a11183ab76e9d$export$c221c3e3969ca24e = (key, entries, overwrite = false)=>{
    return ({ setState: setState, getState: getState })=>{
        const state = getState()[key] || (0, $6P3l4.defaultStateContextPerKey);
        setState({
            [key]: {
                attachments: new Map([
                    ...!overwrite ? state.attachments.entries() : [],
                    ...entries
                ])
            }
        });
    };
};
module.exports["updateAttachements"] = $2a0a11183ab76e9d$export$c221c3e3969ca24e;

});

parcelRegister("dSh4s", function(module, exports) {
module.exports = new URL("preview-bg.12045916.svg", import.meta.url).toString();

});

parcelRegister("acGll", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dc4c1335ec7a2891$var$previewCardMessages = (0, $kSwu1.defineMessages)({
    loadingLabel: {
        id: "ai-mate.preview-card.loading-label",
        defaultMessage: "Loading {label}"
    }
});
var $dc4c1335ec7a2891$export$2e2bcd8739ae039 = $dc4c1335ec7a2891$var$previewCardMessages;
module.exports["default"] = $dc4c1335ec7a2891$export$2e2bcd8739ae039;

});


//# sourceMappingURL=FullPageEditorComponent.daa06ca8.js.map
